
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("kAAxV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $48ce831672685691$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $jFNzP = parcelRequire("jFNzP");
const $48ce831672685691$var$IssueViewDevPanel = ({ ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jFNzP.default), props);
var $48ce831672685691$export$2e2bcd8739ae039 = $48ce831672685691$var$IssueViewDevPanel;

});
parcelRegister("jFNzP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa1651a13ca3871a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gClbM = parcelRequire("gClbM");

var $dxK8I = parcelRequire("dxK8I");

var $kxjPv = parcelRequire("kxjPv");

var $h47gY = parcelRequire("h47gY");

var $7jTnu = parcelRequire("7jTnu");

var $bmoS1 = parcelRequire("bmoS1");

var $eaTQ3 = parcelRequire("eaTQ3");

var $3EmVH = parcelRequire("3EmVH");

var $8oKDI = parcelRequire("8oKDI");

var $814y1 = parcelRequire("814y1");

var $bNexr = parcelRequire("bNexr");

var $5HFSX = parcelRequire("5HFSX");

var $jom8W = parcelRequire("jom8W");

var $8q7lT = parcelRequire("8q7lT");

var $kEUB1 = parcelRequire("kEUB1");

var $gZTP9 = parcelRequire("gZTP9");

var $lUto7 = parcelRequire("lUto7");

var $8Zgq4 = parcelRequire("8Zgq4");
function $fa1651a13ca3871a$var$AllDevInfoPanel({ issueId: issueId, issueAri: issueAri }) {
    const user = (0, $8q7lT.useAccountId)();
    const issueKey = (0, $bmoS1.useIssueKey)();
    const analyticsSource = (0, $bmoS1.useAnalyticsSource)();
    const projectKey = (0, $bmoS1.useProjectKey)();
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    const projectId = (0, $bNexr.useProjectId)(projectKey);
    const cloudId = (0, $kEUB1.useCloudId)();
    const isSimplifiedProject = (0, $bNexr.useIsSimplifiedProject)(projectKey);
    const [{ value: summary }] = (0, $3EmVH.useSummaryField)({
        issueKey: issueKey,
        issueId: issueId
    });
    const [statusFieldValue] = (0, $eaTQ3.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $814y1.STATUS_TYPE)
    });
    const issueStatusCategory = statusFieldValue?.statusCategory.id || null;
    const hasSoftwareAccess = (0, $bmoS1.useHasSoftwareAccess)();
    const isJiraAdmin = (0, $gZTP9.useIsAdmin)();
    const isSiteAdmin = (0, $lUto7.useIsSiteAdmin)();
    const issueContext = (0, $eJOHy.useMemo)(()=>({
            issueKey: issueKey,
            issueId: Number(issueId),
            issueStatusCategory: issueStatusCategory,
            projectAri: (0, $8oKDI.createAri)({
                resourceId: projectId || '',
                resourceOwner: 'jira',
                resourceType: 'project',
                cloudId: cloudId
            }),
            projectId: Number(projectId),
            projectType: projectType || '',
            isSimplifiedProject: isSimplifiedProject
        }), [
        issueKey,
        issueId,
        issueStatusCategory,
        projectId,
        projectType,
        isSimplifiedProject,
        cloudId
    ]);
    const devPanelAppProps = {
        hasSoftwareAccess: hasSoftwareAccess,
        issueId: issueId.toString(),
        issueAri: issueAri,
        issueKey: issueKey,
        issueStatusCategory: issueStatusCategory || '',
        projectId: projectId || '',
        projectType: projectType || '',
        nextGenProject: isSimplifiedProject,
        analyticsSource: analyticsSource || '',
        projectAri: (0, $8oKDI.createAri)({
            resourceId: projectId || '',
            resourceOwner: 'jira',
            resourceType: 'project',
            cloudId: cloudId
        }),
        isJiraAdmin: isJiraAdmin
    };
    // ProjectContext is still loading
    if (projectId == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "devInfoPanelApp",
        packageName: "jiraDevelopmentDevInfoPanelApp"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5HFSX.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gClbM.default), devPanelAppProps), !(0, $jom8W.isDevopsFeatureDisabledInFedRamp)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dxK8I.default), {
        issueContext: issueContext,
        hasSoftwareAccess: hasSoftwareAccess,
        analyticsSource: analyticsSource || '',
        summary: summary || '',
        user: user,
        isJiraAdmin: isJiraAdmin,
        isSiteAdmin: isSiteAdmin,
        cloudAri: cloudId
    }), !(0, $jom8W.isDevopsFeatureDisabledInFedRamp)() && (0, $7jTnu.fg)('isotopes-security-page-in-jira-enabled-v2') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kxjPv.default), {
        issueAri: issueAri
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Zgq4.default), {
        scopeId: `devInfoPanelApp${issueContext.issueKey}`
    })));
}
var $fa1651a13ca3871a$export$2e2bcd8739ae039 = $fa1651a13ca3871a$var$AllDevInfoPanel;

});
parcelRegister("gClbM", function(module, exports) {

$parcel$export(module.exports, "default", () => $223346cebe8127b5$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gnQAk = parcelRequire("gnQAk");

var $eltlS = parcelRequire("eltlS");

var $1k5xZ = parcelRequire("1k5xZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$223346cebe8127b5$export$2e2bcd8739ae039 = ({ issueKey: issueKey, ...props })=>{
    const [store] = (0, $eJOHy.useState)((0, $eltlS.default)({
        issueKey: issueKey
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gnQAk.Provider), {
        store: store
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1k5xZ.default), {
        ...props,
        issueKey: issueKey
    }));
};

});
parcelRegister("eltlS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f45037635b6b497d$export$2e2bcd8739ae039);

var $7HHI1 = parcelRequire("7HHI1");

var $4tM8k = parcelRequire("4tM8k");

var $iWqim = parcelRequire("iWqim");

var $kqAfW = parcelRequire("kqAfW");

var $gb7nH = parcelRequire("gb7nH");

var $07c9r = parcelRequire("07c9r");

var $iutjY = parcelRequire("iutjY");

var $50OY9 = parcelRequire("50OY9");
const $f45037635b6b497d$var$defaultInitialState = (0, $iWqim.freeze)({
    context: (0, $07c9r.initialState),
    entities: (0, $50OY9.initialState)
});
const $f45037635b6b497d$export$a8a69c316169e623 = (state = $f45037635b6b497d$var$defaultInitialState, action)=>(0, $iWqim.freeze)((0, $7HHI1.combineReducers)({
        context: (0, $07c9r.default),
        entities: (0, $50OY9.default)
    })(state, action));
const $f45037635b6b497d$export$49b6a7dfc84f00c4 = ()=>(0, $4tM8k.combineEpics)((0, $iutjY.fetchDevPanel), (0, $iutjY.enrichDevPanelWithOneClickLinks), // @ts-expect-error - TS2345 - Argument of type '(action$: ActionsObservable<Action>, store: MiddlewareAPI<State>) => Observable<{ eventData: any; analyticsEvent: any; action: any; actionSubjectId: any; }>' is not assignable to parameter of type 'Epic<State, DevPanelActions>'.
    (0, $gb7nH.default));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f45037635b6b497d$export$2e2bcd8739ae039 = ({ initialState: initialState = $f45037635b6b497d$var$defaultInitialState, issueKey: issueKey = '' })=>(0, $7HHI1.createStore)($f45037635b6b497d$export$a8a69c316169e623, initialState, (0, $kqAfW.default)({
        name: `DevPanel-${issueKey}`
    })((0, $7HHI1.applyMiddleware)((0, $4tM8k.createEpicMiddleware)($f45037635b6b497d$export$49b6a7dfc84f00c4()))));

});
parcelRegister("gb7nH", function(module, exports) {

$parcel$export(module.exports, "default", () => $55b67465b78d4a6c$export$2e2bcd8739ae039);
parcelRequire("llumX");
parcelRequire("1o2WJ");
parcelRequire("7La6O");
parcelRequire("8yIb3");

var $gCeeo = parcelRequire("gCeeo");

var $cnDNc = parcelRequire("cnDNc");
// @ts-expect-error - TS7031 - Binding element 'type' implicitly has an 'any' type. | TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ FETCH_DEV_PANEL_SUCCESS: (state: State, action: { analyticsEvent: UIAnalyticsEventInterface; }) => { eventNameSuffix: string; eventData: { issueId: string; issueStatusCategory: string; projectId: string; ... 4 more ...; isEmptyStateEnabled: boolean; }; analyticsEvent: UIAnalyticsEventInterface; action: string; act...'.
const $55b67465b78d4a6c$var$shouldActionTriggerAnalytics = ({ type: type })=>(0, $cnDNc.default)[type] !== undefined;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $55b67465b78d4a6c$var$getAnalyticsForAction = (state, action)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ FETCH_DEV_PANEL_SUCCESS: (state: State, action: { analyticsEvent: UIAnalyticsEventInterface; }) => { eventNameSuffix: string; eventData: { issueId: string; issueStatusCategory: string; projectId: string; ... 4 more ...; isEmptyStateEnabled: boolean; }; analyticsEvent: UIAnalyticsEventInterface; action: string; act...'.
    (0, $cnDNc.default)[action.type](state, action);
// @ts-expect-error - TS7031 - Binding element 'eventData' implicitly has an 'any' type. | TS7031 - Binding element 'analyticsEvent' implicitly has an 'any' type. | TS7031 - Binding element 'action' implicitly has an 'any' type. | TS7031 - Binding element 'actionSubjectId' implicitly has an 'any' type.
const $55b67465b78d4a6c$var$triggerAnalyticsForAction = ({ eventData: eventData, analyticsEvent: analyticsEvent, action: action, actionSubjectId: actionSubjectId })=>{
    if (analyticsEvent) (0, $gCeeo.fireUIAnalytics)(analyticsEvent, action, actionSubjectId, {
        ...eventData
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$55b67465b78d4a6c$export$2e2bcd8739ae039 = (action$, store)=>action$.filter($55b67465b78d4a6c$var$shouldActionTriggerAnalytics).map((action)=>$55b67465b78d4a6c$var$getAnalyticsForAction(store.getState(), action)).do($55b67465b78d4a6c$var$triggerAnalyticsForAction).ignoreElements();

});
parcelRegister("cnDNc", function(module, exports) {

$parcel$export(module.exports, "default", () => $72bfd63518fde254$export$2e2bcd8739ae039);

var $ikKUs = parcelRequire("ikKUs");

var $kLuCE = parcelRequire("kLuCE");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$72bfd63518fde254$export$2e2bcd8739ae039 = {
    [(0, $ikKUs.FETCH_DEV_PANEL_SUCCESS)]: (state, action)=>({
            eventNameSuffix: 'fetch.succeeded',
            eventData: (0, $kLuCE.getAnalyticsIssueData)(state),
            analyticsEvent: action.analyticsEvent,
            action: 'panel rendered',
            actionSubjectId: 'devpanelsummary'
        }),
    [(0, $ikKUs.FETCH_DEV_PANEL_FAILURE)]: (state, action)=>({
            eventNameSuffix: 'fetch.failed',
            eventData: (0, $kLuCE.getAnalyticsIssueData)(state),
            analyticsEvent: action.analyticsEvent,
            action: 'panel failed',
            actionSubjectId: 'devpanelsummary'
        })
};

});
parcelRegister("ikKUs", function(module, exports) {

$parcel$export(module.exports, "FETCH_DEV_PANEL_REQUEST", () => $267734c3aef19020$export$bbc62c19ae8d5cf2);
$parcel$export(module.exports, "FETCH_DEV_PANEL_SUCCESS", () => $267734c3aef19020$export$49acc9c095f6b36a);
$parcel$export(module.exports, "FETCH_DEV_PANEL_URL_DETAILS_SUCCESS", () => $267734c3aef19020$export$45a86e169e39400e);
$parcel$export(module.exports, "FETCH_DEV_PANEL_FAILURE", () => $267734c3aef19020$export$8317438e1e61dba2);
$parcel$export(module.exports, "DEV_PANEL_UNMOUNTED", () => $267734c3aef19020$export$2b6a364d21006071);
$parcel$export(module.exports, "TOGGLE_SUMMARY_SECTION_MESSAGE", () => $267734c3aef19020$export$9efb0389f7941b30);
$parcel$export(module.exports, "fetchDevPanelRequest", () => $267734c3aef19020$export$e272b9d3c8c7592d);
$parcel$export(module.exports, "fetchDevPanelFailure", () => $267734c3aef19020$export$2009dc8f2d7ae19e);
$parcel$export(module.exports, "fetchDevPanelSuccess", () => $267734c3aef19020$export$2d700a870e93952c);
$parcel$export(module.exports, "fetchDevPanelUrlDetailsSuccess", () => $267734c3aef19020$export$6235ecf44e113529);
$parcel$export(module.exports, "devPanelWillUnmount", () => $267734c3aef19020$export$17a40c054c1ce3d2);
$parcel$export(module.exports, "onClickDismissLink", () => $267734c3aef19020$export$e08c79c9b6badf94);
$parcel$export(module.exports, "SHOW_EMPTY_STATE_DIALOG", () => $267734c3aef19020$export$8f51b498d82c8c4d);
$parcel$export(module.exports, "CLOSE_EMPTY_STATE_DIALOG", () => $267734c3aef19020$export$3ee0ca31ae1c64e);
$parcel$export(module.exports, "TOGGLE_EMPTY_STATE_PANEL", () => $267734c3aef19020$export$7ec1c869208a9fdf);
$parcel$export(module.exports, "showEmptyStateDialog", () => $267734c3aef19020$export$397c34c503e1422c);
$parcel$export(module.exports, "closeEmptyStateDialog", () => $267734c3aef19020$export$2a4ad6c2ee7b351a);
$parcel$export(module.exports, "onToggleDismissButton", () => $267734c3aef19020$export$33ebfbc795cb0b7c);
const $267734c3aef19020$export$bbc62c19ae8d5cf2 = 'FETCH_DEV_PANEL_REQUEST';
const $267734c3aef19020$export$49acc9c095f6b36a = 'FETCH_DEV_PANEL_SUCCESS';
const $267734c3aef19020$export$45a86e169e39400e = 'FETCH_DEV_PANEL_URL_DETAILS_SUCCESS';
const $267734c3aef19020$export$8317438e1e61dba2 = 'FETCH_DEV_PANEL_FAILURE';
const $267734c3aef19020$export$2b6a364d21006071 = 'DEV_PANEL_UNMOUNTED';
const $267734c3aef19020$export$9efb0389f7941b30 = 'TOGGLE_SUMMARY_SECTION_MESSAGE';
const $267734c3aef19020$export$e272b9d3c8c7592d = (analyticsEvent)=>({
        type: $267734c3aef19020$export$bbc62c19ae8d5cf2,
        analyticsEvent: analyticsEvent
    });
const $267734c3aef19020$export$2009dc8f2d7ae19e = (analyticsEvent)=>({
        type: $267734c3aef19020$export$8317438e1e61dba2,
        analyticsEvent: analyticsEvent
    });
const $267734c3aef19020$export$2d700a870e93952c = (devPanel, analyticsEvent)=>({
        type: $267734c3aef19020$export$49acc9c095f6b36a,
        payload: devPanel,
        analyticsEvent: analyticsEvent
    });
const $267734c3aef19020$export$6235ecf44e113529 = (swagDetailsResponse)=>({
        type: $267734c3aef19020$export$45a86e169e39400e,
        payload: swagDetailsResponse
    });
const $267734c3aef19020$export$17a40c054c1ce3d2 = ()=>({
        type: $267734c3aef19020$export$2b6a364d21006071
    });
const $267734c3aef19020$export$e08c79c9b6badf94 = (showSection)=>({
        type: $267734c3aef19020$export$9efb0389f7941b30,
        payload: {
            showSummarySectionMessage: showSection
        }
    });
const $267734c3aef19020$export$8f51b498d82c8c4d = 'SHOW_EMPTY_STATE_DIALOG';
const $267734c3aef19020$export$3ee0ca31ae1c64e = 'CLOSE_EMPTY_STATE_DIALOG';
const $267734c3aef19020$export$7ec1c869208a9fdf = 'TOGGLE_EMPTY_STATE_PANEL';
const $267734c3aef19020$export$397c34c503e1422c = ()=>({
        type: $267734c3aef19020$export$8f51b498d82c8c4d
    });
const $267734c3aef19020$export$2a4ad6c2ee7b351a = ()=>({
        type: $267734c3aef19020$export$3ee0ca31ae1c64e
    });
const $267734c3aef19020$export$33ebfbc795cb0b7c = (showPanel)=>({
        type: $267734c3aef19020$export$7ec1c869208a9fdf,
        payload: {
            panelState: showPanel ? 'NOT_CONNECTED' : 'HIDDEN'
        }
    });

});

parcelRegister("kLuCE", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsIssueData", () => $0f5048f42dceadf8$export$7009ae149c507c45);

var $8O88z = parcelRequire("8O88z");

var $g9ECZ = parcelRequire("g9ECZ");

var $ddPfy = parcelRequire("ddPfy");
const $0f5048f42dceadf8$var$getSummaryItemCounts = (state)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $8O88z.SUMMARY_ITEMS).reduce((items, itemKey)=>{
        const summaryItem = (0, $ddPfy.summaryItemSelector)(state, itemKey);
        return summaryItem && typeof summaryItem.count === 'number' ? {
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...items,
            [`${itemKey}Count`]: summaryItem.count
        } : items;
    }, {});
const $0f5048f42dceadf8$var$updateInstanceTypeCounts = (instanceTypeCounts, // @ts-expect-error - TS2304 - Cannot find name 'ByInstanceType'.
byInstanceType)=>Object.keys(byInstanceType).reduce((counts, typeKey)=>{
        const typeCountKey = `${typeKey}Count`;
        const updatedCount = typeof counts[typeCountKey] === 'number' ? counts[typeCountKey] + byInstanceType[typeKey] : byInstanceType[typeKey];
        return {
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...counts,
            [typeCountKey]: updatedCount
        };
    }, instanceTypeCounts);
const $0f5048f42dceadf8$var$getInstanceTypeCounts = (state)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $8O88z.SUMMARY_ITEMS).reduce((instanceTypeCounts, itemKey)=>{
        const summaryItem = (0, $ddPfy.summaryItemSelector)(state, itemKey);
        return summaryItem && summaryItem.byInstanceType && typeof summaryItem.byInstanceType === 'object' ? $0f5048f42dceadf8$var$updateInstanceTypeCounts(instanceTypeCounts, summaryItem.byInstanceType) : instanceTypeCounts;
    }, {});
const $0f5048f42dceadf8$export$7009ae149c507c45 = (state)=>({
        ...$0f5048f42dceadf8$var$getSummaryItemCounts(state),
        ...$0f5048f42dceadf8$var$getInstanceTypeCounts(state),
        issueId: (0, $g9ECZ.issueIdSelector)(state),
        issueStatusCategory: (0, $g9ECZ.issueStatusCategorySelector)(state),
        projectId: (0, $g9ECZ.projectIdSelector)(state),
        projectType: (0, $g9ECZ.projectTypeSelector)(state),
        nextGenProject: (0, $g9ECZ.isSimplifiedProjectSelector)(state),
        analyticsSource: (0, $g9ECZ.analyticsSourceSelector)(state),
        isSiteAdmin: (0, $g9ECZ.isSiteAdminSelector)(state),
        isEmptyStateEnabled: true
    });

});
parcelRegister("8O88z", function(module, exports) {

$parcel$export(module.exports, "SUMMARY_ITEM_BRANCH", () => $71de90d4e8898519$export$f8cedd52860eb0c6);
$parcel$export(module.exports, "SUMMARY_ITEM_BUILD", () => $71de90d4e8898519$export$6b8ec8efdecdf53a);
$parcel$export(module.exports, "SUMMARY_ITEM_COMMIT", () => $71de90d4e8898519$export$befef22dc4a207fa);
$parcel$export(module.exports, "SUMMARY_ITEM_DEPLOYMENT", () => $71de90d4e8898519$export$142531b80687303b);
$parcel$export(module.exports, "SUMMARY_ITEM_REMOTE_LINKS", () => $71de90d4e8898519$export$c291fab954691bf6);
$parcel$export(module.exports, "SUMMARY_ITEM_PULLREQUEST", () => $71de90d4e8898519$export$2ca8301ae4f309cb);
$parcel$export(module.exports, "SUMMARY_ITEM_REVIEW", () => $71de90d4e8898519$export$e1520d4b87b6e628);
$parcel$export(module.exports, "SUMMARY_ITEM_FEATURE_FLAGS", () => $71de90d4e8898519$export$14c52f7179b512b3);
$parcel$export(module.exports, "OAUTH_ANALYTICS_TYPE", () => $71de90d4e8898519$export$f231da52e4714b2f);
$parcel$export(module.exports, "SUMMARY_ITEMS", () => $71de90d4e8898519$export$fbab704f516d97ea);
const $71de90d4e8898519$export$f8cedd52860eb0c6 = 'branch';
const $71de90d4e8898519$export$6b8ec8efdecdf53a = 'build';
const $71de90d4e8898519$export$befef22dc4a207fa = 'commit';
const $71de90d4e8898519$export$142531b80687303b = 'deployment';
const $71de90d4e8898519$export$c291fab954691bf6 = 'remote-links';
const $71de90d4e8898519$export$2ca8301ae4f309cb = 'pullrequest';
const $71de90d4e8898519$export$e1520d4b87b6e628 = 'review';
const $71de90d4e8898519$export$14c52f7179b512b3 = 'feature-flags';
const $71de90d4e8898519$export$f231da52e4714b2f = 'oAuth';
const $71de90d4e8898519$export$fbab704f516d97ea = [
    $71de90d4e8898519$export$f8cedd52860eb0c6,
    $71de90d4e8898519$export$6b8ec8efdecdf53a,
    $71de90d4e8898519$export$befef22dc4a207fa,
    $71de90d4e8898519$export$142531b80687303b,
    $71de90d4e8898519$export$2ca8301ae4f309cb,
    $71de90d4e8898519$export$e1520d4b87b6e628
];

});

parcelRegister("g9ECZ", function(module, exports) {

$parcel$export(module.exports, "issueIdSelector", () => $304ade07260fbdde$export$31efbca30077ec1e);
$parcel$export(module.exports, "issueAriSelector", () => $304ade07260fbdde$export$a2cdbba2136e72d3);
$parcel$export(module.exports, "issueKeySelector", () => $304ade07260fbdde$export$d22bc6271070f453);
$parcel$export(module.exports, "issueStatusCategorySelector", () => $304ade07260fbdde$export$a10c82b15d578e5c);
$parcel$export(module.exports, "projectIdSelector", () => $304ade07260fbdde$export$4c9d6034f65d22f4);
$parcel$export(module.exports, "projectTypeSelector", () => $304ade07260fbdde$export$69316f88206ca90b);
$parcel$export(module.exports, "isSimplifiedProjectSelector", () => $304ade07260fbdde$export$d94d544d4b2e1310);
$parcel$export(module.exports, "analyticsSourceSelector", () => $304ade07260fbdde$export$85a9d212d56669b4);
$parcel$export(module.exports, "isSiteAdminSelector", () => $304ade07260fbdde$export$69b767f18b3bb094);
$parcel$export(module.exports, "projectAriSelector", () => $304ade07260fbdde$export$5106f43689b4a85c);
$parcel$export(module.exports, "isJiraAdminSelector", () => $304ade07260fbdde$export$7562da76c85fc278);

var $ahm5r = parcelRequire("ahm5r");
const $304ade07260fbdde$var$contextSelector = (state)=>state.context;
const $304ade07260fbdde$export$f7b7935883444b11 = (0, $ahm5r.createSelector)($304ade07260fbdde$var$contextSelector, (context)=>context.locale);
const $304ade07260fbdde$export$31efbca30077ec1e = (0, $ahm5r.createSelector)($304ade07260fbdde$var$contextSelector, (context)=>context.issueId);
const $304ade07260fbdde$export$a2cdbba2136e72d3 = (0, $ahm5r.createSelector)($304ade07260fbdde$var$contextSelector, (context)=>context.issueAri);
const $304ade07260fbdde$export$d22bc6271070f453 = (0, $ahm5r.createSelector)($304ade07260fbdde$var$contextSelector, (context)=>context.issueKey);
const $304ade07260fbdde$export$a10c82b15d578e5c = (0, $ahm5r.createSelector)($304ade07260fbdde$var$contextSelector, (context)=>context.issueStatusCategory);
const $304ade07260fbdde$export$4c9d6034f65d22f4 = (0, $ahm5r.createSelector)($304ade07260fbdde$var$contextSelector, (context)=>context.projectId);
const $304ade07260fbdde$export$69316f88206ca90b = (0, $ahm5r.createSelector)($304ade07260fbdde$var$contextSelector, (context)=>context.projectType);
const $304ade07260fbdde$export$d94d544d4b2e1310 = (0, $ahm5r.createSelector)($304ade07260fbdde$var$contextSelector, (context)=>context.nextGenProject);
const $304ade07260fbdde$export$85a9d212d56669b4 = (0, $ahm5r.createSelector)($304ade07260fbdde$var$contextSelector, (context)=>context.analyticsSource);
const $304ade07260fbdde$export$69b767f18b3bb094 = (0, $ahm5r.createSelector)($304ade07260fbdde$var$contextSelector, (context)=>context.isSiteAdmin);
const $304ade07260fbdde$export$5106f43689b4a85c = (0, $ahm5r.createSelector)($304ade07260fbdde$var$contextSelector, (context)=>context.projectAri);
const $304ade07260fbdde$export$7562da76c85fc278 = (0, $ahm5r.createSelector)($304ade07260fbdde$var$contextSelector, (context)=>context.isJiraAdmin);

});

parcelRegister("ddPfy", function(module, exports) {

$parcel$export(module.exports, "panelStateSelector", () => $83ac5f0f3091aa67$export$4db67466d2142ff6);
$parcel$export(module.exports, "summarySectionMessageSelector", () => $83ac5f0f3091aa67$export$6288a95dc1e9fa82);
$parcel$export(module.exports, "hasBranchCapabilitiesSelector", () => $83ac5f0f3091aa67$export$ce27eee7f896f3ec);
$parcel$export(module.exports, "branchSelector", () => $83ac5f0f3091aa67$export$f6e2a4674b29f42d);
$parcel$export(module.exports, "summaryItemSelector", () => $83ac5f0f3091aa67$export$279a9274584d53c7);
$parcel$export(module.exports, "reviewSummaryItemSelector", () => $83ac5f0f3091aa67$export$906faa0920af59ca);
$parcel$export(module.exports, "buildSummaryItemSelector", () => $83ac5f0f3091aa67$export$827121cd798e25c0);
$parcel$export(module.exports, "deploymentSummaryItemSelector", () => $83ac5f0f3091aa67$export$ec75155dea010df);
$parcel$export(module.exports, "pullRequestSummaryItemSelector", () => $83ac5f0f3091aa67$export$244b92a64afca3ee);
$parcel$export(module.exports, "commitSummaryItemSelector", () => $83ac5f0f3091aa67$export$76e3496587cae227);
$parcel$export(module.exports, "errorsSelector", () => $83ac5f0f3091aa67$export$3c37ade598c5e9ac);
$parcel$export(module.exports, "configErrorsSelector", () => $83ac5f0f3091aa67$export$1289f902b7edde01);
$parcel$export(module.exports, "hasSummaryItemsSelector", () => $83ac5f0f3091aa67$export$549de3bd56af64bd);
$parcel$export(module.exports, "hasSummaryInformationSelector", () => $83ac5f0f3091aa67$export$7b03622ad1f8cf49);
$parcel$export(module.exports, "legacyDataInformationSelector", () => $83ac5f0f3091aa67$export$8ced1f44c2c172d0);
$parcel$export(module.exports, "detailsHasInstanceErrorsSelector", () => $83ac5f0f3091aa67$export$dc780f3efd24e350);
$parcel$export(module.exports, "isEmptyStateDialogShownSelector", () => $83ac5f0f3091aa67$export$2e400ffeacd51ab7);
$parcel$export(module.exports, "createBranchTargetsSelector", () => $83ac5f0f3091aa67$export$6c6618802c6368cd);
$parcel$export(module.exports, "hasCreateBranchTargetsSelector", () => $83ac5f0f3091aa67$export$8513b5682faea8d1);
$parcel$export(module.exports, "hasDevelopmentDataInProjectSelector", () => $83ac5f0f3091aa67$export$298b0b6799269967);
$parcel$export(module.exports, "isLoadingDevPanelSelector", () => $83ac5f0f3091aa67$export$ee4172fcbc68a753);

var $ahm5r = parcelRequire("ahm5r");

var $8O88z = parcelRequire("8O88z");
const $83ac5f0f3091aa67$var$entitiesSelector = (state)=>state.entities;
const $83ac5f0f3091aa67$export$1e24ad2b2f2c3fc1 = (0, $ahm5r.createSelector)([
    $83ac5f0f3091aa67$var$entitiesSelector
], (entities)=>entities.devPanel);
const $83ac5f0f3091aa67$export$4db67466d2142ff6 = (0, $ahm5r.createSelector)($83ac5f0f3091aa67$export$1e24ad2b2f2c3fc1, (devPanel)=>devPanel.panelState);
const $83ac5f0f3091aa67$export$6288a95dc1e9fa82 = (0, $ahm5r.createSelector)($83ac5f0f3091aa67$export$1e24ad2b2f2c3fc1, (devPanel)=>devPanel.showSummarySectionMessage);
/* Summary selectors */ const $83ac5f0f3091aa67$var$hasSummaryItemWithPositiveCount = (summary)=>(0, $8O88z.SUMMARY_ITEMS).some(// @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2532 - Object is possibly 'undefined'.
    (item)=>summary[item] && summary[item].count != null && summary[item].count > 0);
const $83ac5f0f3091aa67$var$hasItems = (items)=>!!(items && items.length);
const $83ac5f0f3091aa67$var$entitiesSummarySelector = (0, $ahm5r.createSelector)($83ac5f0f3091aa67$export$1e24ad2b2f2c3fc1, (devPanel)=>devPanel.summary);
const $83ac5f0f3091aa67$export$ce27eee7f896f3ec = (0, $ahm5r.createSelector)($83ac5f0f3091aa67$export$1e24ad2b2f2c3fc1, (devPanel)=>devPanel.hasBranchCapabilities);
const $83ac5f0f3091aa67$export$f6e2a4674b29f42d = (0, $ahm5r.createSelector)($83ac5f0f3091aa67$var$entitiesSummarySelector, (summary)=>{
    if (summary.branch) return summary.branch;
    return null;
});
const $83ac5f0f3091aa67$export$279a9274584d53c7 = (0, $ahm5r.createSelector)(// @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'State'.
(state)=>$83ac5f0f3091aa67$var$entitiesSummarySelector(state), // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
(state, itemType)=>itemType, (summary, itemType)=>{
    if (summary[itemType]) return summary[itemType];
    return null;
});
const $83ac5f0f3091aa67$export$906faa0920af59ca = (0, $ahm5r.createSelector)($83ac5f0f3091aa67$var$entitiesSummarySelector, (summary)=>summary[0, $8O88z.SUMMARY_ITEM_REVIEW]);
const $83ac5f0f3091aa67$export$827121cd798e25c0 = (0, $ahm5r.createSelector)($83ac5f0f3091aa67$var$entitiesSummarySelector, (summary)=>summary[0, $8O88z.SUMMARY_ITEM_BUILD]);
const $83ac5f0f3091aa67$export$ec75155dea010df = (0, $ahm5r.createSelector)($83ac5f0f3091aa67$var$entitiesSummarySelector, (summary)=>summary[0, $8O88z.SUMMARY_ITEM_DEPLOYMENT]);
const $83ac5f0f3091aa67$export$244b92a64afca3ee = (0, $ahm5r.createSelector)($83ac5f0f3091aa67$var$entitiesSummarySelector, (summary)=>summary[0, $8O88z.SUMMARY_ITEM_PULLREQUEST]);
const $83ac5f0f3091aa67$export$76e3496587cae227 = (0, $ahm5r.createSelector)($83ac5f0f3091aa67$var$entitiesSummarySelector, (summary)=>summary[0, $8O88z.SUMMARY_ITEM_COMMIT]);
const $83ac5f0f3091aa67$export$3c37ade598c5e9ac = (0, $ahm5r.createSelector)($83ac5f0f3091aa67$var$entitiesSummarySelector, (summary)=>summary.errors);
const $83ac5f0f3091aa67$export$1289f902b7edde01 = (0, $ahm5r.createSelector)($83ac5f0f3091aa67$var$entitiesSummarySelector, (summary)=>summary.configErrors);
const $83ac5f0f3091aa67$export$549de3bd56af64bd = (0, $ahm5r.createSelector)($83ac5f0f3091aa67$var$entitiesSummarySelector, (summary)=>!!$83ac5f0f3091aa67$var$hasSummaryItemWithPositiveCount(summary));
const $83ac5f0f3091aa67$var$hasSummaryErrorsSelector = (0, $ahm5r.createSelector)($83ac5f0f3091aa67$var$entitiesSummarySelector, (summary)=>!!(summary && ($83ac5f0f3091aa67$var$hasItems(summary.errors) || $83ac5f0f3091aa67$var$hasItems(summary.configErrors))));
const $83ac5f0f3091aa67$export$7b03622ad1f8cf49 = (0, $ahm5r.createSelector)($83ac5f0f3091aa67$export$549de3bd56af64bd, $83ac5f0f3091aa67$var$hasSummaryErrorsSelector, (hasSummaryItems, hasSummaryErrors)=>hasSummaryItems || hasSummaryErrors);
const $83ac5f0f3091aa67$export$8ced1f44c2c172d0 = (0, $ahm5r.createSelector)($83ac5f0f3091aa67$var$entitiesSummarySelector, (summary)=>summary && summary?.legacyResponseData?.summary);
const $83ac5f0f3091aa67$export$922f0e499aac2772 = (0, $ahm5r.createSelector)($83ac5f0f3091aa67$var$entitiesSummarySelector, (summary)=>!!summary.branch?.count);
const $83ac5f0f3091aa67$export$e648fd5b118a44e9 = (0, $ahm5r.createSelector)($83ac5f0f3091aa67$var$entitiesSummarySelector, (summary)=>!!summary.pullrequest?.count);
const $83ac5f0f3091aa67$export$dc780f3efd24e350 = (0, $ahm5r.createSelector)($83ac5f0f3091aa67$var$entitiesSummarySelector, (summary)=>!!summary.detailsHasInstanceErrors);
const $83ac5f0f3091aa67$export$2e400ffeacd51ab7 = (0, $ahm5r.createSelector)($83ac5f0f3091aa67$var$entitiesSelector, (entities)=>entities.isEmptyStateDialogShown);
const $83ac5f0f3091aa67$export$6c6618802c6368cd = (0, $ahm5r.createSelector)($83ac5f0f3091aa67$var$entitiesSelector, (entities)=>entities.createBranchTargets);
const $83ac5f0f3091aa67$export$8513b5682faea8d1 = (0, $ahm5r.createSelector)($83ac5f0f3091aa67$export$6c6618802c6368cd, (targets)=>!!(targets && targets.length > 0));
const $83ac5f0f3091aa67$export$298b0b6799269967 = (0, $ahm5r.createSelector)($83ac5f0f3091aa67$export$1e24ad2b2f2c3fc1, (devPanel)=>devPanel.hasDevelopmentDataInProject);
const $83ac5f0f3091aa67$export$ee4172fcbc68a753 = (0, $ahm5r.createSelector)($83ac5f0f3091aa67$var$entitiesSelector, (entities)=>entities.isLoading);

});




parcelRegister("07c9r", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $72619854871854c5$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $72619854871854c5$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

var $4qiFT = parcelRequire("4qiFT");

var $jsi4K = parcelRequire("jsi4K");
const $72619854871854c5$export$d4c72bab9d6cc13a = (0, $iWqim.freeze)({
    issueId: '',
    issueKey: '',
    issueStatusCategory: '',
    projectId: '',
    projectType: '',
    analyticsSource: null,
    locale: (0, $4qiFT.defaultLocale),
    isSiteAdmin: false,
    issueAri: '',
    nextGenProject: false,
    projectAri: '',
    isJiraAdmin: false
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$72619854871854c5$export$2e2bcd8739ae039 = (state = $72619854871854c5$export$d4c72bab9d6cc13a, action)=>{
    const { type: type, payload: payload } = action;
    switch(type){
        case 0, $jsi4K.SET_CONTEXT:
            return (0, $iWqim.freeze)({
                ...state,
                ...payload
            });
        default:
            return state;
    }
};

});
parcelRegister("jsi4K", function(module, exports) {

$parcel$export(module.exports, "SET_CONTEXT", () => $8dfe6f721a893c5c$export$4bc4e62e7d72b94b);
$parcel$export(module.exports, "setContext", () => $8dfe6f721a893c5c$export$2f04de43fe27971a);
const $8dfe6f721a893c5c$export$4bc4e62e7d72b94b = 'SET_CONTEXT';
const $8dfe6f721a893c5c$export$2f04de43fe27971a = (context)=>({
        type: $8dfe6f721a893c5c$export$4bc4e62e7d72b94b,
        payload: context
    });

});


parcelRegister("iutjY", function(module, exports) {

$parcel$export(module.exports, "fetchDevPanel", () => $8cdda72884485b54$export$90fc97eda5e40724);
$parcel$export(module.exports, "enrichDevPanelWithOneClickLinks", () => $8cdda72884485b54$export$9f99316f0f0eb5f);
parcelRequire("1AyD5");
parcelRequire("9BkTq");
parcelRequire("b0lv4");
parcelRequire("hfuHK");
parcelRequire("1o2WJ");
parcelRequire("c1D7V");
parcelRequire("d2zWP");

var $2InI0 = parcelRequire("2InI0");

var $8XZn3 = parcelRequire("8XZn3");

var $7kixv = parcelRequire("7kixv");

var $jN7Dt = parcelRequire("jN7Dt");

var $eSnSE = parcelRequire("eSnSE");

var $8O88z = parcelRequire("8O88z");

var $gYnSx = parcelRequire("gYnSx");

var $gCeeo = parcelRequire("gCeeo");

var $dA5Z8 = parcelRequire("dA5Z8");

var $glpJZ = parcelRequire("glpJZ");

var $gHrsg = parcelRequire("gHrsg");

var $9wJd0 = parcelRequire("9wJd0");

var $g9ECZ = parcelRequire("g9ECZ");

var $ikKUs = parcelRequire("ikKUs");
const $8cdda72884485b54$export$2cca46dea398dd67 = ()=>(0, $2InI0.default)((0, $8XZn3.default)(new Date(), {
        weeks: 6
    })).toISOString();
const $8cdda72884485b54$export$90fc97eda5e40724 = (action$, store)=>action$.ofType((0, $ikKUs.FETCH_DEV_PANEL_REQUEST)).switchMap(({ analyticsEvent: analyticsEvent })=>{
        (0, $dA5Z8.devPanelTimeToLoad).start();
        const state = store.getState();
        const issueAri = (0, $g9ECZ.issueAriSelector)(state);
        const issueId = (0, $g9ECZ.issueIdSelector)(state);
        const projectAri = (0, $g9ECZ.projectAriSelector)(state);
        const updatedFrom = $8cdda72884485b54$export$2cca46dea398dd67();
        const isJiraAdmin = (0, $g9ECZ.isJiraAdminSelector)(state);
        const isSiteAdmin = (0, $g9ECZ.isSiteAdminSelector)(state);
        return (0, $7kixv.Observable).zip((0, $glpJZ.fetchCreateBranchTargets)(issueId), (0, $9wJd0.fetchDevSummaryData)(issueAri), (0, $gHrsg.getHasDevelopmentDataInProject)(projectAri, updatedFrom, isJiraAdmin, isSiteAdmin), (createBranchTargets, { summary: summary, bannerType: bannerType, hasBranchCapabilities: hasBranchCapabilities, panelState: panelState }, hasDevelopmentDataInProject)=>(0, $ikKUs.fetchDevPanelSuccess)({
                summary: summary || undefined,
                panelState: panelState || undefined,
                bannerType: bannerType || undefined,
                hasBranchCapabilities: !!hasBranchCapabilities,
                createBranchTargets: createBranchTargets,
                hasDevelopmentDataInProject: hasDevelopmentDataInProject
            }, analyticsEvent)).catch(()=>{
            (0, $eSnSE.default).safeWarnWithoutCustomerData('issue.dev-panel.fetch.epic', 'Failed to fetch the devPanel');
            return (0, $7kixv.Observable).of((0, $ikKUs.fetchDevPanelFailure)(analyticsEvent));
        });
    });
const $8cdda72884485b54$export$622f497494fcce79 = (summaryBuilds)=>{
    let targetBuildStatesForOneClickUrl;
    if (summaryBuilds?.failedBuildCount === 1) targetBuildStatesForOneClickUrl = [
        'FAILED'
    ];
    else if (summaryBuilds?.failedBuildCount === 0 && summaryBuilds?.successfulBuildCount === 1) targetBuildStatesForOneClickUrl = [
        'SUCCESSFUL'
    ];
    else if (summaryBuilds?.failedBuildCount === 0 && summaryBuilds?.successfulBuildCount === 0 && summaryBuilds?.count === 1) targetBuildStatesForOneClickUrl = [
        'IN_PROGRESS',
        'PENDING',
        'CANCELLED',
        'UNKNOWN'
    ];
    else // empty means that the build summary item will show a count greater than 1. So don't look for url matching target build state.
    targetBuildStatesForOneClickUrl = [];
    return targetBuildStatesForOneClickUrl;
};
const $8cdda72884485b54$export$65ec12ccacbb4546 = (summary)=>{
    const branchesCount = summary[0, $8O88z.SUMMARY_ITEM_BRANCH]?.count ?? 0;
    const branchesStatisfied = branchesCount >= 1;
    return branchesStatisfied || summary[0, $8O88z.SUMMARY_ITEM_COMMIT]?.count === 1 || summary[0, $8O88z.SUMMARY_ITEM_PULLREQUEST]?.stateCount === 1 || $8cdda72884485b54$export$622f497494fcce79(summary[0, $8O88z.SUMMARY_ITEM_BUILD]).length !== 0;
};
const $8cdda72884485b54$export$9f99316f0f0eb5f = (action$, store)=>action$.ofType((0, $ikKUs.FETCH_DEV_PANEL_SUCCESS)).switchMap(({ payload: { summary: summary }, analyticsEvent: analyticsEvent })=>{
        const state = store.getState();
        const issueId = (0, $g9ECZ.issueIdSelector)(state);
        if (!summary || !$8cdda72884485b54$export$65ec12ccacbb4546(summary)) return (0, $7kixv.Observable).empty();
        return (0, $gHrsg.query)(issueId).map((details)=>{
            (0, $gCeeo.fireOperationalAnalytics)(// @ts-expect-error - Argument of type 'UIAnalyticsEvent | undefined' is not assignable to parameter of type 'UIAnalyticsEvent'.
            analyticsEvent, 'developmentDetailsSwagQuery.jiraDevelopmentSummaryDevelopmentField success');
            return (0, $ikKUs.fetchDevPanelUrlDetailsSuccess)(details);
        }).catch((e)=>{
            (0, $gYnSx.default)({
                error: e,
                event: analyticsEvent,
                meta: {
                    id: 'developmentDetailsSwagQuery',
                    packageName: 'jiraDevelopmentSummaryDevelopmentField',
                    teamName: 'nova'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return (0, $7kixv.Observable).empty();
        });
    });
const $8cdda72884485b54$export$8a87b6f1f86abbd0 = (action$)=>(0, $jN7Dt.default)().takeUntil(action$.ofType((0, $ikKUs.DEV_PANEL_UNMOUNTED))).switchMap((isVisible)=>{
        if (isVisible !== true) return (0, $7kixv.Observable).empty();
        return (0, $7kixv.Observable).of((0, $ikKUs.fetchDevPanelRequest)());
    });

});
parcelRegister("jN7Dt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2f3a0f960b97983$export$2e2bcd8739ae039);

var $7kixv = parcelRequire("7kixv");

var $6WhQS = parcelRequire("6WhQS");
parcelRequire("7SsGX");
parcelRequire("8rm0O");
parcelRequire("1o2WJ");

var $jzYet = parcelRequire("jzYet");
/**
 * Returns a stream of the current page visibility state whenever it changes.
 * Emits 'true' when the page is visible and 'false' when the page is hidden.
 *
 * Will emit `null` if document is not defined.
 *
 * This Observable WILL EMIT a value at the start of the load. If you're using
 * it to trigger refreshes, you should skip 1 value.
 */ const $a2f3a0f960b97983$var$getVisibility$ = ()=>// @ts-expect-error - TS2322 - Type 'Observable<unknown>' is not assignable to type 'Observable<boolean | null>'.
    typeof document !== 'undefined' ? (0, $7kixv.Observable).fromEvent(document, (0, $jzYet.supportedVisiblityEvent))// We want to send the current visibility on a new subscription.
    // If we use `.startWith(isPageVisible())` then new subscribers
    // will get the initial visibility at load and not the current
    // visibility as the initial value.
    .startWith(null).map((0, $jzYet.isPageVisible)) : new (0, $6WhQS.Subject)().startWith(null);
var $a2f3a0f960b97983$export$2e2bcd8739ae039 = $a2f3a0f960b97983$var$getVisibility$;

});

parcelRegister("dA5Z8", function(module, exports) {

$parcel$export(module.exports, "devPanelTimeToLoad", () => $23db30280083649e$export$5fdf275a85d26686);

var $hqYEY = parcelRequire("hqYEY");
const $23db30280083649e$export$5fdf275a85d26686 = (0, $hqYEY.metrics).interaction({
    key: 'devPanelApp.time-to.load',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '300_1000_2500_4000_7000_10000'
    }
});

});

parcelRegister("glpJZ", function(module, exports) {

$parcel$export(module.exports, "fetchCreateBranchTargets", () => $bd45d479d3e7c076$export$7b4e63bdbf1b6bf5);
parcelRequire("1o2WJ");

var $1K8u5 = parcelRequire("1K8u5");

var $b9iQ5 = parcelRequire("b9iQ5");
const $bd45d479d3e7c076$export$7b4e63bdbf1b6bf5 = (issueId)=>(0, $1K8u5.default)(`/rest/dev-status/1.0/issue/create-branch-targets?issueId=${issueId}`).map(// @ts-expect-error - TS2304 - Cannot find name 'RemoteAppResponse'.
    (response)=>(0, $b9iQ5.transformRemoteApps)(response));

});
parcelRegister("b9iQ5", function(module, exports) {

$parcel$export(module.exports, "transformRemoteApps", () => $0518dbb5211e245a$export$e4cc182e808e80ea);

var $gXu8g = parcelRequire("gXu8g");
const $0518dbb5211e245a$export$e4cc182e808e80ea = ({ remoteApps: remoteApps = [] })=>remoteApps.map((remoteApp)=>({
            ...remoteApp,
            url: remoteApp.url !== null && remoteApp.url !== undefined ? (0, $gXu8g.toSanitizedUrl)(remoteApp.url) : undefined
        })).filter((target)=>target.url);

});
parcelRegister("gXu8g", function(module, exports) {

$parcel$export(module.exports, "toSanitizedUrl", () => $97a86ecf43d11173$export$36fdccbdcd093523);

var $2Cxb3 = parcelRequire("2Cxb3");
const $97a86ecf43d11173$export$36fdccbdcd093523 = (url)=>(0, $2Cxb3.sanitizeUrl)(url);

});
parcelRegister("2Cxb3", function(module, exports) {
'use strict';
var $1e88ddb581a2ec8f$var$invalidPrototcolRegex = /^(%20|\s)*(javascript|data)/im;
var $1e88ddb581a2ec8f$var$ctrlCharactersRegex = /[^\x20-\x7E]/gmi;
var $1e88ddb581a2ec8f$var$urlSchemeRegex = /^([^:]+):/gm;
var $1e88ddb581a2ec8f$var$relativeFirstCharacters = [
    '.',
    '/'
];
function $1e88ddb581a2ec8f$var$isRelativeUrl(url) {
    return $1e88ddb581a2ec8f$var$relativeFirstCharacters.indexOf(url[0]) > -1;
}
function $1e88ddb581a2ec8f$var$sanitizeUrl(url) {
    if (!url) return 'about:blank';
    var urlScheme, urlSchemeParseResults;
    var sanitizedUrl = url.replace($1e88ddb581a2ec8f$var$ctrlCharactersRegex, '');
    if ($1e88ddb581a2ec8f$var$isRelativeUrl(sanitizedUrl)) return sanitizedUrl;
    urlSchemeParseResults = sanitizedUrl.match($1e88ddb581a2ec8f$var$urlSchemeRegex);
    if (!urlSchemeParseResults) return 'about:blank';
    urlScheme = urlSchemeParseResults[0];
    if ($1e88ddb581a2ec8f$var$invalidPrototcolRegex.test(urlScheme)) return 'about:blank';
    return sanitizedUrl;
}
module.exports = {
    sanitizeUrl: $1e88ddb581a2ec8f$var$sanitizeUrl
};

});




parcelRegister("gHrsg", function(module, exports) {

$parcel$export(module.exports, "query", () => $a2d9852e7883db9b$export$2fa187e846a241c4);
$parcel$export(module.exports, "getHasDevelopmentDataInProject", () => $a2d9852e7883db9b$export$13c6bf08097300d7);

var $cQPLC = parcelRequire("cQPLC");

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");
parcelRequire("1o2WJ");

var $7zZ4w = parcelRequire("7zZ4w");

var $cQPLC = parcelRequire("cQPLC");

var $awygH = parcelRequire("awygH");
const $a2d9852e7883db9b$var$OPERATION_NAME = 'DevSummaryPanelOneClickUrls';
const $a2d9852e7883db9b$var$innerQuery = ()=>`
    details {
        instanceTypes {
            id
            type
            devStatusErrorMessages
            repository {
                avatarUrl
                name
                branches {
                    createPullRequestUrl
                    name
                    url
                }
                commits{
                    url
                }
                pullRequests {
                    url
                    status
                }
            }
            danglingPullRequests {
                url
                status
            }
            buildProviders {
                id
                builds {
                    url
                    state
                }
            }
         }
    }
`;
const $a2d9852e7883db9b$var$swagGraphQLQuery = ()=>`
    query ${$a2d9852e7883db9b$var$OPERATION_NAME} ($issueId: ID!) {
        developmentInformation(issueId: $issueId){
            ${$a2d9852e7883db9b$var$innerQuery()}
        }
    }`;
const $a2d9852e7883db9b$export$2fa187e846a241c4 = (issueId)=>// @ts-expect-error - TS2322 - Type 'Observable<unknown>' is not assignable to type 'Observable<ResponseData>'.
    (0, $awygH.query$)('', $a2d9852e7883db9b$var$OPERATION_NAME, $a2d9852e7883db9b$var$swagGraphQLQuery(), {
        issueId: issueId
    }).map((result)=>({
            data: result
        })).map((result)=>{
        // @ts-expect-error - TS2339 Property 'errors' does not exist on type '{ data: ResponseData; }'.
        if (result.errors && result.errors.length) {
            // @ts-expect-error - TS2339 Property 'errors' does not exist on type '{ data: ResponseData; }'.
            const errorMessages = result.errors// @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
            .map((error)=>error.message)// @ts-expect-error - TS7006 - Parameter 'acc' implicitly has an 'any' type. | TS7006 - Parameter 'current' implicitly has an 'any' type.
            .reduce((acc, current)=>`${acc}\n ${current}`, '');
            throw Error(`Error retrieving url details from service: ${errorMessages}`);
        }
        return result;
    });
const $a2d9852e7883db9b$export$13c6bf08097300d7 = (projectAri, updatedFrom, isJiraAdmin, isSiteAdmin)=>{
    if (isJiraAdmin || isSiteAdmin) {
        const developmentDataQuery = (0, $cQPLC.default);
        const variables = {
            projectAri: projectAri,
            updatedFrom: updatedFrom
        };
        const request = (0, $j4oe4.fetchQuery)((0, $7zZ4w.default)(), developmentDataQuery, variables, {
            fetchPolicy: 'store-or-network'
        });
        /* fetchQuery will NOT retain the data for the query, meaning that it is not guaranteed that the
         data will remain saved in the Relay store at any point after the request completes. We need to
         explicitly retain the operation to ensure it doesn't get deleted. See https://relay.dev/docs/api-reference/fetch-query/#behavior */ (0, $7zZ4w.default)().retain((0, $37Ewn.createOperationDescriptor)((0, $cQPLC.default), variables));
        return request.toPromise().then((result)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const data = result;
            return (data?.devOps?.ariGraph?.branchRelationships?.nodes ?? []).length > 0 || (data?.devOps?.ariGraph?.buildRelationships?.nodes ?? []).length > 0 || (data?.devOps?.ariGraph?.prRelationships?.nodes ?? []).length > 0;
        });
    }
    return Promise.resolve(false);
};

});
parcelRegister("cQPLC", function(module, exports) {

$parcel$export(module.exports, "default", () => $172b188b0766257e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5b5fcd39ff155b4b7f81d42a73651366>>
 * @relayHash 92b74832e1427424c007d113f6dffd74
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 397fdbc6c0cc480189efdc0912beed08f87eb4ea62f247a0b2b871b55ab34b30
const $172b188b0766257e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "updatedFrom"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "from",
        "variableName": "projectAri"
    }, v2 = {
        "kind": "Variable",
        "name": "updatedFrom",
        "variableName": "updatedFrom"
    }, v3 = {
        "kind": "Literal",
        "name": "first",
        "value": 1
    }, v4 = [
        {
            "concreteType": "AriGraphRelationship",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        }
    ], v5 = [
        {
            "concreteType": "DevOps",
            "kind": "LinkedField",
            "name": "devOps",
            "plural": false,
            "selections": [
                {
                    "concreteType": "AriGraph",
                    "kind": "LinkedField",
                    "name": "ariGraph",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "branchRelationships",
                            "args": [
                                {
                                    "fields": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "project-associated-branch"
                                        },
                                        v2 /*: any*/ 
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "filter"
                                },
                                v3 /*: any*/ 
                            ],
                            "concreteType": "AriGraphRelationshipConnection",
                            "kind": "LinkedField",
                            "name": "relationships",
                            "plural": false,
                            "selections": v4 /*: any*/ 
                        },
                        {
                            "alias": "buildRelationships",
                            "args": [
                                {
                                    "fields": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "project-associated-build"
                                        },
                                        v2 /*: any*/ 
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "filter"
                                },
                                v3 /*: any*/ 
                            ],
                            "concreteType": "AriGraphRelationshipConnection",
                            "kind": "LinkedField",
                            "name": "relationships",
                            "plural": false,
                            "selections": v4 /*: any*/ 
                        },
                        {
                            "alias": "prRelationships",
                            "args": [
                                {
                                    "fields": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "project-associated-pr"
                                        },
                                        v2 /*: any*/ 
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "filter"
                                },
                                v3 /*: any*/ 
                            ],
                            "concreteType": "AriGraphRelationshipConnection",
                            "kind": "LinkedField",
                            "name": "relationships",
                            "plural": false,
                            "selections": v4 /*: any*/ 
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "detailsHasDevelopmentDataInProjectQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "detailsHasDevelopmentDataInProjectQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "id": "397fdbc6c0cc480189efdc0912beed08f87eb4ea62f247a0b2b871b55ab34b30",
            "metadata": {},
            "name": "detailsHasDevelopmentDataInProjectQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$172b188b0766257e$var$node.hash = "23fe9927a99afda98b0233664e8a0667";
var $172b188b0766257e$export$2e2bcd8739ae039 = $172b188b0766257e$var$node;

});

parcelRegister("awygH", function(module, exports) {

$parcel$export(module.exports, "query$", () => $4b886728d24867c4$export$a332dd84c3221bf2);

var $8KjEN = parcelRequire("8KjEN");
const $4b886728d24867c4$export$a332dd84c3221bf2 = (baseUrl, operationName, query, variables, analyticOptions)=>(0, $8KjEN.operation$)('query', baseUrl, operationName, query, variables, analyticOptions);

});
parcelRegister("8KjEN", function(module, exports) {

$parcel$export(module.exports, "operation$", () => $91585db99a196f15$export$cbc7c612df05bda);
parcelRequire("9BkTq");
parcelRequire("gdMGY");
parcelRequire("1ZbB9");
parcelRequire("7La6O");
parcelRequire("c1D7V");
parcelRequire("6cJUr");

var $9Dhvc = parcelRequire("9Dhvc");

var $cvRyD = parcelRequire("cvRyD");

var $7kixv = parcelRequire("7kixv");

var $aXKmr = parcelRequire("aXKmr");

var $hqYEY = parcelRequire("hqYEY");

var $eSnSE = parcelRequire("eSnSE");

var $2HRPu = parcelRequire("2HRPu");

var $1K8u5 = parcelRequire("1K8u5");

var $ee0TI = parcelRequire("ee0TI");

var $kIz4h = parcelRequire("kIz4h");

var $2Mqjh = parcelRequire("2Mqjh");

var $7jTnu = parcelRequire("7jTnu");

var $2gN4N = parcelRequire("2gN4N");

var $dkgjy = parcelRequire("dkgjy");
const $91585db99a196f15$var$sendOperationalEvent = (analyticKey, statusCode)=>{
    (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        // SSR doesn't have an analytics client
        if (!analyticsClient) return;
        let statusCodeFamily = 'unknown';
        if (statusCode !== null) {
            const statusCodeAsStr = String(statusCode);
            if (statusCodeAsStr === '0' || statusCodeAsStr === '429') // special status codes
            statusCodeFamily = statusCodeAsStr;
            else if (statusCodeAsStr.match(/^[12345][0-9]{2}$/)) statusCodeFamily = `${statusCodeAsStr[0]}xx`;
        }
        analyticsClient.sendOperationalEvent({
            action: 'fetch',
            actionSubject: 'swag operation',
            attributes: {
                key: analyticKey,
                statusCode: statusCode,
                statusCodeFamily: statusCodeFamily
            },
            source: 'swagOperation'
        });
    });
};
const $91585db99a196f15$var$onErrorSendOpEventAndCancelMark = (analyticKey, slo, statusCode, concurrentId, // eslint-disable-next-line @typescript-eslint/no-explicit-any
bm3Interaction)=>{
    if (analyticKey !== undefined) {
        // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        $91585db99a196f15$var$sendOperationalEvent(analyticKey, statusCode);
        if (bm3Interaction) bm3Interaction.cancel();
    }
};
const $91585db99a196f15$var$callSwag$ = ({ operationName: operationName, query: query, variables: variables, action: action, headersProcessor: headersProcessor })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let headers = {};
    // set empty xsrfToken for SSR as cookies are unavailable
    const xsrfToken = false ? '' : (0, $kIz4h.default)();
    if (action === 'mutation') {
        if (!xsrfToken) (0, $eSnSE.default).safeErrorWithoutCustomerData('board.xsrf-token.load.failure', 'XSRF Token failed to load');
        headers = {
            'atl-xsrf-token': xsrfToken
        };
    }
    return (0, $1K8u5.default)(`/jsw2/graphql?operation=${operationName}`, {
        method: 'POST',
        body: JSON.stringify({
            operationName: operationName,
            query: query,
            variables: variables
        }),
        headers: headers,
        headersProcessor: headersProcessor
    });
};
const $91585db99a196f15$export$cbc7c612df05bda = (action, baseUrl, operationName, query, variables, analyticOptions)=>{
    const { analyticKey: analyticKey, slo: slo, useBm3Interaction: useBm3Interaction, concurrentMetricDefinition: concurrentMetricDefinition } = analyticOptions || {};
    let traceId = '';
    const headersProcessor = (headers)=>{
        traceId = headers.get((0, $ee0TI.TRACE_ID_HEADER)) || '';
    };
    const concurrentId = (0, $aXKmr.v4)();
    let bm3Interaction = null;
    if (analyticKey && useBm3Interaction) bm3Interaction = (0, $hqYEY.metrics).interaction({
        key: analyticKey,
        // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
        histogram: {
            result: '1000_2000_3000_4000_5000_6000'
        }
    });
    return (0, $7kixv.Observable).defer(()=>{
        if (bm3Interaction) bm3Interaction.start();
        if (concurrentMetricDefinition !== undefined) concurrentMetricDefinition(concurrentId).start();
        return $91585db99a196f15$var$callSwag$({
            baseUrl: baseUrl,
            operationName: operationName,
            query: query,
            variables: variables,
            action: action,
            headersProcessor: headersProcessor
        });
    }).catch((error)=>{
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
            'statusCode'
        ], null);
        const isRetryStatusCode = [
            502,
            503,
            504
        ].includes(Number(statusCode));
        if (isRetryStatusCode && action === 'query') return $91585db99a196f15$var$callSwag$({
            baseUrl: baseUrl,
            operationName: operationName,
            query: query,
            variables: variables,
            action: action,
            headersProcessor: headersProcessor
        }).do(()=>{
            (0, $dkgjy.logRestRetry)({
                queryName: operationName,
                statusCode: statusCode,
                isRetrySuccessful: true,
                retryStatusCode: null
            });
        }, (retryError)=>{
            const retryStatusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(retryError, [
                'statusCode'
            ], null);
            (0, $dkgjy.logRestRetry)({
                queryName: operationName,
                statusCode: statusCode,
                isRetrySuccessful: false,
                retryStatusCode: retryStatusCode
            });
        });
        // throw exception to the next level
        return (0, $7kixv.Observable).throw(error);
    })// catch network error
    .catch((error)=>{
        const e = (0, (/*@__PURE__*/$parcel$interopDefault($cvRyD)))(error) ? error.message : `[unknown error] = ${JSON.stringify(error)}`;
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
            'statusCode'
        ], null);
        const errorName = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
            'name'
        ], null);
        const swagError = new (0, $2gN4N.SwagError)({
            networkError: error,
            traceId: traceId
        });
        const hash = (0, $2HRPu.getErrorHash)(swagError);
        (0, $dkgjy.logRestNetworkError)(e, statusCode, operationName, errorName, hash);
        $91585db99a196f15$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, statusCode, concurrentId, bm3Interaction);
        return (0, $7kixv.Observable).throw(swagError);
    }).flatMap((response)=>{
        if (!response || !response.data) (0, $dkgjy.logRestParsingError)('empty response.data', operationName);
        try {
            // SWAG errors from response
            if (response.errors) {
                if (response.errors.length > 100) {
                    if ((0, $7jTnu.fg)('tnk_try_to_mitigate_unknown_backlog_errors')) {
                        const errorWithMaxStatusCode = response.errors.filter((error)=>error.extensions?.statusCode).reduce((currentMax, current)=>{
                            const currentStatusCode = Number((0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(current, [
                                'extensions',
                                'statusCode'
                            ]));
                            const maxStatusCode = currentMax ? Number((0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(currentMax, [
                                'extensions',
                                'statusCode'
                            ])) : 0;
                            return currentStatusCode > maxStatusCode ? current : currentMax;
                        }, null);
                        const statusCode = Number(errorWithMaxStatusCode?.extensions?.statusCode) || null;
                        let genericMessage = `Too many Errors in response for ${operationName} (${response.errors.length} errors)`;
                        if (errorWithMaxStatusCode) genericMessage += `. With highest status code error message of: "${errorWithMaxStatusCode.message}"`;
                        (0, $dkgjy.logRestError)([
                            genericMessage
                        ], null, operationName, 'too-many-errors');
                        $91585db99a196f15$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, null, concurrentId, bm3Interaction);
                        return (0, $7kixv.Observable).throw(new (0, $2gN4N.SwagError)({
                            graphQLErrors: [
                                {
                                    message: genericMessage,
                                    path: [
                                        genericMessage
                                    ],
                                    extensions: {
                                        statusCode: statusCode,
                                        errorType: 'too-many-errors'
                                    }
                                }
                            ],
                            traceId: traceId
                        }));
                    }
                    const genericMessage = `Too many Errors in response for ${operationName}`;
                    (0, $dkgjy.logRestError)([
                        genericMessage
                    ], null, operationName, 'too-many-errors');
                    $91585db99a196f15$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, null, concurrentId, bm3Interaction);
                    return (0, $7kixv.Observable).throw(new (0, $2gN4N.SwagError)({
                        graphQLErrors: [
                            {
                                message: genericMessage,
                                path: [
                                    genericMessage
                                ],
                                extensions: {
                                    statusCode: null,
                                    errorType: 'too-many-errors'
                                }
                            }
                        ],
                        traceId: traceId
                    }));
                }
                const payload = response.errors.map((e)=>{
                    const { path: path, message: message } = e;
                    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(e, [
                        'extensions',
                        'statusCode'
                    ], null);
                    const errorType = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(e, [
                        'extensions',
                        'errorType'
                    ], undefined);
                    const userMessage = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(e, [
                        'extensions',
                        'userMessage'
                    ], undefined);
                    (0, $dkgjy.logRestError)(path, statusCode, operationName, errorType);
                    $91585db99a196f15$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, statusCode, concurrentId, bm3Interaction);
                    return {
                        message: message,
                        path: path,
                        extensions: {
                            statusCode: statusCode ? Number(statusCode) : null,
                            errorType: errorType,
                            userMessage: userMessage
                        }
                    };
                });
                return (0, $7kixv.Observable).throw(new (0, $2gN4N.SwagError)({
                    graphQLErrors: payload,
                    traceId: traceId
                }));
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const e = (0, (/*@__PURE__*/$parcel$interopDefault($cvRyD)))(error) ? error.message : `[unknown error] = ${JSON.stringify(error)}`;
            (0, $dkgjy.logRestParsingError)(e, operationName);
            $91585db99a196f15$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, 'unknown', concurrentId, bm3Interaction);
            throw error;
        }
        if (analyticKey !== undefined) {
            // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Response<Data>'.
            $91585db99a196f15$var$sendOperationalEvent(analyticKey, response.statusCode ?? '200');
            if (bm3Interaction) bm3Interaction.stop();
            if (concurrentMetricDefinition !== undefined) concurrentMetricDefinition(concurrentId).stop();
        }
        return (0, $7kixv.Observable).of(response.data);
    });
};

});
parcelRegister("2gN4N", function(module, exports) {

$parcel$export(module.exports, "SwagError", () => $e8e7240ff6817e0f$export$c6b77322a15ada4f);
$parcel$export(module.exports, "isJson", () => $e8e7240ff6817e0f$export$952e1d8683e4d0c4);
$parcel$export(module.exports, "isFetchError", () => $e8e7240ff6817e0f$export$96f7e6db4105d70c);
$parcel$export(module.exports, "isSwagError", () => $e8e7240ff6817e0f$export$7d7253f3a1a7c031);

var $1uIew = parcelRequire("1uIew");
const $e8e7240ff6817e0f$var$generateErrorMessage = (err)=>{
    let message = '';
    // If we have GraphQL errors present, add that to the error message.
    if (Array.isArray(err.graphQLErrors) && err.graphQLErrors.length !== 0) err.graphQLErrors.forEach((graphQLError)=>{
        const errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += `GraphQL error: ${errorMessage}\n`;
    });
    if (err.networkError) message += `Network error: ${err.networkError.message}\n`;
    // strip newline from the end of the message
    message = message.replace(/\n$/, '');
    return message;
};
class $e8e7240ff6817e0f$export$c6b77322a15ada4f extends Error {
    constructor({ graphQLErrors: graphQLErrors, networkError: networkError, errorMessage: errorMessage, traceId: traceId = '' }){
        super(errorMessage), this.graphQLErrors = [], this.networkError = null, // SWAG trace id, extracted from "atl-traceid" response-header
        // Helps to find relevant error in SWAG logs
        this.traceId = '';
        this.graphQLErrors = graphQLErrors || [];
        this.networkError = networkError || null;
        if (!errorMessage) this.message = $e8e7240ff6817e0f$var$generateErrorMessage(this);
        else this.message = errorMessage;
        this.name = this.constructor.name;
        this.traceId = traceId;
        this.cause = networkError || graphQLErrors?.[0];
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(this.message).stack;
    }
    skipSentry() {
        return this.networkError != null || this.graphQLErrors.length > 0;
    }
}
const $e8e7240ff6817e0f$export$952e1d8683e4d0c4 = (value)=>{
    try {
        JSON.parse(value);
    } catch (e) {
        return false;
    }
    return true;
};
const $e8e7240ff6817e0f$export$96f7e6db4105d70c = (error)=>error !== null && typeof error === 'object' && error instanceof (0, $1uIew.default);
const $e8e7240ff6817e0f$export$7d7253f3a1a7c031 = (error)=>{
    if (error !== null && typeof error === 'object' && error instanceof $e8e7240ff6817e0f$export$c6b77322a15ada4f) return 'graphQLErrors' in error || 'networkError' in error;
    return false;
};

});

parcelRegister("dkgjy", function(module, exports) {

$parcel$export(module.exports, "logApolloError", () => $98cdc1f8cbd0aee9$export$2c9c775c9aa1863d);
$parcel$export(module.exports, "logApolloNetworkError", () => $98cdc1f8cbd0aee9$export$45c096492076b53a);
$parcel$export(module.exports, "logRestError", () => $98cdc1f8cbd0aee9$export$9a40393cdc64dc7d);
$parcel$export(module.exports, "logRestNetworkError", () => $98cdc1f8cbd0aee9$export$b2eb9fe68368f77d);
$parcel$export(module.exports, "logRestParsingError", () => $98cdc1f8cbd0aee9$export$25d52be9f4671e9e);
$parcel$export(module.exports, "logRestRetry", () => $98cdc1f8cbd0aee9$export$e8ce08d55ac713ef);
$parcel$export(module.exports, "logApolloRetry", () => $98cdc1f8cbd0aee9$export$3e50530825dee9d1);

var $eSnSE = parcelRequire("eSnSE");
const $98cdc1f8cbd0aee9$var$logError = (type, m, extra)=>{
    const { message: message, path: path, queryName: queryName, statusCode: statusCode, errorType: errorType, errorName: errorName, hash: hash } = extra;
    const params = {
        message: message || '',
        path: JSON.stringify(path || []),
        statusCode: String(statusCode || '[unknown]'),
        queryName: queryName,
        errorType: errorType ? String(errorType) : '',
        errorName: errorName ? String(errorName) : '',
        hash: hash
    };
    return (0, $eSnSE.default).safeErrorWithoutCustomerData(type, m, params);
};
const $98cdc1f8cbd0aee9$var$SwagErrorPlaceholder = '[errors in SWAG response]';
const $98cdc1f8cbd0aee9$export$2c9c775c9aa1863d = (path, statusCode, queryName, errorType)=>$98cdc1f8cbd0aee9$var$logError('apollo.swag.error.graphql', '[GraphQL error]', {
        message: $98cdc1f8cbd0aee9$var$SwagErrorPlaceholder,
        path: path,
        statusCode: statusCode,
        queryName: queryName,
        errorType: errorType
    });
const $98cdc1f8cbd0aee9$export$45c096492076b53a = (networkError, statusCode, queryName)=>{
    $98cdc1f8cbd0aee9$var$logError('apollo.swag.error.network', '[Network error]', {
        message: `[Network error]: ${networkError}`,
        statusCode: statusCode,
        queryName: queryName
    });
};
const $98cdc1f8cbd0aee9$export$9a40393cdc64dc7d = (path, statusCode, queryName, errorType)=>{
    $98cdc1f8cbd0aee9$var$logError('rest.swag.error.graphql', '[GraphQL error]', {
        message: $98cdc1f8cbd0aee9$var$SwagErrorPlaceholder,
        path: path,
        statusCode: statusCode,
        queryName: queryName,
        errorType: errorType
    });
};
const $98cdc1f8cbd0aee9$export$b2eb9fe68368f77d = (networkError, statusCode, queryName, errorName, hash)=>{
    $98cdc1f8cbd0aee9$var$logError('rest.swag.error.network', '[Network error]', {
        message: `[Network error]: ${networkError}`,
        statusCode: statusCode,
        queryName: queryName,
        errorName: errorName,
        hash: hash
    });
};
const $98cdc1f8cbd0aee9$export$25d52be9f4671e9e = (error, queryName)=>{
    $98cdc1f8cbd0aee9$var$logError('rest.swag.error.parsing', '[Parsing error]', {
        message: `[Parsing error]: ${error}`,
        queryName: queryName
    });
};
const $98cdc1f8cbd0aee9$export$e8ce08d55ac713ef = ({ queryName: queryName, statusCode: statusCode, isRetrySuccessful: isRetrySuccessful, retryStatusCode: retryStatusCode })=>(0, $eSnSE.default).safeErrorWithoutCustomerData('rest.swag.retry', '[Retry]', {
        queryName: queryName,
        statusCode: statusCode || '',
        isRetrySuccessful: String(isRetrySuccessful),
        retryStatusCode: retryStatusCode || ''
    });
const $98cdc1f8cbd0aee9$export$3e50530825dee9d1 = ({ queryName: queryName, statusCode: statusCode })=>(0, $eSnSE.default).safeErrorWithoutCustomerData('apollo.swag.retry', '[Retry]', {
        queryName: queryName,
        statusCode: statusCode
    });

});




parcelRegister("9wJd0", function(module, exports) {

$parcel$export(module.exports, "fetchDevSummaryData", () => $a72602135034f31e$export$cf3f33145959151a);
parcelRequire("cBiei");

var $7kixv = parcelRequire("7kixv");

var $jKweA = parcelRequire("jKweA");
const $a72602135034f31e$export$cf3f33145959151a = (issueAri)=>(0, $7kixv.Observable).fromPromise((0, $jKweA.fetchDevSummaryData)(issueAri));
const $a72602135034f31e$export$ead66e42ed1ccbb = (_baseUrl)=>fetch('/rest/atlassian-connect/latest/addons-gh4j/properties/is-configured').then((response)=>response.status === 200 ? response.json() : Promise.resolve(null));

});
parcelRegister("jKweA", function(module, exports) {

$parcel$export(module.exports, "fetchDevSummaryData", () => $4ade30b5cf874836$export$cf3f33145959151a);

var $5M9Y3 = parcelRequire("5M9Y3");

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");

var $7zZ4w = parcelRequire("7zZ4w");

var $5M9Y3 = parcelRequire("5M9Y3");

var $2ZEsC = parcelRequire("2ZEsC");
const $4ade30b5cf874836$export$cf3f33145959151a = (issueAri)=>{
    /* eslint-disable @atlassian/relay/unused-fields */ const query = (0, $5M9Y3.default);
    /* eslint-enable @atlassian/relay/unused-fields */ const variables = {
        issueId: issueAri
    };
    const request = (0, $j4oe4.fetchQuery)((0, $7zZ4w.default)(), query, variables, {
        fetchPolicy: 'store-or-network'
    });
    /* fetchQuery will NOT retain the data for the query, meaning that it is not guaranteed that the
      data will remain saved in the Relay store at any point after the request completes. We need to
      explicitly retain the operation to ensure it doesn't get deleted. See https://relay.dev/docs/api-reference/fetch-query/#behavior */ (0, $7zZ4w.default)().retain((0, $37Ewn.createOperationDescriptor)((0, $5M9Y3.default), variables));
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return request.toPromise().then((summary)=>(0, $2ZEsC.transformSummary)(summary));
};

});
parcelRegister("5M9Y3", function(module, exports) {

$parcel$export(module.exports, "default", () => $e14fb508c45779e8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<53b8a068a359283acd10e01a066694e0>>
 * @relayHash 1fa04742645fc628264ccada8ffe90a3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f4b267c1054c9c8b62435530871c2db879a6fd9d0a1debb12c0b384f64029369
const $e14fb508c45779e8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "issueId",
            "variableName": "issueId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "hasBranchCapabilities"
    }, v3 = {
        "kind": "ScalarField",
        "name": "panelState"
    }, v4 = {
        "kind": "ScalarField",
        "name": "devOpsIssuePanelBanner"
    }, v5 = {
        "kind": "ScalarField",
        "name": "count"
    }, v6 = {
        "kind": "ScalarField",
        "name": "lastUpdated"
    }, v7 = [
        v5 /*: any*/ ,
        v6 /*: any*/ 
    ], v8 = {
        "concreteType": "JiraIssueBranchDevSummary",
        "kind": "LinkedField",
        "name": "overall",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "concreteType": "JiraIssueDevSummaryByProvider",
        "kind": "LinkedField",
        "name": "summaryByProvider",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "providerId"
            },
            v9 /*: any*/ ,
            v5 /*: any*/ 
        ]
    }, v11 = {
        "concreteType": "JiraIssueCommitDevSummary",
        "kind": "LinkedField",
        "name": "overall",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v12 = {
        "kind": "ScalarField",
        "name": "state"
    }, v13 = {
        "kind": "ScalarField",
        "name": "stateCount"
    }, v14 = {
        "concreteType": "JiraIssuePullRequestDevSummary",
        "kind": "LinkedField",
        "name": "overall",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v6 /*: any*/ ,
            v12 /*: any*/ ,
            v13 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "open"
            }
        ]
    }, v15 = {
        "concreteType": "JiraIssueBuildDevSummary",
        "kind": "LinkedField",
        "name": "overall",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "failedBuildCount"
            },
            {
                "kind": "ScalarField",
                "name": "successfulBuildCount"
            },
            {
                "kind": "ScalarField",
                "name": "unknownBuildCount"
            }
        ]
    }, v16 = {
        "concreteType": "JiraIssueReviewDevSummary",
        "kind": "LinkedField",
        "name": "overall",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v6 /*: any*/ ,
            v12 /*: any*/ ,
            v13 /*: any*/ 
        ]
    }, v17 = {
        "concreteType": "JiraIssueDeploymentEnvironment",
        "kind": "LinkedField",
        "name": "topEnvironments",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "title"
            }
        ]
    }, v18 = [
        {
            "kind": "ScalarField",
            "name": "message"
        },
        {
            "concreteType": "JiraIssueDevSummaryErrorProviderInstance",
            "kind": "LinkedField",
            "name": "instance",
            "plural": false,
            "selections": [
                v9 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "kind": "ScalarField",
                    "name": "baseUrl"
                }
            ]
        }
    ], v19 = {
        "concreteType": "JiraIssueDevSummaryError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": v18 /*: any*/ 
    }, v20 = {
        "concreteType": "JiraIssueDevSummaryError",
        "kind": "LinkedField",
        "name": "configErrors",
        "plural": true,
        "selections": v18 /*: any*/ 
    }, v21 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "servicesMainJiraDevSummaryDevInfoSummaryQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JiraDevOpsQuery",
                                    "kind": "LinkedField",
                                    "name": "devOps",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "args": v1 /*: any*/ ,
                                                "concreteType": "JiraDevOpsIssuePanel",
                                                "kind": "LinkedField",
                                                "name": "devOpsIssuePanel",
                                                "plural": false,
                                                "selections": [
                                                    v2 /*: any*/ ,
                                                    v3 /*: any*/ ,
                                                    v4 /*: any*/ ,
                                                    {
                                                        "concreteType": "JiraIssueDevSummaryResult",
                                                        "kind": "LinkedField",
                                                        "name": "devSummaryResult",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "concreteType": "JiraIssueDevSummary",
                                                                    "kind": "LinkedField",
                                                                    "name": "devSummary",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": {
                                                                                "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                                                "kind": "LinkedField",
                                                                                "name": "branch",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v8 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.branch.overall"
                                                                                    },
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v10 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.branch.summaryByProvider"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            "action": "THROW",
                                                                            "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.branch"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": {
                                                                                "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                                                "kind": "LinkedField",
                                                                                "name": "commit",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v11 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.commit.overall"
                                                                                    },
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v10 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.commit.summaryByProvider"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            "action": "THROW",
                                                                            "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.commit"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": {
                                                                                "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                                                "kind": "LinkedField",
                                                                                "name": "pullrequest",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v14 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.pullrequest.overall"
                                                                                    },
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v10 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.pullrequest.summaryByProvider"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            "action": "THROW",
                                                                            "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.pullrequest"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": {
                                                                                "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                                                "kind": "LinkedField",
                                                                                "name": "build",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v15 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.build.overall"
                                                                                    },
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v10 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.build.summaryByProvider"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            "action": "THROW",
                                                                            "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.build"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": {
                                                                                "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                                                "kind": "LinkedField",
                                                                                "name": "review",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v16 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.review.overall"
                                                                                    },
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v10 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.review.summaryByProvider"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            "action": "THROW",
                                                                            "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.review"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": {
                                                                                "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                                                "kind": "LinkedField",
                                                                                "name": "deploymentEnvironments",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": {
                                                                                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v5 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "RequiredField",
                                                                                                    "field": v17 /*: any*/ ,
                                                                                                    "action": "THROW",
                                                                                                    "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.deploymentEnvironments.overall.topEnvironments"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        "action": "THROW",
                                                                                        "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.deploymentEnvironments.overall"
                                                                                    },
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v10 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.deploymentEnvironments.summaryByProvider"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            "action": "THROW",
                                                                            "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.deploymentEnvironments"
                                                                        }
                                                                    ]
                                                                },
                                                                "action": "THROW",
                                                                "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary"
                                                            },
                                                            v19 /*: any*/ ,
                                                            v20 /*: any*/ 
                                                        ]
                                                    },
                                                    v21 /*: any*/ 
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.devOps.devOpsIssuePanel"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.devOps"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "servicesMainJiraDevSummaryDevInfoSummaryQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraDevOpsQuery",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraDevOpsIssuePanel",
                                    "kind": "LinkedField",
                                    "name": "devOpsIssuePanel",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssueDevSummaryResult",
                                            "kind": "LinkedField",
                                            "name": "devSummaryResult",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueDevSummary",
                                                    "kind": "LinkedField",
                                                    "name": "devSummary",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                            "kind": "LinkedField",
                                                            "name": "branch",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                            "kind": "LinkedField",
                                                            "name": "commit",
                                                            "plural": false,
                                                            "selections": [
                                                                v11 /*: any*/ ,
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                            "kind": "LinkedField",
                                                            "name": "pullrequest",
                                                            "plural": false,
                                                            "selections": [
                                                                v14 /*: any*/ ,
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                            "kind": "LinkedField",
                                                            "name": "build",
                                                            "plural": false,
                                                            "selections": [
                                                                v15 /*: any*/ ,
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                            "kind": "LinkedField",
                                                            "name": "review",
                                                            "plural": false,
                                                            "selections": [
                                                                v16 /*: any*/ ,
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                            "kind": "LinkedField",
                                                            "name": "deploymentEnvironments",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                                    "kind": "LinkedField",
                                                                    "name": "overall",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        v17 /*: any*/ 
                                                                    ]
                                                                },
                                                                v10 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v19 /*: any*/ ,
                                                v20 /*: any*/ 
                                            ]
                                        },
                                        v21 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f4b267c1054c9c8b62435530871c2db879a6fd9d0a1debb12c0b384f64029369",
            "metadata": {},
            "name": "servicesMainJiraDevSummaryDevInfoSummaryQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e14fb508c45779e8$var$node.hash = "9ab7eb465e7cc94e7d42163b251e7887";
var $e14fb508c45779e8$export$2e2bcd8739ae039 = $e14fb508c45779e8$var$node;

});

parcelRegister("2ZEsC", function(module, exports) {

$parcel$export(module.exports, "transformSummary", () => $a726bf1f5e7f78c6$export$18d1fe37ef2c5ee2);

var $lYzhW = parcelRequire("lYzhW");

var $8O88z = parcelRequire("8O88z");
// @ts-expect-error - TS7006 - Parameter 'date' implicitly has an 'any' type.
const $a726bf1f5e7f78c6$var$transformDate = (date)=>{
    if (date !== undefined && date !== null) return (0, $lYzhW.default)(date);
    return null;
};
const $a726bf1f5e7f78c6$var$transformError = ({ instance: instance, message: message })=>({
        instanceName: instance?.name ?? '',
        instanceUrl: instance?.baseUrl ?? '',
        error: message ?? ''
    });
const $a726bf1f5e7f78c6$var$transformBySummaryProvider = (summaryByProvider)=>// @ts-expect-error - TS2322 - Type '{ readonly count: number | null; readonly name: string | null; readonly providerId: string | null; } | {}' is not assignable to type 'ByInstanceType'.
    summaryByProvider ? summaryByProvider.reduce((instanceTypes, providerInstance)=>{
        if (providerInstance.providerId !== null && providerInstance.providerId !== undefined) return {
            [providerInstance.providerId]: providerInstance.count,
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...instanceTypes
        };
        return instanceTypes;
    }, {}) : {};
function $a726bf1f5e7f78c6$var$getPullRequestState(state) {
    switch(state){
        case 'DECLINED':
            return 'DECLINED';
        case 'MERGED':
            return 'MERGED';
        case 'OPEN':
            return 'OPEN';
        case 'DRAFT':
            return 'DRAFT';
        default:
            return null;
    }
}
const $a726bf1f5e7f78c6$var$transformPullRequest = (summary)=>{
    const { pullrequest: pullrequest } = summary;
    return {
        url: null,
        count: pullrequest?.overall?.count ?? 0,
        lastUpdated: $a726bf1f5e7f78c6$var$transformDate(pullrequest?.overall?.lastUpdated ?? null),
        stateCount: pullrequest?.overall?.stateCount ?? 0,
        state: $a726bf1f5e7f78c6$var$getPullRequestState(pullrequest?.overall?.state),
        byInstanceType: $a726bf1f5e7f78c6$var$transformBySummaryProvider(pullrequest?.summaryByProvider)
    };
};
const $a726bf1f5e7f78c6$var$transformBuild = (summary)=>{
    const { build: build } = summary;
    return {
        url: null,
        count: build?.overall?.count ?? 0,
        lastUpdated: $a726bf1f5e7f78c6$var$transformDate(build.overall.lastUpdated),
        failedBuildCount: build?.overall?.failedBuildCount ?? 0,
        successfulBuildCount: build?.overall?.successfulBuildCount ?? 0,
        unknownBuildCount: build?.overall?.unknownBuildCount ?? 0,
        byInstanceType: $a726bf1f5e7f78c6$var$transformBySummaryProvider(build?.summaryByProvider)
    };
};
function $a726bf1f5e7f78c6$var$getReviewState(state) {
    switch(state){
        case 'APPROVAL':
            return 'APPROVAL';
        case 'CLOSED':
            return 'CLOSED';
        case 'DEAD':
            return 'DEAD';
        case 'DRAFT':
            return 'DRAFT';
        case 'REJECTED':
            return 'REJECTED';
        case 'REVIEW':
            return 'REVIEW';
        case 'SUMMARIZE':
            return 'SUMMARIZE';
        case 'UNKNOWN':
            return 'UNKNOWN';
        default:
            return null;
    }
}
const $a726bf1f5e7f78c6$var$transformReview = (summary)=>{
    const { review: review } = summary;
    return {
        count: review?.overall?.count ?? 0,
        lastUpdated: $a726bf1f5e7f78c6$var$transformDate(review?.overall?.lastUpdated),
        stateCount: review?.overall?.stateCount ?? 0,
        state: $a726bf1f5e7f78c6$var$getReviewState(review?.overall?.state),
        byInstanceType: $a726bf1f5e7f78c6$var$transformBySummaryProvider(review?.summaryByProvider)
    };
};
const $a726bf1f5e7f78c6$var$transformCommit = (summary)=>{
    const { commit: commit } = summary;
    return {
        url: null,
        count: commit?.overall?.count ?? 0,
        lastUpdated: $a726bf1f5e7f78c6$var$transformDate(commit?.overall?.lastUpdated),
        byInstanceType: $a726bf1f5e7f78c6$var$transformBySummaryProvider(commit?.summaryByProvider)
    };
};
const $a726bf1f5e7f78c6$var$transformBranch = (summary)=>{
    const { branch: branch } = summary;
    return {
        url: null,
        count: branch?.overall?.count ?? 0,
        lastUpdated: $a726bf1f5e7f78c6$var$transformDate(branch?.overall?.lastUpdated),
        byInstanceType: $a726bf1f5e7f78c6$var$transformBySummaryProvider(branch?.summaryByProvider)
    };
};
const $a726bf1f5e7f78c6$var$transformDeployment = (summary)=>{
    const { deploymentEnvironments: deploymentEnvironments } = summary;
    return {
        count: deploymentEnvironments?.overall?.count ?? 0,
        environments: (deploymentEnvironments?.overall?.topEnvironments ?? []).map((environment)=>environment?.title ?? ''),
        byInstanceType: $a726bf1f5e7f78c6$var$transformBySummaryProvider(deploymentEnvironments?.summaryByProvider)
    };
};
// @ts-expect-error - TS7006 - Parameter 'byProvider' implicitly has an 'any' type.
const $a726bf1f5e7f78c6$var$mapToLegacyByInstanceType = (byProvider)=>byProvider.reduce(// @ts-expect-error - TS7006 - Parameter 'instanceAcc' implicitly has an 'any' type. | TS7031 - Binding element 'providerId' implicitly has an 'any' type. | TS7031 - Binding element 'name' implicitly has an 'any' type. | TS7031 - Binding element 'count' implicitly has an 'any' type.
    (instanceAcc, { providerId: providerId, name: name, count: count })=>providerId !== null && providerId !== undefined ? {
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...instanceAcc,
            [providerId]: {
                name: name,
                count: count
            }
        } : instanceAcc, {});
const $a726bf1f5e7f78c6$var$mapToLegacyDataStructure = (result)=>({
        configErrors: (result.configErrors ?? []).map((error)=>({
                instance: error.instance,
                error: error.message
            })),
        errors: (result.errors ?? []).map((error)=>({
                instance: error.instance,
                error: error.message
            })),
        summary: {
            branch: {
                overall: {
                    count: result.devSummary.branch.overall.count || 0,
                    lastUpdated: result.devSummary.branch.overall.lastUpdated || ''
                },
                byInstanceType: $a726bf1f5e7f78c6$var$mapToLegacyByInstanceType(result.devSummary.branch.summaryByProvider)
            },
            repository: {
                overall: {
                    count: result.devSummary.commit.overall.count || 0,
                    lastUpdated: result.devSummary.commit.overall.lastUpdated || ''
                },
                byInstanceType: $a726bf1f5e7f78c6$var$mapToLegacyByInstanceType(result.devSummary.commit.summaryByProvider)
            },
            pullrequest: {
                overall: {
                    count: result.devSummary.pullrequest.overall.count || 0,
                    lastUpdated: result.devSummary.pullrequest.overall.lastUpdated || '',
                    state: $a726bf1f5e7f78c6$var$getPullRequestState(result.devSummary.pullrequest.overall.state),
                    stateCount: result.devSummary.pullrequest.overall.stateCount || 0,
                    open: result.devSummary.pullrequest.overall.open || false
                },
                byInstanceType: $a726bf1f5e7f78c6$var$mapToLegacyByInstanceType(result.devSummary.pullrequest.summaryByProvider)
            },
            build: {
                overall: {
                    count: result.devSummary.build.overall.count || 0,
                    lastUpdated: result.devSummary.build.overall.lastUpdated || '',
                    failedBuildCount: result.devSummary.build.overall.failedBuildCount || 0,
                    successfulBuildCount: result.devSummary.build.overall.successfulBuildCount || 0,
                    unknownBuildCount: result.devSummary.build.overall.unknownBuildCount || 0
                },
                byInstanceType: $a726bf1f5e7f78c6$var$mapToLegacyByInstanceType(result.devSummary.build.summaryByProvider)
            },
            review: {
                overall: {
                    count: result.devSummary.review.overall.count || 0,
                    lastUpdated: result.devSummary.review.overall.lastUpdated || '',
                    state: $a726bf1f5e7f78c6$var$getReviewState(result.devSummary.review.overall.state),
                    stateCount: result.devSummary.review.overall.stateCount || 0
                },
                byInstanceType: $a726bf1f5e7f78c6$var$mapToLegacyByInstanceType(result.devSummary.review.summaryByProvider)
            },
            'deployment-environment': {
                overall: {
                    count: result.devSummary.deploymentEnvironments.overall.count || 0,
                    lastUpdated: '',
                    topEnvironments: [],
                    showProjects: false,
                    successfulCount: 0
                },
                byInstanceType: $a726bf1f5e7f78c6$var$mapToLegacyByInstanceType(result.devSummary.deploymentEnvironments.summaryByProvider)
            }
        }
    });
const $a726bf1f5e7f78c6$export$72ddd42e3cc8539f = (result)=>{
    if (!result) return {
        legacyResponseData: undefined,
        [(0, $8O88z.SUMMARY_ITEM_PULLREQUEST)]: undefined,
        [(0, $8O88z.SUMMARY_ITEM_BUILD)]: undefined,
        [(0, $8O88z.SUMMARY_ITEM_REVIEW)]: undefined,
        [(0, $8O88z.SUMMARY_ITEM_COMMIT)]: undefined,
        [(0, $8O88z.SUMMARY_ITEM_BRANCH)]: undefined,
        [(0, $8O88z.SUMMARY_ITEM_DEPLOYMENT)]: undefined,
        errors: [],
        configErrors: []
    };
    const { errors: errors, configErrors: configErrors, devSummary: summary } = result;
    return {
        // TODO: legacyResponseData is only used for legacy dialogue, needs to be cleaned up when legacy dialogue is removed.
        legacyResponseData: $a726bf1f5e7f78c6$var$mapToLegacyDataStructure(result),
        [(0, $8O88z.SUMMARY_ITEM_BRANCH)]: $a726bf1f5e7f78c6$var$transformBranch(summary),
        [(0, $8O88z.SUMMARY_ITEM_COMMIT)]: $a726bf1f5e7f78c6$var$transformCommit(summary),
        [(0, $8O88z.SUMMARY_ITEM_PULLREQUEST)]: $a726bf1f5e7f78c6$var$transformPullRequest(summary),
        [(0, $8O88z.SUMMARY_ITEM_BUILD)]: $a726bf1f5e7f78c6$var$transformBuild(summary),
        [(0, $8O88z.SUMMARY_ITEM_REVIEW)]: $a726bf1f5e7f78c6$var$transformReview(summary),
        [(0, $8O88z.SUMMARY_ITEM_DEPLOYMENT)]: $a726bf1f5e7f78c6$var$transformDeployment(summary),
        errors: errors ? errors.map($a726bf1f5e7f78c6$var$transformError) : [],
        configErrors: configErrors ? configErrors.map($a726bf1f5e7f78c6$var$transformError) : []
    };
};
function $a726bf1f5e7f78c6$var$getPanelState(state) {
    switch(state){
        case 'DEV_SUMMARY':
            return 'DEV_SUMMARY';
        case 'NOT_CONNECTED':
            return 'NOT_CONNECTED';
        case 'HIDDEN':
        default:
            return 'HIDDEN';
    }
}
function $a726bf1f5e7f78c6$var$getDevOpsIssuePanelBanner(item) {
    switch(item){
        case 'ISSUE_KEY_ONBOARDING':
            return 'ISSUE_KEY_ONBOARDING';
        default:
            return null;
    }
}
const $a726bf1f5e7f78c6$export$18d1fe37ef2c5ee2 = (relaySummary)=>{
    const issuePanelSummary = relaySummary.jira.devOps.devOpsIssuePanel;
    return {
        summary: $a726bf1f5e7f78c6$export$72ddd42e3cc8539f(issuePanelSummary.devSummaryResult),
        panelState: $a726bf1f5e7f78c6$var$getPanelState(issuePanelSummary.panelState),
        bannerType: $a726bf1f5e7f78c6$var$getDevOpsIssuePanelBanner(issuePanelSummary.devOpsIssuePanelBanner),
        hasBranchCapabilities: issuePanelSummary.hasBranchCapabilities || false
    };
};

});




parcelRegister("50OY9", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $a1317a40a3d74ab6$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $a1317a40a3d74ab6$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

var $dA5Z8 = parcelRequire("dA5Z8");

var $lG5Sk = parcelRequire("lG5Sk");

var $ikKUs = parcelRequire("ikKUs");
const $a1317a40a3d74ab6$export$d4c72bab9d6cc13a = (0, $iWqim.freeze)({
    devPanel: {
        summary: {},
        panelState: 'HIDDEN',
        showSummarySectionMessage: false,
        hasBranchCapabilities: false,
        hasDevelopmentDataInProject: false
    },
    isLoading: false,
    createBranchTargets: [],
    // To show the empty state diag.
    isEmptyStateDialogShown: false
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a1317a40a3d74ab6$export$2e2bcd8739ae039 = (state = $a1317a40a3d74ab6$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $ikKUs.FETCH_DEV_PANEL_REQUEST:
            return (0, $iWqim.set)(state, 'isLoading', true);
        case 0, $ikKUs.FETCH_DEV_PANEL_SUCCESS:
            {
                (0, $dA5Z8.devPanelTimeToLoad).stop();
                const updatedState = (0, $iWqim.chain)(state).set('createBranchTargets', action.payload.createBranchTargets).set('isLoading', false).value();
                return (0, $iWqim.set)(updatedState, 'devPanel', {
                    summary: action.payload.summary,
                    panelState: action.payload.panelState,
                    hasBranchCapabilities: action.payload.hasBranchCapabilities,
                    showSummarySectionMessage: action.payload.bannerType === 'ISSUE_KEY_ONBOARDING',
                    hasDevelopmentDataInProject: action.payload.hasDevelopmentDataInProject
                });
            }
        case 0, $ikKUs.FETCH_DEV_PANEL_URL_DETAILS_SUCCESS:
            {
                const currentSummary = state.devPanel.summary;
                if (currentSummary) {
                    const enrichedSummary = (0, $lG5Sk.enrichSummary)(currentSummary, action.payload);
                    return (0, $iWqim.setIn)(state, [
                        'devPanel',
                        'summary'
                    ], enrichedSummary);
                }
                return state;
            }
        case 0, $ikKUs.FETCH_DEV_PANEL_FAILURE:
            (0, $dA5Z8.devPanelTimeToLoad).cancel();
            return (0, $iWqim.set)(state, 'isLoading', false);
        case 0, $ikKUs.SHOW_EMPTY_STATE_DIALOG:
            return (0, $iWqim.set)(state, 'isEmptyStateDialogShown', true);
        case 0, $ikKUs.CLOSE_EMPTY_STATE_DIALOG:
            return (0, $iWqim.set)(state, 'isEmptyStateDialogShown', false);
        case 0, $ikKUs.TOGGLE_EMPTY_STATE_PANEL:
            return (0, $iWqim.set)(state, 'devPanel', {
                ...state.devPanel,
                panelState: action.payload.panelState
            });
        case 0, $ikKUs.TOGGLE_SUMMARY_SECTION_MESSAGE:
            return (0, $iWqim.set)(state, 'devPanel', {
                ...state.devPanel,
                showSummarySectionMessage: action.payload.showSummarySectionMessage
            });
        default:
            return state;
    }
};

});
parcelRegister("lG5Sk", function(module, exports) {

$parcel$export(module.exports, "enrichSummary", () => $109d58c2a00c910c$export$580ec73975159411);

var $fqICx = parcelRequire("fqICx");

var $8O88z = parcelRequire("8O88z");
// Do not use this function on entity types that have state/status
const $109d58c2a00c910c$var$shouldStoreEntityUrl = (// @ts-expect-error - TS7006 - Parameter 'summary' implicitly has an 'any' type.
summary, summaryItemType, // @ts-expect-error - TS2304 - Cannot find name 'BranchesType'. | TS2304 - Cannot find name 'CommitsType'.
entities)=>summary[summaryItemType]?.url === null && summary[summaryItemType]?.count === 1 && entities.length === 1;
const $109d58c2a00c910c$var$shouldStorePullRequestUrl = (// @ts-expect-error - TS7006 - Parameter 'summary' implicitly has an 'any' type.
summary, pullRequest)=>summary[0, $8O88z.SUMMARY_ITEM_PULLREQUEST]?.stateCount === 1 && summary[0, $8O88z.SUMMARY_ITEM_PULLREQUEST]?.url === null && summary[0, $8O88z.SUMMARY_ITEM_PULLREQUEST]?.state === pullRequest.status;
const $109d58c2a00c910c$export$622f497494fcce79 = (summaryBuilds)=>{
    let targetBuildStatesForOneClickUrl;
    if (summaryBuilds?.failedBuildCount === 1) targetBuildStatesForOneClickUrl = [
        'FAILED'
    ];
    else if (summaryBuilds?.failedBuildCount === 0 && summaryBuilds?.successfulBuildCount === 1) targetBuildStatesForOneClickUrl = [
        'SUCCESSFUL'
    ];
    else if (summaryBuilds?.failedBuildCount === 0 && summaryBuilds?.successfulBuildCount === 0 && summaryBuilds?.count === 1) targetBuildStatesForOneClickUrl = [
        'IN_PROGRESS',
        'PENDING',
        'CANCELLED',
        'UNKNOWN'
    ];
    else // empty means that the build summary item will show a count greater than 1. So don't look for url matching target build state.
    targetBuildStatesForOneClickUrl = [];
    return targetBuildStatesForOneClickUrl;
};
const $109d58c2a00c910c$export$580ec73975159411 = (transformedSummary, swagResponse)=>{
    const enrichedSummary = (0, (/*@__PURE__*/$parcel$interopDefault($fqICx)))(transformedSummary);
    const targetBuildStatesForOneClickUrl = $109d58c2a00c910c$export$622f497494fcce79(enrichedSummary[0, $8O88z.SUMMARY_ITEM_BUILD]);
    const createPullRequestTargets = [];
    enrichedSummary.detailsHasInstanceErrors = false;
    swagResponse.data.developmentInformation.details.instanceTypes.forEach((instanceType)=>{
        if (instanceType.devStatusErrorMessages.length > 0) enrichedSummary.detailsHasInstanceErrors = true;
        // Repository types
        instanceType.repository.forEach(({ name: name, avatarUrl: avatarUrl, commits: commits, branches: branches, pullRequests: pullRequests })=>{
            // Find the first pull request matching state of summary pull request to be shown (see above note about PRs)
            const pullRequestToStore = pullRequests.find((pullRequest)=>$109d58c2a00c910c$var$shouldStorePullRequestUrl(enrichedSummary, pullRequest));
            if (enrichedSummary[0, $8O88z.SUMMARY_ITEM_PULLREQUEST] && pullRequestToStore !== undefined) enrichedSummary[0, $8O88z.SUMMARY_ITEM_PULLREQUEST].url = pullRequestToStore.url;
            if (enrichedSummary[0, $8O88z.SUMMARY_ITEM_COMMIT] && $109d58c2a00c910c$var$shouldStoreEntityUrl(enrichedSummary, (0, $8O88z.SUMMARY_ITEM_COMMIT), commits)) enrichedSummary[0, $8O88z.SUMMARY_ITEM_COMMIT].url = commits[0].url;
            if (enrichedSummary[0, $8O88z.SUMMARY_ITEM_BRANCH] && $109d58c2a00c910c$var$shouldStoreEntityUrl(enrichedSummary, (0, $8O88z.SUMMARY_ITEM_BRANCH), branches)) enrichedSummary[0, $8O88z.SUMMARY_ITEM_BRANCH].url = branches[0].url;
            if (name != null && branches.length > 0) createPullRequestTargets.push(...branches.filter((branch)=>branch.createPullRequestUrl != null && branch.name != null).map((branch)=>({
                    repositoryName: name,
                    repositoryAvatarUrl: avatarUrl,
                    branchName: branch.name ?? '',
                    createPullRequestUrl: branch.createPullRequestUrl ?? '',
                    scmProvider: instanceType.type !== undefined && instanceType.type.startsWith((0, $8O88z.OAUTH_ANALYTICS_TYPE)) ? (0, $8O88z.OAUTH_ANALYTICS_TYPE) : instanceType.type ?? ''
                })));
        });
        // Dangling Pull requests - if PR url hasn't already been set by above repository check
        // Find the first pull request matching state of summary pull request to be shown (see above note about PRs)
        if (instanceType.danglingPullRequests !== null && instanceType.danglingPullRequests !== undefined) {
            const pullRequestToStore = instanceType.danglingPullRequests.find((pullRequest)=>$109d58c2a00c910c$var$shouldStorePullRequestUrl(enrichedSummary, pullRequest));
            if (enrichedSummary[0, $8O88z.SUMMARY_ITEM_PULLREQUEST] && pullRequestToStore !== undefined) enrichedSummary[0, $8O88z.SUMMARY_ITEM_PULLREQUEST].url = pullRequestToStore.url;
        }
        // Builds
        if (targetBuildStatesForOneClickUrl.length !== 0) instanceType.buildProviders.forEach((buildProvider)=>{
            const buildToStore = buildProvider.builds.find((build)=>enrichedSummary[0, $8O88z.SUMMARY_ITEM_BUILD]?.url === null && targetBuildStatesForOneClickUrl.includes(build.state));
            if (enrichedSummary[0, $8O88z.SUMMARY_ITEM_BUILD] && buildToStore !== undefined) enrichedSummary[0, $8O88z.SUMMARY_ITEM_BUILD].url = buildToStore.url;
        });
    });
    createPullRequestTargets.sort((a, b)=>a.repositoryName.localeCompare(b.repositoryName) || a.branchName.localeCompare(b.branchName));
    if (enrichedSummary[0, $8O88z.SUMMARY_ITEM_PULLREQUEST]) enrichedSummary[0, $8O88z.SUMMARY_ITEM_PULLREQUEST].createPullRequestTargets = createPullRequestTargets;
    return enrichedSummary;
};

});



parcelRegister("1k5xZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc7fc354bdcab70f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $dLR8J = parcelRequire("dLR8J");

var $hrKgE = parcelRequire("hrKgE");

var $7iHUq = parcelRequire("7iHUq");

var $5kYyR = parcelRequire("5kYyR");

var $4xbv3 = parcelRequire("4xbv3");
var $ftN6c = parcelRequire("ftN6c");

var $gnQAk = parcelRequire("gnQAk");

var $ljej9 = parcelRequire("ljej9");

var $lvKO5 = parcelRequire("lvKO5");

var $7jTnu = parcelRequire("7jTnu");

var $f2JN3 = parcelRequire("f2JN3");

var $jsi4K = parcelRequire("jsi4K");

var $ikKUs = parcelRequire("ikKUs");

var $ddPfy = parcelRequire("ddPfy");

var $ct7pX = parcelRequire("ct7pX");

var $9pmMO = parcelRequire("9pmMO");
class $bc7fc354bdcab70f$export$23c3014dd13d0108 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            issueAri: '',
            issueId: '',
            issueKey: (0, $ljej9.toIssueKey)(''),
            issueStatusCategory: '',
            isSiteAdmin: false,
            hasSoftwareAccess: false,
            projectId: '',
            projectType: '',
            nextGenProject: false,
            analyticsSource: '',
            panelState: 'HIDDEN',
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onFetchDevPanel: ()=>{},
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onWillUnMount: ()=>{},
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onSetContext: ()=>{},
            projectAri: '',
            isJiraAdmin: false,
            isLoading: false
        };
    }
    constructor(props){
        super(props);
        this.dispatchSetContext();
    }
    UNSAFE_componentWillMount() {
        this.props.onFetchDevPanel();
    }
    componentDidUpdate(prevProps) {
        if (this.props.isLoading !== prevProps.isLoading) return;
        if (this.props.panelState !== prevProps.panelState) return;
        this.dispatchSetContext();
        this.props.onFetchDevPanel();
    }
    componentWillUnmount() {
        this.props.onWillUnMount();
    }
    dispatchSetContext() {
        const { issueId: issueId, issueAri: issueAri, issueKey: issueKey, issueStatusCategory: issueStatusCategory, projectId: projectId, projectType: projectType, nextGenProject: nextGenProject, analyticsSource: analyticsSource, isSiteAdmin: isSiteAdmin, onSetContext: onSetContext, projectAri: projectAri, isJiraAdmin: isJiraAdmin } = this.props;
        onSetContext({
            issueId: issueId,
            issueAri: issueAri,
            issueKey: issueKey,
            issueStatusCategory: issueStatusCategory,
            projectId: projectId,
            projectType: projectType,
            nextGenProject: nextGenProject,
            analyticsSource: analyticsSource,
            isSiteAdmin: isSiteAdmin || false,
            projectAri: projectAri,
            isJiraAdmin: isJiraAdmin || false
        });
    }
    render() {
        return this.props.hasSoftwareAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
            attributes: {
                analyticsSource: this.props.analyticsSource,
                issueId: this.props.issueId,
                isEmptyStateEnabled: true,
                isSiteAdmin: this.props.isSiteAdmin
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5kYyR.default), {
            id: "devPanelApp",
            packageName: "jiraDevelopmentSummaryDevelopmentField"
        }, this.props.panelState === 'DEV_SUMMARY' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9pmMO.default), null), this.props.panelState === 'NOT_CONNECTED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ct7pX.default), null)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
    }
}
const $bc7fc354bdcab70f$export$28b914daf6888d9 = (unstableProps)=>{
    const props = (0, $hrKgE.useShallowStableReference)(unstableProps, (0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
    const { issueAri: issueAri = '', issueId: issueId = '', issueKey: issueKey = (0, $ljej9.toIssueKey)(''), issueStatusCategory: issueStatusCategory = '', isSiteAdmin: isSiteAdmin = false, hasSoftwareAccess: hasSoftwareAccess = false, projectId: projectId = '', projectType: projectType = '', nextGenProject: nextGenProject = false, analyticsSource: analyticsSource = '', panelState: panelState = 'HIDDEN', onFetchDevPanel: onFetchDevPanel = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onWillUnMount: onWillUnMount = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onSetContext: onSetContext = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), projectAri: projectAri = '', isJiraAdmin: isJiraAdmin = false, isLoading: isLoading = false } = props;
    const dispatchSetContext = (0, $eJOHy.useCallback)(()=>{
        onSetContext({
            issueId: issueId,
            issueAri: issueAri,
            issueKey: issueKey,
            issueStatusCategory: issueStatusCategory,
            projectId: projectId,
            projectType: projectType,
            nextGenProject: nextGenProject,
            analyticsSource: analyticsSource,
            isSiteAdmin: isSiteAdmin || false,
            projectAri: projectAri,
            isJiraAdmin: isJiraAdmin || false
        });
    }, [
        analyticsSource,
        isJiraAdmin,
        isSiteAdmin,
        issueAri,
        issueId,
        issueKey,
        issueStatusCategory,
        nextGenProject,
        onSetContext,
        projectAri,
        projectId,
        projectType
    ]);
    const hasMounted = (0, $eJOHy.useRef)(false);
    // UNSAFE_componentWillMount
    (0, $eJOHy.useEffect)(()=>{
        if (!issueId || hasMounted.current) return;
        dispatchSetContext();
        onFetchDevPanel();
        hasMounted.current = true;
        // componentWillUnmount
        return ()=>{
            onWillUnMount();
        };
    }, [
        dispatchSetContext,
        issueId,
        onFetchDevPanel,
        onWillUnMount
    ]);
    const previousProps = (0, $eJOHy.useRef)(props);
    (0, $eJOHy.useEffect)(()=>{
        const { isLoading: prevIsLoading, panelState: prevPanelState } = previousProps.current || {};
        previousProps.current = props;
        if (!hasMounted.current) return;
        if (isLoading !== prevIsLoading) return;
        if (panelState !== prevPanelState) return;
        dispatchSetContext();
        onFetchDevPanel();
    }, [
        dispatchSetContext,
        isLoading,
        onFetchDevPanel,
        panelState,
        props
    ]);
    return hasSoftwareAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        attributes: {
            analyticsSource: analyticsSource,
            issueId: issueId,
            isEmptyStateEnabled: true,
            isSiteAdmin: isSiteAdmin
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5kYyR.default), {
        id: "devPanelApp",
        packageName: "jiraDevelopmentSummaryDevelopmentField"
    }, panelState === 'DEV_SUMMARY' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9pmMO.default), null), panelState === 'NOT_CONNECTED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ct7pX.default), null)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
};
const $bc7fc354bdcab70f$export$ffe6c71b6facbc2b = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('jira-concurrent-create-branch-double-call'), $bc7fc354bdcab70f$export$28b914daf6888d9, $bc7fc354bdcab70f$export$23c3014dd13d0108);
const $bc7fc354bdcab70f$var$DevPanelWithTenantContext = ({ onFetchDevPanel: onFetchDevPanel, ...props })=>{
    const { isSiteAdmin: isSiteAdmin } = (0, $lvKO5.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const wrappedOnFetchDevPanel = (0, $eJOHy.useCallback)(()=>onFetchDevPanel(createAnalyticsEvent({
            actionSubject: 'panel'
        })), [
        onFetchDevPanel,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        hold: props.isLoading,
        name: "issue-dev-panel-data-hold"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bc7fc354bdcab70f$export$ffe6c71b6facbc2b, {
        ...props,
        onFetchDevPanel: wrappedOnFetchDevPanel,
        isSiteAdmin: isSiteAdmin
    }));
};
var // This connect uses the store prop thats passed though not the provider that its underneath.
$bc7fc354bdcab70f$export$2e2bcd8739ae039 = (0, $gnQAk.connect)((state)=>({
        panelState: (0, $ddPfy.panelStateSelector)(state),
        isLoading: (0, $ddPfy.isLoadingDevPanelSelector)(state)
    }), (dispatch)=>({
        onFetchDevPanel: (analyticsEvent)=>{
            dispatch((0, $ikKUs.fetchDevPanelRequest)(analyticsEvent));
        },
        onWillUnMount: ()=>dispatch((0, $ikKUs.devPanelWillUnmount)()),
        onSetContext: (issueContext)=>dispatch((0, $jsi4K.setContext)(issueContext))
    }))($bc7fc354bdcab70f$var$DevPanelWithTenantContext);

});
parcelRegister("ct7pX", function(module, exports) {

$parcel$export(module.exports, "default", () => $d51240bda4b29b8c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $jdqdp = parcelRequire("jdqdp");

var $2M0ib = parcelRequire("2M0ib");

var $9zKYv = parcelRequire("9zKYv");

var $cDP77 = parcelRequire("cDP77");

var $8hEMV = parcelRequire("8hEMV");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $iqtgH = parcelRequire("iqtgH");

var $gnQAk = parcelRequire("gnQAk");

var $b1iBk = parcelRequire("b1iBk");

var $ikKUs = parcelRequire("ikKUs");

var $kouRT = parcelRequire("kouRT");

var $dr0NS = parcelRequire("dr0NS");

var $2w4x6 = parcelRequire("2w4x6");


const $d51240bda4b29b8c$var$ConditionalSlideDown = (parcelRequire("gMlkF")).default;
const $d51240bda4b29b8c$export$ea887ee58e627c40 = ({ onOpenEmptyStateDialog: onOpenEmptyStateDialog })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const notIntegratedLabel = formatMessage((0, $2w4x6.default).notIntegrated);
    const buttonCTA = formatMessage((0, $2w4x6.default).buttonCta); // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onButtonClick = (_, analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'openDevPanelEmptyStateModal');
        onOpenEmptyStateDialog();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireUiAnalytics), {
        eventName: "viewed devPanelEmptyState"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d51240bda4b29b8c$var$RelativeFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b1iBk.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d51240bda4b29b8c$var$ConditionalSlideDown, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDP77.SummaryItemContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: "new"
    }, notIntegratedLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2M0ib.BranchEmptyState), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9zKYv.CommitEmptyState), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8hEMV.PullRequestEmptyState), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDP77.SummaryItemContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        spacing: "none",
        appearance: "link",
        onClick: onButtonClick
    }, buttonCTA)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kouRT.default), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dr0NS.default), null));
};
var $d51240bda4b29b8c$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $gnQAk.connect)(()=>({}), {
    onOpenEmptyStateDialog: (0, $ikKUs.showEmptyStateDialog)
})($d51240bda4b29b8c$export$ea887ee58e627c40);
const $d51240bda4b29b8c$var$RelativeFieldWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2M0ib", function(module, exports) {

$parcel$export(module.exports, "BranchEmptyState", () => $96019a2bc698b926$export$2c13bb47265d991b);
$parcel$export(module.exports, "default", () => $96019a2bc698b926$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5lAAn = parcelRequire("5lAAn");

var $1OQKp = parcelRequire("1OQKp");

var $awZZu = parcelRequire("awZZu");

var $jlvUH = parcelRequire("jlvUH");

var $lopBx = parcelRequire("lopBx");

var $dPMMf = parcelRequire("dPMMf");


var $ihplE = parcelRequire("ihplE");

var $1A9lq = parcelRequire("1A9lq");

var $cDP77 = parcelRequire("cDP77");

var $kDaaB = parcelRequire("kDaaB");
var $7qGN1 = parcelRequire("7qGN1");

var $dTocu = parcelRequire("dTocu");

var $bmoS1 = parcelRequire("bmoS1");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $16sa1 = parcelRequire("16sa1");

var $6XJko = parcelRequire("6XJko");

var $epTsa = parcelRequire("epTsa");

var $2NsFw = parcelRequire("2NsFw");

var $dpFae = parcelRequire("dpFae");

var $2Ioi6 = parcelRequire("2Ioi6");

var $4eEF9 = parcelRequire("4eEF9");


const $96019a2bc698b926$var$ConditionalCreateBranchDropdown = (parcelRequire("1rNdT")).default; // eslint-disable-next-line jira/styled/styled-component-order, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $96019a2bc698b926$var$IconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_s7n4nkob",
            __cmplp.className
        ])
    });
});
const $96019a2bc698b926$var$BranchIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($96019a2bc698b926$var$IconWrapper, {
    "aria-hidden": true
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($awZZu))), {
    color: "var(--ds-link, #0C66E4)",
    label: ""
}));
const $96019a2bc698b926$var$BranchIconOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($96019a2bc698b926$var$IconWrapper, {
    "aria-hidden": true
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jlvUH))), {
    LEGACY_size: "medium",
    spacing: "spacious",
    label: ""
}));
const $96019a2bc698b926$export$f99233281efd08a0 = /*#__PURE__*/ (0, $eJOHy.memo)(({ count: count })=>{
    // Defensive: ensure count is always a valid number to prevent blank rendering (FedRAMP only)
    const useFedRampTitleFix = (0, $lopBx.isFedRamp)();
    let safeCount = count;
    if (useFedRampTitleFix && typeof count !== 'number') safeCount = 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
        ...(0, $2Ioi6.default).title,
        values: {
            count: safeCount,
            styledCount: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($96019a2bc698b926$var$BoldFont, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7qGN1.FormattedNumber), {
                value: safeCount
            }))
        }
    });
});
const $96019a2bc698b926$var$CreateBranchSummaryItem = ({ branchTargets: branchTargets, shouldForceVisibleSecondary: shouldForceVisibleSecondary, setShouldForceVisibleSecondary: setShouldForceVisibleSecondary, hasBranchCapabilities: hasBranchCapabilities })=>{
    const { formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const issueKey = (0, $bmoS1.useIssueKey)();
    const downChevron = (0, $eJOHy.useMemo)(()=>(0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
            color: "var(--ds-link, #0C66E4)",
            label: formatMessage((0, $2Ioi6.default).createBranchDropdownIconLabelLowercase),
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $2Ioi6.default).createBranchDropdownIconLabelLowercase),
            size: "small"
        }), [
        formatMessage
    ]);
    const urlArray = (0, $eJOHy.useMemo)(()=>branchTargets.map((target)=>target.url), [
        branchTargets
    ]);
    const hasSingleTarget = urlArray.length === 1;
    const hasMultipleTargets = urlArray.length > 1;
    if (!hasSingleTarget && !hasMultipleTargets && !hasBranchCapabilities) return null;
    const commonSummaryItemProps = {
        title: formatMessage((0, $2Ioi6.default).createBranchTitleLowercase),
        issueKey: issueKey,
        linkFormatting: true,
        icon: (0, $6XJko.isVisualRefreshEnabled)() ? $96019a2bc698b926$var$BranchIcon : $96019a2bc698b926$var$BranchIconOld
    };
    return hasSingleTarget ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDP77.SummaryItem), {
        ...commonSummaryItemProps,
        href: urlArray[0],
        onClick: ()=>{
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createBranchButton', {
                singleScmProvider: true,
                redirectToScmProviderPage: true
            });
        },
        secondaryHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($96019a2bc698b926$var$ConditionalCreateBranchDropdown, {
            getDropdownTrigger: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2NsFw.CreateBranchCommandButton), props),
            createBranchTargets: branchTargets,
            hideCreateBranchLinks: true,
            onOpenDropdown: ({ isOpen: isOpen })=>{
                setShouldForceVisibleSecondary(isOpen);
            }
        }),
        forceVisibleSecondary: shouldForceVisibleSecondary,
        "data-testid": "development-summary-branch.ui.summary-item"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($96019a2bc698b926$var$ConditionalCreateBranchDropdown, {
        createBranchTargets: branchTargets,
        onOpenDropdown: ({ isOpen: isOpen })=>{
            setShouldForceVisibleSecondary(isOpen);
        },
        getDropdownTrigger: ({ ref: ref, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDP77.SummaryItem), {
                secondaryData: downChevron,
                forceVisibleSecondary: shouldForceVisibleSecondary,
                reference: ref,
                ...commonSummaryItemProps,
                ...props,
                onClick: ()=>{
                    props.onClick();
                    (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createBranchButton', {
                        singleScmProvider: false,
                        redirectToScmProviderPage: false
                    });
                },
                "data-testid": "development-summary-branch.ui.summary-item"
            })
    });
};
const $96019a2bc698b926$export$2c13bb47265d991b = ()=>{
    const { formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const icon = (0, $6XJko.isVisualRefreshEnabled)() ? $96019a2bc698b926$var$BranchIcon : $96019a2bc698b926$var$BranchIconOld;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDP77.SummaryItem), {
        icon: icon,
        disabled: true,
        title: formatMessage((0, $2Ioi6.default).emptyStateUpdate),
        "data-testid": "development-summary-branch.ui.summary-item"
    });
};
const $96019a2bc698b926$var$BranchInner = ({ branch: branch, onClick: onClick, hasBranchCapabilities: hasBranchCapabilities, branchTargets: branchTargets, issueId: issueId, issueKey: issueKey, shouldForceVisibleSecondary: initialShouldForceVisibleSecondary = false })=>{
    const { formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const [shouldForceVisibleSecondary, setShouldForceVisibleSecondary] = (0, $eJOHy.useState)(initialShouldForceVisibleSecondary); // Add loading state detection to prevent race conditions (FedRAMP only)
    const isDataLoaded = branch !== null && branch !== undefined;
    const hasValidCount = isDataLoaded && typeof branch.count === 'number';
    const useFedRampFixes = (0, $lopBx.isFedRamp)(); // Feature flag for safer rollout
    const vsCodeBranchTarget = (0, $eJOHy.useMemo)(()=>(0, $4eEF9.createVsCodeBranchTarget)(formatMessage((0, $2Ioi6.default).atlascodeProductName), issueKey, // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.location.hostname), [
        formatMessage,
        issueKey
    ]);
    const branchTargetsWithUrls = (0, $eJOHy.useMemo)(()=>{
        const list = branchTargets.filter((target)=>target.url);
        if (vsCodeBranchTarget?.url && branchTargets.length > 0 && (0, $epTsa.expVal)('jira-work-suggestions-open-in-ide-experiment', 'createBranchButton', false)) list.unshift(vsCodeBranchTarget);
        return list;
    }, [
        branchTargets,
        vsCodeBranchTarget
    ]); // Fix race condition: ensure count is always a valid number (FedRAMP only)
    const { count: count = 0 } = branch ?? {};
    let safeCount = count;
    if (useFedRampFixes && !hasValidCount) safeCount = 0;
    const title = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($96019a2bc698b926$export$f99233281efd08a0, {
            count: safeCount
        }), [
        safeCount
    ]);
    const icon = (0, $6XJko.isVisualRefreshEnabled)() ? $96019a2bc698b926$var$BranchIcon : $96019a2bc698b926$var$BranchIconOld;
    const summaryItemComponent = (branchInput)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDP77.SummaryItem), {
            title: title,
            href: null,
            onClick: onClick,
            itemType: "branch",
            itemCount: useFedRampFixes ? branchInput.count ?? 0 : branchInput.count,
            oneClickUrl: branchInput.url,
            oneClickToolTipContent: formatMessage((0, $2Ioi6.default).tooltip),
            secondaryHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($96019a2bc698b926$var$ConditionalCreateBranchDropdown, {
                getDropdownTrigger: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dpFae.CreateBranchIconButton), props),
                createBranchTargets: branchTargetsWithUrls,
                onOpenDropdown: ({ isOpen: isOpen })=>{
                    setShouldForceVisibleSecondary(isOpen);
                }
            }),
            icon: icon,
            forceVisibleSecondary: shouldForceVisibleSecondary,
            "data-testid": "development-summary-branch.ui.summary-item"
        }); // More robust condition that handles race conditions (FedRAMP only)
    const shouldShowBranches = useFedRampFixes ? isDataLoaded && hasValidCount && branch.count > 0 : branch && branch.count > 0;
    if (shouldShowBranches && branch) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1A9lq.default), {
        devInfoType: (0, $ihplE.DevInfoTypes).BRANCH,
        issueId: Number(issueId),
        customTrigger: summaryItemComponent(branch),
        scopeId: `devInfoPanelApp${issueKey}`,
        placement: "bottom-end",
        offset: [
            -8,
            8
        ],
        zIndex: (0, $dPMMf.layers).modal,
        location: (0, $2425df669549d924$export$76a449e52fa0e1e8)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($96019a2bc698b926$var$CreateBranchSummaryItem, {
        branchTargets: branchTargetsWithUrls,
        hasBranchCapabilities: hasBranchCapabilities,
        shouldForceVisibleSecondary: shouldForceVisibleSecondary,
        setShouldForceVisibleSecondary: setShouldForceVisibleSecondary
    });
};
const $96019a2bc698b926$var$Branch = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "development-summary-branch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($96019a2bc698b926$var$BranchInner, props));
var $96019a2bc698b926$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $96019a2bc698b926$var$Branch;
const $96019a2bc698b926$var$BoldFont = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_k48p1wq8",
            __cmplp.className
        ])
    });
});

});
parcelRegister("awZZu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bb7d4b05cefe88d0219507dc0673c3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7aacfa98324a1e60$var$_react = $7aacfa98324a1e60$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7aacfa98324a1e60$var$_baseNew = $7aacfa98324a1e60$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7aacfa98324a1e60$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7aacfa98324a1e60$var$BranchIcon = (props)=>/*#__PURE__*/ $7aacfa98324a1e60$var$_react.default.createElement($7aacfa98324a1e60$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$7aacfa98324a1e60$var$BranchIcon.displayName = 'BranchIcon';
var $7aacfa98324a1e60$var$_default = module.exports.default = $7aacfa98324a1e60$var$BranchIcon;

});

parcelRegister("jlvUH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bf5f697d891cc6bba8e40c46639eb125>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e158bbdd28450239$var$_react = $e158bbdd28450239$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e158bbdd28450239$var$_branch = $e158bbdd28450239$var$_interopRequireDefault((parcelRequire("awZZu")));

var $e158bbdd28450239$var$_branches = $e158bbdd28450239$var$_interopRequireDefault((parcelRequire("1H8nC")));
function $e158bbdd28450239$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for BranchIcon.
 * This component is BranchIcon, with `UNSAFE_fallbackIcon` set to "BitbucketBranchesIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e158bbdd28450239$var$BranchIcon = (props)=>/*#__PURE__*/ $e158bbdd28450239$var$_react.default.createElement($e158bbdd28450239$var$_branch.default, Object.assign({
        LEGACY_fallbackIcon: $e158bbdd28450239$var$_branches.default
    }, props));
$e158bbdd28450239$var$BranchIcon.Name = 'BranchIconMigration';
var $e158bbdd28450239$var$_default = module.exports.default = $e158bbdd28450239$var$BranchIcon;

});
parcelRegister("1H8nC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $13c04eaf2d4940c0$var$_react = $13c04eaf2d4940c0$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $13c04eaf2d4940c0$var$_branch = $13c04eaf2d4940c0$var$_interopRequireDefault((parcelRequire("awZZu")));
function $13c04eaf2d4940c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $13c04eaf2d4940c0$var$BitbucketBranchesIcon = (props)=>/*#__PURE__*/ $13c04eaf2d4940c0$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M19 11c0 1.3-.8 2.4-2 2.8V15c0 2.2-1.8 4-4 4h-2.2c-.4 1.2-1.5 2-2.8 2-1.7 0-3-1.3-3-3 0-1.3.8-2.4 2-2.8V8.8C5.9 8.4 5 7.3 5 6c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.3-.8 2.4-2.1 2.8v6.4c.9.3 1.6.9 1.9 1.8H13c1.1 0 2-.9 2-2v-1.2c-1.2-.4-2-1.5-2-2.8 0-1.7 1.3-3 3-3s3 1.3 3 3M8 5c-.5 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1m8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1m-8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1"/></svg>`
    }, props, {
        newIcon: $13c04eaf2d4940c0$var$_branch.default
    }));
$13c04eaf2d4940c0$var$BitbucketBranchesIcon.displayName = 'BitbucketBranchesIcon';
var $13c04eaf2d4940c0$var$_default = module.exports.default = $13c04eaf2d4940c0$var$BitbucketBranchesIcon;

});


const $2425df669549d924$export$9b8283d5878d2491 = 'board';
const $2425df669549d924$export$76a449e52fa0e1e8 = 'issue';
const $2425df669549d924$export$ede40e627a0cbf14 = 'version_details';
const $2425df669549d924$export$464c50016d069471 = 'issue_view_child_issues_list';
const $2425df669549d924$export$3a46c5b594c0f84c = 'issue_view_linked_issues_list';

parcelRegister("cDP77", function(module, exports) {

$parcel$export(module.exports, "SummaryItem", () => $a76918bf4452b66c$export$f1c2de779b6eb7bc);
$parcel$export(module.exports, "SummaryItemContainer", () => $a76918bf4452b66c$export$1bf84b639674dc7a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cdbP5 = parcelRequire("cdbP5");

var $goZPP = parcelRequire("goZPP");

var $9itkV = parcelRequire("9itkV");

var $8rAKL = parcelRequire("8rAKL");

var $7ep4S = parcelRequire("7ep4S");

var $k71qx = parcelRequire("k71qx");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $f5dwt = parcelRequire("f5dwt");

var $coXKe = parcelRequire("coXKe");

var $lRq8t = parcelRequire("lRq8t");

var $1wBg3 = parcelRequire("1wBg3");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $6XJko = parcelRequire("6XJko");

var $c9uTK = parcelRequire("c9uTK");

var $bVtNk = parcelRequire("bVtNk");
const $a76918bf4452b66c$export$f1c2de779b6eb7bc = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { userPreferredLayout: userPreferredLayout } = (0, $coXKe.useUserPreferredWorkItemLayout)();
    const isWideLayout = userPreferredLayout === 'WIDE';
    const getIconAfter = (0, $eJOHy.useCallback)(()=>// temporary ternary for visual refresh update
        // eslint-disable-next-line no-nested-ternary
        props.href !== undefined && props.href != null ? (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9itkV))), {
            color: "var(--ds-link, #0C66E4)",
            label: formatMessage((0, $bVtNk.default).externalLink)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8rAKL))), {
            LEGACY_size: "small",
            label: formatMessage((0, $bVtNk.default).externalLink)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
            size: "small"
        }), [
        formatMessage,
        props.href
    ]);
    const iconBeforeProps = {
        iconBefore: props.icon
    };
    const renderClickableSummaryItem = (title, secondaryData, isOneClickLinkEnabled, secondaryHover)=>{
        const plainLinkContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a76918bf4452b66c$var$PlainLink, {
            href: props.href,
            onClick: props.onClick,
            "data-testid": "development-summary-common.ui.summary-item.plain-link"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a76918bf4452b66c$var$ContentContainer, {
            tabIndex: 0,
            isWideLayout: isWideLayout
        }, props.showIconInPlainLink && props.icon !== null && props.icon !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a76918bf4452b66c$var$BeforeIconContainer, null, props.icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a76918bf4452b66c$var$LeftContent, null, title), props.relativeDate !== undefined && props.relativeDate !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a76918bf4452b66c$var$RelativeDateContainer, null, props.relativeDate), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a76918bf4452b66c$var$SecondaryDataContainer, {
            "data-testid": "development-summary-common.ui.summary-item.secondary-data-container"
        }, secondaryData)));
        const linkFormattedButtonContainer = props.routerLinkConfig ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a76918bf4452b66c$var$LinkFormattedButton, {
            appearance: "link",
            component: (0, $c9uTK.Link),
            to: props.routerLinkConfig.route,
            params: props.routerLinkConfig.params,
            prefetch: props.routerLinkConfig.prefetch,
            onClick: props.onClick,
            ...iconBeforeProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a76918bf4452b66c$var$LeftAlignedContent, null, title)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a76918bf4452b66c$var$LinkFormattedButton, {
            ...isWideLayout ? {} : {
                shouldFitContainer: true
            },
            shouldFitContainer: true,
            appearance: "link",
            type: "button",
            onClick: props.onClick,
            href: props.href ?? '',
            ...iconBeforeProps,
            target: props.target,
            isSelected: props.isSelected,
            iconAfter: props.secondaryData !== undefined && props.secondaryData != null ? props.secondaryData : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a76918bf4452b66c$var$IconOnHoverContainer, null, getIconAfter()),
            testId: "development-summary-common.ui.summary-item.link-formatted-button",
            "aria-controls": props['aria-controls'],
            "aria-expanded": props['aria-expanded'],
            "aria-haspopup": props['aria-haspopup']
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a76918bf4452b66c$var$LeftAlignedContent, null, title));
        const handlerContentWithTooltip = !props.linkFormatting ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: title
        }, plainLinkContainer) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a76918bf4452b66c$var$LinkFormattedContainer, {
            isSecondaryHoverExisting: secondaryHover !== undefined && secondaryHover != null,
            "data-testid": "development-summary-common.ui.summary-item.link-formatted-container",
            isWideLayout: isWideLayout
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: title
        }, linkFormattedButtonContainer));
        const children = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f5dwt.default), {
            onEnter: (event)=>{
                props?.onClick?.(event, createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'button'
                }));
            }
        }, handlerContentWithTooltip), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a76918bf4452b66c$var$ActionItemsContainer, null, isOneClickLinkEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a76918bf4452b66c$var$ActionContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: props.oneClickToolTipContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "subtle",
            target: "_blank",
            rel: "noreferrer noopener",
            href: props.oneClickUrl || '',
            onClick: (_, analyticsEvent)=>{
                (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'devPanelSummaryOneClickLink', {
                    summaryItemType: props.itemType
                });
            },
            iconBefore: (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9itkV))), {
                color: "var(--ds-link, #0C66E4)",
                label: props.oneClickToolTipContent || ''
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8rAKL))), {
                LEGACY_size: "small",
                label: props.oneClickToolTipContent || ''
            }),
            testId: "development-summary-common.ui.summary-item.one-click-link-button"
        }))), secondaryHover !== undefined && secondaryHover != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a76918bf4452b66c$var$ActionContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
            attributes: {
                summaryItemType: props.itemType
            }
        }, secondaryHover))));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a76918bf4452b66c$var$RelativeContainer, {
            oneClickLinkEnabled: isOneClickLinkEnabled,
            forceVisibleSecondary: props.forceVisibleSecondary,
            isSecondaryHoverExisting: secondaryHover !== undefined && secondaryHover != null,
            isWideLayout: isWideLayout,
            "data-testid": "development-summary-common.ui.summary-item.relative-container"
        }, isWideLayout ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $a76918bf4452b66c$var$wideLayoutMaxWidthStyles
        }, children) : children);
    };
    const renderDisabledSummaryItem = (title)=>// @ts-expect-error - TS2741 - Property 'tabIndex' is missing in type '{ children: (false | Element)[]; }' but required in type 'Readonly<ThemedOuterStyledProps<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { tabIndex: any; }, any>>'.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a76918bf4452b66c$var$ContentContainer, {
            isWideLayout: isWideLayout
        }, props.icon !== undefined && props.icon !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.icon, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a76918bf4452b66c$var$LeftContent, null, title));
    const isOneClickLinkEnabled = props.itemCount === 1 && props.oneClickUrl !== null;
    return isWideLayout ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_18u0u2gc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a76918bf4452b66c$var$Row // @ts-expect-error - TS2322 - Type 'Ref<ElementType<any>> | undefined' is not assignable to type '((instance: any) => void) | RefObject<HTMLElement | SVGElement | Component<{}, {}, any>> | undefined'.
    , {
        innerRef: props.reference,
        disabled: props.disabled,
        "data-testid": props['data-testid'],
        showIconInPlainLink: props.showIconInPlainLink
    }, props.disableAnimationOnUpdates ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, !props.disabled ? renderClickableSummaryItem(props.title, props.secondaryData, isOneClickLinkEnabled, props.secondaryHover) : renderDisabledSummaryItem(props.title)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1wBg3.UpdateAnimator), {
        animationOut: $a76918bf4452b66c$var$FadeOutAnimation,
        animationIn: $a76918bf4452b66c$var$FadeInAnimation,
        updateProps: {
            title: props.title,
            secondaryData: props.secondaryData
        }
    }, ({ title: title, secondaryData: secondaryData })=>!props.disabled ? renderClickableSummaryItem(title, secondaryData, isOneClickLinkEnabled, props.secondaryHover) : renderDisabledSummaryItem(title)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a76918bf4452b66c$var$Row // @ts-expect-error - TS2322 - Type 'Ref<ElementType<any>> | undefined' is not assignable to type '((instance: any) => void) | RefObject<HTMLElement | SVGElement | Component<{}, {}, any>> | undefined'.
    , {
        innerRef: props.reference,
        disabled: props.disabled,
        "data-testid": props['data-testid'],
        showIconInPlainLink: props.showIconInPlainLink
    }, props.disableAnimationOnUpdates ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, !props.disabled ? renderClickableSummaryItem(props.title, props.secondaryData, isOneClickLinkEnabled, props.secondaryHover) : renderDisabledSummaryItem(props.title)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1wBg3.UpdateAnimator), {
        animationOut: $a76918bf4452b66c$var$FadeOutAnimation,
        animationIn: $a76918bf4452b66c$var$FadeInAnimation,
        updateProps: {
            title: props.title,
            secondaryData: props.secondaryData
        }
    }, ({ title: title, secondaryData: secondaryData })=>!props.disabled ? renderClickableSummaryItem(title, secondaryData, isOneClickLinkEnabled, props.secondaryHover) : renderDisabledSummaryItem(title)));
};
$a76918bf4452b66c$export$f1c2de779b6eb7bc.defaultProps = {
    disabled: false,
    secondaryData: null,
    href: null,
    itemType: null,
    itemCount: null,
    issueKey: null,
    oneClickUrl: null,
    oneClickToolTipContent: null,
    linkFormatting: false,
    target: '_blank',
    secondaryHover: null,
    // secondary hover component next to the one click button
    'aria-controls': '',
    'aria-expanded': false,
    'aria-haspopup': false,
    isSelected: false,
    showIconInPlainLink: false,
    disableAnimationOnUpdates: false
};
const $a76918bf4452b66c$export$1bf84b639674dc7a = ({ children: children })=>// @ts-expect-error - TS2741 - Property 'showIconInPlainLink' is missing in type '{ children: Element; }' but required in type 'Readonly<ThemedOuterStyledProps<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { showIconInPlainLink: boolean; disabled?: any; }, any>>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a76918bf4452b66c$var$Row, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a76918bf4452b66c$var$ContentContainer, null, children)); // eslint-disable-next-line @atlaskit/design-system/no-empty-styled-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a76918bf4452b66c$var$IconOnHoverContainer = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "sc-1s55t3a-0"
})({});
const $a76918bf4452b66c$var$LinkFormattedButton = /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
(0, $cdbP5.default)((0, $goZPP.default)).withConfig({
    componentId: "sc-1s55t3a-1"
})({}); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a76918bf4452b66c$var$LinkFormattedContainer = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "sc-1s55t3a-2"
})`flex:1 0 100%;${({ isSecondaryHoverExisting: isSecondaryHoverExisting })=>isSecondaryHoverExisting && (0, $cdbP5.css)({
        marginRight: `${"var(--ds-space-300, 24px)"}`
    })} ${$a76918bf4452b66c$var$LinkFormattedButton}{padding:0 ${"var(--ds-space-025, 2px)"};${({ isSecondaryHoverExisting: isSecondaryHoverExisting })=>isSecondaryHoverExisting && (0, $6XJko.isVisualRefreshEnabled)() && (0, $cdbP5.css)({
        marginRight: `padding: 0 ${"var(--ds-space-050, 4px)"} 0 ${"var(--ds-space-025, 2px)"};`
    })}}${$a76918bf4452b66c$var$IconOnHoverContainer}{opacity:0;}${({ isWideLayout: isWideLayout })=>`&:hover,
	&:focus-within {
		background-color: ${isWideLayout ? 'transparent' : "var(--ds-background-neutral-subtle-hovered, #091E420F)"};
		border-radius: 3px;
		${$a76918bf4452b66c$var$IconOnHoverContainer} {
			opacity: 1;
		}
	}`}`;
const $a76918bf4452b66c$var$fadeIn = /*#__PURE__*/ (0, $cdbP5.keyframes)({
    '0%': {
        opacity: 0
    },
    '100%': {
        opacity: 1
    }
});
const $a76918bf4452b66c$var$fadeOut = /*#__PURE__*/ (0, $cdbP5.keyframes)({
    '0%': {
        opacity: 1
    },
    '100%': {
        opacity: 0
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a76918bf4452b66c$var$ActionItemsContainer = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "sc-1s55t3a-3"
})({
    position: 'absolute',
    right: 0,
    top: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%'
}); // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a76918bf4452b66c$var$getSecondaryDataMarginRight = (isSecondaryHoverExisting, oneClickLinkEnabled)=>{
    if (oneClickLinkEnabled && isSecondaryHoverExisting) return (0, $cdbP5.css)({
        // With that spacing, we end up having 48px + 8px of paddingRight from the parent = 56px margin to the right
        // with the two icons on the right being 52px
        marginRight: `${"var(--ds-space-600, 48px)"}`
    });
    if (oneClickLinkEnabled || isSecondaryHoverExisting) return (0, $cdbP5.css)({
        marginRight: `${"var(--ds-space-250, 20px)"}`
    });
    return (0, $cdbP5.css)({
        marginRight: 0
    });
}; // FIXME: type error in object syntax
// WORKAROUND: return a plain object instead of `css()` call
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a76918bf4452b66c$var$SecondaryDataContainer = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "sc-1s55t3a-4"
})({
    marginRight: 0,
    transition: 'margin 0.22s ease-in-out'
}); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a76918bf4452b66c$var$RelativeContainer = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "sc-1s55t3a-5"
})`position:relative;${$a76918bf4452b66c$var$ActionItemsContainer}{opacity:0;transition:opacity 0.3s ease-out;}&:hover,&:focus-within{${({ isWideLayout: isWideLayout })=>isWideLayout && `background-color: ${"var(--ds-background-neutral-subtle-hovered, #091E420F)"};`} ${$a76918bf4452b66c$var$ActionItemsContainer}{opacity:1;}${$a76918bf4452b66c$var$SecondaryDataContainer}{${(props)=>$a76918bf4452b66c$var$getSecondaryDataMarginRight(props.isSecondaryHoverExisting, props.oneClickLinkEnabled)}}}${({ forceVisibleSecondary: forceVisibleSecondary })=>forceVisibleSecondary && // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $cdbP5.css)`${$a76918bf4452b66c$var$ActionItemsContainer}{opacity:1;}${$a76918bf4452b66c$var$SecondaryDataContainer}{${(props)=>$a76918bf4452b66c$var$getSecondaryDataMarginRight(props.isSecondaryHoverExisting, props.oneClickLinkEnabled)}}`}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a76918bf4452b66c$var$FadeOutAnimation = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "sc-1s55t3a-6"
})({
    animation: `${$a76918bf4452b66c$var$fadeOut} 0.8s ease-out`
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a76918bf4452b66c$var$FadeInAnimation = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "sc-1s55t3a-7"
})({
    animation: `${$a76918bf4452b66c$var$fadeIn} 0.8s ease-in`
}); // eslint-disable-next-line @typescript-eslint/no-explicit-any,  @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a76918bf4452b66c$var$ContentContainer = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "sc-1s55t3a-8"
})({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ tabIndex: tabIndex })=>tabIndex !== undefined && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $cdbP5.css)({
        borderRadius: '3px',
        '&:focus': {
            boxShadow: `inset 2px 2px ${"var(--ds-border-focused, #388BFF)"}, inset -2px -2px ${"var(--ds-border-focused, #388BFF)"}`
        },
        '&:active': {
            backgroundColor: "var(--ds-background-selected, #E9F2FF)"
        }
    }), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles
({ isWideLayout: isWideLayout })=>`&:hover {
				background-color: ${isWideLayout ? 'transparent' : "var(--ds-background-neutral-subtle-hovered, #091E420F)"};
			},`); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @typescript-eslint/no-explicit-any,  @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a76918bf4452b66c$var$Row = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "sc-1s55t3a-9"
})`margin:0 ${"var(--ds-space-negative-100, -8px)"};${$a76918bf4452b66c$var$ContentContainer}{height:32px;${({ showIconInPlainLink: showIconInPlainLink })=>showIconInPlainLink ? (0, $cdbP5.css)({
        padding: `0 ${"var(--ds-space-100, 8px)"} 0 ${"var(--ds-space-025, 2px)"}`
    }) : (0, $cdbP5.css)({
        padding: `0 ${"var(--ds-space-100, 8px)"}`
    })} ${({ disabled: disabled = false })=>disabled ? (0, $cdbP5.css)({
        color: "var(--ds-text-subtlest, #626F86)"
    }) : (0, $cdbP5.css)({
        color: "var(--ds-text, #172B4D)"
    })}}width:100%;`;
const $a76918bf4452b66c$var$wideLayoutMaxWidthStyles = (0, $1DXK0.xcss)({
    position: 'relative',
    maxWidth: '240px'
});
const $a76918bf4452b66c$var$wideLayout = null;
const $a76918bf4452b66c$var$ellipsisStyles = /*#__PURE__*/ (0, $cdbP5.css)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a76918bf4452b66c$var$BeforeIconContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _19pkidpf _2hwxv77o _otyridpf _18u0v77o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a76918bf4452b66c$var$LeftAlignedContent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _y3gn1e5h _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $a76918bf4452b66c$var$PlainLink = /*#__PURE__*/ (0, $cdbP5.default).a.withConfig({
    componentId: "sc-1s55t3a-10"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: props.onClick ? 'pointer' : 'default',
        '&:hover, &:focus, &:active': {
            textDecoration: 'none'
        }
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a76918bf4452b66c$var$ActionContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1l7b _18u0v77o",
            __cmplp.className
        ])
    });
}); // FIXME: type error in object syntax from ellipsisStyles
const $a76918bf4452b66c$var$RelativeDateContainer = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "sc-1s55t3a-11"
})`${$a76918bf4452b66c$var$ellipsisStyles} flex:0 5 auto;div[role='presentation']{${$a76918bf4452b66c$var$ellipsisStyles}}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a76918bf4452b66c$var$LeftContent = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "sc-1s55t3a-12"
})({
    flexDirection: 'column',
    textAlign: 'left',
    margin: `0 ${"var(--ds-space-025, 2px)"}`
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$a76918bf4452b66c$var$ellipsisStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $cdbP5.css)({
        marginRight: "var(--ds-space-050, 4px)",
        flex: '1 1 auto'
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a76918bf4452b66c$export$7ed12d2a5241e393 = {
    IconOnHoverContainer: $a76918bf4452b66c$var$IconOnHoverContainer,
    PlainLink: $a76918bf4452b66c$var$PlainLink,
    ActionContainer: $a76918bf4452b66c$var$ActionContainer,
    LeftContent: $a76918bf4452b66c$var$LeftContent,
    ContentContainer: $a76918bf4452b66c$var$ContentContainer,
    LeftAlignedContent: $a76918bf4452b66c$var$LeftAlignedContent,
    LinkFormattedButton: $a76918bf4452b66c$var$LinkFormattedButton,
    BeforeIconContainer: $a76918bf4452b66c$var$BeforeIconContainer,
    RelativeDateContainer: $a76918bf4452b66c$var$RelativeDateContainer
};

});
parcelRegister("1wBg3", function(module, exports) {

$parcel$export(module.exports, "UpdateAnimator", () => $17ea4bbbd7a2aa08$export$5790c81d12f4c05);

var $eJOHy = parcelRequire("eJOHy");

var $j5V5L = parcelRequire("j5V5L");
class $17ea4bbbd7a2aa08$export$5790c81d12f4c05 extends (0, $eJOHy.Component) {
    render() {
        const animatedProps = this.state.prevUpdateProps || this.props.updateProps;
        return this.animationWrapper(this.props.children(animatedProps));
    }
    constructor(...args){
        super(...args), this.state = {
            prevUpdateProps: null,
            shouldAnimateIn: false,
            shouldAnimateOut: false
        }, this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!(0, $j5V5L.default)(nextProps.updateProps, this.props.updateProps)) this.setState({
                prevUpdateProps: this.props.updateProps,
                shouldAnimateOut: true
            });
        }, this.onAnimationOutEnd = ()=>{
            this.setState({
                prevUpdateProps: null,
                shouldAnimateOut: false,
                shouldAnimateIn: true
            });
        }, this.onAnimationInEnd = ()=>{
            this.setState({
                shouldAnimateIn: false
            });
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.animationWrapper = (element)=>{
            const { animationOut: AnimationOut, animationIn: AnimationIn } = this.props;
            if (this.state.shouldAnimateOut) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AnimationOut, {
                onAnimationEnd: this.onAnimationOutEnd
            }, element);
            if (this.state.shouldAnimateIn) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AnimationIn, {
                onAnimationEnd: this.onAnimationInEnd
            }, element);
            return element;
        };
    }
}

});

parcelRegister("bVtNk", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd78fdb79e1afc33$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $fd78fdb79e1afc33$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    externalLink: {
        "id": "development-summary-common.summary-item.external-link",
        "defaultMessage": "Link to external website in new tab"
    }
});

});


parcelRegister("2NsFw", function(module, exports) {

$parcel$export(module.exports, "CreateBranchCommandButton", () => $922d70c404b7eb4c$export$20c6aa8af564477c);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $fL0In = parcelRequire("fL0In");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");

var $84MMG = parcelRequire("84MMG");
const $922d70c404b7eb4c$var$TerminalGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: "currentColor",
        d: "M11.236 12C11.236 11.6675 11.104 11.3487 10.8689 11.1135L5.1101 5.35474C4.87652 5.12584 4.56205 4.99836 4.23501 5.00002C3.90798 5.00167 3.59481 5.13231 3.36356 5.36356C3.13231 5.59481 3.00167 5.90798 3.00002 6.23501C2.99836 6.56205 3.12584 6.87652 3.35474 7.11009L8.24465 12L3.35474 16.8899C3.12584 17.1234 2.99836 17.438 3.00002 17.765C3.00167 18.0921 3.13231 18.4052 3.36356 18.6365C3.59481 18.8677 3.90798 18.9983 4.23501 19C4.56205 19.0017 4.87652 18.8742 5.1101 18.6452L10.8689 12.8865C11.104 12.6513 11.236 12.3325 11.236 12ZM13.0305 16.2844C12.3381 16.2844 11.7768 16.8458 11.7768 17.5382C11.7768 18.2307 12.3381 18.7921 13.0305 18.7921H20.5535C21.246 18.7921 21.8073 18.2307 21.8073 17.5382C21.8073 16.8458 21.246 16.2844 20.5535 16.2844H13.0305Z"
    }));
const $922d70c404b7eb4c$var$TerminalIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        glyph: $922d70c404b7eb4c$var$TerminalGlyph,
        ...props
    });
const $922d70c404b7eb4c$export$20c6aa8af564477c = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onClick: onClickProp, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const tooltipContent = formatMessage((0, $84MMG.default).tooltipContent);
    const onClick = (e, analyticsEvent)=>{
        onClickProp && onClickProp();
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'createBranchCommandButton');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: tooltipContent,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        ref: ref,
        ...props,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($922d70c404b7eb4c$var$TerminalIcon, {
            label: tooltipContent,
            size: "small"
        }),
        onClick: onClick,
        testId: "development-summary-branch.ui.create-branch-command-button.create-branch-command-button"
    }));
});

});
parcelRegister("84MMG", function(module, exports) {

$parcel$export(module.exports, "default", () => $a11fb6b8c80f897e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a11fb6b8c80f897e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    tooltipContent: {
        "id": "development-summary-branch.create-branch-command-button.tooltip-content",
        "defaultMessage": "Create and checkout new branch"
    }
});

});


parcelRegister("dpFae", function(module, exports) {

$parcel$export(module.exports, "CreateBranchIconButton", () => $36f4b60df92eb2e0$export$d8c6bc0d6d054dcd);

var $eJOHy = parcelRequire("eJOHy");

var $dcLzM = parcelRequire("dcLzM");

var $goZPP = parcelRequire("goZPP");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");

var $le84y = parcelRequire("le84y");
const $36f4b60df92eb2e0$export$d8c6bc0d6d054dcd = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onClick: onClickProp, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const tooltipContent = formatMessage((0, $le84y.default).tooltipContent);
    const onClick = (e, analyticsEvent)=>{
        onClickProp && onClickProp();
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'createBranchIconButton');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: tooltipContent,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        ref: ref,
        ...props,
        testId: "development-summary-branch.ui.create-branch-icon-button.button",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
            label: tooltipContent,
            color: "var(--ds-icon, #44546F)",
            size: "small"
        }),
        onClick: onClick
    }));
});

});
parcelRegister("le84y", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd50abe268caf7d8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $fd50abe268caf7d8$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    tooltipContent: {
        "id": "development-summary-branch.create-branch-icon-button.tooltip-content",
        "defaultMessage": "Create new branch"
    }
});

});


parcelRegister("2Ioi6", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaa9185b3850ad4f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $aaa9185b3850ad4f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "development-summary-branch.title",
        "defaultMessage": "{styledCount} {count, plural, one {branch} other {branches}}"
    },
    emptyState: {
        "id": "development-summary-branch.empty-state",
        "defaultMessage": "{Icon} Branch"
    },
    emptyStateUpdate: {
        "id": "development-summary-branch.empty-state-update",
        "defaultMessage": "Branch"
    },
    createBranchTitle: {
        "id": "development-summary-branch.create-branch-title",
        "defaultMessage": "{Icon} Create Branch"
    },
    createBranchTitleLowercase: {
        "id": "development-summary-branch.create-branch-title-lowercase",
        "defaultMessage": "Create branch"
    },
    createBranchDropdownIconLabelLowercase: {
        "id": "development-summary-branch.create-branch-dropdown-icon-label-lowercase",
        "defaultMessage": "Create branch"
    },
    tooltip: {
        "id": "development-summary-branch.tooltip",
        "defaultMessage": "Open branch"
    },
    atlascodeProductName: {
        "id": "development-summary-branch-atlascode-product-name",
        "defaultMessage": "VS Code"
    }
});

});

parcelRegister("4eEF9", function(module, exports) {

$parcel$export(module.exports, "createVsCodeBranchTarget", () => $201c07dd65e31566$export$282914c8eb7cb11b);
const $201c07dd65e31566$var$buildVsCodeUrl = (issueKey, host)=>{
    const issueKeyQs = encodeURIComponent(issueKey);
    const hostQs = encodeURIComponent(host);
    return `vscode://atlassian.atlascode/startWorkOnJira?key=${issueKeyQs}&site=${hostQs}&source=jira`;
};
const $201c07dd65e31566$export$282914c8eb7cb11b = (productName, issueKey, host)=>({
        name: productName,
        url: $201c07dd65e31566$var$buildVsCodeUrl(issueKey, host),
        baseUrl: null,
        applicationLinkId: null,
        applicationType: 'vscode.atlascode',
        iconClass: null,
        iconUrl: 'https://atlassian.gallerycdn.vsassets.io/extensions/atlassian/atlascode/3.9.11/1749169574887/Microsoft.VisualStudio.Services.Icons.Small'
    });

});

parcelRegister("1rNdT", function(module, exports) {

module.exports = (parcelRequire("g81qY"))('create-branch-dropdown-iv-llc-dev-panel', function() {
    return parcelRequire('cbTcm');
}, function() {
    return parcelRequire('1BivY');
});

});
parcelRegister("g81qY", function(module, exports) {
"use strict";
module.exports = function loadCond(cond, ifTrue, ifFalse, fallback) {
    let result = globalThis.__MCOND(cond);
    try {
        return result ? ifTrue() : ifFalse();
    } catch (err) {
        if (fallback) {
            console.error('Conditional dependency was not registered when executing. Falling back to synchronous bundle loading.');
            for (const url of fallback.urls)fallback.loader(url);
            return result ? ifTrue() : ifFalse();
        } else throw err;
    }
};

});



parcelRegister("9zKYv", function(module, exports) {

$parcel$export(module.exports, "CommitEmptyState", () => $bed7d77fa1966569$export$9487062309268bce);
$parcel$export(module.exports, "default", () => $bed7d77fa1966569$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kQ82p = parcelRequire("kQ82p");

var $5lAAn = parcelRequire("5lAAn");

var $1OQKp = parcelRequire("1OQKp");

var $7XCnf = parcelRequire("7XCnf");

var $lyfmv = parcelRequire("lyfmv");

var $lopBx = parcelRequire("lopBx");

var $dPMMf = parcelRequire("dPMMf");


var $ihplE = parcelRequire("ihplE");

var $hNyRP = parcelRequire("hNyRP");

var $1A9lq = parcelRequire("1A9lq");

var $fQelk = parcelRequire("fQelk");

var $bE7Lx = parcelRequire("bE7Lx");

var $cDP77 = parcelRequire("cDP77");

var $3eXrV = parcelRequire("3eXrV");

var $dTocu = parcelRequire("dTocu");

var $ch9En = parcelRequire("ch9En");

var $gCeeo = parcelRequire("gCeeo");
var $iqtgH = parcelRequire("iqtgH");
var $ftN6c = parcelRequire("ftN6c");

var $16sa1 = parcelRequire("16sa1");

var $6XJko = parcelRequire("6XJko");

var $cleCy = parcelRequire("cleCy");

var $9bW2S = parcelRequire("9bW2S");

var $azO79 = parcelRequire("azO79");
const $bed7d77fa1966569$var$COMMIT_SUMMARY_ITEM_TEST_ID = 'development-summary-commit.ui.summary-item'; // eslint-disable-next-line jira/styled/styled-component-order, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bed7d77fa1966569$var$IconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_s7n4nkob",
            __cmplp.className
        ])
    });
});
const $bed7d77fa1966569$var$CommitIconOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bed7d77fa1966569$var$IconWrapper, {
    "aria-hidden": true
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lyfmv))), {
    LEGACY_size: "medium",
    spacing: "spacious",
    label: ""
}));
const $bed7d77fa1966569$var$CommitIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bed7d77fa1966569$var$IconWrapper, {
    "aria-hidden": true
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7XCnf))), {
    color: "var(--ds-link, #0C66E4)",
    label: ""
}));
const $bed7d77fa1966569$var$CreateCommitSummaryItem = ({ shouldForceVisibleSecondary: shouldForceVisibleSecondary, setShouldForceVisibleSecondary: setShouldForceVisibleSecondary, hasCommitCapabilities: hasCommitCapabilities, commitCount: commitCount })=>{
    const { formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const downChevron = (0, $eJOHy.useMemo)(()=>(0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
            color: "var(--ds-link, #0C66E4)",
            label: formatMessage((0, $9bW2S.default).createCommitDropdownIconLabel),
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $9bW2S.default).createCommitDropdownIconLabel),
            size: "small"
        }), [
        formatMessage
    ]);
    const commonSummaryItemProps = {
        title: formatMessage((0, $9bW2S.default).createCommitTitleLowercase),
        linkFormatting: true,
        icon: (0, $6XJko.isVisualRefreshEnabled)() ? $bed7d77fa1966569$var$CommitIcon : $bed7d77fa1966569$var$CommitIconOld
    };
    return hasCommitCapabilities ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireUiAnalytics), {
        key: "viewed button createDevAction",
        action: "viewed",
        actionSubject: "button",
        actionSubjectId: "createDevAction",
        attributes: {
            inline: false,
            summaryItemType: 'commit',
            isCommitSummary: Boolean(commitCount)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $azO79.default), {
        onOpenDropdown: ({ isOpen: isOpen })=>{
            setShouldForceVisibleSecondary(isOpen);
        },
        getDropdownTrigger: ({ ref: ref, onClick: onClick, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDP77.SummaryItem), {
                secondaryData: downChevron,
                forceVisibleSecondary: shouldForceVisibleSecondary,
                reference: ref,
                ...commonSummaryItemProps,
                ...props,
                onClick: ()=>{
                    onClick();
                    (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createDevAction', {
                        inline: false,
                        summaryItemType: 'commit'
                    });
                },
                "data-testid": $bed7d77fa1966569$var$COMMIT_SUMMARY_ITEM_TEST_ID
            })
    })) : null;
};
const $bed7d77fa1966569$export$b141efd0b0fb9174 = (previousProps, nextProps)=>nextProps.commit?.count === previousProps.commit?.count && nextProps.commit?.lastUpdated === previousProps.commit?.lastUpdated && nextProps.commit?.url === previousProps.commit?.url;
const $bed7d77fa1966569$var$CommitInner = /*#__PURE__*/ (0, $eJOHy.memo)(({ onClick: onClick, commit: commit, hasCommitCapabilities: hasCommitCapabilities, issueId: issueId, issueKey: issueKey })=>{
    const { formatNumber: formatNumber, formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const { locale: locale, timeZone: timeZone } = (0, $fQelk.useLocaleTimeZone)();
    const [shouldForceVisibleSecondary, setShouldForceVisibleSecondary] = (0, $eJOHy.useState)(false);
    const { count: count = 0, lastUpdated: lastUpdated } = commit ?? {};
    const title = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3eXrV.FormattedI18nMessage), {
            componentsMapping: {
                bold: $bed7d77fa1966569$var$BoldFont
            },
            message: formatMessage((0, $9bW2S.default).title, {
                count: formatNumber(count),
                boldStart: '{boldStart}',
                boldEnd: '{boldEnd}'
            })
        }), [
        formatMessage,
        formatNumber,
        count
    ]);
    const relativeDate = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bed7d77fa1966569$var$RelativeDateContainer, null, lastUpdated !== null && lastUpdated !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bE7Lx.default), {
            date: (0, $kQ82p.default)(lastUpdated),
            locale: locale,
            timeZone: timeZone,
            strict: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)), [
        lastUpdated,
        locale,
        timeZone
    ]);
    const summaryItemComponent = (commitInput)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDP77.SummaryItem), {
            title: title,
            relativeDate: relativeDate,
            onClick: onClick,
            itemType: "commit",
            itemCount: commitInput.count,
            oneClickUrl: commitInput.url,
            oneClickToolTipContent: formatMessage((0, $9bW2S.default).tooltip),
            secondaryHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $azO79.default), {
                getDropdownTrigger: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cleCy.CreateCommitIconButton), props),
                onOpenDropdown: ({ isOpen: isOpen })=>{
                    setShouldForceVisibleSecondary(isOpen);
                }
            }),
            forceVisibleSecondary: shouldForceVisibleSecondary,
            "data-testid": $bed7d77fa1966569$var$COMMIT_SUMMARY_ITEM_TEST_ID
        });
    if (commit && count > 0) {
        if ((0, $lopBx.isFedRamp)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
            fallback: summaryItemComponent(commit),
            name: "async-commit-dev-info-icon"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hNyRP.AsyncDevInfoIcon), {
            devInfoType: (0, $ihplE.DevInfoTypes).COMMIT,
            issueId: Number(issueId),
            customTrigger: summaryItemComponent(commit),
            scopeId: `devInfoPanelApp${issueKey}`,
            placement: "bottom-end",
            offset: [
                -8,
                8
            ],
            zIndex: (0, $dPMMf.layers).modal,
            location: (0, $2425df669549d924$export$76a449e52fa0e1e8)
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1A9lq.default), {
            devInfoType: (0, $ihplE.DevInfoTypes).COMMIT,
            issueId: Number(issueId),
            customTrigger: summaryItemComponent(commit),
            scopeId: `devInfoPanelApp${issueKey}`,
            placement: "bottom-end",
            offset: [
                -8,
                8
            ],
            zIndex: (0, $dPMMf.layers).modal,
            location: (0, $2425df669549d924$export$76a449e52fa0e1e8)
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bed7d77fa1966569$var$CreateCommitSummaryItem, {
        hasCommitCapabilities: hasCommitCapabilities,
        shouldForceVisibleSecondary: shouldForceVisibleSecondary,
        setShouldForceVisibleSecondary: setShouldForceVisibleSecondary,
        commitCount: count
    });
}, $bed7d77fa1966569$export$b141efd0b0fb9174);
const $bed7d77fa1966569$export$9487062309268bce = ()=>{
    const { formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const icon = (0, $6XJko.isVisualRefreshEnabled)() ? $bed7d77fa1966569$var$CommitIcon : $bed7d77fa1966569$var$CommitIconOld;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDP77.SummaryItem), {
        icon: icon,
        disabled: true,
        title: formatMessage((0, $9bW2S.default).emptyStateUpdate),
        "data-testid": $bed7d77fa1966569$var$COMMIT_SUMMARY_ITEM_TEST_ID
    });
};
const $bed7d77fa1966569$var$Commit = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "development-summary-commit"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bed7d77fa1966569$var$CommitInner, props)));
var $bed7d77fa1966569$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $bed7d77fa1966569$var$Commit;
const $bed7d77fa1966569$var$BoldFont = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_k48p1wq8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bed7d77fa1966569$var$RelativeDateContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8dcr7 _syaz1gjq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7XCnf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::06952e599791aaa8e8e82dba5053d210>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5cbbcf5690c6b367$var$_react = $5cbbcf5690c6b367$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5cbbcf5690c6b367$var$_baseNew = $5cbbcf5690c6b367$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $5cbbcf5690c6b367$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Commit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for commits in Jira or Bitbucket.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5cbbcf5690c6b367$var$CommitIcon = (props)=>/*#__PURE__*/ $5cbbcf5690c6b367$var$_react.default.createElement($5cbbcf5690c6b367$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 5.354a2.751 2.751 0 0 0 0 5.292V16h1.5v-5.353a2.751 2.751 0 0 0 0-5.293V0h-1.5zM8 6.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5" clip-rule="evenodd"/>`
    }, props));
$5cbbcf5690c6b367$var$CommitIcon.displayName = 'CommitIcon';
var $5cbbcf5690c6b367$var$_default = module.exports.default = $5cbbcf5690c6b367$var$CommitIcon;

});

parcelRegister("lyfmv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1201ab50caa951687977050b2b11e97b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fb08b087cb0550d7$var$_react = $fb08b087cb0550d7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fb08b087cb0550d7$var$_commit = $fb08b087cb0550d7$var$_interopRequireDefault((parcelRequire("7XCnf")));

var $fb08b087cb0550d7$var$_commits = $fb08b087cb0550d7$var$_interopRequireDefault((parcelRequire("bAoP2")));
function $fb08b087cb0550d7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CommitIcon.
 * This component is CommitIcon, with `UNSAFE_fallbackIcon` set to "BitbucketCommitsIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for commits in Jira or Bitbucket.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fb08b087cb0550d7$var$CommitIcon = (props)=>/*#__PURE__*/ $fb08b087cb0550d7$var$_react.default.createElement($fb08b087cb0550d7$var$_commit.default, Object.assign({
        LEGACY_fallbackIcon: $fb08b087cb0550d7$var$_commits.default
    }, props));
$fb08b087cb0550d7$var$CommitIcon.Name = 'CommitIconMigration';
var $fb08b087cb0550d7$var$_default = module.exports.default = $fb08b087cb0550d7$var$CommitIcon;

});
parcelRegister("bAoP2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $86f64fb1220f49f8$var$_react = $86f64fb1220f49f8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $86f64fb1220f49f8$var$_commit = $86f64fb1220f49f8$var$_interopRequireDefault((parcelRequire("7XCnf")));
function $86f64fb1220f49f8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $86f64fb1220f49f8$var$BitbucketCommitsIcon = (props)=>/*#__PURE__*/ $86f64fb1220f49f8$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16 12c0-1.9-1.3-3.4-3-3.9V4c0-.6-.4-1-1-1s-1 .4-1 1v4.1c-1.7.4-3 2-3 3.9s1.3 3.4 3 3.9V20c0 .6.4 1 1 1s1-.4 1-1v-4.1c1.7-.5 3-2 3-3.9m-4 2c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2"/></svg>`
    }, props, {
        newIcon: $86f64fb1220f49f8$var$_commit.default
    }));
$86f64fb1220f49f8$var$BitbucketCommitsIcon.displayName = 'BitbucketCommitsIcon';
var $86f64fb1220f49f8$var$_default = module.exports.default = $86f64fb1220f49f8$var$BitbucketCommitsIcon;

});


parcelRegister("hNyRP", function(module, exports) {

$parcel$export(module.exports, "AsyncDevInfoIcon", () => $cfadcaa9c2465dbe$export$2677b3d5962c7f1d);

var $eJOHy = parcelRequire("eJOHy");

var $16sa1 = parcelRequire("16sa1");

var $bQWwW = parcelRequire("bQWwW");

const $cfadcaa9c2465dbe$export$d838a49898627bf3 = (0, $bQWwW.lazy)(()=>Promise.resolve((parcelRequire("1A9lq"))), {
    moduleId: "./src/packages/development/board/dev-info-icon/src/main.tsx"
});
const $cfadcaa9c2465dbe$export$2677b3d5962c7f1d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "asyncDevInfoIcon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cfadcaa9c2465dbe$export$d838a49898627bf3, props));

});

parcelRegister("fQelk", function(module, exports) {

$parcel$export(module.exports, "useLocaleTimeZone", () => $f52a21970143a13a$export$180a82d4f668e1c9);

var $2cfd4 = parcelRequire("2cfd4");

var $c9f6v = parcelRequire("c9f6v");
function $f52a21970143a13a$export$180a82d4f668e1c9() {
    const locale = (0, $2cfd4.useLocale)();
    const [{ data: data }] = (0, $c9f6v.useUserSubscriber)();
    return {
        locale: locale,
        timeZone: data?.timeZone
    };
}

});

parcelRegister("bE7Lx", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e213f65fee0e071$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $k71qx = parcelRequire("k71qx");

var $idGBm = parcelRequire("idGBm");

var $dTocu = parcelRequire("dTocu");

var $6uJpm = parcelRequire("6uJpm");

var $dO9h7 = parcelRequire("dO9h7");

var $i8kQm = parcelRequire("i8kQm");
const $4e213f65fee0e071$export$45c85543ba71221d = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
};
function $4e213f65fee0e071$var$RelativeDate(props) {
    const { locale: locale = (0, $6uJpm.defaultLocale), date: date, timeZone: timeZone, intl: { formatDate: formatDate }, strict: strict = false, delay: delay, position: position = 'top' } = props;
    const { formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const options = timeZone !== undefined && timeZone.trim() !== '' && timeZone !== null ? {
        ...$4e213f65fee0e071$export$45c85543ba71221d,
        timeZone: timeZone
    } : {
        ...$4e213f65fee0e071$export$45c85543ba71221d
    };
    const timeElapsed = strict ? (0, $dO9h7.formatDistanceStrictWithLocale)(date, new Date(), locale) : (0, $dO9h7.formatDistanceWithLocale)(date, new Date(), locale);
    const lastUpdateDateTime = formatDate(date.valueOf(), options);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: lastUpdateDateTime,
        position: position,
        delay: delay
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        as: "span",
        testId: "development-common.ui.relative-date"
    }, formatMessage((0, $i8kQm.default).relativeDate, {
        relativeDate: timeElapsed
    })));
}
var $4e213f65fee0e071$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($4e213f65fee0e071$var$RelativeDate);

});
parcelRegister("i8kQm", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0da8ae6f674cf56$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $c0da8ae6f674cf56$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    relativeDate: {
        "id": "development.common.components.relative-date.text",
        "defaultMessage": "{relativeDate} ago"
    }
});

});


parcelRegister("cleCy", function(module, exports) {

$parcel$export(module.exports, "CreateCommitIconButton", () => $2b6f1d02a4568d63$export$fa4479da71fc8551);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $jQjGM = parcelRequire("jQjGM");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $iqtgH = parcelRequire("iqtgH");

var $9fU44 = parcelRequire("9fU44");
const $2b6f1d02a4568d63$export$fa4479da71fc8551 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onClick: onClickProp, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const tooltipContent = formatMessage((0, $9fU44.default).tooltipContent);
    const onClick = (e, analyticsEvent)=>{
        onClickProp && onClickProp();
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'createDevAction', {
            inline: true,
            summaryItemType: 'commit'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: tooltipContent,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireUiAnalytics), {
        action: "viewed",
        actionSubject: "button",
        actionSubjectId: "createDevAction",
        attributes: {
            inline: true,
            summaryItemType: 'commit',
            isCommitSummary: true
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        ref: ref,
        ...props,
        appearance: "subtle",
        testId: "development-summary-commit.ui.create-commit-icon-button.button",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jQjGM))), {
            LEGACY_size: "small",
            label: tooltipContent
        }),
        onClick: onClick
    }));
});

});
parcelRegister("9fU44", function(module, exports) {

$parcel$export(module.exports, "default", () => $60aa64fcf2b73131$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $60aa64fcf2b73131$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    tooltipContent: {
        "id": "development-summary-commit.create-commit-icon-button.tooltip-content",
        "defaultMessage": "Create new commit"
    }
});

});


parcelRegister("9bW2S", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd6b7214cdc4bb36$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $bd6b7214cdc4bb36$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "development-summary-commit.title",
        "defaultMessage": "{boldStart}{count}{boldEnd} {count, plural, one {commit} other {commits}}"
    },
    emptyState: {
        "id": "development-summary-commit.empty-state",
        "defaultMessage": "{Icon} Commit"
    },
    emptyStateUpdate: {
        "id": "development-summary-commit.empty-state-update",
        "defaultMessage": "Commit"
    },
    createCommitTitleLowercase: {
        "id": "development-summary-commit.create-commit-title-lowercase",
        "defaultMessage": "Create commit"
    },
    createCommitDropdownIconLabel: {
        "id": "development-summary-commit.create-commit-dropdown-icon-label",
        "defaultMessage": "Open create commit dropdown"
    },
    tooltip: {
        "id": "development-summary-commit.tooltip",
        "defaultMessage": "Open commit"
    }
});

});

parcelRegister("azO79", function(module, exports) {

$parcel$export(module.exports, "default", () => $d038c325db7c62e5$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dPMMf = parcelRequire("dPMMf");

var $cNe2t = parcelRequire("cNe2t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $ciFJV = parcelRequire("ciFJV");

var $lEIrb = parcelRequire("lEIrb");
const $d038c325db7c62e5$var$entryPointParams = {};
const $d038c325db7c62e5$export$6abc9e0bd1890013 = ({ onOpenDropdown: onOpenDropdown, getDropdownTrigger: getDropdownTrigger })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const previousOpen = (0, $eJOHy.useRef)(false);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $lEIrb.createCommitDropdownContentEntrypoint), $d038c325db7c62e5$var$entryPointParams);
    const triggerRef = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    (0, $eJOHy.useEffect)(()=>{
        if (previousOpen.current !== isOpen) {
            previousOpen.current = isOpen;
            isOpen && (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdown opened', 'commitCreateDropdown');
            !isOpen && (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdown closed', 'commitCreateDropdown');
            onOpenDropdown && onOpenDropdown({
                isOpen: isOpen
            });
        }
    }, [
        createAnalyticsEvent,
        isOpen,
        onOpenDropdown
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        id: "create-commit-dropdown",
        testId: "development-summary-commit.ui.create-commit-dropdown.popup",
        zIndex: (0, $dPMMf.layers).modal + 1,
        placement: "bottom-end",
        messageId: "development-summary-commit.ui.create-commit-dropdown.popup",
        messageType: "transactional",
        shouldFlip: true,
        trigger: (triggerProps)=>getDropdownTrigger({
                ...triggerProps,
                isSelected: isOpen,
                onClick: ()=>setIsOpen(!isOpen),
                ref: (element)=>{
                    triggerRef(element);
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    triggerProps.ref(element);
                }
            }),
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "dev-panel-create-commit-dropdown-content",
                packageName: "jira-development-summary-commit",
                fallback: null,
                runtimeProps: {}
            })
    });
};
var $d038c325db7c62e5$export$2e2bcd8739ae039 = $d038c325db7c62e5$export$6abc9e0bd1890013;

});
parcelRegister("lEIrb", function(module, exports) {

$parcel$export(module.exports, "createCommitDropdownContentEntrypoint", () => $97dd6655f0fa4932$export$e7b0c71bc90db4e9);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $97dd6655f0fa4932$export$e7b0c71bc90db4e9 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("aqYg3")), {
        moduleId: "c85aa6fe",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("aqYg3", function(module, exports) {

let $798b1311bcc6ad57$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $798b1311bcc6ad57$var$load("aNbL6").then(()=>parcelRequire('fcD4i'));

});




parcelRegister("8hEMV", function(module, exports) {

$parcel$export(module.exports, "PullRequestEmptyState", () => $cbd98bd9d336d6f4$export$a7840d0eddc64f6e);
$parcel$export(module.exports, "default", () => $cbd98bd9d336d6f4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jVVB7 = parcelRequire("jVVB7");

var $jdqdp = parcelRequire("jdqdp");

var $lopBx = parcelRequire("lopBx");

var $dPMMf = parcelRequire("dPMMf");


var $ihplE = parcelRequire("ihplE");

var $hNyRP = parcelRequire("hNyRP");

var $1A9lq = parcelRequire("1A9lq");

var $cDP77 = parcelRequire("cDP77");

var $3eXrV = parcelRequire("3eXrV");

var $dTocu = parcelRequire("dTocu");

var $16sa1 = parcelRequire("16sa1");

var $ch9En = parcelRequire("ch9En");

var $1P6aF = parcelRequire("1P6aF");

var $cDDVn = parcelRequire("cDDVn");

var $kpuNj = parcelRequire("kpuNj");


const $cbd98bd9d336d6f4$var$ConditionalCreatePullrequestDropdown = (parcelRequire("2F11O")).default;
const $cbd98bd9d336d6f4$var$statusCategoryToAppearenceMap = {
    OPEN: 'inprogress',
    DRAFT: 'inprogress',
    MERGED: 'success',
    DECLINED: 'removed'
};
const $cbd98bd9d336d6f4$export$b141efd0b0fb9174 = (previousProps, nextProps)=>nextProps.pullRequest?.count === previousProps.pullRequest?.count && nextProps.pullRequest?.lastUpdated === previousProps.pullRequest?.lastUpdated && nextProps.pullRequest?.stateCount === previousProps.pullRequest?.stateCount && nextProps.pullRequest?.state === previousProps.pullRequest?.state && nextProps.pullRequest?.url === previousProps.pullRequest?.url && nextProps.pullRequest?.createPullRequestTargets?.length === previousProps.pullRequest?.createPullRequestTargets?.length;
const $cbd98bd9d336d6f4$var$PullRequestInner = /*#__PURE__*/ (0, $eJOHy.memo)(({ onClick: onClick, branchesCount: branchesCount, pullRequest: pullRequest, hasErrors: hasErrors, issueId: issueId, issueKey: issueKey })=>{
    const { formatNumber: formatNumber, formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const { count: pullRequestsCount = 0, stateCount: stateCount = 0, state: state } = pullRequest ?? {};
    const [shouldForceVisibleSecondary, setShouldForceVisibleSecondary] = (0, $eJOHy.useState)(false);
    const title = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3eXrV.FormattedI18nMessage), {
            componentsMapping: {
                bold: $cbd98bd9d336d6f4$var$BoldFont
            },
            message: formatMessage((0, $kpuNj.default).title, {
                count: formatNumber(stateCount),
                boldStart: '{boldStart}',
                boldEnd: '{boldEnd}'
            })
        }), [
        formatMessage,
        formatNumber,
        stateCount
    ]);
    const secondaryData = (0, $eJOHy.useMemo)(()=>state ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
            appearance: $cbd98bd9d336d6f4$var$statusCategoryToAppearenceMap[state]
        }, state) : undefined, [
        state
    ]);
    const summaryItemComponent = (pullRequestInput, targetsLength, href)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDP77.SummaryItem), {
            title: title,
            secondaryData: secondaryData,
            onClick: onClick,
            itemType: "pullrequest",
            itemCount: pullRequestInput.stateCount,
            oneClickUrl: pullRequestInput.url,
            oneClickToolTipContent: formatMessage((0, $kpuNj.default).tooltip),
            "data-testid": "development-summary-pull-request.ui.summary-item",
            secondaryHover: targetsLength > 0 || hasErrors ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cbd98bd9d336d6f4$var$ConditionalCreatePullrequestDropdown, {
                hasErrors: hasErrors,
                onAuthErrorClick: onClick,
                createPullRequestTargets: pullRequestInput.createPullRequestTargets,
                renderDropdownTrigger: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1P6aF.CreatePRIconButton), {
                        ...props,
                        href: href
                    }),
                onOpenDropdown: ({ isOpen: isOpen })=>{
                    setShouldForceVisibleSecondary(isOpen);
                }
            }) : null,
            forceVisibleSecondary: shouldForceVisibleSecondary
        });
    if (pullRequest && pullRequestsCount) {
        const targetsLength = pullRequest.createPullRequestTargets?.length || 0;
        const isSingleTarget = pullRequest.createPullRequestTargets?.length === 1;
        const href = isSingleTarget && !hasErrors // if there are error messages in response we want to show the dropdown to show the error message.
         ? pullRequest?.createPullRequestTargets?.[0]?.createPullRequestUrl : undefined;
        if ((0, $lopBx.isFedRamp)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
            fallback: summaryItemComponent(pullRequest, targetsLength, href),
            name: "async-pr-dev-info-icon"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hNyRP.AsyncDevInfoIcon), {
            devInfoType: (0, $ihplE.DevInfoTypes).PULLREQUEST,
            issueId: Number(issueId),
            customTrigger: summaryItemComponent(pullRequest, targetsLength, href),
            scopeId: `devInfoPanelApp${issueKey}`,
            placement: "bottom-end",
            offset: [
                -8,
                8
            ],
            zIndex: (0, $dPMMf.layers).modal,
            location: (0, $2425df669549d924$export$76a449e52fa0e1e8)
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1A9lq.default), {
            devInfoType: (0, $ihplE.DevInfoTypes).PULLREQUEST,
            issueId: Number(issueId),
            customTrigger: summaryItemComponent(pullRequest, targetsLength, href),
            scopeId: `devInfoPanelApp${issueKey}`,
            placement: "bottom-end",
            offset: [
                -8,
                8
            ],
            zIndex: (0, $dPMMf.layers).modal,
            location: (0, $2425df669549d924$export$76a449e52fa0e1e8)
        });
    }
    if (pullRequest && branchesCount > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDDVn.CreatePullRequestSummaryItem), {
        createPullRequestTargets: pullRequest.createPullRequestTargets,
        hasErrors: hasErrors,
        onAuthErrorClick: onClick,
        branchesCount: branchesCount
    });
    return null;
}, $cbd98bd9d336d6f4$export$b141efd0b0fb9174);
// eslint-disable-next-line jira/styled/styled-component-order, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cbd98bd9d336d6f4$var$IconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_s7n4nkob",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $cbd98bd9d336d6f4$export$1f4774b4dbeafbe4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cbd98bd9d336d6f4$var$IconWrapper, {
    "aria-hidden": true
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jVVB7))), {
    LEGACY_size: "medium",
    spacing: "spacious",
    label: ""
}));
const $cbd98bd9d336d6f4$export$a7840d0eddc64f6e = ()=>{
    const { formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const icon = $cbd98bd9d336d6f4$export$1f4774b4dbeafbe4;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDP77.SummaryItem), {
        icon: icon,
        disabled: true,
        title: formatMessage((0, $kpuNj.default).emptyStateUpdate),
        "data-testid": "development-summary-pull-request.ui.summary-item"
    });
};
const $cbd98bd9d336d6f4$var$PullRequest = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "development-summary-pullrequest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cbd98bd9d336d6f4$var$PullRequestInner, props)));
var $cbd98bd9d336d6f4$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $cbd98bd9d336d6f4$var$PullRequest;
const $cbd98bd9d336d6f4$var$BoldFont = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_k48p1wq8",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jVVB7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0df86e9f58670341f0be02decae626a5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e83004e3ba57a5e6$var$_react = $e83004e3ba57a5e6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e83004e3ba57a5e6$var$_pullRequest = $e83004e3ba57a5e6$var$_interopRequireDefault((parcelRequire("MUJuW")));

var $e83004e3ba57a5e6$var$_pullrequests = $e83004e3ba57a5e6$var$_interopRequireDefault((parcelRequire("goMQ6")));
function $e83004e3ba57a5e6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PullRequestIcon.
 * This component is PullRequestIcon, with `UNSAFE_fallbackIcon` set to "BitbucketPullrequestsIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pull requests.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e83004e3ba57a5e6$var$PullRequestIcon = (props)=>/*#__PURE__*/ $e83004e3ba57a5e6$var$_react.default.createElement($e83004e3ba57a5e6$var$_pullRequest.default, Object.assign({
        LEGACY_fallbackIcon: $e83004e3ba57a5e6$var$_pullrequests.default
    }, props));
$e83004e3ba57a5e6$var$PullRequestIcon.Name = 'PullRequestIconMigration';
var $e83004e3ba57a5e6$var$_default = module.exports.default = $e83004e3ba57a5e6$var$PullRequestIcon;

});
parcelRegister("MUJuW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a083285ccf5836110a489694f045affe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09307dc51f4f46f2$var$_react = $09307dc51f4f46f2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $09307dc51f4f46f2$var$_baseNew = $09307dc51f4f46f2$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $09307dc51f4f46f2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PullRequest".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pull requests.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $09307dc51f4f46f2$var$PullRequestIcon = (props)=>/*#__PURE__*/ $09307dc51f4f46f2$var$_react.default.createElement($09307dc51f4f46f2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.25 2.25 0 0 1 2 3.25m6-.75h1.75a2.75 2.75 0 0 1 2.75 2.75v5.378a2.251 2.251 0 1 1-1.5 0V5.25C11 4.56 10.44 4 9.75 4H8zM4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$09307dc51f4f46f2$var$PullRequestIcon.displayName = 'PullRequestIcon';
var $09307dc51f4f46f2$var$_default = module.exports.default = $09307dc51f4f46f2$var$PullRequestIcon;

});

parcelRegister("goMQ6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bf04c5bca4302271$var$_react = $bf04c5bca4302271$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $bf04c5bca4302271$var$_pullRequest = $bf04c5bca4302271$var$_interopRequireDefault((parcelRequire("MUJuW")));
function $bf04c5bca4302271$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bf04c5bca4302271$var$BitbucketPullrequestsIcon = (props)=>/*#__PURE__*/ $bf04c5bca4302271$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M18 15.2V11c0-1.7-1.3-3-3-3h-1.9l.8-.8c.3-.3.3-.8 0-1.1s-.8-.3-1.1 0l-2.3 2.3c-.3.4-.3.9 0 1.2l2.3 2.3c.2.2.3.2.5.2q.3 0 .6-.3c.3-.3.3-.8 0-1.1l-.7-.7H15c.6 0 1 .4 1 1v4.2c-1.2.4-2 1.5-2 2.8 0 1.7 1.3 3 3 3s3-1.3 3-3c0-1.3-.8-2.4-2-2.8M17 19c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1M7 3C5.4 3 4 4.3 4 6c0 1.3.8 2.4 2 2.8V20c0 .6.4 1 1 1s1-.4 1-1V8.8c1.2-.4 2-1.5 2-2.8 0-1.7-1.3-3-3-3m0 4c-.5 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1"/></svg>`
    }, props, {
        newIcon: $bf04c5bca4302271$var$_pullRequest.default
    }));
$bf04c5bca4302271$var$BitbucketPullrequestsIcon.displayName = 'BitbucketPullrequestsIcon';
var $bf04c5bca4302271$var$_default = module.exports.default = $bf04c5bca4302271$var$BitbucketPullrequestsIcon;

});


parcelRegister("1P6aF", function(module, exports) {

$parcel$export(module.exports, "CreatePRIconButton", () => $a527402e28c58f75$export$406668a983d2447c);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $jQjGM = parcelRequire("jQjGM");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $hYSG2 = parcelRequire("hYSG2");
const $a527402e28c58f75$export$406668a983d2447c = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onClick: onClickProp, href: href, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'button'
        }), 'createDevAction', {
            summaryItemType: 'pullrequest',
            inline: true
        });
    }, [
        createAnalyticsEvent
    ]);
    const tooltipContent = formatMessage((0, $hYSG2.default).tooltipContent);
    const onClick = (e, analyticsEvent)=>{
        href === undefined && onClickProp && onClickProp();
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'createDevAction', {
            summaryItemType: 'pullrequest',
            inline: true
        });
    };
    const buttonProps = href !== undefined && href !== null ? {
        href: href,
        target: '_blank'
    } : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: tooltipContent,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        ref: ref,
        ...props,
        ...buttonProps,
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jQjGM))), {
            LEGACY_size: "small",
            label: tooltipContent
        }),
        onClick: onClick,
        testId: "development-summary-pull-request.ui.create-pull-request-summary-item.create-pr-icon-button.button"
    }));
});

});
parcelRegister("hYSG2", function(module, exports) {

$parcel$export(module.exports, "default", () => $25e50ea591ccf1d1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $25e50ea591ccf1d1$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    tooltipContent: {
        "id": "development-summary-pull-request.create-pull-request-summary-item.create-pr-icon-button.tooltip-content",
        "defaultMessage": "Create new pull request"
    }
});

});


parcelRegister("cDDVn", function(module, exports) {

$parcel$export(module.exports, "CreatePullRequestSummaryItem", () => $ab1a2883171cfa2b$export$47ec9685588d5f1a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5lAAn = parcelRequire("5lAAn");

var $jVVB7 = parcelRequire("jVVB7");

var $cDP77 = parcelRequire("cDP77");

var $lRq8t = parcelRequire("lRq8t");

var $bmoS1 = parcelRequire("bmoS1");

var $gCeeo = parcelRequire("gCeeo");
var $iqtgH = parcelRequire("iqtgH");
var $ftN6c = parcelRequire("ftN6c");

var $dQUcu = parcelRequire("dQUcu");
const $ab1a2883171cfa2b$var$IconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_s7n4nkob",
            __cmplp.className
        ])
    });
});
const $ab1a2883171cfa2b$export$1f4774b4dbeafbe4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ab1a2883171cfa2b$var$IconWrapper, {
    "aria-hidden": true
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jVVB7))), {
    LEGACY_size: "medium",
    spacing: "spacious",
    label: ""
}));


const $ab1a2883171cfa2b$var$ConditionalCreatePullrequestDropdown = (parcelRequire("2F11O")).default;
const $ab1a2883171cfa2b$export$47ec9685588d5f1a = ({ branchesCount: branchesCount, createPullRequestTargets: createPullRequestTargets, hasErrors: hasErrors, onAuthErrorClick: onAuthErrorClick })=>{
    const PULL_REQUEST_SUMMARY_TYPE = 'pullrequest';
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const issueKey = (0, $bmoS1.useIssueKey)();
    const createPullRequestTitle = formatMessage((0, $dQUcu.default).createPullRequestTitle);
    const downChevron = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $dQUcu.default).createPullRequestDropdownIconLabel),
            size: "small"
        }), [
        formatMessage
    ]);
    const commonSummaryItemProps = {
        title: createPullRequestTitle,
        issueKey: issueKey,
        linkFormatting: true,
        icon: $ab1a2883171cfa2b$export$1f4774b4dbeafbe4
    };
    const commonAnalyticsAttributes = {
        summaryItemType: PULL_REQUEST_SUMMARY_TYPE,
        inline: false
    };
    const isLoading = createPullRequestTargets === null || createPullRequestTargets === undefined;
    const hasUrlLoaded = createPullRequestTargets !== null && createPullRequestTargets !== undefined && createPullRequestTargets.length === 1; // only show link if theres one branch, no errors,
    // and if its either currently loading (show spinner) or theres exactly one link (show external link)
    // otherwise show the dropdown
    if (branchesCount === 1 && !hasErrors && (isLoading || hasUrlLoaded)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDP77.SummaryItem), {
        ...commonSummaryItemProps,
        href: hasUrlLoaded ? createPullRequestTargets?.[0].createPullRequestUrl : null,
        onClick: ()=>{
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'createPullRequestLink', {
                ...commonAnalyticsAttributes,
                linkListLength: 1
            });
        },
        "data-testid": "development-summary-pull-request.ui.create-pull-request-inline-summary-item"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireUiAnalytics), {
        actionSubject: "button",
        action: "viewed",
        actionSubjectId: "createDevAction",
        attributes: commonAnalyticsAttributes
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ab1a2883171cfa2b$var$ConditionalCreatePullrequestDropdown, {
        hasErrors: hasErrors,
        onAuthErrorClick: onAuthErrorClick,
        createPullRequestTargets: createPullRequestTargets,
        renderDropdownTrigger: ({ ref: ref, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDP77.SummaryItem), {
                secondaryData: downChevron,
                reference: ref,
                ...commonSummaryItemProps,
                ...props,
                onClick: ()=>{
                    props.onClick();
                    (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createDevAction', commonAnalyticsAttributes);
                },
                "data-testid": "development-summary-pull-request.ui.create-pull-request-summary-item"
            })
    }));
};

});
parcelRegister("dQUcu", function(module, exports) {

$parcel$export(module.exports, "default", () => $74481e2d9c78ce00$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $74481e2d9c78ce00$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    createPullRequestTitle: {
        "id": "development-summary-pull-request.create-pull-request-summary-item.create-pull-request-title",
        "defaultMessage": "Create pull request"
    },
    createPullRequestDropdownIconLabel: {
        "id": "development-summary-pull-request.create-pull-request-summary-item.create-pull-request-dropdown-icon-label",
        "defaultMessage": "Create pull request"
    }
});

});

parcelRegister("2F11O", function(module, exports) {

module.exports = (parcelRequire("g81qY"))('create_pullrequest_dropdown_iv_llc_dev_panel', function() {
    return parcelRequire('5fYXL');
}, function() {
    return parcelRequire('hzUx3');
});

});


parcelRegister("kpuNj", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f72c7aa62c876e8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $5f72c7aa62c876e8$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "development-summary-pull-request.title",
        "defaultMessage": "{boldStart}{count}{boldEnd} {count, plural, one {pull request} other {pull requests}}"
    },
    emptyState: {
        "id": "development-summary-pull-request.empty-state",
        "defaultMessage": "{Icon} Pull request"
    },
    emptyStateUpdate: {
        "id": "development-summary-pull-request.empty-state-update",
        "defaultMessage": "Pull request"
    },
    tooltip: {
        "id": "development-summary-pull-request.tooltip",
        "defaultMessage": "Open pull request"
    }
});

});


parcelRegister("b1iBk", function(module, exports) {

$parcel$export(module.exports, "default", () => $770cecc9a4ae146a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $bJscI = parcelRequire("bJscI");

var $lRq8t = parcelRequire("lRq8t");

var $9NIQG = parcelRequire("9NIQG");

var $8YDyT = parcelRequire("8YDyT");

var $coXKe = parcelRequire("coXKe");

var $814y1 = parcelRequire("814y1");

var $eW1IH = parcelRequire("eW1IH");
const $770cecc9a4ae146a$export$34c298764f320025 = ({ children: children, afterHeadingNode: afterHeadingNode, pinnable: pinnable = false })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const titleLabel = formatMessage((0, $eW1IH.default).label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9NIQG.FieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($770cecc9a4ae146a$var$DevPanelFieldHeading, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9NIQG.FieldHeadingTitle), null, titleLabel), afterHeadingNode, pinnable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8YDyT.FieldPin), {
        fieldId: (0, $814y1.DEV_SUMMARY_TYPE),
        label: titleLabel
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9NIQG.SideBySideField), null, children));
};
var $770cecc9a4ae146a$export$2e2bcd8739ae039 = $770cecc9a4ae146a$export$34c298764f320025;
const $770cecc9a4ae146a$var$DevPanelFieldHeadingNew = ({ children: children })=>{
    const { userPreferredLayout: userPreferredLayout } = (0, $coXKe.useUserPreferredWorkItemLayout)();
    const isWideViewLayout = userPreferredLayout === 'WIDE';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $770cecc9a4ae146a$var$fieldHeadingSideBySideCssStylesNew,
            isWideViewLayout && $770cecc9a4ae146a$var$wideLayoutStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $770cecc9a4ae146a$var$devPanelFieldHeadingOuterStyles,
            isWideViewLayout && $770cecc9a4ae146a$var$devPanelFieldHeadingOuterStylesWideLayoutOverride
        ]
    }, children));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $770cecc9a4ae146a$var$DevPanelFieldHeadingOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $9NIQG.FieldHeadingSideBySide), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _u5f3idpf",
            __cmplp.className
        ])
    });
});
const $770cecc9a4ae146a$var$fieldHeadingSideBySideCssStylesNew = (0, $1DXK0.xcss)({
    position: 'relative',
    boxSizing: 'border-box',
    minWidth: '120px',
    width: '40%',
    flex: '1 0 0%',
    display: 'flex',
    paddingRight: 'space.200',
    paddingTop: 'space.100'
});
const $770cecc9a4ae146a$var$wideLayoutStyles = (0, $1DXK0.xcss)({
    maxWidth: '170px',
    paddingRight: 'space.0',
    paddingLeft: 'space.050'
});
const $770cecc9a4ae146a$var$devPanelFieldHeadingOuterStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    height: 'fit-content',
    paddingBottom: 'space.100',
    paddingLeft: 'space.050',
    paddingRight: 'space.050',
    borderRadius: '4px',
    width: 'fit-content',
    marginLeft: 'space.negative.050',
    gap: 'space.100',
    ':hover': {
        backgroundColor: 'color.background.neutral.hovered'
    }
});
const $770cecc9a4ae146a$var$devPanelFieldHeadingOuterStylesWideLayoutOverride = (0, $1DXK0.xcss)({
    minWidth: '170px',
    paddingTop: 'space.050',
    justifyContent: 'flex-start',
    marginTop: 'space.negative.050'
});
const $770cecc9a4ae146a$var$DevPanelFieldHeading = (0, $bJscI.componentWithFG)('issue_view_field_config_edit', $770cecc9a4ae146a$var$DevPanelFieldHeadingNew, $770cecc9a4ae146a$var$DevPanelFieldHeadingOld);

});
parcelRegister("eW1IH", function(module, exports) {

$parcel$export(module.exports, "default", () => $488222bfbb963a16$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $488222bfbb963a16$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    label: {
        "id": "development-summary-development-field.common.development-field-wrapper.label",
        "defaultMessage": "Development"
    },
    sectionFirstAction: {
        "id": "development-summary-development-field.common.development-field-wrapper.section-first-action",
        "defaultMessage": "Learn more"
    },
    sectionSecondAction: {
        "id": "development-summary-development-field.common.development-field-wrapper.section-second-action",
        "defaultMessage": "Dismiss"
    },
    sectionMessageCanCreate: {
        "id": "development-summary-development-field.common.development-field-wrapper.section-message-can-create",
        "defaultMessage": "Link this issue to your code by including issue keys when creating a branch, commit, or pull request below."
    },
    sectionMessageCantCreate: {
        "id": "development-summary-development-field.common.development-field-wrapper.section-message-cant-create",
        "defaultMessage": "Link this issue to your code by including issue keys when creating a branch, commit, or pull request."
    },
    sectionTitle: {
        "id": "development-summary-development-field.common.development-field-wrapper.section-title",
        "defaultMessage": "Quick start development"
    },
    sectionMessageCanCreateIssueTermRefresh: {
        "id": "development-summary-development-field.common.development-field-wrapper.section-message-can-create-issue-term-refresh",
        "defaultMessage": "Link this work item to your code by including keys when creating a branch, commit, or pull request below."
    },
    sectionMessageCantCreateIssueTermRefresh: {
        "id": "development-summary-development-field.common.development-field-wrapper.section-message-cant-create-issue-term-refresh",
        "defaultMessage": "Link this work item to your code by including keys when creating a branch, commit, or pull request."
    }
});

});


parcelRegister("kouRT", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fd51842e94fc5bc$export$2e2bcd8739ae039);

var $abmDm = parcelRequire("abmDm");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $2nlj2 = parcelRequire("2nlj2");

var $j4oe4 = parcelRequire("j4oe4");

var $goZPP = parcelRequire("goZPP");

var $6J9k6 = parcelRequire("6J9k6");

var $lnh70 = parcelRequire("lnh70");
var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");

var $gnQAk = parcelRequire("gnQAk");

var $eCZHt = parcelRequire("eCZHt");

var $buktG = parcelRequire("buktG");

var $kEUB1 = parcelRequire("kEUB1");

var $ikKUs = parcelRequire("ikKUs");

var $2kFog = parcelRequire("2kFog");
const $6fd51842e94fc5bc$export$8f1dc3b33a81bbdb = ({ setPanelShownState: setPanelShownState })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const dismissLabel = formatMessage((0, $2kFog.default).dismissState);
    const fireCompleteAnalytics = (analyticsEvent, errors)=>{
        const statusCode = errors ? (0, $buktG.getStatusCodeFromGraphQLErrors)(errors) : 200;
        const isFailure = (0, $eCZHt.isFailureStatusCode)(statusCode); // response contains graphql errors
        if (errors && errors.length > 0 && isFailure) {
            (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, 'optOutOfDevEmptyState failed', {
                statusCode: statusCode,
                errorMessage: (0, (/*@__PURE__*/$parcel$interopDefault($2nlj2)))(errors[0].message, {
                    length: 140
                })
            });
            showFlag((0, $lnh70.default).genericError());
            return;
        }
        (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, 'optOutOfDevEmptyState success', {
            statusCode: statusCode
        });
    };
    const [commitMutation] = (0, $j4oe4.useMutation)((0, $abmDm.default));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onDismiss = (_, analyticsEvent)=>{
        // optimistic update.
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'optOutOfDevEmptyState');
        setPanelShownState(false);
        commitMutation({
            variables: {
                cloudId: cloudId
            },
            onCompleted: (data, errors)=>{
                setPanelShownState(data // @ts-expect-error(Suppressed for relay bump) - 'data.jira' is possibly 'null' or 'undefined'. | 'data.jira.devOps' is possibly 'null' or 'undefined'. | 'data.jira.devOps.optoutOfDevOpsIssuePanelNotConnectedState' is possibly 'null' or 'undefined'.
                 ? !data.jira.devOps.optoutOfDevOpsIssuePanelNotConnectedState.success : true);
                fireCompleteAnalytics(analyticsEvent, errors);
            },
            onError: ()=>{
                setPanelShownState(true);
                showFlag((0, $lnh70.default).genericError());
                (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, 'optOutOfDevEmptyState failed', {
                    statusCode: 'unknown',
                    errorMessage: 'networkError'
                });
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6fd51842e94fc5bc$var$AbsoluteContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))), {
            label: dismissLabel,
            LEGACY_size: "small"
        }),
        appearance: "subtle",
        onClick: onDismiss
    }));
};
var $6fd51842e94fc5bc$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $gnQAk.connect)(()=>({}), {
    setPanelShownState: (0, $ikKUs.onToggleDismissButton)
})($6fd51842e94fc5bc$export$8f1dc3b33a81bbdb);
const $6fd51842e94fc5bc$var$AbsoluteContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _154iidpf _1xi2idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("abmDm", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcdaebac4a8b3f53$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0a99b5771c2326b275543886559dc3ca>>
 * @relayHash f0f958ebdc206ec225be6fc12de3956d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 71e0e1bec419b0d916f639a1da879bf2df3ece36a7031439c655ab8412a81b9c
const $fcdaebac4a8b3f53$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "statusCode"
            }
        ],
        "type": "GenericMutationErrorExtension"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "absoluteCloseButtonJiraDevSummaryUserOptOutNotConnectedStateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraDevOpsMutation",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraOptoutDevOpsIssuePanelNotConnectedPayload",
                                    "kind": "LinkedField",
                                    "name": "optoutOfDevOpsIssuePanelNotConnectedState",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "concreteType": "MutationError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "absoluteCloseButtonJiraDevSummaryUserOptOutNotConnectedStateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraDevOpsMutation",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraOptoutDevOpsIssuePanelNotConnectedPayload",
                                    "kind": "LinkedField",
                                    "name": "optoutOfDevOpsIssuePanelNotConnectedState",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "concreteType": "MutationError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                }
                                                            ],
                                                            "type": "BulkMutationErrorExtension"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "71e0e1bec419b0d916f639a1da879bf2df3ece36a7031439c655ab8412a81b9c",
            "metadata": {},
            "name": "absoluteCloseButtonJiraDevSummaryUserOptOutNotConnectedStateMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$fcdaebac4a8b3f53$var$node.hash = "0189524f2e02f5faf49500efb2d22c19";
var $fcdaebac4a8b3f53$export$2e2bcd8739ae039 = $fcdaebac4a8b3f53$var$node;

});

parcelRegister("2nlj2", function(module, exports) {

var $wkcOI = parcelRequire("wkcOI");

var $j4Djm = parcelRequire("j4Djm");

var $beeZR = parcelRequire("beeZR");

var $546O5 = parcelRequire("546O5");

var $5jnGi = parcelRequire("5jnGi");

var $esCHN = parcelRequire("esCHN");

var $gsm7J = parcelRequire("gsm7J");

var $c9FP3 = parcelRequire("c9FP3");

var $cz1WF = parcelRequire("cz1WF");
/** Used as default options for `_.truncate`. */ var $1bae41afc01471ee$var$DEFAULT_TRUNC_LENGTH = 30, $1bae41afc01471ee$var$DEFAULT_TRUNC_OMISSION = '...';
/** Used to match `RegExp` flags from their coerced string values. */ var $1bae41afc01471ee$var$reFlags = /\w*$/;
/**
 * Truncates `string` if it's longer than the given maximum string length.
 * The last characters of the truncated string are replaced with the omission
 * string which defaults to "...".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to truncate.
 * @param {Object} [options={}] The options object.
 * @param {number} [options.length=30] The maximum string length.
 * @param {string} [options.omission='...'] The string to indicate text is omitted.
 * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
 * @returns {string} Returns the truncated string.
 * @example
 *
 * _.truncate('hi-diddly-ho there, neighborino');
 * // => 'hi-diddly-ho there, neighbo...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': ' '
 * });
 * // => 'hi-diddly-ho there,...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': /,? +/
 * });
 * // => 'hi-diddly-ho there...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'omission': ' [...]'
 * });
 * // => 'hi-diddly-ho there, neig [...]'
 */ function $1bae41afc01471ee$var$truncate(string, options) {
    var length = $1bae41afc01471ee$var$DEFAULT_TRUNC_LENGTH, omission = $1bae41afc01471ee$var$DEFAULT_TRUNC_OMISSION;
    if ($546O5(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? $c9FP3(options.length) : length;
        omission = 'omission' in options ? $wkcOI(options.omission) : omission;
    }
    string = $cz1WF(string);
    var strLength = string.length;
    if ($beeZR(string)) {
        var strSymbols = $gsm7J(string);
        strLength = strSymbols.length;
    }
    if (length >= strLength) return string;
    var end = length - $esCHN(omission);
    if (end < 1) return omission;
    var result = strSymbols ? $j4Djm(strSymbols, 0, end).join('') : string.slice(0, end);
    if (separator === undefined) return result + omission;
    if (strSymbols) end += result.length - end;
    if ($5jnGi(separator)) {
        if (string.slice(end).search(separator)) {
            var match, substring = result;
            if (!separator.global) separator = RegExp(separator.source, $cz1WF($1bae41afc01471ee$var$reFlags.exec(separator)) + 'g');
            separator.lastIndex = 0;
            while(match = separator.exec(substring))var newEnd = match.index;
            result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
    } else if (string.indexOf($wkcOI(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) result = result.slice(0, index);
    }
    return result + omission;
}
module.exports = $1bae41afc01471ee$var$truncate;

});
parcelRegister("5jnGi", function(module, exports) {

var $1o86I = parcelRequire("1o86I");

var $cUaWv = parcelRequire("cUaWv");

var $bLZOH = parcelRequire("bLZOH");
/* Node.js helper references. */ var $3de118ac07a326fa$var$nodeIsRegExp = $bLZOH && $bLZOH.isRegExp;
/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */ var $3de118ac07a326fa$var$isRegExp = $3de118ac07a326fa$var$nodeIsRegExp ? $cUaWv($3de118ac07a326fa$var$nodeIsRegExp) : $1o86I;
module.exports = $3de118ac07a326fa$var$isRegExp;

});
parcelRegister("1o86I", function(module, exports) {

var $1O9y6 = parcelRequire("1O9y6");

var $7gKgM = parcelRequire("7gKgM");
/** `Object#toString` result references. */ var $102e5245e8b75589$var$regexpTag = '[object RegExp]';
/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */ function $102e5245e8b75589$var$baseIsRegExp(value) {
    return $7gKgM(value) && $1O9y6(value) == $102e5245e8b75589$var$regexpTag;
}
module.exports = $102e5245e8b75589$var$baseIsRegExp;

});



parcelRegister("lnh70", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7c4e03eb1ad55b5$export$2e2bcd8739ae039);

var $bStMc = parcelRequire("bStMc");

var $lV87f = parcelRequire("lV87f");

var $dTH8c = parcelRequire("dTH8c");

var $jDEZV = parcelRequire("jDEZV");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a7c4e03eb1ad55b5$export$2e2bcd8739ae039 = {
    forbidden: $bStMc.default,
    genericError: $lV87f.default,
    serverError: $dTH8c.default,
    unauthorized: $jDEZV.default
};

});
parcelRegister("bStMc", function(module, exports) {

$parcel$export(module.exports, "default", () => $c90a507c469d441b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $c90a507c469d441b$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.forbidden.title",
        "defaultMessage": "You don't have permission to do that"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.forbidden.description",
        "defaultMessage": "Ask your Jira admin for help."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c90a507c469d441b$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $c90a507c469d441b$var$messages.title,
        description: $c90a507c469d441b$var$messages.description,
        messageId: 'flags.ui.configurations.errors.forbidden.flag.error',
        messageType: 'transactional'
    });

});

parcelRegister("lV87f", function(module, exports) {

$parcel$export(module.exports, "default", () => $68b06cc30f2102fb$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $68b06cc30f2102fb$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.generic-error.title",
        "defaultMessage": "Something's gone wrong"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.generic-error.description",
        "defaultMessage": "Refresh the page and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$68b06cc30f2102fb$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $68b06cc30f2102fb$var$messages.title,
        description: $68b06cc30f2102fb$var$messages.description,
        messageId: 'flags.ui.configurations.errors.generic-error.flag.error',
        messageType: 'transactional'
    });

});

parcelRegister("dTH8c", function(module, exports) {

$parcel$export(module.exports, "default", () => $10bde4bac51b508b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $10bde4bac51b508b$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.server-error.title",
        "defaultMessage": "We're having some trouble"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.server-error.description",
        "defaultMessage": "Something went wrong on our end. Refresh the page and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$10bde4bac51b508b$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $10bde4bac51b508b$var$messages.title,
        description: $10bde4bac51b508b$var$messages.description,
        messageId: 'flags.ui.configurations.errors.server-error.flag.error',
        messageType: 'transactional'
    });

});

parcelRegister("jDEZV", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f59236eec25e386$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $4f59236eec25e386$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.unauthorized.title",
        "defaultMessage": "You're logged out"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.unauthorized.description",
        "defaultMessage": "Log back in and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4f59236eec25e386$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $4f59236eec25e386$var$messages.title,
        description: $4f59236eec25e386$var$messages.description,
        messageId: 'flags.ui.configurations.errors.unauthorized.flag.error',
        messageType: 'transactional'
    });

});


parcelRegister("eCZHt", function(module, exports) {

$parcel$export(module.exports, "isUserNetworkError", () => $b456e77cda0045ed$export$34bc86f6bf17f1e0);
$parcel$export(module.exports, "isClientSideThirdPartyAppError", () => $b456e77cda0045ed$export$ed0f33c09abc69f3);
$parcel$export(module.exports, "isFailureStatusCode", () => $b456e77cda0045ed$export$790c76b8c83c3421);
$parcel$export(module.exports, "default", () => $b456e77cda0045ed$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $9Dhvc = parcelRequire("9Dhvc");

var $jPROM = parcelRequire("jPROM");

var $hya93 = parcelRequire("hya93");

var $eSnSE = parcelRequire("eSnSE");

var $2HRPu = parcelRequire("2HRPu");

var $8KUFq = parcelRequire("8KUFq");

var $2mHfh = parcelRequire("2mHfh");

var $7jTnu = parcelRequire("7jTnu");

var $8l3c9 = parcelRequire("8l3c9");

var $buktG = parcelRequire("buktG");

var $8ZHj2 = parcelRequire("8ZHj2");

const $b456e77cda0045ed$var$renderExperienceFailureWithStatus = ({ location: location, statusCode: statusCode, traceId: traceId, hash: hash, buildKey: buildKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hya93.ExperienceFailureTracker), {
        location: location,
        failureEventAttributes: {
            ...(0, $8ZHj2.createFailureReasonWithStatusCode)((0, $9efd59a425943517$export$a3bb34ea5a520df8), statusCode),
            buildKey: buildKey,
            traceId: traceId,
            hash: hash
        }
    });
const $b456e77cda0045ed$export$34bc86f6bf17f1e0 = (error)=>{
    const networkErrorName = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'networkError',
        'name'
    ], null);
    const networkErrorStatusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'networkError',
        'statusCode'
    ], null);
    if (networkErrorName && !networkErrorStatusCode) (0, $eSnSE.default).safeErrorWithoutCustomerData('nextgen.sla.network.error.unknown.error.name', networkErrorName);
    // A fetch() promise will reject with a TypeError when a network error is encountered or CORS is misconfigured on the server-side,
    // although this usually means permission issues or similar — a 404 does not constitute a network error
    // more https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch#Checking_that_the_fetch_was_successful
    return networkErrorName === 'TypeError' || networkErrorName === 'AbortError';
};
const $b456e77cda0045ed$export$8a5d666d6e5b82fc = (error)=>{
    if (error?.name === 'ChunkLoadError') {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('nextgen.sla.chunk.load.error', error?.name, {
            message: error.message
        });
        return true;
    }
    return false;
};
const $b456e77cda0045ed$export$7193151b5738a995 = (error)=>{
    if (error?.name === 'ResponseNullError') {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('nextgen.sla.response.null.error', error?.name, {
            message: error.message
        });
        return true;
    }
    return false;
};
const $b456e77cda0045ed$var$KNOWN_CLIENT_SIDE_THIRD_PARTY_APP_ERRORS = [
    'FPClassifier is not defined'
];
const $b456e77cda0045ed$var$KNOWN_REACT_PERFORMANCE_ERRORS = [
    'Maximum update depth exceeded',
    'Minified React error #185'
];
const $b456e77cda0045ed$export$ed0f33c09abc69f3 = (error)=>!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(error) && !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(error.message) && !!$b456e77cda0045ed$var$KNOWN_CLIENT_SIDE_THIRD_PARTY_APP_ERRORS.find((errorMessage)=>error?.message?.includes(errorMessage));
const $b456e77cda0045ed$export$d6897bdd9fc569e3 = (error)=>!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(error) && !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(error.message) && !!$b456e77cda0045ed$var$KNOWN_REACT_PERFORMANCE_ERRORS.find((errorMessage)=>error?.message?.includes(errorMessage));
const $b456e77cda0045ed$export$790c76b8c83c3421 = (statusCode)=>{
    if (statusCode == null || statusCode === 429 || statusCode >= 500) // jira is too busy, unknown error or server error
    return true;
    if (statusCode >= 400 && statusCode < 500) return false;
    return true;
};
const $b456e77cda0045ed$var$detectLocalNetworkErrors = (errorResponse)=>{
    if ($b456e77cda0045ed$export$34bc86f6bf17f1e0(errorResponse)) return 0, $9efd59a425943517$export$3c39b2049cd1acb3;
    if ($b456e77cda0045ed$export$8a5d666d6e5b82fc(errorResponse)) return 0, $9efd59a425943517$export$fdfe3175a0c7be80;
    if ((0, $8KUFq.isClientFetchError)(errorResponse)) return 0, $9efd59a425943517$export$38fe4329f59f7ac5;
    if ($b456e77cda0045ed$export$7193151b5738a995(errorResponse)) return 0, $9efd59a425943517$export$49d11848b43d6dbf;
    if ($b456e77cda0045ed$export$ed0f33c09abc69f3(errorResponse)) return 0, $9efd59a425943517$export$32e56551129a1642;
    if ($b456e77cda0045ed$export$d6897bdd9fc569e3(errorResponse) && (0, $7jTnu.fg)('tnk-ignore-react-performance-error-for-slo')) return 0, $9efd59a425943517$export$23146e1063f522c4;
    return null;
};
const $b456e77cda0045ed$var$responseToSla = (errorResponse, location)=>{
    const statusCode = (0, $buktG.extractStatusCode)(errorResponse);
    const abortFailureReason = $b456e77cda0045ed$var$detectLocalNetworkErrors(errorResponse);
    const traceId = (0, $8l3c9.extractTraceId)(errorResponse) || (0, $9efd59a425943517$export$fa14a20fcf1b1eb4);
    const hash = (0, $2HRPu.getErrorHash)(errorResponse) || (0, $9efd59a425943517$export$fa14a20fcf1b1eb4);
    const buildKey = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(window, [
        'BUILD_KEY'
    ]) || (0, $9efd59a425943517$export$fa14a20fcf1b1eb4);
    const errorResponseMessage = errorResponse?.message || (0, $9efd59a425943517$export$fa14a20fcf1b1eb4);
    const isAbortReactPerformanceError = abortFailureReason === (0, $9efd59a425943517$export$23146e1063f522c4);
    const isBacklogLocation = location === 'ng-backlog' || location === 'cmp-backlog';
    if (abortFailureReason && (!isAbortReactPerformanceError || isAbortReactPerformanceError && isBacklogLocation)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hya93.ExperienceAbortTracker), {
        location: location,
        failureEventAttributes: {
            ...(0, $8ZHj2.createFailureReason)(abortFailureReason),
            error: errorResponseMessage,
            statusCode: statusCode || '',
            buildKey: buildKey,
            traceId: traceId,
            hash: hash
        }
    });
    if (statusCode === null) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('nextgen.sla.unknown.failure', (0, $9efd59a425943517$export$b4f05a271d0831dc), {
            networkErrorName: (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(errorResponse, [
                'networkError',
                'name'
            ], ''),
            networkStatusCode: (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(errorResponse, [
                'networkError',
                'statusCode'
            ], ''),
            graphqlStatusCode: (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(errorResponse, [
                'graphQLErrors',
                0,
                'extensions',
                'statusCode'
            ], ''),
            location: location,
            error: JSON.stringify(errorResponse, Object.getOwnPropertyNames(errorResponse)),
            hash: hash
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hya93.ExperienceFailureTracker), {
            location: location,
            failureEventAttributes: {
                ...(0, $8ZHj2.createFailureReason)((0, $9efd59a425943517$export$b4f05a271d0831dc)),
                traceId: traceId,
                buildKey: buildKey,
                error: JSON.stringify({
                    message: errorResponseMessage
                }),
                hash: hash
            }
        });
    }
    // based on https://hello.atlassian.net/wiki/spaces/agile/pages/512782292/SWAG+response+handling+on+the+client
    // `EXPERIENCE_TRACKER_LOCATION_BACKLOG`, defined in `src/packages/software/backlog/src/common/constants/analytics.tsx`
    if (location === 'ng-backlog') {
        if (statusCode === 400 || statusCode === 401 || statusCode === 403) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hya93.ExperienceAbortTracker), {
            location: location,
            failureEventAttributes: {
                ...(0, $8ZHj2.createFailureReason)((0, $9efd59a425943517$export$c4493605407b2630)),
                error: errorResponseMessage,
                statusCode: statusCode.toString(),
                buildKey: buildKey,
                traceId: traceId,
                hash: hash
            }
        });
    }
    if (statusCode === 400 || statusCode === 401 || statusCode === 403) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hya93.ExperienceSuccessTracker), {
        location: location
    });
    if (statusCode === 429) // jira is too busy
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hya93.ExperienceAbortTracker), {
        location: location,
        failureEventAttributes: {
            ...(0, $8ZHj2.createFailureReason)((0, $9efd59a425943517$export$7b9f56c34c008ec2)),
            error: errorResponseMessage,
            statusCode: '429',
            buildKey: buildKey,
            traceId: traceId,
            hash: hash
        }
    });
    if (statusCode === 404) // redirect to "all-projects" page or error page, when page is not found
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: "/jira/software/projects/not-found"
    });
    if (statusCode > 400 && statusCode < 500) // the rest of 40X
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hya93.ExperienceSuccessTracker), {
        location: location
    });
    if (statusCode >= 500) return $b456e77cda0045ed$var$renderExperienceFailureWithStatus({
        location: location,
        statusCode: statusCode,
        traceId: traceId,
        hash: hash,
        buildKey: buildKey
    });
    return $b456e77cda0045ed$var$renderExperienceFailureWithStatus({
        location: location,
        statusCode: statusCode,
        traceId: traceId,
        hash: hash,
        buildKey: buildKey
    });
};
var $b456e77cda0045ed$export$2e2bcd8739ae039 = $b456e77cda0045ed$var$responseToSla;

});
parcelRegister("8l3c9", function(module, exports) {

$parcel$export(module.exports, "extractTraceId", () => $5bcab93f4b8cd5b3$export$431eacb6aecbacdf);
const $5bcab93f4b8cd5b3$export$431eacb6aecbacdf = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
error)=>String(error?.traceId || error?.networkError?.traceId || '');

});

parcelRegister("8ZHj2", function(module, exports) {

$parcel$export(module.exports, "createFailureReason", () => $989c8fd27e989e97$export$b9e48ed6f1b092c7);
$parcel$export(module.exports, "createFailureReasonWithStatusCode", () => $989c8fd27e989e97$export$cc7dce678df87fe9);
const $989c8fd27e989e97$export$b9e48ed6f1b092c7 = (reason)=>({
        failureReason: reason,
        errorMessage: reason
    });
const $989c8fd27e989e97$export$cc7dce678df87fe9 = (reason, statusCode)=>{
    if (statusCode === undefined || statusCode === null) return {
        failureReason: reason,
        statusCode: '[unknown]',
        errorMessage: `${reason}-unknown`
    };
    return {
        failureReason: reason,
        statusCode: `${statusCode}`,
        errorMessage: `${reason}-${statusCode}`
    };
};

});

const $9efd59a425943517$export$b4f05a271d0831dc = 'critical-data-failed-unknown-reason';
const $9efd59a425943517$export$a3bb34ea5a520df8 = 'critical-data-failed-with-status-code';
const $9efd59a425943517$export$7b9f56c34c008ec2 = '429-error';
const $9efd59a425943517$export$c4493605407b2630 = 'client-error';
const $9efd59a425943517$export$23146e1063f522c4 = 'react-performance-error';
const $9efd59a425943517$export$3c39b2049cd1acb3 = 'user-network-error';
const $9efd59a425943517$export$fdfe3175a0c7be80 = 'chunk-load-error';
const $9efd59a425943517$export$38fe4329f59f7ac5 = 'client-fetch-error';
const $9efd59a425943517$export$49d11848b43d6dbf = 'response-null-error';
const $9efd59a425943517$export$32e56551129a1642 = 'client-third-party-app-error';
const $9efd59a425943517$export$fa14a20fcf1b1eb4 = 'unknown';


parcelRegister("2kFog", function(module, exports) {

$parcel$export(module.exports, "default", () => $e44bb9ecf3d7f8da$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $e44bb9ecf3d7f8da$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    dismissState: {
        "id": "development-summary-development-field.empty-summary.absolute-close-button.dismiss-state",
        "defaultMessage": "Hide empty development information"
    }
});

});


parcelRegister("dr0NS", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e751dc63e717cff$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $fD0Nt = parcelRequire("fD0Nt");

var $bmoS1 = parcelRequire("bmoS1");

var $gnQAk = parcelRequire("gnQAk");

var $RJGWc = parcelRequire("RJGWc");

var $g9ECZ = parcelRequire("g9ECZ");

var $ikKUs = parcelRequire("ikKUs");

var $ddPfy = parcelRequire("ddPfy");
const $9e751dc63e717cff$export$4125f24632a72023 = ()=>{
    // be prepared for the worst code.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const container = document.getElementById('ghx-issue-fragment');
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.AJS) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.AJS.$(container).trigger('minimise-before-crossflow');
};
const $9e751dc63e717cff$export$2ccd5b8c0427dfe4 = ()=>{
    // be prepared for the worst code.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const container = document.getElementById('ghx-issue-fragment');
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.AJS) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.AJS.$(container).trigger('expand-after-crossflow');
};
const $9e751dc63e717cff$export$216944d0df4c048e = ({ onCloseEmptyStateDialog: onCloseEmptyStateDialog, onShowEmptyStateDialog: onShowEmptyStateDialog, isClassicProject: isClassicProject, isEmptyStateDialogShown: isEmptyStateDialogShown, onCompleteConnection: onCompleteConnection })=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const isModal = (0, $bmoS1.useIsModal)();
    const [, updateSelectedIssueQueryParam] = (0, $RJGWc.useQueryParam)('selectedIssue');
    const closeEmptyState = ()=>{
        onCloseEmptyStateDialog();
    };
    const showEmptyState = ()=>{
        onShowEmptyStateDialog();
    };
    const closeModalIssue = ()=>{
        if (isModal) {
            if (isClassicProject) $9e751dc63e717cff$export$4125f24632a72023();
            updateSelectedIssueQueryParam();
        }
    };
    const showModalIssue = ()=>{
        if (isModal) {
            if (isClassicProject) $9e751dc63e717cff$export$2ccd5b8c0427dfe4();
            updateSelectedIssueQueryParam(issueKey);
        }
    };
    const onCrossFlowStart = ()=>{
        closeEmptyState();
        closeModalIssue();
    };
    const onCrossFlowEnd = (success)=>{
        showModalIssue();
        if (success) showEmptyState();
    };
    return isEmptyStateDialogShown ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fD0Nt.AsyncDevPanelEmptyStateModal), {
        onCloseModal: closeEmptyState,
        onComplete: onCompleteConnection,
        onCrossFlowStart: onCrossFlowStart,
        onCrossFlowEnd: onCrossFlowEnd
    }) : null;
};
var $9e751dc63e717cff$export$2e2bcd8739ae039 = (0, $gnQAk.connect)((state)=>({
        // @ts-expect-error - TS2345 - Argument of type '{}' is not assignable to parameter of type 'State'.
        isEmptyStateDialogShown: (0, $ddPfy.isEmptyStateDialogShownSelector)(state),
        // @ts-expect-error - TS2345 - Argument of type '{}' is not assignable to parameter of type 'State'.
        isClassicProject: !(0, $g9ECZ.isSimplifiedProjectSelector)(state)
    }), (dispatch)=>({
        onCloseEmptyStateDialog: ()=>dispatch((0, $ikKUs.closeEmptyStateDialog)()),
        onShowEmptyStateDialog: ()=>dispatch((0, $ikKUs.showEmptyStateDialog)()),
        onCompleteConnection: ()=>{
            dispatch((0, $ikKUs.fetchDevPanelRequest)());
        }
    }))($9e751dc63e717cff$export$216944d0df4c048e);

});
parcelRegister("fD0Nt", function(module, exports) {

$parcel$export(module.exports, "AsyncDevPanelEmptyStateModal", () => $a7d28b38fa244bae$export$7e6c4aadb77b1832);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a7d28b38fa244bae$var$LazyDevPanelEmptyStateModal = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("kdJUY")), {
    ssr: false,
    moduleId: "./src/packages/development/empty-state-modal/src/main.tsx"
});
const $a7d28b38fa244bae$export$7e6c4aadb77b1832 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "dev-panel-empty-state-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a7d28b38fa244bae$var$LazyDevPanelEmptyStateModal, props));

});
parcelRegister("kdJUY", function(module, exports) {

let $eb88a3e5d067adde$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $eb88a3e5d067adde$var$load("76pw5").then(()=>parcelRequire('bH9VO'));

});


parcelRegister("RJGWc", function(module, exports) {

$parcel$export(module.exports, "useQueryParam", () => $65c863447b82163c$export$ae316f0eeb712a36);

var $eJOHy = parcelRequire("eJOHy");

var $jPROM = parcelRequire("jPROM");

var $4lYQk = parcelRequire("4lYQk");

var $b5RwB = parcelRequire("b5RwB");

var $gCY1z = parcelRequire("gCY1z");
const $65c863447b82163c$export$ae316f0eeb712a36 = (queryParam)=>{
    const [{ location: { pathname: pathname }, query: query }, { push: push }] = (0, $gCY1z.useRouter)();
    const queryParamValue = query[queryParam];
    const setQueryParam = (0, $eJOHy.useCallback)((newValue)=>{
        const parsedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($4lYQk)))({
            ...query,
            [queryParam]: newValue
        }, (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(value));
        const strSearch = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify(parsedSearch);
        push(pathname + (strSearch !== '' ? `?${strSearch}` : ''));
    }, [
        pathname,
        push,
        query,
        queryParam
    ]);
    return [
        queryParamValue,
        setQueryParam
    ];
};

});


parcelRegister("2w4x6", function(module, exports) {

$parcel$export(module.exports, "default", () => $50c10b181f7458f8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $50c10b181f7458f8$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    buttonCta: {
        "id": "development-summary-development-field.empty-summary.button-cta",
        "defaultMessage": "Integrate source code"
    },
    notIntegrated: {
        "id": "development-summary-development-field.empty-summary.not-integrated",
        "defaultMessage": "Not Integrated"
    }
});

});

parcelRegister("gMlkF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b98dd8bd85c730d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $c1cLY = parcelRequire("c1cLY");
const $4b98dd8bd85c730d$var$SlideDownOnMount = ({ children: children })=>{
    const [show, setShow] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        setShow(true);
    }, [
        setShow
    ]);
    const { ref: ref } = (0, $c1cLY.useResizingHeight)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4b98dd8bd85c730d$var$HiddenOverflowContainer, {
        ref: ref
    }, show && children);
};
var $4b98dd8bd85c730d$export$2e2bcd8739ae039 = $4b98dd8bd85c730d$var$SlideDownOnMount;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4b98dd8bd85c730d$var$HiddenOverflowContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _19pkmgjw _2hwxmgjw _otyrmgjw _18u0mgjw _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("c1cLY", function(module, exports) {

$parcel$export(module.exports, "useResizingHeight", () => $a255eaffd25937a1$export$da99457d6430d83);
$parcel$export(module.exports, "ResizingHeight", () => $a255eaffd25937a1$export$204d7b6d1491a2d3);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kk5YU = parcelRequire("kk5YU");


var $34ZNB = parcelRequire("34ZNB");

var $gcrIE = parcelRequire("gcrIE");

var $grWPV = parcelRequire("grWPV");

var $5mfrv = parcelRequire("5mfrv");

var $lumgu = parcelRequire("lumgu");
const $a255eaffd25937a1$export$da99457d6430d83 = ({ duration: calcDuration = ()=>(0, $34ZNB.durations).medium, timingFunction: calcTimingFunction = ()=>(0, $eeb70e8c0a60dc66$export$c07234257a03d5e9) } = {})=>{
    const prevDimensions = (0, $eJOHy.useRef)();
    const [element, setElementRef] = (0, $grWPV.useElementRef)();
    // We cleanup on the next effect to prevent the previous timeout being called during
    // the next motion - as now the timeout has essentially been extended!
    const setTimeout = (0, $gcrIE.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $gcrIE.useRequestAnimationFrame)();
    (0, $lumgu.useSnapshotBeforeUpdate)(()=>{
        if ((0, $kk5YU.isReducedMotion)() || !element) return;
        prevDimensions.current = element.getBoundingClientRect();
    });
    (0, $5mfrv.useLayoutEffect)(()=>{
        if ((0, $kk5YU.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination height first.
        element.setAttribute('style', '');
        const nextDimensions = element.getBoundingClientRect();
        if (nextDimensions.height === prevDimensions.current.height) return;
        const duration = calcDuration(prevDimensions.current.height, nextDimensions.height);
        const newStyles = {
            height: `${prevDimensions.current.height}px`,
            willChange: 'height',
            transitionProperty: 'height',
            transitionDuration: `${duration}ms`,
            boxSizing: 'border-box',
            transitionTimingFunction: calcTimingFunction(prevDimensions.current.height, nextDimensions.height, duration)
        };
        Object.assign(element.style, newStyles);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                }, duration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
const $a255eaffd25937a1$export$204d7b6d1491a2d3 = ({ children: children, ...props })=>{
    const resizing = $a255eaffd25937a1$export$da99457d6430d83(props);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
        children: children(resizing)
    });
};

});
const $eeb70e8c0a60dc66$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $eeb70e8c0a60dc66$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $eeb70e8c0a60dc66$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $eeb70e8c0a60dc66$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';

parcelRegister("lumgu", function(module, exports) {

$parcel$export(module.exports, "useSnapshotBeforeUpdate", () => $6481a9a383669445$export$9e95200239cd148b);

var $eJOHy = parcelRequire("eJOHy");

var $5mfrv = parcelRequire("5mfrv");
const $6481a9a383669445$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $eJOHy.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $5mfrv.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};

});




parcelRegister("9pmMO", function(module, exports) {

$parcel$export(module.exports, "default", () => $0118c8fd7b212b02$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ahm5r = parcelRequire("ahm5r");

var $dLR8J = parcelRequire("dLR8J");

var $ka9RA = parcelRequire("ka9RA");

var $dbm72 = parcelRequire("dbm72");

var $72FkX = parcelRequire("72FkX");

var $l98s9 = parcelRequire("l98s9");

var $1pV1F = parcelRequire("1pV1F");

var $2M0ib = parcelRequire("2M0ib");

var $cMtXS = parcelRequire("cMtXS");

var $9zKYv = parcelRequire("9zKYv");

var $8O88z = parcelRequire("8O88z");

var $i4v50 = parcelRequire("i4v50");

var $2SSJ3 = parcelRequire("2SSJ3");

var $8hEMV = parcelRequire("8hEMV");

var $cjeLM = parcelRequire("cjeLM");

var $7jTnu = parcelRequire("7jTnu");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $bNexr = parcelRequire("bNexr");

var $gnQAk = parcelRequire("gnQAk");

var $16sa1 = parcelRequire("16sa1");

var $epTsa = parcelRequire("epTsa");

var $1KdDN = parcelRequire("1KdDN");

var $b6JAY = parcelRequire("b6JAY");

var $kEUB1 = parcelRequire("kEUB1");

var $1c9L5 = parcelRequire("1c9L5");

var $7zZ4w = parcelRequire("7zZ4w");

var $8q7lT = parcelRequire("8q7lT");

var $bJscI = parcelRequire("bJscI");

var $b1iBk = parcelRequire("b1iBk");

var $gMlkF = parcelRequire("gMlkF");

var $kLuCE = parcelRequire("kLuCE");

var $g9ECZ = parcelRequire("g9ECZ");

var $ddPfy = parcelRequire("ddPfy");

var $7i1gE = parcelRequire("7i1gE");

var $78KGy = parcelRequire("78KGy");

var $66efJ = parcelRequire("66efJ");

var $5oysz = parcelRequire("5oysz");
const $0118c8fd7b212b02$var$NoWrapperComponent = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
const $0118c8fd7b212b02$var$ConditionalSlideDown = (0, $bJscI.componentWithFG)('jiv-20508-remove-height-animation-dev-panel', $0118c8fd7b212b02$var$NoWrapperComponent, (0, $gMlkF.default));
const $0118c8fd7b212b02$var$useIsAutoDevEnabledOnIssueView = (projectKey)=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const atlassianAccountId = (0, $8q7lT.useAccountId)();
    const [isAutoDevEnabled, state] = (0, $1c9L5.useIsAutoDevEnabled)(atlassianAccountId, cloudId, (0, $7zZ4w.default)(), !(0, $7jTnu.fg)('autodev-disable-rovo-check-in-issue-view'), // Skip Autodev enabled check if Rovo Dev Agents panel migration is enabled
    (0, $7jTnu.fg)('devai-issue-view-main-migration'));
    return {
        isEntitlementsLoading: state !== (0, $1c9L5.Status).DETERMINED,
        userHasEntitlements: isAutoDevEnabled,
        legacyFeatureflagsEnabled: !(0, $7jTnu.fg)('devai-issue-view-main-migration') && (0, $7jTnu.fg)('autodev-on-jira-issue') && // eslint-disable-next-line jira/ff/inline-expVal-params
        ((0, $epTsa.expVal)('autodev-project-enabled', 'value', []).includes(projectKey) || (0, $7jTnu.fg)('autodev-enabled-by-user'))
    };
};
const $0118c8fd7b212b02$var$useIsCodePlannerEnabledOnIssueView = ()=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const atlassianAccountId = (0, $8q7lT.useAccountId)();
    const { hasRovoDevAgentsEntitlement: hasRovoDevAgentsEntitlement } = (0, $7i1gE.useHasRovoDevAgentsEntitlement)(atlassianAccountId, cloudId, (0, $7zZ4w.default)(), (0, $7jTnu.fg)('code-planner-agent-limited-beta') && !(0, $7jTnu.fg)('devai-issue-view-main-migration'));
    return {
        isCodePlannerEnabledOnIssueView: !(0, $7jTnu.fg)('devai-issue-view-main-migration') && // technical-planner-on-jira-issue is the internal dogfooding flag
        (hasRovoDevAgentsEntitlement || (0, $7jTnu.fg)('technical-planner-on-jira-issue'))
    };
};
const $0118c8fd7b212b02$export$46453a0401d6cd1a = ({ hasSummaryData: hasSummaryData, showSummarySectionMessage: showSummarySectionMessage, review: review, build: build, deployment: deployment, pullRequest: pullRequest, issueKey: issueKey, issueId: issueId, hasBranchCapabilities: hasBranchCapabilities, analyticsAttributes: analyticsAttributes, branch: branch, branchTargets: branchTargets, legacyDataSummary: legacyDataSummary, commit: commit, detailsHasInstanceErrors: detailsHasInstanceErrors, hasDevelopmentDataInProject: hasDevelopmentDataInProject })=>{
    const { showDevDetailDialog: showDevDetailDialog } = (0, $l98s9.useDevOpsDetailsDialogLoaderActions)(`devInfoPanelApp${issueKey}`);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectId = (0, $bNexr.useProjectId)(projectKey) ?? '';
    const { userHasEntitlements: userHasEntitlements, legacyFeatureflagsEnabled: legacyFeatureflagsEnabled, isEntitlementsLoading: isEntitlementsLoading } = $0118c8fd7b212b02$var$useIsAutoDevEnabledOnIssueView(projectKey);
    const { isCodePlannerEnabledOnIssueView: isCodePlannerEnabledOnIssueView } = $0118c8fd7b212b02$var$useIsCodePlannerEnabledOnIssueView();
    const onShowDevDetailsDialog = (clickEvent, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
    devInfoType)=>{
        clickEvent && clickEvent.preventDefault();
        const detailDialogAnalyticsAttributes = {
            ...analyticsAttributes,
            summaryType: devInfoType
        };
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'summaryItem'
        }), 'devpanelsummary', detailDialogAnalyticsAttributes);
        const panelItemType = (0, $i4v50.toDetailDialogDataType)(devInfoType);
        if (devInfoType === (0, $8O88z.SUMMARY_ITEM_REVIEW)) {
            const summaryItem = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'LegacyDevSummary'.
            legacyDataSummary && legacyDataSummary[panelItemType] ? legacyDataSummary[panelItemType] : undefined;
            showDevDetailDialog(// @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'PanelDataTypes'.
            panelItemType, summaryItem, issueKey, issueId);
        } else showDevDetailDialog(// @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'PanelDataTypes'.
        panelItemType, undefined, issueKey, issueId);
    };
    const { count: branchesCount = 0 } = branch ?? {};
    return !hasSummaryData && !hasDevelopmentDataInProject && branchTargets.length === 0 && (0, $7jTnu.fg)('isotopes-devsummary-hide-development-no-connection') ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, !hasSummaryData && showSummarySectionMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5oysz.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b1iBk.default), {
        afterHeadingNode: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $66efJ.default), null),
        pinnable: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0118c8fd7b212b02$var$ConditionalSlideDown, null, isCodePlannerEnabledOnIssueView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "view-technical-planner-issue-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        packageName: "jiraTechnicalPlanner",
        teamName: "nova",
        id: "JiraTechnicalPlannerDevSummaryField",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b6JAY.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: "autodev-enabled-hold",
        hold: isEntitlementsLoading
    }), (userHasEntitlements || legacyFeatureflagsEnabled) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "view-autodev-issue-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dbm72.AutodevErrorBoundary), {
        id: "JiraAutodevDevSummaryField",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $72FkX.AutodevIssueContextStoreContainer), {
        issueId: issueId,
        issueKey: issueKey,
        projectId: projectId,
        projectKey: projectKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ka9RA.default), {
        issueId: issueId
    }))))), !hasSummaryData && !hasDevelopmentDataInProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1pV1F.AppConfigurationPromptSummary), {
        location: "DEVELOPMENT_PANEL",
        panelHasOtherPrompts: hasBranchCapabilities
    }), branchTargets.length > 0 && (0, $epTsa.expVal)('jira-work-suggestions-open-in-ide-experiment', 'openButton', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78KGy.default), {
        issueKey: issueKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2M0ib.default), {
        branch: branch,
        branchTargets: branchTargets,
        hasBranchCapabilities: hasBranchCapabilities,
        // @ts-expect-error - TS2322 - Type '(e: any) => void' is not assignable to type '() => void'. | TS7006 - Parameter 'e' implicitly has an 'any' type.
        onClick: (e)=>onShowDevDetailsDialog(e, (0, $8O88z.SUMMARY_ITEM_BRANCH)),
        issueId: issueId,
        issueKey: issueKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9zKYv.default), {
        commit: commit,
        hasCommitCapabilities: hasBranchCapabilities,
        // @ts-expect-error - TS2322 - Type '(e: any) => void' is not assignable to type '() => void'. | TS7006 - Parameter 'e' implicitly has an 'any' type.
        onClick: (e)=>onShowDevDetailsDialog(e, (0, $8O88z.SUMMARY_ITEM_COMMIT)),
        issueId: issueId,
        issueKey: issueKey
    }), hasSummaryData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8hEMV.default), {
        branchesCount: branchesCount,
        hasErrors: detailsHasInstanceErrors,
        pullRequest: pullRequest,
        // @ts-expect-error - TS2322 - Type '(e: any) => void' is not assignable to type '() => void'. | TS7006 - Parameter 'e' implicitly has an 'any' type.
        onClick: (e)=>onShowDevDetailsDialog(e, (0, $8O88z.SUMMARY_ITEM_PULLREQUEST)),
        issueId: issueId,
        issueKey: issueKey
    }), hasSummaryData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cjeLM.default), {
        review: review,
        // @ts-expect-error - TS2322 - Type '(e: any) => void' is not assignable to type '() => void'. | TS7006 - Parameter 'e' implicitly has an 'any' type.
        onClick: (e)=>onShowDevDetailsDialog(e, (0, $8O88z.SUMMARY_ITEM_REVIEW))
    }), hasSummaryData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cMtXS.default), {
        build: build,
        // @ts-expect-error - TS2322 - Type '(e: any) => void' is not assignable to type '() => void'. | TS7006 - Parameter 'e' implicitly has an 'any' type.
        onClick: (e)=>onShowDevDetailsDialog(e, (0, $8O88z.SUMMARY_ITEM_BUILD))
    }), hasSummaryData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2SSJ3.default), {
        deployment: deployment,
        issueKey: issueKey,
        // @ts-expect-error - TS2322 - Type '(e: any) => void' is not assignable to type '() => void'. | TS7006 - Parameter 'e' implicitly has an 'any' type.
        onClick: (e)=>onShowDevDetailsDialog(e, (0, $8O88z.SUMMARY_ITEM_DEPLOYMENT))
    }))));
};
const $0118c8fd7b212b02$var$getAnalyticsIssueDataMemoized = ()=>(0, $ahm5r.createSelector)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (state)=>(0, $kLuCE.getAnalyticsIssueData)(state), (res)=>res);
const $0118c8fd7b212b02$var$mapStateToPropsFactory = ()=>{
    const getAnalyticsIssueDataInstance = $0118c8fd7b212b02$var$getAnalyticsIssueDataMemoized();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (state)=>({
            showSummarySectionMessage: (0, $ddPfy.summarySectionMessageSelector)(state),
            // hasSummaryData includes errors
            hasSummaryData: (0, $ddPfy.hasSummaryInformationSelector)(state),
            // hasSummaryItems does not include errors
            hasSummaryItems: (0, $ddPfy.hasSummaryItemsSelector)(state),
            legacyDataSummary: (0, $ddPfy.legacyDataInformationSelector)(state),
            analyticsAttributes: getAnalyticsIssueDataInstance(state),
            review: (0, $ddPfy.reviewSummaryItemSelector)(state),
            build: (0, $ddPfy.buildSummaryItemSelector)(state),
            commit: (0, $ddPfy.commitSummaryItemSelector)(state),
            deployment: (0, $ddPfy.deploymentSummaryItemSelector)(state),
            pullRequest: (0, $ddPfy.pullRequestSummaryItemSelector)(state),
            issueKey: (0, $g9ECZ.issueKeySelector)(state),
            issueId: (0, $g9ECZ.issueIdSelector)(state),
            hasBranchCapabilities: (0, $ddPfy.hasBranchCapabilitiesSelector)(state),
            branch: (0, $ddPfy.branchSelector)(state),
            branchTargets: (0, $ddPfy.createBranchTargetsSelector)(state) ?? [],
            detailsHasInstanceErrors: (0, $ddPfy.detailsHasInstanceErrorsSelector)(state),
            hasDevelopmentDataInProject: (0, $ddPfy.hasDevelopmentDataInProjectSelector)(state)
        });
};
var $0118c8fd7b212b02$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($0118c8fd7b212b02$var$mapStateToPropsFactory, {})($0118c8fd7b212b02$export$46453a0401d6cd1a);

});
parcelRegister("1pV1F", function(module, exports) {

$parcel$export(module.exports, "AppConfigurationPromptSummary", () => $524b1b4081feb18d$export$e7fc2879f890f36f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $5lAAn = parcelRequire("5lAAn");

var $1OQKp = parcelRequire("1OQKp");

var $kkiGo = parcelRequire("kkiGo");

var $4F5bb = parcelRequire("4F5bb");

var $jdqdp = parcelRequire("jdqdp");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $22TK9 = parcelRequire("22TK9");

var $cDP77 = parcelRequire("cDP77");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $lRq8t = parcelRequire("lRq8t");

var $kEUB1 = parcelRequire("kEUB1");

var $gZTP9 = parcelRequire("gZTP9");

var $lUto7 = parcelRequire("lUto7");

var $coXKe = parcelRequire("coXKe");

var $ft1r3 = parcelRequire("ft1r3");
const $524b1b4081feb18d$export$e7fc2879f890f36f = ({ location: location, panelHasOtherPrompts: panelHasOtherPrompts = false })=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isSiteAdmin = (0, $lUto7.useIsSiteAdmin)();
    const isJiraAdmin = (0, $gZTP9.useIsAdmin)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $22TK9.appConfigurationPromptEntryPoint), {
        location: location,
        cloudId: cloudId
    });
    const { userPreferredLayout: userPreferredLayout } = (0, $coXKe.useUserPreferredWorkItemLayout)();
    const isWideViewLayout = userPreferredLayout === 'WIDE';
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (isSiteAdmin || isJiraAdmin) entryPointActions.load();
    }, [
        entryPointActions,
        isSiteAdmin,
        isJiraAdmin
    ]);
    if (!isSiteAdmin && !isJiraAdmin) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "jswDevelopmentSummaryAppConfigPromptEntryPoint",
        packageName: "development-field",
        entryPointReferenceSubject: entryPointReferenceSubject,
        errorFallback: "flag",
        runtimeProps: {
            location: location,
            cloudId: cloudId,
            getDropdownTrigger: ({ ref: ref, onClick: onClick, appIcon: appIcon, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                    className: (0, $hcewu.default)([
                        "_1e0c1txw _2lx21bp4 _1bsb1osq _18u0idpf"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDP77.SummaryItem), {
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, location === 'DEVELOPMENT_PANEL' && formatMessage((0, $ft1r3.default).codeToolsPromptLabel), location === 'RELEASES_PANEL' && formatMessage((0, $ft1r3.default).deploymentToolsPromptLabel), location === 'SECURITY_PANEL' && formatMessage((0, $ft1r3.default).securityToolsPromptLabel)),
                    icon: appIcon || isWideViewLayout ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4F5bb))), {
                        color: "var(--ds-link, #0C66E4)",
                        label: "finish-tool-setup-icon"
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kkiGo))), {
                        spacing: "spacious",
                        label: "finish-tool-setup-icon"
                    }),
                    secondaryData: isWideViewLayout ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
                        label: "providers-dropdown",
                        size: "small",
                        color: "var(--ds-link, #0C66E4)"
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
                        spacing: "spacious",
                        label: "providers-dropdown",
                        size: "small"
                    }),
                    reference: ref,
                    ...props,
                    onClick: onClick,
                    linkFormatting: true,
                    "data-testid": "development-summary-app-config-prompt-field.ui.summary-item",
                    disableAnimationOnUpdates: true
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                    xcss: $524b1b4081feb18d$var$lozengeWrapperStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
                    appearance: "moved"
                }, formatMessage((0, $ft1r3.default).pendingLozenge))), panelHasOtherPrompts && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                    className: (0, $hcewu.default)([
                        "_2rko1l7b _n7zludwz _19pkutpp _otyrutpp _18u01lpd _t9ec1e99"
                    ])
                }))
        }
    });
};
const $524b1b4081feb18d$var$wrapperStyles = null;
const $524b1b4081feb18d$var$lozengeWrapperStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.100'
});
const $524b1b4081feb18d$var$separatorStyles = null;

});
parcelRegister("22TK9", function(module, exports) {

$parcel$export(module.exports, "appConfigurationPromptEntryPoint", () => $7f398e0bbc8ac4a4$export$9f3d34e7a5ba63ec);

var $6mYGR = parcelRequire("6mYGR");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");
const $7f398e0bbc8ac4a4$var$locationToProviderTypes = (location)=>{
    switch(location){
        case 'DEVELOPMENT_PANEL':
            return [
                'DEVELOPMENT_INFO'
            ];
        case 'RELEASES_PANEL':
            return [
                'DEPLOYMENTS'
            ];
        case 'SECURITY_PANEL':
            return [
                'SECURITY'
            ];
        default:
            return [];
    }
};

const $7f398e0bbc8ac4a4$export$9f3d34e7a5ba63ec = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("4wiMA")), {
        moduleId: "873c3603",
        priority: "interaction"
    }),
    getPreloadProps: ({ location: location, cloudId: cloudId })=>({
            queries: {
                queryRef: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $6mYGR.default,
                    variables: {
                        cloudId: cloudId,
                        providerTypes: $7f398e0bbc8ac4a4$var$locationToProviderTypes(location),
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        location: location
                    }
                }
            }
        })
});

});
parcelRegister("6mYGR", function(module, exports) {

$parcel$export(module.exports, "default", () => $880619f9d94f215d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<03e7291518456d4895303607753b8334>>
 * @relayHash e0f1f2a58d6cdd8d7028571b28e491fa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6b26f86bac3fdf64d54f307c65f97fec71607084cfed9ade7abcc3ccf4c0c13b
const $880619f9d94f215d$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "6b26f86bac3fdf64d54f307c65f97fec71607084cfed9ade7abcc3ccf4c0c13b",
        "metadata": {},
        "name": "uiAppConfigurationPromptQuery",
        "operationKind": "query",
        "text": null
    }
};
var $880619f9d94f215d$export$2e2bcd8739ae039 = $880619f9d94f215d$var$node;

});

parcelRegister("4wiMA", function(module, exports) {

let $34a8b8695a4187fa$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $34a8b8695a4187fa$var$load("hPjUM").then(()=>parcelRequire('hy8z1'));

});


parcelRegister("ft1r3", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bacb1da8d5b0356$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $8bacb1da8d5b0356$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    codeToolsPromptLabel: {
        "id": "development-summary-app-config-prompt-field.code-tools-prompt-label",
        "defaultMessage": "Set up code tools"
    },
    deploymentToolsPromptLabel: {
        "id": "development-summary-app-config-prompt-field.deployment-tools-prompt-label",
        "defaultMessage": "Set up deployment tools"
    },
    securityToolsPromptLabel: {
        "id": "development-summary-app-config-prompt-field.security-tools-prompt-label",
        "defaultMessage": "Set up security tools"
    },
    pendingLozenge: {
        "id": "development-summary-app-config-prompt-field.pending-lozenge",
        "defaultMessage": "PENDING"
    }
});

});


parcelRegister("cMtXS", function(module, exports) {

$parcel$export(module.exports, "default", () => $17647385554d24df$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3TFuO = parcelRequire("3TFuO");

var $kXEdL = parcelRequire("kXEdL");

var $cDP77 = parcelRequire("cDP77");

var $kDaaB = parcelRequire("kDaaB");

var $dTocu = parcelRequire("dTocu");

var $3WpOe = parcelRequire("3WpOe");
const $17647385554d24df$export$b141efd0b0fb9174 = (previousProps, nextProps)=>nextProps.build?.count === previousProps.build?.count && nextProps.build?.lastUpdated === previousProps.build?.lastUpdated && nextProps.build?.failedBuildCount === previousProps.build?.failedBuildCount && nextProps.build?.successfulBuildCount === previousProps.build?.successfulBuildCount && nextProps.build?.unknownBuildCount === previousProps.build?.unknownBuildCount && nextProps.build?.url === previousProps.build?.url;
const $17647385554d24df$export$77b5f1d340d6466b = /*#__PURE__*/ (0, $eJOHy.memo)(({ build: build, onClick: onClick })=>{
    const { formatNumber: formatNumber, formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const { count: count = 0, failedBuildCount: failedBuildCount = 0, successfulBuildCount: successfulBuildCount = 0 } = build ?? {};
    const { title: title, secondaryData: secondaryData } = (0, $eJOHy.useMemo)(()=>{
        let titleComponent;
        let icon;
        if (failedBuildCount > 0) {
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kXEdL))), {
                spacing: "spacious",
                label: "dev-panel-failed-build-icon",
                color: "var(--ds-icon-danger, #C9372C)"
            });
            titleComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
                ...(0, $3WpOe.default).failingBuildsTitle,
                values: {
                    bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($17647385554d24df$var$BoldFont, null, chunks),
                    count: formatNumber(failedBuildCount)
                }
            });
        } else if (successfulBuildCount > 0) {
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3TFuO))), {
                spacing: "spacious",
                label: "dev-panel-successful-build-icon",
                color: "var(--ds-icon-success, #22A06B)"
            });
            titleComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
                ...(0, $3WpOe.default).successfulBuildsTitle,
                values: {
                    bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($17647385554d24df$var$BoldFont, null, chunks),
                    count: formatNumber(successfulBuildCount)
                }
            });
        } else {
            icon = null;
            titleComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
                ...(0, $3WpOe.default).incompleteBuildsTitle,
                values: {
                    bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($17647385554d24df$var$BoldFont, null, chunks),
                    count: formatNumber(count)
                }
            });
        }
        return {
            title: titleComponent,
            secondaryData: icon
        };
    }, [
        count,
        failedBuildCount,
        formatNumber,
        successfulBuildCount
    ]);
    const shownItemCount = (0, $eJOHy.useMemo)(()=>{
        let buildCountToBeShown;
        if (failedBuildCount > 0) buildCountToBeShown = failedBuildCount;
        else if (successfulBuildCount > 0) buildCountToBeShown = successfulBuildCount;
        else buildCountToBeShown = count;
        return buildCountToBeShown;
    }, [
        count,
        failedBuildCount,
        successfulBuildCount
    ]);
    if (build && count > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDP77.SummaryItem), {
        title: title,
        secondaryData: secondaryData,
        href: undefined,
        onClick: onClick,
        itemType: "build",
        itemCount: shownItemCount,
        oneClickUrl: build.url,
        oneClickToolTipContent: formatMessage((0, $3WpOe.default).tooltip),
        "data-testid": "development-summary-build.ui.summary-item"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
}, $17647385554d24df$export$b141efd0b0fb9174);
var $17647385554d24df$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $17647385554d24df$export$77b5f1d340d6466b;
const $17647385554d24df$var$BoldFont = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_k48p1wq8",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3WpOe", function(module, exports) {

$parcel$export(module.exports, "default", () => $87b7d98dd610f07d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $87b7d98dd610f07d$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    failingBuildsTitle: {
        "id": "development-summary-build.failingBuildsMessageTitle",
        "defaultMessage": "<bold>{count}</bold> {count, plural, one {build} other {builds}} failing"
    },
    successfulBuildsTitle: {
        "id": "development-summary-build.successfulBuildsMessageTitle",
        "defaultMessage": "<bold>{count}</bold> {count, plural, one {build} other {builds}}"
    },
    incompleteBuildsTitle: {
        "id": "development-summary-build.incompleteBuildsMessageTitle",
        "defaultMessage": "<bold>{count}</bold> {count, plural, one {build} other {builds}} incomplete"
    },
    tooltip: {
        "id": "development-summary-build.tooltip",
        "defaultMessage": "Open build"
    }
});

});


parcelRegister("i4v50", function(module, exports) {

$parcel$export(module.exports, "toDetailDialogDataType", () => $4a7672e29aa45d31$export$c7936759ace5464a);

var $8O88z = parcelRequire("8O88z");
const $4a7672e29aa45d31$export$c7936759ace5464a = (itemType)=>{
    const needsTransformation = ![
        (0, $8O88z.SUMMARY_ITEM_BRANCH),
        (0, $8O88z.SUMMARY_ITEM_BUILD),
        (0, $8O88z.SUMMARY_ITEM_PULLREQUEST),
        (0, $8O88z.SUMMARY_ITEM_REVIEW),
        (0, $8O88z.SUMMARY_ITEM_FEATURE_FLAGS),
        (0, $8O88z.SUMMARY_ITEM_REMOTE_LINKS)
    ].includes(itemType);
    if (!needsTransformation) return itemType;
    if (itemType === (0, $8O88z.SUMMARY_ITEM_DEPLOYMENT) || itemType === 'deploymentEnvironments') return 'deployment-environment';
    if (itemType === (0, $8O88z.SUMMARY_ITEM_COMMIT)) return 'repository';
    throw new Error(`Unknown item type ${itemType}`);
};

});

parcelRegister("2SSJ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $546c8a57cc0298ac$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $8IeH1 = parcelRequire("8IeH1");
var $3cMgR = parcelRequire("3cMgR");

var $k71qx = parcelRequire("k71qx");

var $cDP77 = parcelRequire("cDP77");

var $lRq8t = parcelRequire("lRq8t");

var $3Muzf = parcelRequire("3Muzf");
const $546c8a57cc0298ac$var$getHref = (issueKey)=>`/browse/${issueKey}?devStatusDetailDialog=deployment-environment`;
const $546c8a57cc0298ac$export$b141efd0b0fb9174 = (previousProps, nextProps)=>(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(nextProps.deployment?.environments, previousProps.deployment?.environments) && nextProps.deployment?.count === previousProps.deployment?.count;
const $546c8a57cc0298ac$export$4c71438264bb2277 = /*#__PURE__*/ (0, $eJOHy.memo)(({ deployment: deployment, issueKey: issueKey, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { count: count = 0, environments: environments = [] } = deployment ?? {};
    const title = (0, $eJOHy.useMemo)(()=>{
        const displayedEnvironments = environments.join(', ');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            size: "UNSAFE_small",
            color: "color.text.subtle"
        }, formatMessage((0, $3Muzf.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: displayedEnvironments
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            maxLines: 1
        }, displayedEnvironments)));
    }, [
        environments,
        formatMessage
    ]);
    if (deployment && count > 0 && environments.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDP77.SummaryItem), {
        title: title,
        href: $546c8a57cc0298ac$var$getHref(issueKey),
        onClick: onClick,
        "data-testid": "development-summary-deployment-development-field.ui.summary-item"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
}, $546c8a57cc0298ac$export$b141efd0b0fb9174);
var $546c8a57cc0298ac$export$2e2bcd8739ae039 = $546c8a57cc0298ac$export$4c71438264bb2277;

});
parcelRegister("3Muzf", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2b490751c98e759$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $d2b490751c98e759$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "development-summary-deployment-development-field.title",
        "defaultMessage": "Deployed to"
    }
});

});


parcelRegister("cjeLM", function(module, exports) {

$parcel$export(module.exports, "default", () => $99c04f1df2e7953b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jdqdp = parcelRequire("jdqdp");

var $cDP77 = parcelRequire("cDP77");

var $3eXrV = parcelRequire("3eXrV");

var $dTocu = parcelRequire("dTocu");

var $kbYGv = parcelRequire("kbYGv");
const $99c04f1df2e7953b$var$statusCategoryToAppearenceMap = {
    REVIEW: 'inprogress',
    SUMMARIZE: 'inprogress',
    DRAFT: 'new',
    CLOSED: 'success',
    APPROVAL: 'inprogress',
    DEAD: 'removed',
    REJECTED: 'removed',
    UNKNOWN: 'default'
};
const $99c04f1df2e7953b$export$b141efd0b0fb9174 = (previousProps, nextProps)=>nextProps.review?.count === previousProps.review?.count && nextProps.review?.lastUpdated === previousProps.review?.lastUpdated && nextProps.review?.stateCount === previousProps.review?.stateCount && nextProps.review?.state === previousProps.review?.state;
const $99c04f1df2e7953b$export$4e3e332352c3d092 = /*#__PURE__*/ (0, $eJOHy.memo)(({ review: review, onClick: onClick })=>{
    const { formatNumber: formatNumber, formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const { count: count = 0, stateCount: stateCount = 0, state: state } = review ?? {};
    const title = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3eXrV.FormattedI18nMessage), {
            componentsMapping: {
                bold: $99c04f1df2e7953b$var$BoldFont
            },
            message: formatMessage((0, $kbYGv.default).title, {
                count: formatNumber(stateCount),
                boldStart: '{boldStart}',
                boldEnd: '{boldEnd}'
            })
        }), [
        formatMessage,
        formatNumber,
        stateCount
    ]);
    const secondaryData = (0, $eJOHy.useMemo)(()=>{
        const safeState = state || 'UNKNOWN'; // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'ThemeAppearance | undefined'.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
            appearance: $99c04f1df2e7953b$var$statusCategoryToAppearenceMap[safeState]
        }, safeState);
    }, [
        state
    ]);
    if (review && count > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDP77.SummaryItem), {
        title: title,
        href: null,
        onClick: onClick,
        itemType: "review",
        secondaryData: secondaryData,
        "data-testid": "development-summary-review.ui.summary-item"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
}, $99c04f1df2e7953b$export$b141efd0b0fb9174);
var $99c04f1df2e7953b$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $99c04f1df2e7953b$export$4e3e332352c3d092;
const $99c04f1df2e7953b$var$BoldFont = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_k48p1wq8",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kbYGv", function(module, exports) {

$parcel$export(module.exports, "default", () => $202be846e5fa64c2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $202be846e5fa64c2$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "development-summary-review.title",
        "defaultMessage": "{boldStart}{count}{boldEnd} {count, plural, one {review} other {reviews}}"
    }
});

});


parcelRegister("b6JAY", function(module, exports) {

$parcel$export(module.exports, "default", () => $04dc88da5809b636$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

const $04dc88da5809b636$var$LazyComponent = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("6yJ4I")), {
    moduleId: "./src/packages/autodev/jira-technical-planner/src/ui/index.tsx"
});
const $04dc88da5809b636$export$16fa2f45be04daa8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "jira-technical-planner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($04dc88da5809b636$var$LazyComponent, null));
var $04dc88da5809b636$export$2e2bcd8739ae039 = $04dc88da5809b636$export$16fa2f45be04daa8;

});
parcelRegister("6yJ4I", function(module, exports) {

let $4c68e20574fdf3ac$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4c68e20574fdf3ac$var$load("6vUHo").then(()=>parcelRequire('kvaSW'));

});


parcelRegister("1c9L5", function(module, exports) {

$parcel$export(module.exports, "Status", () => $02b6e4781598f393$export$96e9906d6d93a972);
$parcel$export(module.exports, "useIsAutoDevEnabled", () => $02b6e4781598f393$export$4c4ab362d8a15770);

var $5JzWL = parcelRequire("5JzWL");

var $eJOHy = parcelRequire("eJOHy");

var $37Ewn = parcelRequire("37Ewn");

var $7jTnu = parcelRequire("7jTnu");
const $02b6e4781598f393$export$96e9906d6d93a972 = {
    NOT_DETERMINED: 0,
    PROCESSING: 1,
    DETERMINED: 2
};
const $02b6e4781598f393$export$4c4ab362d8a15770 = (atlassianAccountId, cloudId, relayEnv, isRovoRequired = true, skipCheck = false)=>{
    const [isAutoDevEnabled, setIsAutoDevEnabled] = (0, $eJOHy.useState)(false);
    const [isDetermined, setIsDetermined] = (0, $eJOHy.useState)($02b6e4781598f393$export$96e9906d6d93a972.NOT_DETERMINED);
    (0, $eJOHy.useEffect)(()=>{
        const determineDevAIEnabled = async ()=>{
            if (atlassianAccountId === null || atlassianAccountId.trim() === '') {
                setIsAutoDevEnabled(false);
                setIsDetermined($02b6e4781598f393$export$96e9906d6d93a972.DETERMINED);
            } else $02b6e4781598f393$export$dee0c91847f2a763({
                atlassianAccountId: atlassianAccountId,
                cloudId: cloudId,
                relayEnv: relayEnv
            }).then((response)=>{
                const hasProductAccess = response?.hasProductAccess ?? false;
                const rovoEnabled = response?.isRovoEnabled ?? false;
                setIsDetermined($02b6e4781598f393$export$96e9906d6d93a972.DETERMINED);
                setIsAutoDevEnabled(hasProductAccess && (isRovoRequired ? rovoEnabled : true));
            }).catch(()=>{
                setIsAutoDevEnabled(false);
                setIsDetermined($02b6e4781598f393$export$96e9906d6d93a972.DETERMINED);
            });
        };
        if (isDetermined === $02b6e4781598f393$export$96e9906d6d93a972.NOT_DETERMINED && atlassianAccountId !== '') {
            setIsDetermined($02b6e4781598f393$export$96e9906d6d93a972.PROCESSING);
            if (!skipCheck && (0, $7jTnu.fg)('coding-agents-limited-beta')) determineDevAIEnabled();
            else {
                setIsDetermined($02b6e4781598f393$export$96e9906d6d93a972.DETERMINED);
                setIsAutoDevEnabled(false);
            }
        }
    }, [
        atlassianAccountId,
        isDetermined,
        cloudId,
        relayEnv,
        isRovoRequired,
        skipCheck
    ]);
    return [
        isAutoDevEnabled,
        isDetermined
    ];
};
const $02b6e4781598f393$export$dee0c91847f2a763 = async ({ atlassianAccountId: atlassianAccountId, cloudId: cloudId, relayEnv: relayEnv })=>{
    const result = await (0, $37Ewn.fetchQuery)(relayEnv, (0, $5JzWL.default), {
        atlassianAccountId: atlassianAccountId,
        cloudId: cloudId,
        isAutodevBetaEnabled: (0, $7jTnu.fg)('coding-agents-limited-beta')
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise().then((response)=>{
        return {
            hasProductAccess: response?.devai_rovoDevAgentsUser?.hasProductAccess ?? false,
            isAdmin: response?.devai_rovoDevAgentsUser?.isAdmin ?? false,
            isRovoEnabled: response?.jira?.isRovoEnabled ?? false
        };
    });
    return result;
};

});
parcelRegister("5JzWL", function(module, exports) {

$parcel$export(module.exports, "default", () => $88b9ea2a716f734c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<617855ec21de464b6fa2c4294ef59e04>>
 * @relayHash 835cf47f6749ab86fa6fd796e566b197
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e046b4c1327a28b7d4c765a0380da862200507908d5b6a7b0d1bf782e0a87057
const $88b9ea2a716f734c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "atlassianAccountId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isAutodevBetaEnabled"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "args": [
            {
                "kind": "Variable",
                "name": "atlassianAccountId",
                "variableName": "atlassianAccountId"
            },
            v1 /*: any*/ 
        ],
        "concreteType": "DevAiUser",
        "kind": "LinkedField",
        "name": "devai_rovoDevAgentsUser",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasProductAccess"
            },
            {
                "kind": "ScalarField",
                "name": "isAdmin"
            }
        ]
    }, v3 = {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
            {
                "condition": "isAutodevBetaEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "args": [
                            v1 /*: any*/ 
                        ],
                        "kind": "ScalarField",
                        "name": "isRovoEnabled"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsAutodevEnabledQuery",
            "selections": [
                {
                    "condition": "isAutodevBetaEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v2 /*: any*/ ,
                            "action": "THROW",
                            "path": "devai_rovoDevAgentsUser"
                        }
                    ]
                },
                v3 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsAutodevEnabledQuery",
            "selections": [
                {
                    "condition": "isAutodevBetaEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                },
                v3 /*: any*/ 
            ]
        },
        "params": {
            "id": "e046b4c1327a28b7d4c765a0380da862200507908d5b6a7b0d1bf782e0a87057",
            "metadata": {},
            "name": "useIsAutodevEnabledQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$88b9ea2a716f734c$var$node.hash = "35a2fac16cf075dfe6102fcdda3a7299";
var $88b9ea2a716f734c$export$2e2bcd8739ae039 = $88b9ea2a716f734c$var$node;

});


parcelRegister("7i1gE", function(module, exports) {

$parcel$export(module.exports, "useHasRovoDevAgentsEntitlement", () => $30a9ecb27b0c3b1b$export$f88ef27717fc01fc);

var $eJOHy = parcelRequire("eJOHy");

var $gceL9 = parcelRequire("gceL9");
const $30a9ecb27b0c3b1b$export$f88ef27717fc01fc = (atlassianAccountId, cloudId, relayEnv, shouldCheckEntitlement)=>{
    const [hasRovoDevAgentsEntitlement, setHasRovoDevAgentsEntitlement] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (!atlassianAccountId || !shouldCheckEntitlement) return;
        (0, $gceL9.userHasRovoDevAgentsAccess)({
            atlassianAccountId: atlassianAccountId,
            cloudId: cloudId,
            relayEnv: relayEnv
        }).then((hasAccess)=>{
            setHasRovoDevAgentsEntitlement(hasAccess);
        });
    }, [
        atlassianAccountId,
        cloudId,
        relayEnv,
        shouldCheckEntitlement
    ]);
    return {
        hasRovoDevAgentsEntitlement: hasRovoDevAgentsEntitlement
    };
};

});
parcelRegister("gceL9", function(module, exports) {

$parcel$export(module.exports, "userHasRovoDevAgentsAccess", () => $518dd3fd6fd68e39$export$555786b5fe156a9d);

var $9GipL = parcelRequire("9GipL");

var $37Ewn = parcelRequire("37Ewn");
const $518dd3fd6fd68e39$export$555786b5fe156a9d = async ({ atlassianAccountId: atlassianAccountId, cloudId: cloudId, relayEnv: relayEnv })=>{
    const response = await (0, $37Ewn.fetchQuery)(relayEnv, (0, $9GipL.default), {
        atlassianAccountId: atlassianAccountId,
        cloudId: cloudId
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    return response?.devai_rovoDevAgentsUser?.hasProductAccess ?? false;
};

});
parcelRegister("9GipL", function(module, exports) {

$parcel$export(module.exports, "default", () => $f87f7109f12128af$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<723b3ac8a7b187c136c463dff552fed1>>
 * @relayHash 826e32a782d6c914902f0dd48681143e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6cc503e1004536c657beb712f31ebd0b4deb94e2a5cca8f7225c3cc502ece7d6
const $f87f7109f12128af$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "atlassianAccountId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "args": [
            {
                "kind": "Variable",
                "name": "atlassianAccountId",
                "variableName": "atlassianAccountId"
            },
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ],
        "concreteType": "DevAiUser",
        "kind": "LinkedField",
        "name": "devai_rovoDevAgentsUser",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasProductAccess"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "userHasRovoDevAgentsAccessQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": v1 /*: any*/ ,
                    "action": "THROW",
                    "path": "devai_rovoDevAgentsUser"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "userHasRovoDevAgentsAccessQuery",
            "selections": [
                v1 /*: any*/ 
            ]
        },
        "params": {
            "id": "6cc503e1004536c657beb712f31ebd0b4deb94e2a5cca8f7225c3cc502ece7d6",
            "metadata": {},
            "name": "userHasRovoDevAgentsAccessQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f87f7109f12128af$var$node.hash = "2211f981812c18f10eb7045dcff65aae";
var $f87f7109f12128af$export$2e2bcd8739ae039 = $f87f7109f12128af$var$node;

});



parcelRegister("78KGy", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd0c64b8d34d2e2b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3fGoc = parcelRequire("3fGoc");

var $dTocu = parcelRequire("dTocu");

var $cDP77 = parcelRequire("cDP77");

var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");
var $gCeeo = parcelRequire("gCeeo");

var $e3wrk = parcelRequire("e3wrk");
const $dd0c64b8d34d2e2b$var$verticalAlignStyle = null;
const $dd0c64b8d34d2e2b$var$ScreenIcon = /*#__PURE__*/ $eJOHy.createElement("span", {
    "aria-hidden": true,
    className: (0, $hcewu.default)([
        "_s7n4nkob"
    ])
}, /*#__PURE__*/ $eJOHy.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fGoc))), {
    color: "var(--ds-link, #0C66E4)",
    label: ""
}));
const $dd0c64b8d34d2e2b$var$buildVsCodeUrl = (issueKey, host)=>{
    const issueKeyQs = encodeURIComponent(issueKey);
    const hostQs = encodeURIComponent(host);
    return `vscode://atlassian.atlascode/openJiraIssue?key=${issueKeyQs}&site=${hostQs}&source=jira`;
};
const $dd0c64b8d34d2e2b$var$OpenInVSCodeItem = ({ issueKey: issueKey })=>{
    const { formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const title = formatMessage((0, $e3wrk.default).openWithMessage);
    const clickUrl = (0, $eJOHy.useMemo)(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    ()=>$dd0c64b8d34d2e2b$var$buildVsCodeUrl(issueKey, document.location.hostname), [
        issueKey
    ]);
    return /*#__PURE__*/ $eJOHy.createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "openInVSCodeButton",
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ $eJOHy.createElement((0, $iqtgH.FireScreenAnalytics), null), /*#__PURE__*/ $eJOHy.createElement((0, $cDP77.SummaryItem), {
        title: title,
        issueKey: issueKey,
        icon: $dd0c64b8d34d2e2b$var$ScreenIcon,
        linkFormatting: true,
        href: clickUrl,
        onClick: (_, analyticEvent)=>{
            return (0, $gCeeo.fireUIAnalytics)(analyticEvent, 'openInVSCodeButton');
        },
        "data-testid": "development-summary-development-field.ui.summary.open-in-vscode.open-in-vscode-summary-item"
    }));
};
var $dd0c64b8d34d2e2b$export$2e2bcd8739ae039 = $dd0c64b8d34d2e2b$var$OpenInVSCodeItem;

});
parcelRegister("3fGoc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1698552166bfef93121ec02f2fff1081>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25e3a76f3acc4c37$var$_react = $25e3a76f3acc4c37$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $25e3a76f3acc4c37$var$_baseNew = $25e3a76f3acc4c37$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $25e3a76f3acc4c37$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Screen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: assets in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25e3a76f3acc4c37$var$ScreenIcon = (props)=>/*#__PURE__*/ $25e3a76f3acc4c37$var$_react.default.createElement($25e3a76f3acc4c37$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H8.75v1.5H12V15H4v-1.5h3.25V12H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$25e3a76f3acc4c37$var$ScreenIcon.displayName = 'ScreenIcon';
var $25e3a76f3acc4c37$var$_default = module.exports.default = $25e3a76f3acc4c37$var$ScreenIcon;

});

// SCREENS
const $466f60259c330878$export$f636b5b56f1d624a = 'Screen';
const $466f60259c330878$export$9d2de6eebf7462b5 = 'Drawer';
const $466f60259c330878$export$1171103ea9083ffa = 'Modal';
const $466f60259c330878$export$cae2783c9279926 = 'InlineDialog';
const $466f60259c330878$export$d1123261ca8831d2 = 'Dropdown';
const $466f60259c330878$export$238d30785c4bca84 = 'Banner';
const $466f60259c330878$export$a1562d08625f5d7e = 'UI';
const $466f60259c330878$export$947dac6c72b26f81 = 'TRACK';
const $466f60259c330878$export$f1d537d508d2945a = 'SCREEN';
const $466f60259c330878$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("e3wrk", function(module, exports) {

$parcel$export(module.exports, "default", () => $13b5a64f9d954a07$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $13b5a64f9d954a07$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    openWithMessage: {
        "id": "development-summary-development-field.summary.open-in-vscode.open-with-message",
        "defaultMessage": "Open with VS Code"
    }
});

});


parcelRegister("66efJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3319de9a5157ae8f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $fAoiP = parcelRequire("fAoiP");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $9NIQG = parcelRequire("9NIQG");

var $gnQAk = parcelRequire("gnQAk");

var $ddPfy = parcelRequire("ddPfy");

var $8G3oL = parcelRequire("8G3oL");

var $a4nux = parcelRequire("a4nux");
const $3319de9a5157ae8f$export$b8e9cd941e8016ac = (props)=>{
    const { errors: errors, configErrors: configErrors } = props;
    if (!errors.length && !configErrors.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9NIQG.DevPanelIconContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fAoiP.default), {
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $3319de9a5157ae8f$var$containerStyles
    }, errors && errors.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a4nux.default), {
        errors: errors
    }) : null, configErrors && configErrors.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8G3oL.default), {
        configErrors: configErrors
    }) : null)));
};
var $3319de9a5157ae8f$export$2e2bcd8739ae039 = (0, $gnQAk.connect)((state)=>({
        // @ts-expect-error - TS2345 - Argument of type '{}' is not assignable to parameter of type 'State'.
        errors: (0, $ddPfy.errorsSelector)(state) ?? [],
        // @ts-expect-error - TS2345 - Argument of type '{}' is not assignable to parameter of type 'State'.
        configErrors: (0, $ddPfy.configErrorsSelector)(state) ?? []
    }), {})($3319de9a5157ae8f$export$b8e9cd941e8016ac);
const $3319de9a5157ae8f$var$containerStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.negative.300'
});

});
parcelRegister("8G3oL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0f831d35516cfa6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eJ9f5 = parcelRequire("eJ9f5");

var $7jTnu = parcelRequire("7jTnu");

var $kDaaB = parcelRequire("kDaaB");

var $dTocu = parcelRequire("dTocu");

var $8rM8l = parcelRequire("8rM8l");
const $a0f831d35516cfa6$var$getInstanceLink = (error)=>(0, $7jTnu.fg)('replace-anchor-with-link__nova') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
        href: error.instanceUrl
    }, error.instanceName) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
        href: error.instanceUrl
    }, error.instanceName);
const $a0f831d35516cfa6$export$74198bf8b0e4be91 = (props)=>{
    const { formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const configErrorInstancesOneMessage = (errors)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
            ...(0, $8rM8l.default).oneConfigError,
            values: {
                instanceOne: $a0f831d35516cfa6$var$getInstanceLink(errors[0])
            }
        });
    const configErrorInstancesTwoMessage = (errors)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
            ...(0, $8rM8l.default).twoConfigError,
            values: {
                instanceOne: $a0f831d35516cfa6$var$getInstanceLink(errors[0]),
                instanceTwo: $a0f831d35516cfa6$var$getInstanceLink(errors[1])
            }
        });
    const configErrorInstancesThreeMessage = (errors)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
            ...(0, $8rM8l.default).threeConfigError,
            values: {
                instanceOne: $a0f831d35516cfa6$var$getInstanceLink(errors[0]),
                instanceTwo: $a0f831d35516cfa6$var$getInstanceLink(errors[1]),
                instanceThree: $a0f831d35516cfa6$var$getInstanceLink(errors[2])
            }
        });
    const configErrorInstancesMoreMessage = (errors)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
            ...(0, $8rM8l.default).moreConfigError,
            values: {
                instanceOne: $a0f831d35516cfa6$var$getInstanceLink(errors[0]),
                instanceTwo: $a0f831d35516cfa6$var$getInstanceLink(errors[1]),
                instanceThree: $a0f831d35516cfa6$var$getInstanceLink(errors[2]),
                count: errors.length - 3
            }
        });
    const configErrorLearnMore = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
            ...(0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $8rM8l.default).configErrorAndLearnMoreIssueTermRefresh : (0, $8rM8l.default).configErrorAndLearnMore,
            values: {
                h: (chunks)=>(0, $7jTnu.fg)('replace-anchor-with-link__nova') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                        href: "https://confluence.atlassian.com/display/JIRAKB/JIRA+Application+Development+panel+displays+error+-+Couldn%27t+read+data"
                    }, chunks) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
                        href: "https://confluence.atlassian.com/display/JIRAKB/JIRA+Application+Development+panel+displays+error+-+Couldn%27t+read+data"
                    }, chunks),
                a: (chunks)=>(0, $7jTnu.fg)('replace-anchor-with-link__nova') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                        href: "/plugins/servlet/applinks/listApplicationLinks"
                    }, chunks) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
                        href: "/plugins/servlet/applinks/listApplicationLinks"
                    }, chunks)
            }
        });
    const renderConfigErrorDescription = (configErrors)=>{
        switch(configErrors.length){
            case 1:
                return configErrorInstancesOneMessage(configErrors);
            case 2:
                return configErrorInstancesTwoMessage(configErrors);
            case 3:
                return configErrorInstancesThreeMessage(configErrors);
            default:
                return configErrorInstancesMoreMessage(configErrors);
        }
    };
    const { configErrors: configErrors } = props;
    return configErrors && configErrors.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a0f831d35516cfa6$var$Title, null, formatMessage((0, $8rM8l.default).configTitle)), renderConfigErrorDescription(configErrors), " ", configErrorLearnMore()) : null;
};
var $a0f831d35516cfa6$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $a0f831d35516cfa6$export$74198bf8b0e4be91;
const $a0f831d35516cfa6$var$Title = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pk1ejb _2hwxidpf _otyru2gc _18u0idpf _k48p1wq8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a0f831d35516cfa6$export$7ed12d2a5241e393 = {
    Title: $a0f831d35516cfa6$var$Title
};

});
parcelRegister("8rM8l", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffe94f91dae0e561$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $ffe94f91dae0e561$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    oneConfigError: {
        "id": "development-summary-development-field.summary.error-tag.config-errors.one-config-error",
        "defaultMessage": "Couldn't read data from {instanceOne}."
    },
    twoConfigError: {
        "id": "development-summary-development-field.summary.error-tag.config-errors.two-config-error",
        "defaultMessage": "Couldn't read data from {instanceOne} and {instanceTwo}."
    },
    threeConfigError: {
        "id": "development-summary-development-field.summary.error-tag.config-errors.three-config-error",
        "defaultMessage": "Couldn't read data from {instanceOne}, {instanceTwo} and {instanceThree}."
    },
    moreConfigError: {
        "id": "development-summary-development-field.summary.error-tag.config-errors.more-config-error",
        "defaultMessage": "Couldn't read data from {instanceOne}, {instanceTwo}, {instanceThree} and {count} other {count, plural, one {application} other {applications}}."
    },
    configErrorAndLearnMore: {
        "id": "development-summary-development-field.summary.error-tag.config-errors.config-error-and-learn-more",
        "defaultMessage": "Learn <h>about this issue</h> or go to <a>application links</a> to fix it."
    },
    configTitle: {
        "id": "development-summary-development-field.summary.error-tag.config-errors.config-title",
        "defaultMessage": "Configuration problem"
    },
    configErrorAndLearnMoreIssueTermRefresh: {
        "id": "development-summary-development-field.summary.error-tag.config-errors.config-error-and-learn-more-issue-term-refresh",
        "defaultMessage": "Find out <h>about this work item</h> or go to <a>application links</a> to fix it."
    }
});

});


parcelRegister("a4nux", function(module, exports) {

$parcel$export(module.exports, "default", () => $a802366142bcda38$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eJ9f5 = parcelRequire("eJ9f5");

var $7jTnu = parcelRequire("7jTnu");

var $kDaaB = parcelRequire("kDaaB");

var $dTocu = parcelRequire("dTocu");

var $lxSmY = parcelRequire("lxSmY");
const $a802366142bcda38$var$getInstanceLink = (error)=>(0, $7jTnu.fg)('replace-anchor-with-link__nova') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
        href: error.instanceUrl
    }, error.instanceName) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
        href: error.instanceUrl
    }, error.instanceName);
const $a802366142bcda38$export$9b99eb2c33ab1595 = (props)=>{
    const { formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const errorInstancesOneMessage = (errors)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
            ...(0, $lxSmY.default).oneInstanceError,
            values: {
                instanceOne: $a802366142bcda38$var$getInstanceLink(errors[0])
            }
        });
    const errorInstancesTwoMessage = (errors)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
            ...(0, $lxSmY.default).twoInstanceError,
            values: {
                instanceOne: $a802366142bcda38$var$getInstanceLink(errors[0]),
                instanceTwo: $a802366142bcda38$var$getInstanceLink(errors[1])
            }
        });
    const errorInstancesThreeMessage = (errors)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
            ...(0, $lxSmY.default).threeInstanceError,
            values: {
                instanceOne: $a802366142bcda38$var$getInstanceLink(errors[0]),
                instanceTwo: $a802366142bcda38$var$getInstanceLink(errors[1]),
                instanceThree: $a802366142bcda38$var$getInstanceLink(errors[2])
            }
        });
    const errorInstancesMoreMessage = (errors)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
            ...(0, $lxSmY.default).moreInstanceError,
            values: {
                instanceOne: $a802366142bcda38$var$getInstanceLink(errors[0]),
                instanceTwo: $a802366142bcda38$var$getInstanceLink(errors[1]),
                instanceThree: $a802366142bcda38$var$getInstanceLink(errors[2]),
                count: errors.length - 3
            }
        });
    const renderErrorDescription = (errors)=>{
        switch(errors.length){
            case 1:
                return errorInstancesOneMessage(errors);
            case 2:
                return errorInstancesTwoMessage(errors);
            case 3:
                return errorInstancesThreeMessage(errors);
            default:
                return errorInstancesMoreMessage(errors);
        }
    };
    const { errors: errors } = props;
    return errors && errors.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a802366142bcda38$var$Title, null, formatMessage((0, $lxSmY.default).connectionTitle)), renderErrorDescription(errors)) : null;
};
var $a802366142bcda38$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $a802366142bcda38$export$9b99eb2c33ab1595;
const $a802366142bcda38$var$Title = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pk1ejb _2hwxidpf _otyru2gc _18u0idpf _k48p1wq8",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lxSmY", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfd4667b6e5c70a1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $cfd4667b6e5c70a1$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    oneInstanceError: {
        "id": "development-summary-development-field.summary.error-tag.instance-errors.one-instance-error",
        "defaultMessage": "Jira is having difficulty contacting {instanceOne}. If this condition persists, please contact your Jira administrators."
    },
    threeInstanceError: {
        "id": "development-summary-development-field.summary.error-tag.instance-errors.three-instance-error",
        "defaultMessage": "Jira is having difficulty contacting {instanceOne}, {instanceTwo} and {instanceThree}. If this condition persists, please contact your Jira administrators."
    },
    twoInstanceError: {
        "id": "development-summary-development-field.summary.error-tag.instance-errors.two-instance-error",
        "defaultMessage": "Jira is having difficulty contacting {instanceOne} and {instanceTwo}. If this condition persists, please contact your Jira administrators."
    },
    moreInstanceError: {
        "id": "development-summary-development-field.summary.error-tag.instance-errors.more-instance-error",
        "defaultMessage": "Jira is having difficulty contacting {instanceOne}, {instanceTwo}, {instanceThree} and {count} other {count, plural, one {application} other {applications}}. If this condition persists, please contact your Jira administrators."
    },
    connectionTitle: {
        "id": "development-summary-development-field.summary.error-tag.instance-errors.connection-title",
        "defaultMessage": "Connection problem"
    }
});

});



parcelRegister("5oysz", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9ecb011a562ea53$export$2e2bcd8739ae039);

var $3V1SX = parcelRequire("3V1SX");

var $eJOHy = parcelRequire("eJOHy");

var $2nlj2 = parcelRequire("2nlj2");

var $j4oe4 = parcelRequire("j4oe4");

var $goZPP = parcelRequire("goZPP");

var $iHPvF = parcelRequire("iHPvF");
var $akOEX = parcelRequire("akOEX");

var $7jTnu = parcelRequire("7jTnu");

var $lnh70 = parcelRequire("lnh70");
var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $iqtgH = parcelRequire("iqtgH");

var $gnQAk = parcelRequire("gnQAk");

var $eCZHt = parcelRequire("eCZHt");

var $buktG = parcelRequire("buktG");

var $g9ECZ = parcelRequire("g9ECZ");

var $ikKUs = parcelRequire("ikKUs");

var $ddPfy = parcelRequire("ddPfy");

var $5MJqx = parcelRequire("5MJqx");
const $b9ecb011a562ea53$export$6125de7b8ba1e4ee = ({ issueAri: issueAri, setShowSummarySectionMessageState: setShowSummarySectionMessageState, hasCreateBranchTargets: hasCreateBranchTargets })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const fireCompleteAnalytics = (analyticsEvent, errors)=>{
        const statusCode = errors ? (0, $buktG.getStatusCodeFromGraphQLErrors)(errors) : 200;
        const isFailure = (0, $eCZHt.isFailureStatusCode)(statusCode);
        // response contains graphql errors
        if (errors && errors.length > 0 && isFailure) {
            (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, 'optOutOfDevOpsIssuePanelBanner failed', {
                statusCode: statusCode,
                errorMessage: (0, (/*@__PURE__*/$parcel$interopDefault($2nlj2)))(errors[0].message, {
                    length: 140
                })
            });
            showFlag((0, $lnh70.default).genericError());
            return;
        }
        (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, 'optOutOfDevOpsIssuePanelBanner success', {
            statusCode: statusCode
        });
    };
    const [commitMutation] = (0, $j4oe4.useMutation)((0, $3V1SX.default));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onDismiss = (_, analyticsEvent)=>{
        const bannerType = 'ISSUE_KEY_ONBOARDING';
        // optimistic update.
        setShowSummarySectionMessageState(false);
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'dismissDevOpsIssuePanelBanner');
        commitMutation({
            variables: {
                issueId: issueAri,
                bannerType: bannerType
            },
            onCompleted: (data, errors)=>{
                setShowSummarySectionMessageState(// @ts-expect-error(Suppressed for relay bump) - 'data.jira' is possibly 'null' or 'undefined'. | 'data.jira.devOps' is possibly 'null' or 'undefined'. | 'data.jira.devOps.dismissDevOpsIssuePanelBanner' is possibly 'null' or 'undefined'.
                data ? !data.jira.devOps.dismissDevOpsIssuePanelBanner.success : true);
                fireCompleteAnalytics(analyticsEvent, errors);
            },
            onError: ()=>{
                setShowSummarySectionMessageState(true);
                showFlag((0, $lnh70.default).genericError());
                (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, 'dismissDevOpsIssuePanelBanner failed', {
                    statusCode: 'unknown',
                    errorMessage: 'networkError'
                });
            }
        });
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onLearnMoreLinkClick = (_, analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'devPannelOnboardingBannerLink');
    };
    const sectionTitle = formatMessage((0, $5MJqx.default).sectionTitle);
    const learnMoreUrl = 'https://support.atlassian.com/jira-software-cloud/docs/reference-issues-in-your-development-work/';
    const sectionFirstAction = formatMessage((0, $5MJqx.default).sectionFirstAction);
    const sectionSecondAction = formatMessage((0, $5MJqx.default).sectionSecondAction);
    const sectionMessageCanCreate = formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $5MJqx.default).sectionMessageCanCreateIssueTermRefresh : (0, $5MJqx.default).sectionMessageCanCreate);
    const sectionMessageCantCreate = formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $5MJqx.default).sectionMessageCantCreateIssueTermRefresh : (0, $5MJqx.default).sectionMessageCantCreate);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireUiAnalytics), {
        eventName: "viewed devPanelOnboardingBanner"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHPvF.default), {
        testId: "development-summary-development-field.ui.summary.onboarding-message.onboarding-section-message",
        title: sectionTitle,
        appearance: "discovery",
        actions: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $akOEX.default), {
                key: "dismiss",
                onClick: onDismiss
            }, sectionSecondAction)
        ]
    }, hasCreateBranchTargets ? sectionMessageCanCreate : sectionMessageCantCreate, "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        key: "learnMore",
        appearance: "link",
        spacing: "none",
        href: learnMoreUrl,
        target: "_blank",
        onClick: onLearnMoreLinkClick
    }, sectionFirstAction)));
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b9ecb011a562ea53$var$mapStateToProps = (state)=>({
        hasCreateBranchTargets: (0, $ddPfy.hasCreateBranchTargetsSelector)(state),
        issueAri: (0, $g9ECZ.issueAriSelector)(state)
    });
const $b9ecb011a562ea53$var$mapDispatchToProps = {
    setShowSummarySectionMessageState: (0, $ikKUs.onClickDismissLink)
};
var $b9ecb011a562ea53$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($b9ecb011a562ea53$var$mapStateToProps, $b9ecb011a562ea53$var$mapDispatchToProps)($b9ecb011a562ea53$export$6125de7b8ba1e4ee);

});
parcelRegister("3V1SX", function(module, exports) {

$parcel$export(module.exports, "default", () => $20b78547106291f3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a38e7252ca772f10ce6144e3c1cbf6cf>>
 * @relayHash 96bb2eca78918614ce294099276a0f50
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f9c9105d2e411f6df4cdf09defb95d3a63d1676d90c0f515e5eb728c283e1916
const $20b78547106291f3$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "bannerType"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueId"
    }, v2 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "bannerType",
                    "variableName": "bannerType"
                },
                {
                    "kind": "Variable",
                    "name": "issueId",
                    "variableName": "issueId"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "statusCode"
            }
        ],
        "type": "GenericMutationErrorExtension"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "onboardingMessageJiraDevstatusUserOptOutOfNoDataStateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraDevOpsMutation",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraDismissDevOpsIssuePanelBannerPayload",
                                    "kind": "LinkedField",
                                    "name": "dismissDevOpsIssuePanelBanner",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "concreteType": "MutationError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "onboardingMessageJiraDevstatusUserOptOutOfNoDataStateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraDevOpsMutation",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraDismissDevOpsIssuePanelBannerPayload",
                                    "kind": "LinkedField",
                                    "name": "dismissDevOpsIssuePanelBanner",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "concreteType": "MutationError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                }
                                                            ],
                                                            "type": "BulkMutationErrorExtension"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f9c9105d2e411f6df4cdf09defb95d3a63d1676d90c0f515e5eb728c283e1916",
            "metadata": {},
            "name": "onboardingMessageJiraDevstatusUserOptOutOfNoDataStateMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$20b78547106291f3$var$node.hash = "b1f05d6abb35abced8feaf2ccc8a39be";
var $20b78547106291f3$export$2e2bcd8739ae039 = $20b78547106291f3$var$node;

});

parcelRegister("5MJqx", function(module, exports) {

$parcel$export(module.exports, "default", () => $79221b938bbcee37$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $79221b938bbcee37$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    label: {
        "id": "development-summary-development-field.summary.onboarding-message.label",
        "defaultMessage": "Development"
    },
    sectionFirstAction: {
        "id": "development-summary-development-field.summary.onboarding-message.section-first-action",
        "defaultMessage": "Learn more"
    },
    sectionSecondAction: {
        "id": "development-summary-development-field.summary.onboarding-message.section-second-action",
        "defaultMessage": "Dismiss"
    },
    sectionMessageCanCreate: {
        "id": "development-summary-development-field.summary.onboarding-message.section-message-can-create",
        "defaultMessage": "Link this issue to your code by including issue keys when creating a branch, commit, or pull request below."
    },
    sectionMessageCantCreate: {
        "id": "development-summary-development-field.summary.onboarding-message.section-message-cant-create",
        "defaultMessage": "Link this issue to your code by including issue keys when creating a branch, commit, or pull request."
    },
    sectionTitle: {
        "id": "development-summary-development-field.summary.onboarding-message.section-title",
        "defaultMessage": "Quick start development"
    },
    sectionMessageCanCreateIssueTermRefresh: {
        "id": "development-summary-development-field.summary.onboarding-message.section-message-can-create-issue-term-refresh",
        "defaultMessage": "Link this work item to your code by including keys when creating a branch, commit, or pull request below."
    },
    sectionMessageCantCreateIssueTermRefresh: {
        "id": "development-summary-development-field.summary.onboarding-message.section-message-cant-create-issue-term-refresh",
        "defaultMessage": "Link this work item to your code by including keys when creating a branch, commit, or pull request."
    }
});

});





parcelRegister("dxK8I", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdde8dafb8f2f6e2$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7iHUq = parcelRequire("7iHUq");

var $gnQAk = parcelRequire("gnQAk");

var $fFaw8 = parcelRequire("fFaw8");

var $8Xp7D = parcelRequire("8Xp7D");

var $jDWu3 = parcelRequire("jDWu3");
const $cdde8dafb8f2f6e2$var$ReleasesFieldApp = (props)=>{
    const isInitialMount = (0, $eJOHy.useRef)(true);
    const { hasSoftwareAccess: hasSoftwareAccess, ...stateProps } = props;
    const [store] = (0, $eJOHy.useState)(()=>{
        const s = (0, $8Xp7D.default)();
        s.dispatch((0, $fFaw8.setContext)(stateProps));
        return s;
    });
    (0, $eJOHy.useEffect)(()=>{
        if (isInitialMount.current) isInitialMount.current = false;
        else store.dispatch((0, $fFaw8.setContext)(stateProps));
    }, [
        store,
        stateProps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gnQAk.Provider), {
        store: store
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jDWu3.default), {
        hasSoftwareAccess: hasSoftwareAccess
    })));
};
var $cdde8dafb8f2f6e2$export$2e2bcd8739ae039 = $cdde8dafb8f2f6e2$var$ReleasesFieldApp;

});
parcelRegister("fFaw8", function(module, exports) {

$parcel$export(module.exports, "SET_CONTEXT", () => $8524379479c90820$export$4bc4e62e7d72b94b);
$parcel$export(module.exports, "setContext", () => $8524379479c90820$export$2f04de43fe27971a);
const $8524379479c90820$export$4bc4e62e7d72b94b = 'SET_RELEASES_CONTEXT';
const $8524379479c90820$export$2f04de43fe27971a = (context)=>({
        type: $8524379479c90820$export$4bc4e62e7d72b94b,
        payload: context
    });

});

parcelRegister("8Xp7D", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc401c723fe238d$export$2e2bcd8739ae039);

var $7HHI1 = parcelRequire("7HHI1");

var $4tM8k = parcelRequire("4tM8k");

var $gs6vs = parcelRequire("gs6vs");

var $ei4WV = parcelRequire("ei4WV");

var $fqUks = parcelRequire("fqUks");

var $auNyT = parcelRequire("auNyT");
const $2cc401c723fe238d$export$a8a69c316169e623 = (0, $7HHI1.combineReducers)({
    releasesContext: (0, $ei4WV.contextReducer),
    releasesData: (0, $auNyT.releasesDataReducer)
});
const $2cc401c723fe238d$export$49b6a7dfc84f00c4 = (0, $4tM8k.combineEpics)((0, $fqUks.default));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2cc401c723fe238d$export$2e2bcd8739ae039 = ()=>(0, $gs6vs.default)({
        appName: 'releases-glance',
        rootReducer: // @ts-expect-error - Type 'Reducer<CombinedState<{ releasesContext: Context; releasesData: ReleasesData | null; }>, { type: "RELEASES_DATA_FETCH_RESPONSE"; payload: Error | ReleasesData; error: boolean; } | SetContextAction>' is not assignable to type 'Reducer<State, AnyAction>'.
        $2cc401c723fe238d$export$a8a69c316169e623,
        rootEpic: $2cc401c723fe238d$export$49b6a7dfc84f00c4
    });

});
parcelRegister("ei4WV", function(module, exports) {

$parcel$export(module.exports, "contextReducer", () => $97b1ae39fac43969$export$2803ff8111172487);

var $iWqim = parcelRequire("iWqim");

var $ljej9 = parcelRequire("ljej9");

var $fFaw8 = parcelRequire("fFaw8");
const $97b1ae39fac43969$var$initialContext = (0, $iWqim.freeze)({
    issueContext: {
        issueId: 0,
        issueKey: (0, $ljej9.toIssueKey)(''),
        issueStatusCategory: '',
        projectId: 0,
        projectAri: '',
        projectType: '',
        isSimplifiedProject: false
    },
    analyticsSource: '',
    summary: '',
    user: (0, $ljej9.toAccountId)('abc123'),
    isJiraAdmin: false,
    isSiteAdmin: false,
    cloudAri: ''
});
const $97b1ae39fac43969$export$2803ff8111172487 = (state = $97b1ae39fac43969$var$initialContext, action)=>{
    const { type: type, payload: payload } = action;
    switch(type){
        case 0, $fFaw8.SET_CONTEXT:
            return (0, $iWqim.freeze)(payload);
        default:
            return state;
    }
};

});

parcelRegister("fqUks", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fad8fad643dc6c7$export$2e2bcd8739ae039);
parcelRequire("9BkTq");
parcelRequire("cBiei");
parcelRequire("1o2WJ");
parcelRequire("c1D7V");
parcelRequire("6cJUr");
parcelRequire("b0lv4");

var $2InI0 = parcelRequire("2InI0");

var $8XZn3 = parcelRequire("8XZn3");

var $7kixv = parcelRequire("7kixv");

var $jKweA = parcelRequire("jKweA");

var $8oKDI = parcelRequire("8oKDI");

var $fPpKF = parcelRequire("fPpKF");

var $9PaPz = parcelRequire("9PaPz");

var $dQ5QI = parcelRequire("dQ5QI");

var $2Ugax = parcelRequire("2Ugax");
const $4fad8fad643dc6c7$export$2cca46dea398dd67 = ()=>(0, $2InI0.default)((0, $8XZn3.default)(new Date(), {
        weeks: 6
    })).toISOString();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4fad8fad643dc6c7$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $2Ugax.RELEASES_DATA_FETCH_REQUEST)).mergeMap((action)=>{
        const state = store.getState();
        const context = (0, $dQ5QI.contextSelector)(state);
        const { payload: payload } = action;
        const { projectAri: projectAri } = (0, $dQ5QI.issueContextSelector)(state);
        const updatedFrom = $4fad8fad643dc6c7$export$2cca46dea398dd67();
        return (0, $7kixv.Observable).zip((0, $9PaPz.default)({
            issueId: context.issueContext.issueId,
            analyticsEvent: payload.meta.analyticsEvent
        }), (0, $fPpKF.getDeploymentDataDetected)(projectAri, updatedFrom), (0, $fPpKF.getShowAppConfigPrompt)(context.cloudAri, context.isSiteAdmin, context.isJiraAdmin), (0, $jKweA.fetchDevSummaryData)((0, $8oKDI.createAri)({
            resourceOwner: 'jira',
            cloudId: (0, $8oKDI.getAriConfig)(projectAri).cloudId ?? '',
            resourceType: 'issue',
            resourceId: String(context.issueContext.issueId)
        })), (releasesData, hasDeploymentsInProject, shouldShowAppConfigContextPrompt, { panelState: panelState, summary: summary })=>(0, $2Ugax.releasesDataFetchResponse)({
                ...releasesData,
                shouldShowEmptyState: panelState === 'DEV_SUMMARY' && (summary.pullrequest?.count ?? 0) !== 0 && !hasDeploymentsInProject,
                hasDeploymentsInProject: hasDeploymentsInProject,
                shouldShowAppConfigContextPrompt: shouldShowAppConfigContextPrompt
            })).catch((ex)=>(0, $7kixv.Observable).of((0, $2Ugax.releasesDataFetchResponse)(ex)));
    });

});
parcelRegister("fPpKF", function(module, exports) {

$parcel$export(module.exports, "fetchReleasesData", () => $92af71dcfbb8b2b5$export$b6fa289f64b57d6);
$parcel$export(module.exports, "getDeploymentDataDetected", () => $92af71dcfbb8b2b5$export$ee660826ba4bb836);
$parcel$export(module.exports, "getShowAppConfigPrompt", () => $92af71dcfbb8b2b5$export$d76ed50d7edd1a17);

var $aMU1X = parcelRequire("aMU1X");

var $lpD9X = parcelRequire("lpD9X");

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");

var $eSnSE = parcelRequire("eSnSE");

var $coiM0 = parcelRequire("coiM0");

var $1Ozm9 = parcelRequire("1Ozm9");

var $7zZ4w = parcelRequire("7zZ4w");

var $lpD9X = parcelRequire("lpD9X");

var $aMU1X = parcelRequire("aMU1X");
const $92af71dcfbb8b2b5$export$5db520940cf00715 = 'jswddFetchOperation';
const $92af71dcfbb8b2b5$var$remoteLinkInformationQuery = `remoteLinkInformation {
      providers {
        id
        name
        homeUrl
        logoUrl
        documentationUrl
        actions {
          id
          label {
            value
          }
          templateUrl
        }
      }
      remoteLinks {
        id
        providerId
        displayName
        url
        type
        description
        status {
          appearance
          label
        }
        actionIds
        attributeMap {
          key
          value
        }
      }
    }`;
const $92af71dcfbb8b2b5$var$createGraphqlQuery = (issueId)=>`query ${$92af71dcfbb8b2b5$export$5db520940cf00715} {
  dataDepotEntities (issueId:${issueId}) {
    deploymentInformation {
      providers {
        id
        name
        homeUrl
        logoUrl
        documentationUrl
        listDeploymentsTemplateUrl
      }
      deployments {
        providerId
        deploymentSequenceNumber
        updateSequenceNumber
        displayName
        url
        description
        lastUpdated
        state
        pipeline {
          id
          displayName
          url
        }
        environment {
          id
          type
          displayName
        }
      }
    }
    featureFlagInformation {
      providers {
        id,
        createFlagTemplateUrl,
        linkFlagTemplateUrl
      },
      featureFlags {
        id,
        key,
        displayName,
        providerId,
        summary {
          url,
          lastUpdated,
          status{
            enabled,
            defaultValue,
            rollout {
              text,
              percentage,
              rules
            }
          }
        }
      }
    }
    ${$92af71dcfbb8b2b5$var$remoteLinkInformationQuery}
  }
}`;
const $92af71dcfbb8b2b5$export$b6fa289f64b57d6 = (issueId)=>(0, $1Ozm9.default)('/jsw2/graphql', {
        method: 'POST',
        body: JSON.stringify({
            operationName: $92af71dcfbb8b2b5$export$5db520940cf00715,
            query: $92af71dcfbb8b2b5$var$createGraphqlQuery(issueId)
        })
    });
const $92af71dcfbb8b2b5$export$ee660826ba4bb836 = (projectAri, updatedFrom)=>{
    const query = (0, $lpD9X.default);
    const variables = {
        projectAri: projectAri,
        updatedFrom: updatedFrom
    };
    const request = (0, $j4oe4.fetchQuery)((0, $7zZ4w.default)(), query, variables, {
        fetchPolicy: 'store-or-network'
    });
    /* fetchQuery will NOT retain the data for the query, meaning that it is not guaranteed that the
        data will remain saved in the Relay store at any point after the request completes. We need to
        explicitly retain the operation to ensure it doesn't get deleted. See https://relay.dev/docs/api-reference/fetch-query/#behavior */ (0, $7zZ4w.default)().retain((0, $37Ewn.createOperationDescriptor)((0, $lpD9X.default), variables));
    return request.toPromise().then((result)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const data = result;
        return (data?.devOps?.ariGraph?.deploymentRelationships?.nodes ?? []).length > 0;
    });
};
const $92af71dcfbb8b2b5$export$d76ed50d7edd1a17 = (cloudAri, isJiraAdmin, isSiteAdmin)=>{
    if (!isJiraAdmin && !isSiteAdmin) return Promise.resolve(false);
    const query = (0, $aMU1X.default);
    const variables = {
        cloudAri: cloudAri
    };
    const request = (0, $j4oe4.fetchQuery)((0, $7zZ4w.default)(), query, variables, {
        fetchPolicy: 'store-or-network'
    });
    /* fetchQuery will NOT retain the data for the query, meaning that it is not guaranteed that the
      data will remain saved in the Relay store at any point after the request completes. We need to
      explicitly retain the operation to ensure it doesn't get deleted. See https://relay.dev/docs/api-reference/fetch-query/#behavior */ (0, $7zZ4w.default)().retain((0, $37Ewn.createOperationDescriptor)((0, $aMU1X.default), variables));
    return request.toPromise().then((result)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const data = result;
        const isPromptDismissed = data.jira.devOps.isInContextConfigPromptDismissed || false;
        if (isPromptDismissed) return false;
        const appEdges = data.jira.devOps.configStates.edges || [];
        const unconfiguredDisplayableEdges = appEdges// Known apps filter
        .filter((edge)=>(0, $coiM0.KNOWN_APPS).includes(edge.node.id))// UNCONFIGURED filter
        .filter((edge)=>edge.node.config.edges.map((configEdge)=>configEdge.node)// finding apps that have only workspaces whose states are either NOT_SET or NOT_CONFIGURED
            .find((node)=>node.status === 'CONFIGURED') === undefined)// BBC Permission filter
        .filter((edge)=>!(0, $coiM0.isBitbucketApp)(edge.node.id) || isJiraAdmin)// BBC no workspace filter.
        .filter((edge)=>!(0, $coiM0.isBitbucketApp)(edge.node.id) || edge.node.config.edges.length !== 0)// Site admin filter for non-BBC apps
        .filter((edge)=>(0, $coiM0.isBitbucketApp)(edge.node.id) || isSiteAdmin).filter(Boolean);
        return unconfiguredDisplayableEdges.length > 0;
    }).catch((error)=>{
        (0, $eSnSE.default).safeErrorWithoutCustomerData('packages.development.summary.releases-field.src.services.servicesGetShowAppConfigPromptQuery', error);
        return false;
    });
};

});
parcelRegister("aMU1X", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2a0ee4cd1fbaad1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4c34f2437bfc2f423bf32ced7881a8e3>>
 * @relayHash b236bb037f21efae8b3db9e134b79fab
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2178ae09b612a2f0e42deb54ceb81da2ddc4fa6fe165bc1ebe48551e0d4fab69
const $c2a0ee4cd1fbaad1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudAri"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudAri"
    }, v2 = [
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "providerTypeFilter",
            "value": [
                "DEPLOYMENTS"
            ]
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "status"
    }, v5 = {
        "args": [
            v1 /*: any*/ ,
            {
                "kind": "Literal",
                "name": "location",
                "value": "RELEASES_PANEL"
            }
        ],
        "kind": "ScalarField",
        "name": "isInContextConfigPromptDismissed"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "servicesGetShowAppConfigPromptQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JiraDevOpsQuery",
                                    "kind": "LinkedField",
                                    "name": "devOps",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "args": v2 /*: any*/ ,
                                                "concreteType": "JiraAppConfigStateConnection",
                                                "kind": "LinkedField",
                                                "name": "configStates",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraAppConfigStateEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JiraAppConfigState",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v3 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "jira.devOps.configStates.edges.node.id"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": {
                                                                                    "concreteType": "JiraConfigStateConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "config",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": {
                                                                                                "concreteType": "JiraConfigStateEdge",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "edges",
                                                                                                "plural": true,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "RequiredField",
                                                                                                        "field": {
                                                                                                            "concreteType": "JiraConfigState",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "RequiredField",
                                                                                                                    "field": v4 /*: any*/ ,
                                                                                                                    "action": "THROW",
                                                                                                                    "path": "jira.devOps.configStates.edges.node.config.edges.node.status"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        "action": "THROW",
                                                                                                        "path": "jira.devOps.configStates.edges.node.config.edges.node"
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            "action": "THROW",
                                                                                            "path": "jira.devOps.configStates.edges.node.config.edges"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                "action": "THROW",
                                                                                "path": "jira.devOps.configStates.edges.node.config"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "jira.devOps.configStates.edges.node"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira.devOps.configStates.edges"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.devOps.configStates"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v5 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.devOps.isInContextConfigPromptDismissed"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.devOps"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "servicesGetShowAppConfigPromptQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraDevOpsQuery",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraAppConfigStateConnection",
                                    "kind": "LinkedField",
                                    "name": "configStates",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraAppConfigStateEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraAppConfigState",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraConfigStateConnection",
                                                            "kind": "LinkedField",
                                                            "name": "config",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraConfigStateEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraConfigState",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v4 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2178ae09b612a2f0e42deb54ceb81da2ddc4fa6fe165bc1ebe48551e0d4fab69",
            "metadata": {},
            "name": "servicesGetShowAppConfigPromptQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c2a0ee4cd1fbaad1$var$node.hash = "5a496058391c2f700c2a788b106615f3";
var $c2a0ee4cd1fbaad1$export$2e2bcd8739ae039 = $c2a0ee4cd1fbaad1$var$node;

});

parcelRegister("lpD9X", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c35dd6414409a4d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<627fe55cd027a11ebd9af0ed29ba0e3c>>
 * @relayHash b0eb9873044d9ccba19314fe68e9bb1a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8342e2ea0ff3cd037923d335fe38968b82cafad942e8e2eafb1a491ed32effc8
const $6c35dd6414409a4d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "updatedFrom"
        }
    ], v1 = {
        "concreteType": "DevOps",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
            {
                "concreteType": "AriGraph",
                "kind": "LinkedField",
                "name": "ariGraph",
                "plural": false,
                "selections": [
                    {
                        "alias": "deploymentRelationships",
                        "args": [
                            {
                                "fields": [
                                    {
                                        "kind": "Variable",
                                        "name": "from",
                                        "variableName": "projectAri"
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "type",
                                        "value": "project-associated-deployment"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "updatedFrom",
                                        "variableName": "updatedFrom"
                                    }
                                ],
                                "kind": "ObjectValue",
                                "name": "filter"
                            },
                            {
                                "kind": "Literal",
                                "name": "first",
                                "value": 1
                            }
                        ],
                        "concreteType": "AriGraphRelationshipConnection",
                        "kind": "LinkedField",
                        "name": "relationships",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "AriGraphRelationship",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "servicesDeploymentDataDetectedQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": v1 /*: any*/ ,
                    "action": "THROW",
                    "path": "devOps"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "servicesDeploymentDataDetectedQuery",
            "selections": [
                v1 /*: any*/ 
            ]
        },
        "params": {
            "id": "8342e2ea0ff3cd037923d335fe38968b82cafad942e8e2eafb1a491ed32effc8",
            "metadata": {},
            "name": "servicesDeploymentDataDetectedQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6c35dd6414409a4d$var$node.hash = "4abf81733e9857e06456b12e09b78a9a";
var $6c35dd6414409a4d$export$2e2bcd8739ae039 = $6c35dd6414409a4d$var$node;

});

parcelRegister("coiM0", function(module, exports) {

$parcel$export(module.exports, "getFallbackConfigurationUrl", () => $0d9dad56767024d8$export$e4abb5a575872172);
$parcel$export(module.exports, "FULLY_SUPPORTED_APPS", () => $0d9dad56767024d8$export$984829de7b959fa);
$parcel$export(module.exports, "SECURITY_KNOWN_APPS", () => $0d9dad56767024d8$export$295a47a2b6f71e87);
$parcel$export(module.exports, "KNOWN_APPS", () => $0d9dad56767024d8$export$ce50b0371c784bb4);
$parcel$export(module.exports, "isGitHubApp", () => $0d9dad56767024d8$export$8692316b30955965);
$parcel$export(module.exports, "isBitbucketApp", () => $0d9dad56767024d8$export$f727bb5c7a5da2e8);
const $0d9dad56767024d8$export$e4abb5a575872172 = (providerId)=>`/plugins/servlet/upm#manage/${providerId}`;
const $0d9dad56767024d8$export$849f8961c23a6717 = 'bitbucket';
const $0d9dad56767024d8$var$AZURE_DEVOPS_FOR_JIRA_APP_ID = 'azure-devops-for-jira';
const $0d9dad56767024d8$var$GITHUB_DEV_APP_ID = 'com.github.integration.development';
const $0d9dad56767024d8$export$88a3a98061542c02 = 'com.github.integration.production';
const $0d9dad56767024d8$var$GITHUB_STG_APP_ID = 'com.github.integration.staging';
const $0d9dad56767024d8$export$7577c3ec4f9ea9b2 = 'gitlab-jira-connect-gitlab.com';
const $0d9dad56767024d8$var$CIRCLE_CI_APP_ID = 'circleci.jira';
const $0d9dad56767024d8$export$4d58d622f2bf10cd = 'com.xiplink.jira.git.jira_git_plugin';
const $0d9dad56767024d8$var$HARNESS_CI_APP_ID = 'com.harness.ci.plugin.jira';
const $0d9dad56767024d8$var$JENKINS_APP_ID = 'com.atlassian.jenkins-for-jira';
const $0d9dad56767024d8$var$JFROG_APP_ID = 'jfrog-artifactory-saas-integration';
const $0d9dad56767024d8$var$OCTOPUS_DEPLOY_APP_ID = 'com.octopus.jiraconnectapp.production';
const $0d9dad56767024d8$var$STACK_HAWK_APP_ID = 'stackhawk-jira-connect-prod';
const $0d9dad56767024d8$var$JSM_APP_ID = 'com.plugins4people.jsd.jsd-config-importer';
const $0d9dad56767024d8$var$SNYK_APP_ID = 'snyk.in.jira';
const $0d9dad56767024d8$var$SNYK_STG_APP_ID = 'jira-devops-security-app-stg';
const $0d9dad56767024d8$var$STACKHAWK_APP_ID = 'stackhawk-jira-connect-prod';
const $0d9dad56767024d8$var$MEND_APP_ID = 'WhiteSource-Jira-Cloud';
const $0d9dad56767024d8$var$LACEWORK_APP_ID = 'lacework-vuln-jira-connect';
const $0d9dad56767024d8$var$JFROG_SECURITY_APP_ID = 'jfrog.security.jiraSecurityInfoProvider';
const $0d9dad56767024d8$var$SYSDIG_APP_ID = 'sysdigAppKey';
// Design
const $0d9dad56767024d8$var$FIGMA_APP_ID = 'com.figma.jira-add-on-dev';
const $0d9dad56767024d8$export$984829de7b959fa = [
    $0d9dad56767024d8$export$849f8961c23a6717,
    $0d9dad56767024d8$export$88a3a98061542c02,
    $0d9dad56767024d8$var$GITHUB_STG_APP_ID,
    $0d9dad56767024d8$var$SNYK_APP_ID,
    $0d9dad56767024d8$var$SNYK_STG_APP_ID
];
const $0d9dad56767024d8$export$295a47a2b6f71e87 = [
    $0d9dad56767024d8$var$JFROG_APP_ID,
    $0d9dad56767024d8$var$STACK_HAWK_APP_ID,
    $0d9dad56767024d8$var$SNYK_APP_ID,
    $0d9dad56767024d8$var$SNYK_STG_APP_ID,
    $0d9dad56767024d8$var$STACKHAWK_APP_ID,
    $0d9dad56767024d8$var$MEND_APP_ID,
    $0d9dad56767024d8$var$LACEWORK_APP_ID,
    $0d9dad56767024d8$var$JFROG_SECURITY_APP_ID,
    $0d9dad56767024d8$var$SYSDIG_APP_ID
];
const $0d9dad56767024d8$export$ce50b0371c784bb4 = [
    $0d9dad56767024d8$export$849f8961c23a6717,
    $0d9dad56767024d8$var$AZURE_DEVOPS_FOR_JIRA_APP_ID,
    $0d9dad56767024d8$var$GITHUB_DEV_APP_ID,
    $0d9dad56767024d8$export$88a3a98061542c02,
    $0d9dad56767024d8$var$GITHUB_STG_APP_ID,
    $0d9dad56767024d8$export$7577c3ec4f9ea9b2,
    $0d9dad56767024d8$var$CIRCLE_CI_APP_ID,
    $0d9dad56767024d8$export$4d58d622f2bf10cd,
    $0d9dad56767024d8$var$HARNESS_CI_APP_ID,
    $0d9dad56767024d8$var$JENKINS_APP_ID,
    $0d9dad56767024d8$var$OCTOPUS_DEPLOY_APP_ID,
    $0d9dad56767024d8$var$JSM_APP_ID,
    $0d9dad56767024d8$var$FIGMA_APP_ID,
    ...$0d9dad56767024d8$export$295a47a2b6f71e87
];
const $0d9dad56767024d8$export$8692316b30955965 = (appId)=>[
        $0d9dad56767024d8$var$GITHUB_DEV_APP_ID,
        $0d9dad56767024d8$export$88a3a98061542c02,
        $0d9dad56767024d8$var$GITHUB_STG_APP_ID
    ].includes(appId);
const $0d9dad56767024d8$export$f727bb5c7a5da2e8 = (appId)=>appId === $0d9dad56767024d8$export$849f8961c23a6717;

});


parcelRegister("9PaPz", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd54e01444c81bd2$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

var $6Abnv = parcelRequire("6Abnv");

var $79hL0 = parcelRequire("79hL0");

var $eDkwf = parcelRequire("eDkwf");

var $eSnSE = parcelRequire("eSnSE");

var $gXu8g = parcelRequire("gXu8g");

var $lq5Hg = parcelRequire("lq5Hg");

var $gCeeo = parcelRequire("gCeeo");


var $fPpKF = parcelRequire("fPpKF");

var $a7KJf = parcelRequire("a7KJf");
const $cd54e01444c81bd2$var$ENABLED = true;
const $cd54e01444c81bd2$var$DISABLED = false;
const $cd54e01444c81bd2$var$ENTITY_PERMISSION_ERROR_STATUS_CODE = 403; // User does not have view_issue permission or dev_tool_permission
const $cd54e01444c81bd2$var$ENTITY_NOT_AVAILABLE_STATUS_CODE = 404; // jswdd entity is not available, e.g tenant is not active.
const $cd54e01444c81bd2$var$EXPECTED_ERROR_STATUS_CODES = [
    $cd54e01444c81bd2$var$ENTITY_PERMISSION_ERROR_STATUS_CODE,
    $cd54e01444c81bd2$var$ENTITY_NOT_AVAILABLE_STATUS_CODE
];
const $cd54e01444c81bd2$var$JSWDD_ENTITIES_FETCH_ERROR = 'jswdd.entities.fetch-error';
const $cd54e01444c81bd2$var$byEnabledFilter = (enabledStatus)=>(flag)=>((0, $iWqim.getIn)(flag, [
            'summary',
            'status',
            'enabled'
        ]) || $cd54e01444c81bd2$var$DISABLED) === enabledStatus;
const $cd54e01444c81bd2$var$byUrlExistsFilter = (flag)=>!!(0, $iWqim.getIn)(flag, [
        'summary',
        'url'
    ]);
const $cd54e01444c81bd2$var$extractFlagName = (flag)=>(0, $lq5Hg.toFeatureFlagName)(flag.displayName || flag.key || flag.id || '');
const $cd54e01444c81bd2$var$extractFeatureFlagNames = (response, enabledStatus)=>((0, $iWqim.getIn)(response, [
        'data',
        'featureFlagInformation',
        'featureFlags'
    ]) || []).filter($cd54e01444c81bd2$var$byEnabledFilter(enabledStatus)).map($cd54e01444c81bd2$var$extractFlagName);
const $cd54e01444c81bd2$var$extractRolloutSummary = (response)=>(0, $iWqim.getIn)(response.data.featureFlagInformation.featureFlags[0], [
        'summary',
        'status',
        'rollout'
    ]) || {
        text: undefined,
        percentage: undefined,
        rules: undefined
    };
const $cd54e01444c81bd2$var$extractDetailsLink = (response, enabledStatus)=>{
    const suitableFlagWithUrl = ((0, $iWqim.getIn)(response, [
        'data',
        'featureFlagInformation',
        'featureFlags'
    ]) || []).filter($cd54e01444c81bd2$var$byEnabledFilter(enabledStatus)).filter($cd54e01444c81bd2$var$byUrlExistsFilter)// @ts-expect-error - TS7006 - Parameter 'flag1' implicitly has an 'any' type. | TS7006 - Parameter 'flag2' implicitly has an 'any' type.
    .sort((flag1, flag2)=>$cd54e01444c81bd2$var$extractFlagName(flag1) < $cd54e01444c81bd2$var$extractFlagName(flag2) ? -1 : 1)[0];
    if (suitableFlagWithUrl) {
        // getIn return type is generic. Not specifying the type as string causes flow to infer getIn returns SanitizedUrl
        const summaryUrl = (0, $iWqim.getIn)(suitableFlagWithUrl, [
            'summary',
            'url'
        ]) || '';
        return (0, $lq5Hg.toFeatureFlagDetailsLink)((0, $gXu8g.toSanitizedUrl)(summaryUrl));
    }
    return undefined;
};
const $cd54e01444c81bd2$var$extractCreateFeatureFlagLinkTemplate = (response)=>((0, $iWqim.getIn)(response, [
        'data',
        'featureFlagInformation',
        'providers'
    ]) || [])// @ts-expect-error - TS7006 - Parameter 'provider' implicitly has an 'any' type.
    .filter((provider)=>!!provider.createFlagTemplateUrl)// @ts-expect-error - TS7006 - Parameter 'provider' implicitly has an 'any' type.
    .map((provider)=>({
            linkTemplate: (0, $gXu8g.toSanitizedUrl)(provider.createFlagTemplateUrl || ''),
            providerId: provider.id || (0, $bac024f2616e0584$export$44ed44629a994f5a)
        }))[0];
const $cd54e01444c81bd2$var$extractConnectFeatureFlagLinkTemplate = (response)=>((0, $iWqim.getIn)(response, [
        'data',
        'featureFlagInformation',
        'providers'
    ]) || [])// @ts-expect-error - TS7006 - Parameter 'provider' implicitly has an 'any' type.
    .filter((provider)=>!!provider.linkFlagTemplateUrl)// @ts-expect-error - TS7006 - Parameter 'provider' implicitly has an 'any' type.
    .map((provider)=>({
            linkTemplate: (0, $gXu8g.toSanitizedUrl)(provider.linkFlagTemplateUrl || ''),
            providerId: provider.id || (0, $bac024f2616e0584$export$44ed44629a994f5a)
        }))[0];
const $cd54e01444c81bd2$var$extractFeatureFlagsPerProvider = (response)=>{
    const featureFlagsPerProvider = {};
    // @ts-expect-error - TS7006 - Parameter 'provider' implicitly has an 'any' type.
    ((0, $iWqim.getIn)(response, [
        'data',
        'featureFlagInformation',
        'providers'
    ]) || []).forEach((provider)=>{
        featureFlagsPerProvider[provider.id || (0, $bac024f2616e0584$export$44ed44629a994f5a)] = [];
    });
    // @ts-expect-error - TS7006 - Parameter 'flag' implicitly has an 'any' type.
    ((0, $iWqim.getIn)(response, [
        'data',
        'featureFlagInformation',
        'featureFlags'
    ]) || []).forEach((flag)=>{
        const providerId = flag.providerId || (0, $bac024f2616e0584$export$44ed44629a994f5a);
        featureFlagsPerProvider[providerId] = featureFlagsPerProvider[providerId] || [];
        featureFlagsPerProvider[providerId].push((0, $lq5Hg.toFeatureFlagId)(flag.id || ''));
    });
    Object.keys(featureFlagsPerProvider).forEach((key)=>{
        featureFlagsPerProvider[key].sort();
    });
    return featureFlagsPerProvider;
};
const $cd54e01444c81bd2$var$extractEnvironmentTypeWeight = (deployment)=>(0, $a7KJf.deploymentEnvironmentTypes)[deployment.environment.type];
const $cd54e01444c81bd2$var$extractStateWeight = (deployment)=>(0, $a7KJf.deploymentStates)[deployment.state];
const $cd54e01444c81bd2$export$10b995b311a339fd = (deployments)=>{
    const deploymentsByEnvironment = (0, (/*@__PURE__*/$parcel$interopDefault($6Abnv)))(deployments, (deployment)=>{
        const { environment: environment } = deployment;
        return `${environment.type}_${environment.displayName}`;
    });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, (/*@__PURE__*/$parcel$interopDefault($79hL0)))(deploymentsByEnvironment, (deploymentsInEnv)=>(0, (/*@__PURE__*/$parcel$interopDefault($eDkwf)))(deploymentsInEnv, (deployment)=>new Date(deployment.lastUpdated)));
};
const $cd54e01444c81bd2$export$c033b07930063f14 = (deployments)=>{
    let environmentTypeWeight = -1;
    let stateWeight = -1;
    if (!deployments) return null;
    // @ts-expect-error - TS2741 - Property 'environmentType' is missing in type 'Deployment' but required in type 'DeploymentSummary'. | TS2769 - No overload matches this call.
    return deployments.reduce((accumulator, deployment)=>{
        const newEnvironmentTypeWeight = $cd54e01444c81bd2$var$extractEnvironmentTypeWeight(deployment);
        const newStateWeight = $cd54e01444c81bd2$var$extractStateWeight(deployment);
        if (typeof newEnvironmentTypeWeight !== 'undefined' && (environmentTypeWeight < newEnvironmentTypeWeight || environmentTypeWeight === newEnvironmentTypeWeight && typeof newStateWeight !== 'undefined' && stateWeight < newStateWeight)) {
            environmentTypeWeight = newEnvironmentTypeWeight;
            stateWeight = typeof newStateWeight !== 'undefined' ? newStateWeight : -1; // Can't move undefined check to constant or flow doesn't pick it up
            return {
                environmentType: deployment.environment.type,
                state: deployment.state,
                providerId: deployment.providerId
            };
        }
        return accumulator;
    }, null);
};
const $cd54e01444c81bd2$export$f5988b35e0aea011 = (deployments)=>{
    const latestDeploymentInEachEnvironment = $cd54e01444c81bd2$export$10b995b311a339fd(deployments);
    return $cd54e01444c81bd2$export$c033b07930063f14(latestDeploymentInEachEnvironment);
};
const $cd54e01444c81bd2$var$extractDeploymentsDataForMultipleProviders = (response)=>{
    const providerInformation = response?.data?.deploymentInformation?.providers || [];
    const deploymentInformation = response?.data?.deploymentInformation?.deployments || [];
    // Organise by provider for future referencing
    const deploymentsByProvider = deploymentInformation.reduce((accumulator, deployment)=>{
        const { providerId: providerId } = deployment;
        // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
        const newAccumulator = {
            ...accumulator
        };
        if (!Object.hasOwnProperty.call(newAccumulator, providerId)) newAccumulator[providerId] = [];
        newAccumulator[providerId].push(deployment);
        return newAccumulator;
    }, {});
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const mapToDeploymentsByEnvironmentType = (deployments)=>// @ts-expect-error - TS7006 - Parameter 'accumulator' implicitly has an 'any' type. | TS7006 - Parameter 'deployment' implicitly has an 'any' type.
        deployments.reduce((accumulator, deployment)=>{
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            const newAccumulator = {
                ...accumulator
            };
            const { environment: { type: environmentType } } = deployment;
            if (!Object.hasOwnProperty.call(newAccumulator, environmentType)) newAccumulator[environmentType] = [];
            newAccumulator[environmentType].push({
                displayName: (0, $lq5Hg.toDeploymentDisplayName)(deployment.displayName),
                lastUpdated: Date.parse(deployment.lastUpdated),
                environment: {
                    displayName: (0, $lq5Hg.toEnvironmentDisplayName)(deployment.environment.displayName)
                },
                pipeline: {
                    displayName: (0, $lq5Hg.toPipelineDisplayName)(deployment.pipeline.displayName),
                    url: (0, $gXu8g.toSanitizedUrl)(deployment.pipeline.url)
                },
                state: deployment.state,
                url: (0, $gXu8g.toSanitizedUrl)(deployment.url)
            });
            return newAccumulator;
        }, {});
    const providers = providerInformation.reduce((accumulator, provider)=>{
        const summary = $cd54e01444c81bd2$export$f5988b35e0aea011(deploymentsByProvider[provider.id]);
        if (summary) // @ts-expect-error - TS2769 - No overload matches this call.
        return accumulator.concat({
            id: provider.id || (0, $bac024f2616e0584$export$44ed44629a994f5a),
            name: provider.name || '',
            state: summary.state,
            listDeploymentsLinkTemplateUrl: (0, $gXu8g.toSanitizedUrl)(provider.listDeploymentsTemplateUrl || ''),
            environments: mapToDeploymentsByEnvironmentType(deploymentsByProvider[provider.id])
        });
        return accumulator;
    }, []);
    const summary = $cd54e01444c81bd2$export$f5988b35e0aea011(deploymentInformation);
    return summary ? {
        summary: summary,
        providers: providers
    } : {
        summary: null,
        providers: []
    };
};
const $cd54e01444c81bd2$var$extractRemoteLinksForMultipleProviders = (response)=>{
    let providers = response?.data?.remoteLinkInformation?.providers || [];
    let remoteLinks = response?.data?.remoteLinkInformation?.remoteLinks || [];
    // check FF
    // @ts-expect-error - TS2339 - Property 'actions' does not exist on type 'RemoteLinkProvider'.
    providers = providers.map(({ logoUrl: logoUrl, homeUrl: homeUrl, documentationUrl: documentationUrl, actions: actions, ...rest })=>({
            ...rest,
            // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            logoUrl: (0, $gXu8g.toSanitizedUrl)(logoUrl),
            homeUrl: (0, $gXu8g.toSanitizedUrl)(homeUrl),
            // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            documentationUrl: (0, $gXu8g.toSanitizedUrl)(documentationUrl),
            actions: {
                ...actions,
                ...actions && {
                    templateUrl: (0, $gXu8g.toSanitizedUrl)(actions.templateUrl)
                }
            }
        }));
    remoteLinks = remoteLinks.map(({ url: url, ...rest })=>({
            ...rest,
            url: (0, $gXu8g.toSanitizedUrl)(url)
        }));
    return providers.length ? {
        providers: providers,
        remoteLinks: remoteLinks
    } : {
        providers: [],
        remoteLinks: []
    };
};
const $cd54e01444c81bd2$var$logErrors = (response)=>{
    if (response.errors && response.errors.length > 0) (0, $eSnSE.default).safeErrorWithoutCustomerData('development.releases-glance.data-provider.errors', `Releases information from SWAG contains errors: ${JSON.stringify(response.errors)}`);
};
const $cd54e01444c81bd2$var$transformResponse = (response)=>{
    $cd54e01444c81bd2$var$logErrors(response);
    const enabledFlagNames = $cd54e01444c81bd2$var$extractFeatureFlagNames(response, $cd54e01444c81bd2$var$ENABLED).sort();
    const disabledFlagNames = $cd54e01444c81bd2$var$extractFeatureFlagNames(response, $cd54e01444c81bd2$var$DISABLED).sort();
    return {
        featureFlags: {
            enabledFlagNames: enabledFlagNames,
            disabledFlagNames: disabledFlagNames,
            // This is a temp solution: the details will be replaced by a sliding panel after MVP
            detailsLink: $cd54e01444c81bd2$var$extractDetailsLink(response, $cd54e01444c81bd2$var$ENABLED) || $cd54e01444c81bd2$var$extractDetailsLink(response, $cd54e01444c81bd2$var$DISABLED),
            rolloutSummary: enabledFlagNames.length === 1 && disabledFlagNames.length === 0 ? $cd54e01444c81bd2$var$extractRolloutSummary(response) : undefined,
            createFlagLinkTemplate: $cd54e01444c81bd2$var$extractCreateFeatureFlagLinkTemplate(response),
            connectFlagLinkTemplate: $cd54e01444c81bd2$var$extractConnectFeatureFlagLinkTemplate(response),
            flagsPerProvider: $cd54e01444c81bd2$var$extractFeatureFlagsPerProvider(response)
        },
        deployments: $cd54e01444c81bd2$var$extractDeploymentsDataForMultipleProviders(response),
        remoteLinks: $cd54e01444c81bd2$var$extractRemoteLinksForMultipleProviders(response),
        shouldShowEmptyState: undefined,
        hasDeploymentsInProject: undefined,
        shouldShowAppConfigContextPrompt: undefined
    };
};
const $cd54e01444c81bd2$var$eventName = 'releasesData fetched';
const $cd54e01444c81bd2$export$9bfdf944b8987eac = (error)=>{
    if (error.extensions) {
        const { statusCode: statusCode, errorType: errorType } = error.extensions;
        (0, $eSnSE.default).safeErrorWithoutCustomerData('development.releases-glance.data-provider.errors', `Releases information SWAG errors statusCode: ${statusCode}, errorType: ${errorType}`);
        if (// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        $cd54e01444c81bd2$var$EXPECTED_ERROR_STATUS_CODES.includes(statusCode) && errorType === $cd54e01444c81bd2$var$JSWDD_ENTITIES_FETCH_ERROR) return true;
    }
    return false;
};
const $cd54e01444c81bd2$var$fireFetchedEvent = (issueId, analyticsEvent, restResponse, releasesData, startTime)=>{
    const hasErrors = !!(restResponse && restResponse.errors && restResponse.errors.length > 0);
    const isExpectedBackendError = hasErrors && restResponse.errors && restResponse.errors.length > 0 ? $cd54e01444c81bd2$export$9bfdf944b8987eac(restResponse.errors[0]) : false;
    (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, $cd54e01444c81bd2$var$eventName, {
        issueId: issueId,
        hasFeatureFlags: (0, $lq5Hg.hasFeatureFlags)(releasesData),
        hasDeployments: (0, $lq5Hg.hasDeployments)(releasesData),
        hasRemoteLinks: (0, $lq5Hg.hasRemoteLinks)(releasesData),
        hasErrors: hasErrors,
        elapsed: Date.now() - startTime,
        isExpectedBackendError: isExpectedBackendError
    });
};
const $cd54e01444c81bd2$var$fireFetchedErrorEvent = (issueId, analyticsEvent, error, startTime)=>{
    (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, $cd54e01444c81bd2$var$eventName, {
        issueId: issueId,
        globalError: true,
        error: error,
        elapsed: Date.now() - startTime
    });
};
const $cd54e01444c81bd2$var$flattenEntities = (response)=>({
        data: response.data.dataDepotEntities,
        errors: response.errors
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cd54e01444c81bd2$export$2e2bcd8739ae039 = ({ issueId: issueId, analyticsEvent: analyticsEvent })=>{
    const startTime = Date.now();
    return (0, $fPpKF.fetchReleasesData)(issueId).then($cd54e01444c81bd2$var$flattenEntities).then((restResponse)=>{
        const releasesData = $cd54e01444c81bd2$var$transformResponse(restResponse);
        $cd54e01444c81bd2$var$fireFetchedEvent(issueId, analyticsEvent, restResponse, releasesData, startTime);
        return releasesData;
    }).catch((error)=>{
        (0, $eSnSE.default).safeErrorWithoutCustomerData('development.releases-glance.data-provider.exception', 'Failed to fetch releases information via SWAG', error);
        $cd54e01444c81bd2$var$fireFetchedErrorEvent(issueId, analyticsEvent, error, startTime);
        throw error;
    });
};

});
parcelRegister("6Abnv", function(module, exports) {

var $iBJlb = parcelRequire("iBJlb");

var $a9KaZ = parcelRequire("a9KaZ");
/** Used for built-in method references. */ var $4caeee4f6c048b0e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4caeee4f6c048b0e$var$hasOwnProperty = $4caeee4f6c048b0e$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $4caeee4f6c048b0e$var$groupBy = $a9KaZ(function(result, value, key) {
    if ($4caeee4f6c048b0e$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $iBJlb(result, key, [
        value
    ]);
});
module.exports = $4caeee4f6c048b0e$var$groupBy;

});

parcelRegister("eDkwf", function(module, exports) {

var $dbOsL = parcelRequire("dbOsL");

var $9wRNl = parcelRequire("9wRNl");

var $1lM9j = parcelRequire("1lM9j");
/**
 * This method is like `_.max` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.maxBy(objects, function(o) { return o.n; });
 * // => { 'n': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.maxBy(objects, 'n');
 * // => { 'n': 2 }
 */ function $aa749fdb5c9e8320$var$maxBy(array, iteratee) {
    return array && array.length ? $dbOsL(array, $1lM9j(iteratee, 2), $9wRNl) : undefined;
}
module.exports = $aa749fdb5c9e8320$var$maxBy;

});

parcelRegister("lq5Hg", function(module, exports) {

$parcel$export(module.exports, "toFeatureFlagId", () => $d257a30cb64019a3$export$8e66ad0b633b415f);
$parcel$export(module.exports, "toFeatureFlagName", () => $d257a30cb64019a3$export$665dc250cb388c02);
$parcel$export(module.exports, "toFeatureFlagDetailsLink", () => $d257a30cb64019a3$export$57fd4590ae62089e);
$parcel$export(module.exports, "toPipelineDisplayName", () => $d257a30cb64019a3$export$fd91eb7369da4a69);
$parcel$export(module.exports, "toEnvironmentDisplayName", () => $d257a30cb64019a3$export$d1c32f7be115aa97);
$parcel$export(module.exports, "toDeploymentDisplayName", () => $d257a30cb64019a3$export$ec390a449fea39b3);
$parcel$export(module.exports, "fromRemoteLinkProviderId", () => $d257a30cb64019a3$export$50d16d2f55ca2376);
$parcel$export(module.exports, "fromRemoteLinkType", () => $d257a30cb64019a3$export$70e3985bd51b81e);
$parcel$export(module.exports, "deploymentStates", () => $d257a30cb64019a3$export$1b225d9a00ae61b0);
$parcel$export(module.exports, "deploymentEnvironmentTypes", () => $d257a30cb64019a3$export$891e2ef97b236dc0);
$parcel$export(module.exports, "hasFeatureFlags", () => $d257a30cb64019a3$export$89e863511b5e821a);
$parcel$export(module.exports, "hasDeployments", () => $d257a30cb64019a3$export$feabb47efebd957);
$parcel$export(module.exports, "hasRemoteLinks", () => $d257a30cb64019a3$export$29f28c1ba5d28d3c);
const $d257a30cb64019a3$export$8e66ad0b633b415f = (str)=>str;
const $d257a30cb64019a3$export$665dc250cb388c02 = (str)=>str;
const $d257a30cb64019a3$export$57fd4590ae62089e = (str)=>str;
const $d257a30cb64019a3$export$32e9107523e9d25e = (str)=>str;
const $d257a30cb64019a3$export$fd91eb7369da4a69 = (str)=>str;
const $d257a30cb64019a3$export$d1c32f7be115aa97 = (str)=>str;
const $d257a30cb64019a3$export$ec390a449fea39b3 = (str)=>str;
const $d257a30cb64019a3$export$50d16d2f55ca2376 = (remoteLinkProviderId)=>remoteLinkProviderId;
const $d257a30cb64019a3$export$70e3985bd51b81e = (remoteLinkType)=>remoteLinkType;
const $d257a30cb64019a3$export$c7ab90603432f2be = (str)=>str;
const $d257a30cb64019a3$export$339c9f5f886e20c2 = (str)=>str;
const $d257a30cb64019a3$export$d751c2a45ba0c98e = (str)=>str;
const $d257a30cb64019a3$export$25aad62b43bfd30a = (str)=>str;
const $d257a30cb64019a3$export$9b78d14d979e43d2 = (str)=>str;
const $d257a30cb64019a3$export$3c6531bfd08bfa25 = (str)=>str;
const $d257a30cb64019a3$export$a8290d7b04222021 = (str)=>str;
const $d257a30cb64019a3$export$1b225d9a00ae61b0 = {
    PENDING: 'PENDING',
    IN_PROGRESS: 'IN_PROGRESS',
    SUCCESSFUL: 'SUCCESSFUL',
    FAILED: 'FAILED',
    ROLLED_BACK: 'ROLLED_BACK',
    CANCELLED: 'CANCELLED',
    UNKNOWN: 'UNKNOWN'
};
const $d257a30cb64019a3$export$891e2ef97b236dc0 = {
    PRODUCTION: 'PRODUCTION',
    STAGING: 'STAGING',
    TESTING: 'TESTING',
    DEVELOPMENT: 'DEVELOPMENT',
    UNMAPPED: 'UNMAPPED'
};
const $d257a30cb64019a3$export$d029bea844ee98c1 = [
    'PRODUCTION',
    'STAGING',
    'TESTING',
    'DEVELOPMENT',
    'UNMAPPED'
];
const $d257a30cb64019a3$export$89e863511b5e821a = (data)=>!!(data && data.featureFlags && (data.featureFlags.enabledFlagNames && data.featureFlags.enabledFlagNames.length > 0 || data.featureFlags.disabledFlagNames && data.featureFlags.disabledFlagNames.length > 0));
const $d257a30cb64019a3$export$feabb47efebd957 = (data)=>!!(data && data.deployments && data.deployments.summary);
const $d257a30cb64019a3$export$29f28c1ba5d28d3c = (data)=>!!(data && data.remoteLinks && data.remoteLinks.remoteLinks);

});

const $bac024f2616e0584$export$44ed44629a994f5a = '<unknown>';
const $bac024f2616e0584$export$e68cad5334cc5b = 'vyhOd8hgbSa4rzgnTvyaZNSUqUViKIOc';
const $bac024f2616e0584$export$a42a1a2fb6310bc7 = 'oAPCjkrphiFxmqbTLkv9r2jBFTvfOI8x';

parcelRegister("a7KJf", function(module, exports) {

$parcel$export(module.exports, "deploymentStates", () => $08b15d68f0d14318$export$1b225d9a00ae61b0);
$parcel$export(module.exports, "deploymentEnvironmentTypes", () => $08b15d68f0d14318$export$891e2ef97b236dc0);
const $08b15d68f0d14318$export$1b225d9a00ae61b0 = {
    PENDING: 5,
    IN_PROGRESS: 4,
    SUCCESSFUL: 3,
    FAILED: 6,
    ROLLED_BACK: 2,
    CANCELLED: 1,
    UNKNOWN: 0
};
const $08b15d68f0d14318$export$891e2ef97b236dc0 = {
    PRODUCTION: 4,
    STAGING: 3,
    TESTING: 2,
    DEVELOPMENT: 1,
    UNMAPPED: 0
};

});


parcelRegister("dQ5QI", function(module, exports) {

$parcel$export(module.exports, "contextSelector", () => $6288c0ffa7f85a1f$export$c420c9f40402ab6d);
$parcel$export(module.exports, "issueContextSelector", () => $6288c0ffa7f85a1f$export$415e6aac9a9554d9);
$parcel$export(module.exports, "userSelector", () => $6288c0ffa7f85a1f$export$210c0a88ec4709b);
$parcel$export(module.exports, "isAnonymousSelector", () => $6288c0ffa7f85a1f$export$a165ec261432d0b8);

var $ahm5r = parcelRequire("ahm5r");
const $6288c0ffa7f85a1f$export$c420c9f40402ab6d = (state)=>state.releasesContext;
const $6288c0ffa7f85a1f$export$415e6aac9a9554d9 = (0, $ahm5r.createSelector)($6288c0ffa7f85a1f$export$c420c9f40402ab6d, (context)=>context.issueContext);
const $6288c0ffa7f85a1f$export$210c0a88ec4709b = (0, $ahm5r.createSelector)($6288c0ffa7f85a1f$export$c420c9f40402ab6d, (context)=>context.user);
const $6288c0ffa7f85a1f$export$a165ec261432d0b8 = (0, $ahm5r.createSelector)($6288c0ffa7f85a1f$export$210c0a88ec4709b, (user)=>user === null);

});

parcelRegister("2Ugax", function(module, exports) {

$parcel$export(module.exports, "RELEASES_DATA_FETCH_REQUEST", () => $b2a875282a1301a8$export$61d84ae40be9d55);
$parcel$export(module.exports, "RELEASES_DATA_FETCH_RESPONSE", () => $b2a875282a1301a8$export$5599495e69db04b2);
$parcel$export(module.exports, "releasesDataFetchRequest", () => $b2a875282a1301a8$export$328ad4a3fe812d60);
$parcel$export(module.exports, "releasesDataFetchResponse", () => $b2a875282a1301a8$export$97fc21bca7692f58);
const $b2a875282a1301a8$export$61d84ae40be9d55 = 'RELEASES_DATA_FETCH_REQUEST';
const $b2a875282a1301a8$export$5599495e69db04b2 = 'RELEASES_DATA_FETCH_RESPONSE';
const $b2a875282a1301a8$export$328ad4a3fe812d60 = (analyticsEvent)=>({
        type: $b2a875282a1301a8$export$61d84ae40be9d55,
        payload: {
            meta: {
                analyticsEvent: analyticsEvent
            }
        }
    });
const $b2a875282a1301a8$export$97fc21bca7692f58 = (payload)=>({
        type: $b2a875282a1301a8$export$5599495e69db04b2,
        payload: payload,
        error: payload instanceof Error
    });

});


parcelRegister("auNyT", function(module, exports) {

$parcel$export(module.exports, "releasesDataReducer", () => $bc38882c52595c59$export$c9a345f0b294927c);

var $iWqim = parcelRequire("iWqim");

var $gYnSx = parcelRequire("gYnSx");

var $2Ugax = parcelRequire("2Ugax");
const $bc38882c52595c59$export$c9a345f0b294927c = (state = null, action)=>{
    const { type: type, payload: payload } = action;
    switch(type){
        case 0, $2Ugax.RELEASES_DATA_FETCH_RESPONSE:
            if (payload instanceof Error) {
                // TODO: show a error flag
                (0, $gYnSx.default)({
                    meta: {
                        id: 'releasesField',
                        packageName: 'jiraDevelopmentSummaryReleasesField'
                    },
                    attributes: {
                        errorType: 'serverError'
                    }
                });
                return null;
            }
            return (0, $iWqim.freeze)(payload);
        default:
            return state;
    }
};

});


parcelRegister("jDWu3", function(module, exports) {

$parcel$export(module.exports, "default", () => $062097516f616516$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ahm5r = parcelRequire("ahm5r");

var $1KdDN = parcelRequire("1KdDN");

var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");
var $ftN6c = parcelRequire("ftN6c");

var $gnQAk = parcelRequire("gnQAk");

var $dQ5QI = parcelRequire("dQ5QI");

var $2Ugax = parcelRequire("2Ugax");

var $2m2Hx = parcelRequire("2m2Hx");

var $lLPLY = parcelRequire("lLPLY");

var $1gHM1 = parcelRequire("1gHM1");
const $062097516f616516$export$fc88f4c7d9964b37 = (props)=>{
    const { isAnonymous: isAnonymous, onIssueChange: onIssueChange, hasProviders: hasProviders, hasSoftwareAccess: hasSoftwareAccess, flagsPerProvider: flagsPerProvider, providers: providers, remoteLinksData: remoteLinksData } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        if (!isAnonymous && props.issueContext.issueId) onIssueChange(createAnalyticsEvent({
            action: 'mounted'
        }));
    }, [
        props.issueContext.issueId,
        createAnalyticsEvent,
        onIssueChange,
        isAnonymous
    ]);
    const fireOnMountAnalytics = (0, $1gHM1.useOnMountedAnalytics)({
        actionSubject: 'panel',
        actionSubjectId: 'releasepanelsummary',
        flagsPerProvider: flagsPerProvider,
        providers: providers,
        remoteLinksData: remoteLinksData
    });
    (0, $eJOHy.useEffect)(()=>{
        if (!isAnonymous && hasProviders) fireOnMountAnalytics();
    }, [
        fireOnMountAnalytics,
        hasProviders,
        isAnonymous
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "releasesField",
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "releasesField",
        packageName: "jiraDevelopmentSummaryReleasesField"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), {
        attributes: {
            isAnonymous: isAnonymous
        }
    }), hasSoftwareAccess && !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lLPLY.ReleasesFieldSummary), props)));
};
const $062097516f616516$var$disabledFeatureFlagsSelectorMemoized = ()=>(0, $ahm5r.createSelector)((0, $2m2Hx.disabledFeatureFlagsSelector), (res)=>res);
const $062097516f616516$var$enabledFeatureFlagsSelectorMemoized = ()=>(0, $ahm5r.createSelector)((0, $2m2Hx.enabledFeatureFlagsSelector), (res)=>res);
const $062097516f616516$var$providersSelectorMemoized = ()=>(0, $ahm5r.createSelector)((0, $2m2Hx.providersSelector), (res)=>res);
const $062097516f616516$var$flagsPerProviderSelectorMemoized = ()=>(0, $ahm5r.createSelector)((0, $2m2Hx.flagsPerProviderSelector), (res)=>res);
const $062097516f616516$var$mapStateToPropsFactory = ()=>{
    const disabledFeatureFlagsSelectorInstance = $062097516f616516$var$disabledFeatureFlagsSelectorMemoized();
    const enabledFeatureFlagsSelectorInstance = $062097516f616516$var$enabledFeatureFlagsSelectorMemoized();
    const providersSelectorInstance = $062097516f616516$var$providersSelectorMemoized();
    const flagsPerProviderSelectorInstance = $062097516f616516$var$flagsPerProviderSelectorMemoized();
    return (state)=>({
            hasProviders: (0, $2m2Hx.panelHasValidProvidersOrDataSelector)(state),
            hasFeatureFlagsProviders: (0, $2m2Hx.panelHasFeatureFlagsProvidersSelector)(state),
            hasFeatureFlags: (0, $2m2Hx.panelHasFeatureFlagsSelector)(state),
            hasDeployments: Boolean((0, $2m2Hx.deploymentSummarySelector)(state)),
            isAnonymous: (0, $dQ5QI.isAnonymousSelector)(state),
            user: (0, $dQ5QI.userSelector)(state),
            deploymentSummary: (0, $2m2Hx.deploymentSummarySelector)(state),
            shouldShowEmptyState: (0, $2m2Hx.shouldShowEmptyStateSelector)(state),
            shouldShowAppConfigContextPrompt: (0, $2m2Hx.shouldShowAppConfigContextPromptSelector)(state),
            providers: providersSelectorInstance(state),
            remoteLinksCount: (0, $2m2Hx.remoteLinksCountSelector)(state),
            issueContext: (0, $dQ5QI.issueContextSelector)(state),
            totalFeatureFlags: (0, $2m2Hx.totalFeatureFlagSelector)(state),
            createFlagLink: (0, $2m2Hx.createFlagLinkSelector)(state),
            connectFlagLink: (0, $2m2Hx.connectFlagLinkSelector)(state),
            enabledFeatureFlags: enabledFeatureFlagsSelectorInstance(state),
            disabledFeatureFlags: disabledFeatureFlagsSelectorInstance(state),
            detailsLink: (0, $2m2Hx.detailsLinkSelector)(state),
            enabledFeatureFlagsCnt: (0, $2m2Hx.enabledFeatureFlagsCntSelector)(state),
            disabledFeatureFlagsCnt: (0, $2m2Hx.disabledFeatureFlagsCntSelector)(state),
            rolloutSummary: (0, $2m2Hx.rolloutSummarySelector)(state),
            flagsPerProvider: flagsPerProviderSelectorInstance(state),
            remoteLinksData: (0, $2m2Hx.remoteLinksDataSelector)(state)
        });
};
var $062097516f616516$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($062097516f616516$var$mapStateToPropsFactory, (dispatch)=>({
        onIssueChange: (analyticsEvent)=>{
            dispatch((0, $2Ugax.releasesDataFetchRequest)(analyticsEvent));
        }
    }))($062097516f616516$export$fc88f4c7d9964b37);

});
parcelRegister("2m2Hx", function(module, exports) {

$parcel$export(module.exports, "panelHasFeatureFlagsProvidersSelector", () => $160d6f27087f55bf$export$e6b0ec1826afb24b);
$parcel$export(module.exports, "enabledFeatureFlagsSelector", () => $160d6f27087f55bf$export$fa33ff9734ca0a71);
$parcel$export(module.exports, "enabledFeatureFlagsCntSelector", () => $160d6f27087f55bf$export$e07e282ffa13c546);
$parcel$export(module.exports, "disabledFeatureFlagsSelector", () => $160d6f27087f55bf$export$b00ef6e2f355faf6);
$parcel$export(module.exports, "detailsLinkSelector", () => $160d6f27087f55bf$export$29cb6940623d77ea);
$parcel$export(module.exports, "flagsPerProviderSelector", () => $160d6f27087f55bf$export$a6e9d1620bb2932);
$parcel$export(module.exports, "createFlagLinkSelector", () => $160d6f27087f55bf$export$12338aa1263469a8);
$parcel$export(module.exports, "connectFlagLinkSelector", () => $160d6f27087f55bf$export$ab240ab572c876f2);
$parcel$export(module.exports, "disabledFeatureFlagsCntSelector", () => $160d6f27087f55bf$export$36435b68d5fc9a62);
$parcel$export(module.exports, "totalFeatureFlagSelector", () => $160d6f27087f55bf$export$38ad2089440807a6);
$parcel$export(module.exports, "panelHasFeatureFlagsSelector", () => $160d6f27087f55bf$export$749121da3f993a0a);
$parcel$export(module.exports, "rolloutSummarySelector", () => $160d6f27087f55bf$export$8fb4bf9916714a47);
$parcel$export(module.exports, "deploymentSummarySelector", () => $160d6f27087f55bf$export$8ccd5e71c4425c2e);
$parcel$export(module.exports, "shouldShowEmptyStateSelector", () => $160d6f27087f55bf$export$83452d57f100d2e1);
$parcel$export(module.exports, "shouldShowAppConfigContextPromptSelector", () => $160d6f27087f55bf$export$4b34f3b91ade27f);
$parcel$export(module.exports, "remoteLinksDataSelector", () => $160d6f27087f55bf$export$e2eec4c83cc21e45);
$parcel$export(module.exports, "remoteLinksCountSelector", () => $160d6f27087f55bf$export$5b94b4c138de532d);
$parcel$export(module.exports, "panelHasValidProvidersOrDataSelector", () => $160d6f27087f55bf$export$f1eb9bbb58c6a45e);
$parcel$export(module.exports, "providersSelector", () => $160d6f27087f55bf$export$572c57f4fbd7354d);

var $ahm5r = parcelRequire("ahm5r");

var $8dH3d = parcelRequire("8dH3d");

var $dQ5QI = parcelRequire("dQ5QI");

var $9Qklh = parcelRequire("9Qklh");
const $160d6f27087f55bf$export$e6b0ec1826afb24b = (state)=>!!state.releasesData && Object.keys(state.releasesData.featureFlags.flagsPerProvider).length > 0;
const $160d6f27087f55bf$export$fa33ff9734ca0a71 = (state)=>state.releasesData ? state.releasesData.featureFlags.enabledFlagNames : [];
const $160d6f27087f55bf$export$e07e282ffa13c546 = (state)=>$160d6f27087f55bf$export$fa33ff9734ca0a71(state).length;
const $160d6f27087f55bf$export$b00ef6e2f355faf6 = (state)=>state.releasesData ? state.releasesData.featureFlags.disabledFlagNames : [];
const $160d6f27087f55bf$export$29cb6940623d77ea = (state)=>state.releasesData ? state.releasesData.featureFlags.detailsLink : undefined;
const $160d6f27087f55bf$export$a6e9d1620bb2932 = (state)=>state.releasesData ? state.releasesData.featureFlags.flagsPerProvider : {};
const $160d6f27087f55bf$var$injectContextParams = (state, urlTemplate)=>{
    if (!urlTemplate) return undefined;
    const contextValues = {
        'issue.key': (0, $dQ5QI.contextSelector)(state).issueContext.issueKey || '',
        'issue.flags': ($160d6f27087f55bf$export$a6e9d1620bb2932(state)[urlTemplate.providerId] || []).join(','),
        'issue.summary': ((0, $dQ5QI.contextSelector)(state).summary || '').substr(0, 255)
    };
    return Object.keys(contextValues).reduce((previousValue, key)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ 'issue.key': string; 'issue.flags': string; 'issue.summary': string; }'.
        previousValue.split(`{${key}}`).join(encodeURIComponent(contextValues[key])), urlTemplate.linkTemplate);
};
const $160d6f27087f55bf$export$12338aa1263469a8 = (state)=>state.releasesData ? $160d6f27087f55bf$var$injectContextParams(state, state.releasesData.featureFlags.createFlagLinkTemplate) : undefined;
const $160d6f27087f55bf$export$ab240ab572c876f2 = (state)=>state.releasesData ? $160d6f27087f55bf$var$injectContextParams(state, state.releasesData.featureFlags.connectFlagLinkTemplate) : undefined;
const $160d6f27087f55bf$export$1c2601b8f2c0e608 = (0, $ahm5r.createSelector)($160d6f27087f55bf$export$e6b0ec1826afb24b, $160d6f27087f55bf$export$12338aa1263469a8, $160d6f27087f55bf$export$ab240ab572c876f2, (hasFeatureFlagsProviders, createFlagLink, connectFlagLink)=>hasFeatureFlagsProviders && (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(createFlagLink) || !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(connectFlagLink)));
const $160d6f27087f55bf$export$36435b68d5fc9a62 = (state)=>$160d6f27087f55bf$export$b00ef6e2f355faf6(state).length;
const $160d6f27087f55bf$export$38ad2089440807a6 = (state)=>$160d6f27087f55bf$export$e07e282ffa13c546(state) + $160d6f27087f55bf$export$36435b68d5fc9a62(state);
const $160d6f27087f55bf$export$749121da3f993a0a = (state)=>$160d6f27087f55bf$export$e07e282ffa13c546(state) + $160d6f27087f55bf$export$36435b68d5fc9a62(state) > 0;
const $160d6f27087f55bf$export$8fb4bf9916714a47 = (state)=>state.releasesData ? state.releasesData.featureFlags.rolloutSummary : undefined;
const $160d6f27087f55bf$export$8ccd5e71c4425c2e = (state)=>state.releasesData && state.releasesData.deployments && state.releasesData.deployments.summary || undefined;
const $160d6f27087f55bf$export$83452d57f100d2e1 = (state)=>state.releasesData?.shouldShowEmptyState ?? false;
const $160d6f27087f55bf$export$4b34f3b91ade27f = (state)=>!$160d6f27087f55bf$export$8ccd5e71c4425c2e(state) && !$160d6f27087f55bf$export$10e5ce2c721175a2(state) && state.releasesData?.shouldShowAppConfigContextPrompt || false;
const $160d6f27087f55bf$export$10e5ce2c721175a2 = (state)=>state.releasesData?.hasDeploymentsInProject ?? true;
const $160d6f27087f55bf$export$b0c2f2aacbcd25e4 = (state)=>state.releasesData;
const $160d6f27087f55bf$export$e2eec4c83cc21e45 = (0, $ahm5r.createSelector)($160d6f27087f55bf$export$b0c2f2aacbcd25e4, (releasesData)=>releasesData && releasesData.remoteLinks);
const $160d6f27087f55bf$export$ecbe7938e86d42ce = (0, $ahm5r.createSelector)($160d6f27087f55bf$export$e2eec4c83cc21e45, (remoteLinksData)=>remoteLinksData && remoteLinksData.providers ? remoteLinksData.providers.filter((provider)=>!(0, $9Qklh.isVersionRelatedLinksProvider)(provider.id)) : []);
const $160d6f27087f55bf$export$d05d3d930a0084b6 = (0, $ahm5r.createSelector)($160d6f27087f55bf$export$e2eec4c83cc21e45, (remoteLinksData)=>remoteLinksData && remoteLinksData.remoteLinks ? remoteLinksData.remoteLinks.filter((link)=>!(0, $9Qklh.isVersionRelatedLinksProvider)(link.providerId)) : []);
const $160d6f27087f55bf$export$3a27e788a34d118a = (state)=>$160d6f27087f55bf$export$ecbe7938e86d42ce(state).length;
const $160d6f27087f55bf$export$5b94b4c138de532d = (state)=>$160d6f27087f55bf$export$d05d3d930a0084b6(state).length;
const $160d6f27087f55bf$export$a9e5760c0f6e9e80 = (0, $ahm5r.createSelector)($160d6f27087f55bf$export$e6b0ec1826afb24b, $160d6f27087f55bf$export$8ccd5e71c4425c2e, $160d6f27087f55bf$export$3a27e788a34d118a, $160d6f27087f55bf$export$5b94b4c138de532d, (hasFeatureFlagsProviders, deploymentSummary, remoteLinksProvidersCount, remoteLinksCount)=>hasFeatureFlagsProviders || !!deploymentSummary || remoteLinksProvidersCount > 0 && remoteLinksCount > 0);
const $160d6f27087f55bf$export$f1eb9bbb58c6a45e = (0, $ahm5r.createSelector)($160d6f27087f55bf$export$1c2601b8f2c0e608, $160d6f27087f55bf$export$749121da3f993a0a, $160d6f27087f55bf$export$8ccd5e71c4425c2e, $160d6f27087f55bf$export$3a27e788a34d118a, $160d6f27087f55bf$export$5b94b4c138de532d, $160d6f27087f55bf$export$10e5ce2c721175a2, (panelHasValidFeatureFlagsProviders, panelHasFeatureFlags, deploymentSummary, remoteLinksProvidersCount, remoteLinksCount, hasDeploymentsInProject)=>panelHasValidFeatureFlagsProviders || panelHasFeatureFlags || !!deploymentSummary || !hasDeploymentsInProject || remoteLinksProvidersCount > 0 && remoteLinksCount > 0);
const $160d6f27087f55bf$export$572c57f4fbd7354d = (state)=>state.releasesData && state.releasesData.deployments && state.releasesData.deployments.providers || [];

});
parcelRegister("9Qklh", function(module, exports) {

$parcel$export(module.exports, "isVersionRelatedLinksProvider", () => $35e63e9b2112afee$export$d85eb3fb354ab222);

const $35e63e9b2112afee$export$d85eb3fb354ab222 = (id)=>id === (0, $bac024f2616e0584$export$a42a1a2fb6310bc7) || id === (0, $bac024f2616e0584$export$e68cad5334cc5b);

});


parcelRegister("lLPLY", function(module, exports) {

$parcel$export(module.exports, "ReleasesFieldSummary", () => $382c97147acb10d0$export$c6b9afe7bf3faba6);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $l98s9 = parcelRequire("l98s9");

var $8O88z = parcelRequire("8O88z");

var $i4v50 = parcelRequire("i4v50");

var $37D99 = parcelRequire("37D99");

var $eIpwf = parcelRequire("eIpwf");

var $cYVTJ = parcelRequire("cYVTJ");

var $cchwz = parcelRequire("cchwz");

var $1KdDN = parcelRequire("1KdDN");

var $lRq8t = parcelRequire("lRq8t");

var $coXKe = parcelRequire("coXKe");

var $9NIQG = parcelRequire("9NIQG");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $bJscI = parcelRequire("bJscI");

var $eQLsa = parcelRequire("eQLsa");
const $382c97147acb10d0$export$c6b9afe7bf3faba6 = (props)=>{
    const { hasDeployments: hasDeployments, hasFeatureFlagsProviders: hasFeatureFlagsProviders, createFlagLink: createFlagLink, connectFlagLink: connectFlagLink, hasFeatureFlags: hasFeatureFlags, issueContext: issueContext, deploymentSummary: deploymentSummary, remoteLinksCount: remoteLinksCount, disabledFeatureFlags: disabledFeatureFlags, disabledFeatureFlagsCnt: disabledFeatureFlagsCnt, enabledFeatureFlags: enabledFeatureFlags, enabledFeatureFlagsCnt: enabledFeatureFlagsCnt, detailsLink: detailsLink, rolloutSummary: rolloutSummary, totalFeatureFlags: totalFeatureFlags, shouldShowAppConfigContextPrompt: shouldShowAppConfigContextPrompt } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { showDevDetailDialog: showDevDetailDialog } = (0, $l98s9.useDevOpsDetailsDialogLoaderActions)(`devInfoPanelApp${issueContext.issueKey}`);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const analyticsAttributes = {
        issueStatusCategory: issueContext.issueStatusCategory,
        projectType: issueContext.projectType,
        projectId: issueContext.projectId,
        isSimplifiedProject: issueContext.isSimplifiedProject
    };
    const onShowDevDetailsDialog = (clickEvent, devInfoType)=>{
        clickEvent && clickEvent.preventDefault();
        const detailDialogAnalyticsAttributes = {
            ...analyticsAttributes,
            summaryType: devInfoType
        };
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'summaryItem'
        }), 'devpanelsummary', detailDialogAnalyticsAttributes);
        const panelItemType = (0, $i4v50.toDetailDialogDataType)(devInfoType);
        showDevDetailDialog(// @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'PanelDataTypes'.
        panelItemType, undefined, issueContext.issueKey, String(issueContext.issueId));
    };
    if (!deploymentSummary && !hasFeatureFlags && connectFlagLink == null && createFlagLink == null && remoteLinksCount === 0 && !shouldShowAppConfigContextPrompt) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9NIQG.FieldWrapper), {
        "data-testid": "development-summary-releases-field.ui.summary.actions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($382c97147acb10d0$var$ReleasesGlanceFieldHeading, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9NIQG.FieldHeadingTitle), null, formatMessage((0, $eQLsa.default).label))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9NIQG.SideBySideField), null, (deploymentSummary || shouldShowAppConfigContextPrompt) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $37D99.default), {
        issueContext: issueContext,
        summary: deploymentSummary,
        onClick: (e)=>onShowDevDetailsDialog(e, (0, $8O88z.SUMMARY_ITEM_DEPLOYMENT)),
        shouldShowAppConfigContextPrompt: shouldShowAppConfigContextPrompt,
        fieldHasOtherActions: createFlagLink != null || connectFlagLink != null || remoteLinksCount > 0
    }), hasFeatureFlags && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cYVTJ.default), {
        issueContext: issueContext,
        hasFeatureFlagsProviders: hasFeatureFlagsProviders,
        connectFeatureFlagTarget: connectFlagLink,
        createFeatureFlagTarget: createFlagLink,
        hasFeatureFlags: hasFeatureFlags,
        enabledFeatureFlags: enabledFeatureFlags,
        enabledFeatureFlagsCnt: enabledFeatureFlagsCnt,
        disabledFeatureFlags: disabledFeatureFlags,
        disabledFeatureFlagsCnt: disabledFeatureFlagsCnt,
        detailsLink: detailsLink,
        rolloutSummary: rolloutSummary,
        totalFeatureFlags: totalFeatureFlags,
        onClick: (e)=>onShowDevDetailsDialog(e, (0, $8O88z.SUMMARY_ITEM_FEATURE_FLAGS))
    }), remoteLinksCount !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cchwz.default), {
        issueContext: issueContext,
        remoteLinksCount: remoteLinksCount,
        onClick: (e)=>onShowDevDetailsDialog(e, (0, $8O88z.SUMMARY_ITEM_REMOTE_LINKS))
    }), !hasFeatureFlags && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cYVTJ.default), {
        issueContext: issueContext,
        hasFeatureFlagsProviders: hasFeatureFlagsProviders,
        connectFeatureFlagTarget: connectFlagLink,
        createFeatureFlagTarget: createFlagLink,
        hasFeatureFlags: hasFeatureFlags,
        enabledFeatureFlags: enabledFeatureFlags,
        enabledFeatureFlagsCnt: enabledFeatureFlagsCnt,
        disabledFeatureFlags: disabledFeatureFlags,
        disabledFeatureFlagsCnt: disabledFeatureFlagsCnt,
        detailsLink: detailsLink,
        rolloutSummary: rolloutSummary,
        totalFeatureFlags: totalFeatureFlags,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onClick: ()=>{}
    }), hasDeployments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "releasesGlanceDeploymentsLink",
        packageName: "jiraDevelopmentReleasesGlance",
        teamName: "nova"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eIpwf.DeploymentsViewLink), null))));
};
const $382c97147acb10d0$var$labelColumnWidthForGrouping = 40.0;
const $382c97147acb10d0$var$fieldHeadingSideBySideCssStylesOld = null;
const $382c97147acb10d0$var$ReleasesGlanceFieldHeadingNew = ({ children: children })=>{
    const { userPreferredLayout: userPreferredLayout } = (0, $coXKe.useUserPreferredWorkItemLayout)();
    const isWideViewLayout = userPreferredLayout === 'WIDE';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $382c97147acb10d0$var$fieldHeadingSideBySideCssStylesNew,
            isWideViewLayout && $382c97147acb10d0$var$wideLayoutStyles
        ]
    }, children);
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $382c97147acb10d0$var$ReleasesGlanceFieldHeadingOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCompact: isCompact, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _16jlkb7n _vchhusvi _1ul968cl _1bsbhwvj _ca0qu2gc _1e0c1txw _u5f3pxbi",
            !__cmplp.isCompact && "_p12f7l9q",
            __cmplp.className
        ])
    });
});
const $382c97147acb10d0$var$ReleasesGlanceFieldHeading = (0, $bJscI.componentWithFG)('issue_view_field_config_edit', $382c97147acb10d0$var$ReleasesGlanceFieldHeadingNew, $382c97147acb10d0$var$ReleasesGlanceFieldHeadingOld);
const $382c97147acb10d0$var$fieldHeadingSideBySideCssStylesNew = (0, $1DXK0.xcss)({
    position: 'relative',
    boxSizing: 'border-box',
    minWidth: '120px',
    width: `${$382c97147acb10d0$var$labelColumnWidthForGrouping}%`,
    paddingTop: 'space.100',
    flex: '1 0 0%',
    display: 'flex',
    paddingRight: 'space.200'
});
const $382c97147acb10d0$var$wideLayoutStyles = (0, $1DXK0.xcss)({
    maxWidth: '170px',
    padding: 'space.050',
    borderRadius: '4px',
    ':hover': {
        backgroundColor: 'color.background.neutral.hovered'
    }
});

});
parcelRegister("37D99", function(module, exports) {

$parcel$export(module.exports, "default", () => $26b408720299bc7a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2PadD = parcelRequire("2PadD");

var $dPMMf = parcelRequire("dPMMf");


var $ihplE = parcelRequire("ihplE");

var $1A9lq = parcelRequire("1A9lq");

var $1pV1F = parcelRequire("1pV1F");

var $cDP77 = parcelRequire("cDP77");

var $dTocu = parcelRequire("dTocu");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $16sa1 = parcelRequire("16sa1");

var $gNjM7 = parcelRequire("gNjM7");

var $2ESvf = parcelRequire("2ESvf");
const $26b408720299bc7a$var$envTypeMessageKeys = {
    PRODUCTION: 'production',
    STAGING: 'staging',
    TESTING: 'testing',
    DEVELOPMENT: 'development',
    UNMAPPED: 'unmapped'
};
const $26b408720299bc7a$var$envTypeMessage = (key)=>// @ts-expect-error - TS2538 - Type 'undefined' cannot be used as an index type.
    (0, $gNjM7.default)[$26b408720299bc7a$var$envTypeMessageKeys[key] || $26b408720299bc7a$var$envTypeMessageKeys.UNMAPPED];
const $26b408720299bc7a$var$DeploymentsInner = ({ issueContext: issueContext, summary: summary, onClick: onClick, fieldHasOtherActions: fieldHasOtherActions = false, shouldShowAppConfigContextPrompt: shouldShowAppConfigContextPrompt = false })=>{
    const { formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    if (shouldShowAppConfigContextPrompt) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1pV1F.AppConfigurationPromptSummary), {
        location: "RELEASES_PANEL",
        panelHasOtherPrompts: fieldHasOtherActions
    });
    if (!summary || !summary.state || !summary.environmentType) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
    const { state: state, environmentType: environmentType } = summary;
    const { issueStatusCategory: issueStatusCategory, projectType: projectType, projectId: projectId, issueKey: issueKey, issueId: issueId, isSimplifiedProject: isSimplifiedProject } = issueContext;
    const analyticsAttributes = {
        environmentType: environmentType,
        deploymentState: state,
        issueStatusCategory: issueStatusCategory,
        projectType: projectType,
        projectId: projectId,
        isSimplifiedProject: isSimplifiedProject
    };
    const onSummaryItemClick = ()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'summaryItem'
        }), 'deploymentSummaryLink', analyticsAttributes);
        onClick();
    };
    const summaryItemComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDP77.SummaryItem), {
        title: formatMessage($26b408720299bc7a$var$envTypeMessage(environmentType)),
        issueKey: issueKey,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2PadD))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: ""
        }),
        onClick: onSummaryItemClick,
        secondaryData: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ESvf.default), {
            state: state,
            environmentType: environmentType
        }),
        forceVisibleSecondary: true,
        showIconInPlainLink: true,
        "data-testid": "development-summary-deployment-releases-field.summary-item"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceType: (0, $466f60259c330878$export$9d2de6eebf7462b5),
        sourceName: "deploymentSummary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1A9lq.default), {
        devInfoType: (0, $ihplE.DevInfoTypes).DEPLOYMENT,
        issueId: issueId,
        customTrigger: summaryItemComponent,
        scopeId: `devInfoPanelApp${issueKey}`,
        placement: "bottom-end",
        offset: [
            -8,
            8
        ],
        zIndex: (0, $dPMMf.layers).modal,
        location: (0, $2425df669549d924$export$76a449e52fa0e1e8)
    }));
};
const $26b408720299bc7a$var$Deployments = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "development-summary-deployment"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($26b408720299bc7a$var$DeploymentsInner, props));
var $26b408720299bc7a$export$2e2bcd8739ae039 = $26b408720299bc7a$var$Deployments;

});
parcelRegister("2PadD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da6815f1e303f26a4e473874c26eef5d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $20e8457987a4b96b$var$_react = $20e8457987a4b96b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $20e8457987a4b96b$var$_cloudArrowUp = $20e8457987a4b96b$var$_interopRequireDefault((parcelRequire("bzGVj")));

var $20e8457987a4b96b$var$_upload = $20e8457987a4b96b$var$_interopRequireDefault((parcelRequire("lmcPJ")));
function $20e8457987a4b96b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloudArrowUpIcon.
 * This component is CloudArrowUpIcon, with `UNSAFE_fallbackIcon` set to "UploadIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $20e8457987a4b96b$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $20e8457987a4b96b$var$_react.default.createElement($20e8457987a4b96b$var$_cloudArrowUp.default, Object.assign({
        LEGACY_fallbackIcon: $20e8457987a4b96b$var$_upload.default
    }, props));
$20e8457987a4b96b$var$CloudArrowUpIcon.Name = 'CloudArrowUpIconMigration';
var $20e8457987a4b96b$var$_default = module.exports.default = $20e8457987a4b96b$var$CloudArrowUpIcon;

});
parcelRegister("bzGVj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e83f76db2e7ada7e0358014b5e026a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $86d44242ca1c7b8f$var$_react = $86d44242ca1c7b8f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $86d44242ca1c7b8f$var$_baseNew = $86d44242ca1c7b8f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $86d44242ca1c7b8f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $86d44242ca1c7b8f$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $86d44242ca1c7b8f$var$_react.default.createElement($86d44242ca1c7b8f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3a4.25 4.25 0 0 0-4.236 3.9.75.75 0 0 1-.565.668A2.251 2.251 0 0 0 3.75 12v1.5a3.75 3.75 0 0 1-1.418-7.222 5.751 5.751 0 0 1 11.239-.458A4 4 0 0 1 12 13.5V12a2.5 2.5 0 0 0 .712-4.897.75.75 0 0 1-.526-.59A4.25 4.25 0 0 0 8 3m0 4a.75.75 0 0 1 .53.22l3 3-1.06 1.06-1.72-1.72V16h-1.5V9.56l-1.72 1.72-1.06-1.06 3-3A.75.75 0 0 1 8 7" clip-rule="evenodd"/>`
    }, props));
$86d44242ca1c7b8f$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $86d44242ca1c7b8f$var$_default = module.exports.default = $86d44242ca1c7b8f$var$CloudArrowUpIcon;

});

parcelRegister("lmcPJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f8c59b79ccf43c2a$var$_react = $f8c59b79ccf43c2a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $f8c59b79ccf43c2a$var$_cloudArrowUp = $f8c59b79ccf43c2a$var$_interopRequireDefault((parcelRequire("bzGVj")));
function $f8c59b79ccf43c2a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f8c59b79ccf43c2a$var$UploadIcon = (props)=>/*#__PURE__*/ $f8c59b79ccf43c2a$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.208 9.32 9.29 11.253a1 1 0 0 0 0 1.409.98.98 0 0 0 1.397 0l1.29-1.301 1.336 1.347a.98.98 0 0 0 1.397.001 1 1 0 0 0 .001-1.408l-1.965-1.98a1.08 1.08 0 0 0-1.538-.001"/><path d="m11 10.007.001 9.986c0 .557.448 1.008 1 1.007.553 0 1-.45 1-1.007L13 10.006C13 9.451 12.552 9 12 9s-1.001.451-1 1.007"/><path d="M7.938 5.481a5 5 0 0 0-.777-.063C4.356 5.419 2 7.62 2 10.499 2 13.408 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.051.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.119a4.14 4.14 0 0 1 4.069 3.644l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-1.999-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.021-3.901.901-5.038 2.481"/></g></svg>`
    }, props, {
        newIcon: $f8c59b79ccf43c2a$var$_cloudArrowUp.default
    }));
$f8c59b79ccf43c2a$var$UploadIcon.displayName = 'UploadIcon';
var $f8c59b79ccf43c2a$var$_default = module.exports.default = $f8c59b79ccf43c2a$var$UploadIcon;

});


parcelRegister("gNjM7", function(module, exports) {

$parcel$export(module.exports, "default", () => $95ca6f82f5fee80c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $95ca6f82f5fee80c$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    production: {
        "id": "development-summary-deployment-releases-field.env-type.production",
        "defaultMessage": "Production"
    },
    staging: {
        "id": "development-summary-deployment-releases-field.env-type.staging",
        "defaultMessage": "Staging"
    },
    testing: {
        "id": "development-summary-deployment-releases-field.env-type.testing",
        "defaultMessage": "Testing"
    },
    development: {
        "id": "development-summary-deployment-releases-field.env-type.development",
        "defaultMessage": "Development"
    },
    unmapped: {
        "id": "development-summary-deployment-releases-field.env-type.unmapped",
        "defaultMessage": "Undefined environment"
    }
});

});

parcelRegister("2ESvf", function(module, exports) {

$parcel$export(module.exports, "default", () => $f63424fe42ac9588$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $lq5Hg = parcelRequire("lq5Hg");

var $dTocu = parcelRequire("dTocu");

var $2ztQs = parcelRequire("2ztQs");

var $jBmfi = parcelRequire("jBmfi");

var $7WN6p = parcelRequire("7WN6p");
const $f63424fe42ac9588$var$deploymentStates = {
    PENDING: {
        messageKey: 'pending'
    },
    IN_PROGRESS: {
        messageKey: 'inProgress'
    },
    SUCCESSFUL: {
        messageKey: 'successful'
    },
    FAILED: {
        messageKey: 'failed'
    },
    ROLLED_BACK: {
        messageKey: 'rolledBack'
    },
    CANCELLED: {
        messageKey: 'cancelled'
    },
    UNKNOWN: {
        messageKey: 'unknown'
    }
};
const $f63424fe42ac9588$var$stateMessage = (key)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ unknown: MessageDescriptorV2; cancelled: MessageDescriptorV2; rolledBack: MessageDescriptorV2; failed: MessageDescriptorV2; successful: MessageDescriptorV2; inProgress: MessageDescriptorV2; pending: MessageDescriptorV2; }'. | TS2532 - Object is possibly 'undefined'.
    (0, $7WN6p.default)[($f63424fe42ac9588$var$deploymentStates[key] || $f63424fe42ac9588$var$deploymentStates.UNKNOWN).messageKey];
const $f63424fe42ac9588$var$getDeploymentIconState = (state, environmentType)=>{
    switch(state){
        case (0, $lq5Hg.deploymentStates).SUCCESSFUL:
            return environmentType === (0, $lq5Hg.deploymentEnvironmentTypes).PRODUCTION ? (0, $jBmfi.DeploymentStateOptions).SUCCESSFUL : (0, $jBmfi.DeploymentStateOptions).SUCCESSFULNONPRODUCTION;
        default:
            return state;
    }
};
const $f63424fe42ac9588$var$getDeploymentIcon = (state, environmentType)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ztQs.DeploymentIcons), {
        deploymentState: $f63424fe42ac9588$var$getDeploymentIconState(state, environmentType),
        size: "medium"
    });
const $f63424fe42ac9588$var$Status = ({ state: state, environmentType: environmentType })=>{
    const { formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    if (!state) return null;
    const StatusIcon = $f63424fe42ac9588$var$getDeploymentIcon(state, environmentType ?? (0, $lq5Hg.deploymentEnvironmentTypes).UNMAPPED);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage($f63424fe42ac9588$var$stateMessage(state))
    }, StatusIcon);
};
var $f63424fe42ac9588$export$2e2bcd8739ae039 = $f63424fe42ac9588$var$Status;

});
parcelRegister("7WN6p", function(module, exports) {

$parcel$export(module.exports, "default", () => $95327c14c484d52e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $95327c14c484d52e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    pending: {
        "id": "development-summary-deployment-releases-field.status.pending",
        "defaultMessage": "Pending"
    },
    inProgress: {
        "id": "development-summary-deployment-releases-field.status.in-progress",
        "defaultMessage": "In progress"
    },
    successful: {
        "id": "development-summary-deployment-releases-field.status.successful",
        "defaultMessage": "Successful"
    },
    failed: {
        "id": "development-summary-deployment-releases-field.status.failed",
        "defaultMessage": "Failed"
    },
    rolledBack: {
        "id": "development-summary-deployment-releases-field.status.rolled-back",
        "defaultMessage": "Rolled back"
    },
    cancelled: {
        "id": "development-summary-deployment-releases-field.status.cancelled",
        "defaultMessage": "Canceled"
    },
    unknown: {
        "id": "development-summary-deployment-releases-field.status.unknown",
        "defaultMessage": "Unknown"
    }
});

});



parcelRegister("eIpwf", function(module, exports) {

$parcel$export(module.exports, "DeploymentsViewLink", () => $23cf1620339c880d$export$ecea6a623b55b991);

var $eJOHy = parcelRequire("eJOHy");

var $lmMkH = parcelRequire("lmMkH");

var $cDP77 = parcelRequire("cDP77");

var $lRq8t = parcelRequire("lRq8t");

var $3wPiD = parcelRequire("3wPiD");

var $d425D = parcelRequire("d425D");

var $hih5V = parcelRequire("hih5V");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $2aY2d = parcelRequire("2aY2d");

var $gCY1z = parcelRequire("gCY1z");

var $eu90N = parcelRequire("eu90N");
const $23cf1620339c880d$var$DeploymentsViewLinkSummaryItem = ({ href: href, routerLinkConfig: routerLinkConfig })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    // Memoizing to prevent SummaryItem animations firing on hover caused by react-resource-router prefetch triggering a re-render
    const secondaryData = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDP77.SummaryItem), {
        title: formatMessage((0, $eu90N.default).deploymentsLink),
        linkFormatting: true,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lmMkH))), {
            spacing: "spacious",
            label: ""
        }),
        href: href,
        routerLinkConfig: routerLinkConfig,
        secondaryData: secondaryData,
        onClick: ()=>{
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'releasesGlanceDeploymentsViewLink');
        },
        "data-testid": "development-summary-deployments-view-link.summary-item"
    });
};
const $23cf1620339c880d$var$ClassicDeploymentsViewLink = ({ projectKey: projectKey })=>{
    const route = (0, $hih5V.useRouteByName)('software-deployments-classic');
    // check if deployments jira feature is enabled in CMP
    const { data: data, loading: loading } = (0, $d425D.useFeatures)();
    if (loading || !data?.hasDeployments) return null;
    return route !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23cf1620339c880d$var$DeploymentsViewLinkSummaryItem, {
        routerLinkConfig: {
            route: route,
            prefetch: 'hover',
            params: {
                projectKey: projectKey
            }
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23cf1620339c880d$var$DeploymentsViewLinkSummaryItem, {
        href: `/jira/software/c/projects/${projectKey}/deployments`
    });
};
const $23cf1620339c880d$var$NextGenDeploymentsViewLink = ({ projectKey: projectKey })=>{
    const route = (0, $hih5V.useRouteByName)('software-deployments');
    // check if deployments jira feature is enabled in TMP
    const { data: data, loading: loading } = (0, $3wPiD.useFeatures)();
    if (loading || !data?.hasDeployments) return null;
    return route !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23cf1620339c880d$var$DeploymentsViewLinkSummaryItem, {
        routerLinkConfig: {
            route: route,
            prefetch: 'hover',
            params: {
                projectKey: projectKey
            }
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23cf1620339c880d$var$DeploymentsViewLinkSummaryItem, {
        href: `/jira/software/projects/${projectKey}/deployments`
    });
};
const $23cf1620339c880d$export$ecea6a623b55b991 = ()=>{
    const { data: project } = (0, $2aY2d.useProjectContext)();
    // Check if user is currently already on the Deployment page, hence button display not required
    const [{ route: route }] = (0, $gCY1z.useRouter)();
    const routeName = route.name;
    const isOnDeploymentsPage = routeName === 'software-deployments' || routeName === 'software-deployments-classic';
    if (isOnDeploymentsPage || project == null) return null;
    return project.simplified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23cf1620339c880d$var$NextGenDeploymentsViewLink, {
        projectKey: project.projectKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23cf1620339c880d$var$ClassicDeploymentsViewLink, {
        projectKey: project.projectKey
    });
};

});
parcelRegister("lmMkH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2acc08ab6395d499b2798249d78c49fd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f8e124ec42965eb7$var$_react = $f8e124ec42965eb7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f8e124ec42965eb7$var$_arrowUpRight = $f8e124ec42965eb7$var$_interopRequireDefault((parcelRequire("ac080")));

var $f8e124ec42965eb7$var$_open = $f8e124ec42965eb7$var$_interopRequireDefault((parcelRequire("63Q5r")));
function $f8e124ec42965eb7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowUpRightIcon.
 * This component is ArrowUpRightIcon, with `UNSAFE_fallbackIcon` set to "OpenIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f8e124ec42965eb7$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $f8e124ec42965eb7$var$_react.default.createElement($f8e124ec42965eb7$var$_arrowUpRight.default, Object.assign({
        LEGACY_fallbackIcon: $f8e124ec42965eb7$var$_open.default
    }, props));
$f8e124ec42965eb7$var$ArrowUpRightIcon.Name = 'ArrowUpRightIconMigration';
var $f8e124ec42965eb7$var$_default = module.exports.default = $f8e124ec42965eb7$var$ArrowUpRightIcon;

});
parcelRegister("ac080", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aa37e7fb05387379200e2a91e20ea76e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76bb1fce06e44d9d$var$_react = $76bb1fce06e44d9d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $76bb1fce06e44d9d$var$_baseNew = $76bb1fce06e44d9d$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $76bb1fce06e44d9d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUpRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $76bb1fce06e44d9d$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $76bb1fce06e44d9d$var$_react.default.createElement($76bb1fce06e44d9d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m2.47 12.47 9.75-9.75 1.06 1.06-9.75 9.75z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M12 4H5.75V2.5h7a.75.75 0 0 1 .75.75v7H12z" clip-rule="evenodd"/>`
    }, props));
$76bb1fce06e44d9d$var$ArrowUpRightIcon.displayName = 'ArrowUpRightIcon';
var $76bb1fce06e44d9d$var$_default = module.exports.default = $76bb1fce06e44d9d$var$ArrowUpRightIcon;

});

parcelRegister("63Q5r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $469b6d360521f5db$var$_react = $469b6d360521f5db$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $469b6d360521f5db$var$_arrowUpRight = $469b6d360521f5db$var$_interopRequireDefault((parcelRequire("ac080")));
function $469b6d360521f5db$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $469b6d360521f5db$var$OpenIcon = (props)=>/*#__PURE__*/ $469b6d360521f5db$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.031 7A1.03 1.03 0 0 0 10 8.036a1.05 1.05 0 0 0 1.044 1.045l3.121.014.014 3.121a1.05 1.05 0 0 0 1.045 1.044 1.03 1.03 0 0 0 1.036-1.035l-.019-4.161a1.053 1.053 0 0 0-1.045-1.045L11.035 7z"/><path d="m13.364 8.292-7.071 7.071a1 1 0 0 0 0 1.415 1 1 0 0 0 1.414 0l7.071-7.071A1.002 1.002 0 0 0 14.071 8a1 1 0 0 0-.707.292"/></g></svg>`
    }, props, {
        newIcon: $469b6d360521f5db$var$_arrowUpRight.default
    }));
$469b6d360521f5db$var$OpenIcon.displayName = 'OpenIcon';
var $469b6d360521f5db$var$_default = module.exports.default = $469b6d360521f5db$var$OpenIcon;

});


parcelRegister("3wPiD", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $429849cdadbc9a3e$export$4a39035bacc4ed76);

var $eJOHy = parcelRequire("eJOHy");

var $dSkLG = parcelRequire("dSkLG");

var $jphFu = parcelRequire("jphFu");

var $1WzGp = parcelRequire("1WzGp");

var $cZfeH = parcelRequire("cZfeH");

var $fsjYk = parcelRequire("fsjYk");
const $429849cdadbc9a3e$export$4a39035bacc4ed76 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $dSkLG.useJiraSoftwareProjectNavigation)();
    const isEligibleForFeatureToggle = (0, $fsjYk.useShouldApplyFeatureToggle)();
    const [sidebarFeatureToggled] = (0, $1WzGp.useSidebarFeatureToggled)();
    const extractedData = (0, $eJOHy.useMemo)(()=>data && (0, $jphFu.extractData)(data), [
        data
    ]);
    // merged feature status before navigation resource gets refreshed
    // if and only if there are features toggled and they are eligible for the feature
    const features = (0, $eJOHy.useMemo)(()=>{
        if (!extractedData || !isEligibleForFeatureToggle || !sidebarFeatureToggled) return extractedData;
        return {
            ...extractedData,
            ...sidebarFeatureToggled
        };
    }, [
        extractedData,
        isEligibleForFeatureToggle,
        sidebarFeatureToggled
    ]);
    (0, $cZfeH.useClearSidebarToggled)();
    return {
        data: features,
        loading: loading,
        error: error
    };
};

});
parcelRegister("jphFu", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $e9a39bce412d9671$export$9df5fa0a366163d2);

var $epTsa = parcelRequire("epTsa");
const $e9a39bce412d9671$export$9df5fa0a366163d2 = (navData)=>{
    const { permissionInfo: permissionInfo, hasBacklog: hasBacklog, hasBoard: hasBoard, hasCode: hasCode, hasGoals: hasGoals, hasGetStarted: hasGetStarted, hasSecurity: hasSecurity, hasDeployments: hasDeployments, hasDevelopment: hasDevelopment, hasList: hasList, hasOpsgenieSchedule: hasOpsgenieSchedule, hasPages: hasPages, hasReleases: hasReleases, hasRoadmap: hasRoadmap, hasReports: hasReports, hasRequests: hasRequests, hasIssues: hasIssues, hasSprint: hasSprint, hasIncidents: hasIncidents, hasCalendar: hasCalendar, hasForms: hasForms, hasSummaryPage: hasSummaryPage, aiInfo: aiInfo, hasArchivedIssues: hasArchivedIssues = false } = navData;
    const isProjectOrJiraAdmin = permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    return {
        hasArchivedIssues: hasArchivedIssues,
        hasBacklog: hasBacklog,
        hasBoard: hasBoard,
        hasRoadmap: hasRoadmap,
        hasCode: hasCode,
        hasGoals: hasGoals,
        hasGetStarted: isProjectOrJiraAdmin && hasGetStarted,
        hasSecurity: hasSecurity,
        hasDeployments: hasDeployments,
        hasDevelopment: hasDevelopment,
        hasList: (0, $epTsa.expValEquals)('jsw_list_view', 'cohort', 'variation') ? hasList : false,
        hasReleases: hasReleases,
        hasSIN: hasIssues,
        hasReports: hasReports,
        hasRequests: hasRequests,
        hasPages: hasPages,
        hasOpsgenie: hasOpsgenieSchedule,
        hasShortcutsAdd: isProjectOrJiraAdmin,
        hasSettings: isProjectOrJiraAdmin,
        hasSprint: hasSprint,
        hasIncidents: hasIncidents,
        hasCalendar: hasCalendar,
        hasForms: (0, $epTsa.expValEquals)('forms_for_jsw_experiment', 'isEnabled', true) && hasForms,
        hasSummaryPage: hasSummaryPage,
        hasAIInNIN: hasIssues && aiInfo?.isEnabledInIssueNavigator === true
    };
};

});

parcelRegister("1WzGp", function(module, exports) {

$parcel$export(module.exports, "useFeature", () => $2c23860c2dfc0b9e$export$fc97652867e5867e);
$parcel$export(module.exports, "useEnablingFeature", () => $2c23860c2dfc0b9e$export$207b461610a7fca6);
$parcel$export(module.exports, "useSidebarFeatureToggled", () => $2c23860c2dfc0b9e$export$9eef668f94562feb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $gpE3r = parcelRequire("gpE3r");
const $2c23860c2dfc0b9e$var$initialState = {
    features: [],
    isLoading: false,
    enablingFeatures: [],
    isFetchError: false,
    sidebarFeatureToggled: null
};
const $2c23860c2dfc0b9e$var$store = (0, $GtRbT.createStore)({
    name: 'feature-toggle',
    initialState: $2c23860c2dfc0b9e$var$initialState,
    actions: $gpE3r.actions
});
const $2c23860c2dfc0b9e$export$fc97652867e5867e = (0, $iJq0l.createHook)($2c23860c2dfc0b9e$var$store);
const $2c23860c2dfc0b9e$export$207b461610a7fca6 = (0, $iJq0l.createHook)($2c23860c2dfc0b9e$var$store, {
    selector: (state, { feature: feature })=>state.enablingFeatures.some((f)=>f === feature)
});
const $2c23860c2dfc0b9e$export$e7699ed698eeb9ec = (0, $iJq0l.createHook)($2c23860c2dfc0b9e$var$store, {
    selector: (state, { feature: feature })=>state.features.find((f)=>f.feature === feature)?.state
});
const $2c23860c2dfc0b9e$export$9eef668f94562feb = (0, $iJq0l.createHook)($2c23860c2dfc0b9e$var$store, {
    selector: (state)=>state.sidebarFeatureToggled
});

});
parcelRegister("gpE3r", function(module, exports) {

$parcel$export(module.exports, "actions", () => $e143742cb7786e84$export$e324594224ef24da);

var $gYnSx = parcelRequire("gYnSx");

var $epTsa = parcelRequire("epTsa");

var $gCeeo = parcelRequire("gCeeo");

var $2DEdX = parcelRequire("2DEdX");

var $75UwL = parcelRequire("75UwL");

var $dFKLJ = parcelRequire("dFKLJ");

var $5ekEZ = parcelRequire("5ekEZ");
const $e143742cb7786e84$var$clearSiderbarFeatureToggled = ()=>({ setState: setState })=>{
        setState({
            sidebarFeatureToggled: null
        });
    };
const $e143742cb7786e84$var$fetchFeatures = (boardId)=>async ({ getState: getState, setState: setState })=>{
        const { features: features, isLoading: isLoading } = getState();
        if (isLoading) return;
        setState({
            isFetchError: false
        });
        try {
            if (features.length === 0) {
                setState({
                    isLoading: true
                });
                const data = await (0, $dFKLJ.getBoardFeatures)(boardId);
                const filteredFeatures = (0, $75UwL.filterAndSort)(data);
                (0, $75UwL.fireErrorAnalyticsOnUnmatchFeatureKey)(filteredFeatures);
                setState({
                    isLoading: false,
                    features: filteredFeatures
                });
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                isFetchError: true,
                isLoading: false
            });
            (0, $gYnSx.default)({
                meta: {
                    ...(0, $2DEdX.commonErrorAnalyticsMeta),
                    id: 'fetchFeatures'
                },
                error: error
            });
        }
    };
const $e143742cb7786e84$var$syncFeatures = (sidebarFeatureStatus)=>({ getState: getState, setState: setState })=>{
        const { features: features } = getState();
        const featureMap = (0, $2DEdX.getFeatureMap)({
            isListViewEnabled: (0, $epTsa.expValEquals)('jsw_list_view', 'cohort', 'variation')
        });
        const synced = features.map((f)=>{
            const id = f.feature;
            if (featureMap[id]) {
                const { statusKey: statusKey } = featureMap[id];
                return {
                    ...f,
                    state: sidebarFeatureStatus[statusKey] ? 'ENABLED' : 'DISABLED'
                };
            }
            return f;
        });
        setState({
            features: synced
        });
    };
const $e143742cb7786e84$var$updateFeature = ({ boardId: boardId, feature: feature, dependentFeature: dependentFeature, analyticsEvent: analyticsEvent, onError: onError, onAfterUpdate: onAfterUpdate })=>async ({ getState: getState, setState: setState })=>{
        const { features: features, enablingFeatures: enablingFeatures, sidebarFeatureToggled: sidebarFeatureToggled } = getState();
        let featureMap = (0, $2DEdX.getFeatureMap)();
        if ((0, $epTsa.expValEquals)('jsw_list_view', 'cohort', 'variation')) featureMap = {
            ...featureMap,
            ...(0, $2DEdX.listFeature)
        };
        const currentStatus = features.find((f)=>f.feature === feature)?.state;
        const isEnabling = currentStatus === 'DISABLED';
        if (!boardId || feature.length === 0 || !currentStatus) return;
        try {
            // Optimistically update the toggle status before the API call finishes
            // and add feature to the enabling states
            setState({
                features: features.map((0, $75UwL.updateFeatureState)(feature, dependentFeature)),
                sidebarFeatureToggled: {
                    ...sidebarFeatureToggled ?? {},
                    [featureMap[feature].statusKey]: isEnabling,
                    ...dependentFeature && {
                        [featureMap[dependentFeature].statusKey]: isEnabling
                    }
                },
                ...isEnabling && {
                    enablingFeatures: [
                        ...enablingFeatures,
                        feature
                    ]
                }
            });
            await (0, $5ekEZ.updateBoardFeature)({
                boardId: boardId,
                feature: feature,
                enabling: isEnabling
            });
            (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'featureStatus updated', {
                featureId: feature,
                newStatus: currentStatus
            });
            onAfterUpdate?.(feature, isEnabling);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            onError?.();
            setState({
                features: features,
                sidebarFeatureToggled: sidebarFeatureToggled
            });
            (0, $gYnSx.default)({
                meta: {
                    ...(0, $2DEdX.commonErrorAnalyticsMeta),
                    id: 'updateFeature'
                },
                error: error
            });
        }
        if (isEnabling) setState({
            // feature has been enabled, remove from enabling state
            enablingFeatures: getState().enablingFeatures.filter((f)=>f !== feature)
        });
    };
const $e143742cb7786e84$export$e324594224ef24da = {
    fetchFeatures: $e143742cb7786e84$var$fetchFeatures,
    updateFeature: $e143742cb7786e84$var$updateFeature,
    syncFeatures: $e143742cb7786e84$var$syncFeatures,
    clearSiderbarFeatureToggled: $e143742cb7786e84$var$clearSiderbarFeatureToggled
};

});
parcelRegister("2DEdX", function(module, exports) {

$parcel$export(module.exports, "commonErrorAnalyticsMeta", () => $5997e650472e24c4$export$47825241dc3c472c);
$parcel$export(module.exports, "MANAGE_FEATURE_MENU_ITEM_TEST_ID", () => $5997e650472e24c4$export$143e1d685830adbe);
$parcel$export(module.exports, "listFeature", () => $5997e650472e24c4$export$4ddfd7a9f5527982);
$parcel$export(module.exports, "getFeatureMap", () => $5997e650472e24c4$export$6ac50cf33852adb5);
$parcel$export(module.exports, "ERROR_FLAG_ID", () => $5997e650472e24c4$export$f5e4c120ac01b615);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $LFmXM = parcelRequire("LFmXM");

var $azIHD = parcelRequire("azIHD");

var $aFAJl = parcelRequire("aFAJl");

var $cRAIo = parcelRequire("cRAIo");

var $cajrN = parcelRequire("cajrN");

var $cdYRp = parcelRequire("cdYRp");

var $2gsxL = parcelRequire("2gsxL");
const $5997e650472e24c4$export$47825241dc3c472c = {
    packageName: 'jiraTmpFeatureToggle',
    teamName: 'jlove-makkuro'
};
const $5997e650472e24c4$export$143e1d685830adbe = 'manage-feature-menu-item';
const $5997e650472e24c4$export$4ddfd7a9f5527982 = {
    'jsw.agility.list_view': {
        descriptionKey: 'listDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cRAIo))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasList',
        order: 35,
        redirectOn: [
            'software-list'
        ]
    }
};
const $5997e650472e24c4$export$a712b1e96d47b856 = {
    'jsw.agility.simple-roadmap': {
        descriptionKey: 'timelineDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2gsxL))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasRoadmap',
        order: 10,
        redirectOn: [
            'software-timeline',
            'software-roadmap'
        ]
    },
    'jsw.agility.backlog': {
        descriptionKey: 'backlogDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($azIHD))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasBacklog',
        order: 20,
        redirectOn: [
            'software-backlog'
        ]
    },
    'jsw.agility.board': {
        descriptionKey: 'boardDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aFAJl))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasBoard',
        order: 30
    },
    'jsw.agility.issue_navigator': {
        descriptionKey: 'issueNavigatorDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cajrN))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasSIN',
        order: 40,
        redirectOn: [
            'software-issue-navigator',
            'issue'
        ]
    },
    'jsw.agility.sprints': {
        descriptionKey: 'releasesDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null),
        statusKey: 'hasSprint',
        order: 50,
        isHidden: true
    }
}; // satisfies Partial<Record<ToggleableFeatureKey, FeatureProperties>>
const $5997e650472e24c4$export$6ac50cf33852adb5 = (0, $LFmXM.default)(({ isSimplifyNavExperimentEnabled: isSimplifyNavExperimentEnabled, isListViewEnabled: isListViewEnabled } = {})=>({
        'jsw.agility.simple-roadmap': {
            descriptionKey: 'timelineDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2gsxL))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasRoadmap',
            order: 10,
            redirectOn: [
                'software-timeline',
                'software-roadmap'
            ]
        },
        'jsw.agility.backlog': {
            descriptionKey: 'backlogDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($azIHD))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasBacklog',
            order: 20,
            redirectOn: [
                'software-backlog'
            ]
        },
        'jsw.agility.board': {
            descriptionKey: 'boardDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aFAJl))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasBoard',
            order: 30
        },
        ...!isSimplifyNavExperimentEnabled && {
            'jsw.agility.issue_navigator': {
                descriptionKey: 'issueNavigatorDescription',
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cajrN))), {
                    spacing: "spacious",
                    label: ""
                }),
                statusKey: 'hasSIN',
                order: 40,
                redirectOn: [
                    'software-issue-navigator',
                    'issue'
                ]
            }
        },
        'jsw.agility.sprints': {
            descriptionKey: 'releasesDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null),
            statusKey: 'hasSprint',
            order: 50,
            isHidden: true
        },
        'jsw.agility.pages': {
            descriptionKey: 'projectPagesDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cdYRp))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasPages',
            order: 60,
            redirectOn: [
                'project-pages'
            ]
        },
        ...isListViewEnabled && $5997e650472e24c4$export$4ddfd7a9f5527982
    }), (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))); // satisfies Partial<Record<ToggleableFeatureKey, FeatureProperties>>;
const $5997e650472e24c4$export$f5e4c120ac01b615 = 'feature-toggle-error-flag';

});
parcelRegister("azIHD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8757186054f9d759a1f776986ffd32d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7b2fd95289d8d424$var$_react = $7b2fd95289d8d424$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7b2fd95289d8d424$var$_backlog = $7b2fd95289d8d424$var$_interopRequireDefault((parcelRequire("jtFRs")));

var $7b2fd95289d8d424$var$_backlog2 = $7b2fd95289d8d424$var$_interopRequireDefault((parcelRequire("eKycu")));
function $7b2fd95289d8d424$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for BacklogIcon.
 * This component is BacklogIcon, with `UNSAFE_fallbackIcon` set to "BacklogIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for backlogs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7b2fd95289d8d424$var$BacklogIcon = (props)=>/*#__PURE__*/ $7b2fd95289d8d424$var$_react.default.createElement($7b2fd95289d8d424$var$_backlog.default, Object.assign({
        LEGACY_fallbackIcon: $7b2fd95289d8d424$var$_backlog2.default
    }, props));
$7b2fd95289d8d424$var$BacklogIcon.Name = 'BacklogIconMigration';
var $7b2fd95289d8d424$var$_default = module.exports.default = $7b2fd95289d8d424$var$BacklogIcon;

});
parcelRegister("jtFRs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::471b5e5cdc883753bc3e3b52ee5ae2e2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e2e13280cb3fa5ae$var$_react = $e2e13280cb3fa5ae$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e2e13280cb3fa5ae$var$_baseNew = $e2e13280cb3fa5ae$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $e2e13280cb3fa5ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Backlog".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for backlogs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e2e13280cb3fa5ae$var$BacklogIcon = (props)=>/*#__PURE__*/ $e2e13280cb3fa5ae$var$_react.default.createElement($e2e13280cb3fa5ae$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2.167h11V3a.5.5 0 0 0-.5-.5zm10.5 4.167h-11v2.666h11zm0 4.166h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$e2e13280cb3fa5ae$var$BacklogIcon.displayName = 'BacklogIcon';
var $e2e13280cb3fa5ae$var$_default = module.exports.default = $e2e13280cb3fa5ae$var$BacklogIcon;

});

parcelRegister("eKycu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $abcfe41085ed6837$var$_react = $abcfe41085ed6837$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $abcfe41085ed6837$var$_backlog = $abcfe41085ed6837$var$_interopRequireDefault((parcelRequire("jtFRs")));
function $abcfe41085ed6837$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $abcfe41085ed6837$var$BacklogIcon = (props)=>/*#__PURE__*/ $abcfe41085ed6837$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M5 19.002C5 19 17 19 17 19v-2.002C17 17 5 17 5 17zm-2-2.004C3 15.894 3.895 15 4.994 15h12.012c1.101 0 1.994.898 1.994 1.998v2.004A1.997 1.997 0 0 1 17.006 21H4.994A2 2 0 0 1 3 19.002z"/><path d="M5 15h12v-2H5zm-2-4h16v6H3z"/><path d="M7 11.002C7 11 19 11 19 11V8.998C19 9 7 9 7 9zM5 8.998C5 7.894 5.895 7 6.994 7h12.012C20.107 7 21 7.898 21 8.998v2.004A1.997 1.997 0 0 1 19.006 13H6.994A2 2 0 0 1 5 11.002z"/><path d="M5 5v2h12V5zm-2-.002C3 3.894 3.895 3 4.994 3h12.012C18.107 3 19 3.898 19 4.998V9H3z"/></g></svg>`
    }, props, {
        newIcon: $abcfe41085ed6837$var$_backlog.default
    }));
$abcfe41085ed6837$var$BacklogIcon.displayName = 'BacklogIcon';
var $abcfe41085ed6837$var$_default = module.exports.default = $abcfe41085ed6837$var$BacklogIcon;

});


parcelRegister("aFAJl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2d6de69f6e8d23d80c647d0a6d3ecd7a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7c4a399538fc5b54$var$_react = $7c4a399538fc5b54$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7c4a399538fc5b54$var$_board = $7c4a399538fc5b54$var$_interopRequireDefault((parcelRequire("Wdhjx")));

var $7c4a399538fc5b54$var$_board2 = $7c4a399538fc5b54$var$_interopRequireDefault((parcelRequire("g3o8b")));
function $7c4a399538fc5b54$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for BoardIcon.
 * This component is BoardIcon, with `UNSAFE_fallbackIcon` set to "BoardIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7c4a399538fc5b54$var$BoardIcon = (props)=>/*#__PURE__*/ $7c4a399538fc5b54$var$_react.default.createElement($7c4a399538fc5b54$var$_board.default, Object.assign({
        LEGACY_fallbackIcon: $7c4a399538fc5b54$var$_board2.default
    }, props));
$7c4a399538fc5b54$var$BoardIcon.Name = 'BoardIconMigration';
var $7c4a399538fc5b54$var$_default = module.exports.default = $7c4a399538fc5b54$var$BoardIcon;

});
parcelRegister("Wdhjx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bfc058bc597636775f186a66702ef9b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0aefb7ae3bc1328f$var$_react = $0aefb7ae3bc1328f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0aefb7ae3bc1328f$var$_baseNew = $0aefb7ae3bc1328f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $0aefb7ae3bc1328f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Board".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0aefb7ae3bc1328f$var$BoardIcon = (props)=>/*#__PURE__*/ $0aefb7ae3bc1328f$var$_react.default.createElement($0aefb7ae3bc1328f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h2.833v-9zm4.333 0v9h3.334v-9zm4.834 0v9H14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$0aefb7ae3bc1328f$var$BoardIcon.displayName = 'BoardIcon';
var $0aefb7ae3bc1328f$var$_default = module.exports.default = $0aefb7ae3bc1328f$var$BoardIcon;

});

parcelRegister("g3o8b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $baffa5141480bfcd$var$_react = $baffa5141480bfcd$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $baffa5141480bfcd$var$_board = $baffa5141480bfcd$var$_interopRequireDefault((parcelRequire("Wdhjx")));
function $baffa5141480bfcd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $baffa5141480bfcd$var$BoardIcon = (props)=>/*#__PURE__*/ $baffa5141480bfcd$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M4 18h16.008C20 18 20 6 20 6H3.992C4 6 4 18 4 18M2 5.994C2 4.893 2.898 4 3.99 4h16.02C21.108 4 22 4.895 22 5.994v12.012A1.997 1.997 0 0 1 20.01 20H3.99A1.994 1.994 0 0 1 2 18.006z"/><path d="M8 6v12h2V6zm6 0v12h2V6z"/></g></svg>`
    }, props, {
        newIcon: $baffa5141480bfcd$var$_board.default
    }));
$baffa5141480bfcd$var$BoardIcon.displayName = 'BoardIcon';
var $baffa5141480bfcd$var$_default = module.exports.default = $baffa5141480bfcd$var$BoardIcon;

});


parcelRegister("cRAIo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e406a416cb0a4f8d2c2370983b384961>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $95d6ea16e8902236$var$_react = $95d6ea16e8902236$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $95d6ea16e8902236$var$_listBulleted = $95d6ea16e8902236$var$_interopRequireDefault((parcelRequire("hJIkn")));

var $95d6ea16e8902236$var$_bulletList = $95d6ea16e8902236$var$_interopRequireDefault((parcelRequire("aDHzd")));
function $95d6ea16e8902236$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ListBulletedIcon.
 * This component is ListBulletedIcon, with `UNSAFE_fallbackIcon` set to "BulletListIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $95d6ea16e8902236$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $95d6ea16e8902236$var$_react.default.createElement($95d6ea16e8902236$var$_listBulleted.default, Object.assign({
        LEGACY_fallbackIcon: $95d6ea16e8902236$var$_bulletList.default
    }, props));
$95d6ea16e8902236$var$ListBulletedIcon.Name = 'ListBulletedIconMigration';
var $95d6ea16e8902236$var$_default = module.exports.default = $95d6ea16e8902236$var$ListBulletedIcon;

});
parcelRegister("hJIkn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c464a7d95484e897372db9f1fff872cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ce990635ee602485$var$_react = $ce990635ee602485$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $ce990635ee602485$var$_baseNew = $ce990635ee602485$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $ce990635ee602485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ce990635ee602485$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $ce990635ee602485$var$_react.default.createElement($ce990635ee602485$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.5 4.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 5H6V3.5h10zm0 7.5H6V11h10z" clip-rule="evenodd"/>`
    }, props));
$ce990635ee602485$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $ce990635ee602485$var$_default = module.exports.default = $ce990635ee602485$var$ListBulletedIcon;

});

parcelRegister("aDHzd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7bef5760a52e3d3a$var$_react = $7bef5760a52e3d3a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $7bef5760a52e3d3a$var$_listBulleted = $7bef5760a52e3d3a$var$_interopRequireDefault((parcelRequire("hJIkn")));
function $7bef5760a52e3d3a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7bef5760a52e3d3a$var$BulletListIcon = (props)=>/*#__PURE__*/ $7bef5760a52e3d3a$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="10" y="15" rx="1"/><rect width="2" height="2" x="6" y="15" rx="1"/><rect width="8" height="2" x="10" y="11" rx="1"/><rect width="2" height="2" x="6" y="11" rx="1"/><rect width="8" height="2" x="10" y="7" rx="1"/><rect width="2" height="2" x="6" y="7" rx="1"/></g></svg>`
    }, props, {
        newIcon: $7bef5760a52e3d3a$var$_listBulleted.default
    }));
$7bef5760a52e3d3a$var$BulletListIcon.displayName = 'BulletListIcon';
var $7bef5760a52e3d3a$var$_default = module.exports.default = $7bef5760a52e3d3a$var$BulletListIcon;

});


parcelRegister("2gsxL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::478474977414af6f20354d0841ac3249>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1a633790993c57f3$var$_react = $1a633790993c57f3$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $1a633790993c57f3$var$_roadmap = $1a633790993c57f3$var$_interopRequireDefault((parcelRequire("l5gdO")));

var $1a633790993c57f3$var$_roadmap2 = $1a633790993c57f3$var$_interopRequireDefault((parcelRequire("jzOmA")));
function $1a633790993c57f3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for RoadmapIcon.
 * This component is RoadmapIcon, with `UNSAFE_fallbackIcon` set to "RoadmapIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1a633790993c57f3$var$RoadmapIcon = (props)=>/*#__PURE__*/ $1a633790993c57f3$var$_react.default.createElement($1a633790993c57f3$var$_roadmap.default, Object.assign({
        LEGACY_fallbackIcon: $1a633790993c57f3$var$_roadmap2.default
    }, props));
$1a633790993c57f3$var$RoadmapIcon.Name = 'RoadmapIconMigration';
var $1a633790993c57f3$var$_default = module.exports.default = $1a633790993c57f3$var$RoadmapIcon;

});
parcelRegister("jzOmA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e4085a500b27a688$var$_react = $e4085a500b27a688$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $e4085a500b27a688$var$_roadmap = $e4085a500b27a688$var$_interopRequireDefault((parcelRequire("l5gdO")));
function $e4085a500b27a688$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e4085a500b27a688$var$RoadmapIcon = (props)=>/*#__PURE__*/ $e4085a500b27a688$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 2h10a3 3 0 0 1 0 6H6a3 3 0 1 1 0-6m0 2a1 1 0 1 0 0 2h10a1 1 0 0 0 0-2zm4 5h8a3 3 0 0 1 0 6h-8a3 3 0 0 1 0-6m0 2a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2zm-4 5h6a3 3 0 0 1 0 6H6a3 3 0 0 1 0-6m0 2a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        newIcon: $e4085a500b27a688$var$_roadmap.default
    }));
$e4085a500b27a688$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $e4085a500b27a688$var$_default = module.exports.default = $e4085a500b27a688$var$RoadmapIcon;

});



parcelRegister("75UwL", function(module, exports) {

$parcel$export(module.exports, "filterAndSort", () => $df1cc586f514efec$export$d0e0de50c701304c);
$parcel$export(module.exports, "findDependentFeature", () => $df1cc586f514efec$export$4c8205136225a4e2);
$parcel$export(module.exports, "updateFeatureState", () => $df1cc586f514efec$export$2bdeae30201d513c);
$parcel$export(module.exports, "fireErrorAnalyticsOnUnmatchFeatureKey", () => $df1cc586f514efec$export$5da1e8c5ba5c0dc2);

var $3l9kN = parcelRequire("3l9kN");

var $gYnSx = parcelRequire("gYnSx");

var $epTsa = parcelRequire("epTsa");

var $2DEdX = parcelRequire("2DEdX");
const $df1cc586f514efec$export$b70265791d2079d4 = (hasFeature)=>hasFeature ? 'ENABLED' : 'DISABLED';
const $df1cc586f514efec$export$d0e0de50c701304c = (features)=>{
    const featureMap = (0, $2DEdX.getFeatureMap)({
        isListViewEnabled: (0, $epTsa.expValEquals)('jsw_list_view', 'cohort', 'variation')
    });
    return features.filter((f)=>Object.keys(featureMap).includes(f.feature)).sort((a, b)=>featureMap[a.feature].order - featureMap[b.feature].order);
};
const $df1cc586f514efec$export$4c8205136225a4e2 = (features, featureId)=>{
    const featureToDisable = features.find((f)=>f.feature === featureId);
    // Will only show the modal when the current status is enabled for both the feature to disable and the dependent feature
    if (featureToDisable?.state !== 'ENABLED') return undefined;
    // For the scope of the feature toggle, we assume there is only one dependency for now
    return features.find((f)=>f.prerequisites.includes(featureId) && f.state === 'ENABLED');
};
const $df1cc586f514efec$export$2bdeae30201d513c = (featureId, dependentFeatureId)=>(feature)=>feature.feature === featureId || dependentFeatureId && feature.feature === dependentFeatureId ? {
            ...feature,
            state: feature.state === 'ENABLED' ? 'DISABLED' : 'ENABLED'
        } : feature;
const $df1cc586f514efec$export$5da1e8c5ba5c0dc2 = (filteredFeatures)=>{
    const featureMap = (0, $2DEdX.getFeatureMap)({
        isListViewEnabled: (0, $epTsa.expValEquals)('jsw_list_view', 'cohort', 'variation')
    });
    if (filteredFeatures.length < Object.keys(featureMap).length) {
        const unmatchedFeatureKeys = (0, (/*@__PURE__*/$parcel$interopDefault($3l9kN)))(Object.keys(featureMap), ...filteredFeatures.map((f)=>f.feature));
        (0, $gYnSx.default)({
            error: new Error("Some feature keys don't match . Please check API response"),
            meta: {
                ...(0, $2DEdX.commonErrorAnalyticsMeta),
                id: 'unmatchFeatureKey'
            },
            attributes: {
                unmatchedFeatureKeys: unmatchedFeatureKeys.toString()
            }
        });
    }
};

});

parcelRegister("dFKLJ", function(module, exports) {

$parcel$export(module.exports, "getBoardFeatures", () => $5482b7a0e862d1ce$export$c20100b185d41ab0);

var $jGzN3 = parcelRequire("jGzN3");

var $8ZH3C = parcelRequire("8ZH3C");
const $5482b7a0e862d1ce$export$c20100b185d41ab0 = async (boardId)=>{
    const data = await (0, $jGzN3.performGetRequest)((0, $8ZH3C.getBoardFeaturesUrl)(boardId));
    return data.features;
};

});
parcelRegister("8ZH3C", function(module, exports) {

$parcel$export(module.exports, "getBoardFeaturesUrl", () => $a432628e74c040a5$export$3f9939d302766b52);
const $a432628e74c040a5$export$3f9939d302766b52 = (boardId)=>`/rest/agile/latest/board/${boardId}/features`;

});


parcelRegister("5ekEZ", function(module, exports) {

$parcel$export(module.exports, "updateBoardFeature", () => $daf54280ff8482fb$export$61f6bbb745b3a3);

var $jGzN3 = parcelRequire("jGzN3");

var $8ZH3C = parcelRequire("8ZH3C");
const $daf54280ff8482fb$export$61f6bbb745b3a3 = async (request)=>{
    // it returns the board features array, but we don't use it for optimistic update
    // feature state is used instead to indicate if the updates successful or not
    const data = await (0, $jGzN3.performPutRequest)((0, $8ZH3C.getBoardFeaturesUrl)(request.boardId), {
        body: JSON.stringify(request)
    });
    const newState = data.features.find((f)=>f.feature === request.feature)?.state;
    return newState ?? (request.enabling ? 'ENABLED' : 'DISABLED');
};

});



parcelRegister("cZfeH", function(module, exports) {

$parcel$export(module.exports, "useClearSidebarToggled", () => $ab83a592c4668936$export$2946f555c6f48127);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $dSkLG = parcelRequire("dSkLG");

var $6d9QY = parcelRequire("6d9QY");

var $1WzGp = parcelRequire("1WzGp");

var $fsjYk = parcelRequire("fsjYk");
const $ab83a592c4668936$export$2946f555c6f48127 = ()=>{
    const { data: data, refresh: refresh } = (0, $dSkLG.useJiraSoftwareProjectNavigation)();
    const [sidebarFeatureToggled, { clearSiderbarFeatureToggled: clearSiderbarFeatureToggled }] = (0, $1WzGp.useSidebarFeatureToggled)();
    const isEligibleForFeatureToggle = (0, $fsjYk.useShouldApplyFeatureToggle)();
    const sidebarHasChanged = (0, $eJOHy.useRef)(false);
    const previousData = (0, $6d9QY.usePreviousWithInitial)(data);
    // if resource data has changed since the last refresh then remove the sidebar toggled data.
    // i.e. whatever that has been toggled is reflected on the latest resource
    const shouldClear = (0, $eJOHy.useMemo)(()=>isEligibleForFeatureToggle && !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(previousData, data), [
        isEligibleForFeatureToggle,
        previousData,
        data
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (shouldClear) clearSiderbarFeatureToggled();
    }, [
        shouldClear,
        clearSiderbarFeatureToggled
    ]);
    (0, $eJOHy.useEffect)(()=>{
        sidebarHasChanged.current = isEligibleForFeatureToggle && !!sidebarFeatureToggled;
    }, [
        isEligibleForFeatureToggle,
        sidebarFeatureToggled
    ]);
    // refresh the navigation resource if sidebar has changed
    (0, $eJOHy.useEffect)(()=>()=>{
            if (sidebarHasChanged.current) refresh();
        }, [
        refresh
    ]);
};

});
parcelRegister("fsjYk", function(module, exports) {

$parcel$export(module.exports, "useShouldApplyFeatureToggle", () => $fa56f9341174283f$export$7deca16ba2d9eb74);

var $ln6Iy = parcelRequire("ln6Iy");

var $2aY2d = parcelRequire("2aY2d");

var $01Isa = parcelRequire("01Isa");
const $fa56f9341174283f$export$7deca16ba2d9eb74 = ()=>{
    const { data: project } = (0, $2aY2d.useProjectContext)();
    const firstActivationDateMs = (0, $01Isa.useFirstActivationDateMs)() || 0;
    const isJSW = project?.projectType === (0, $ln6Iy.SOFTWARE_PROJECT);
    const isTMP = !!project?.simplified;
    const isProjectAdmin = !!project?.isProjectAdmin;
    const isNewInstance = new Date(firstActivationDateMs) >= new Date('2023-09-25T15:00:00');
    return isJSW && isTMP && isProjectAdmin && isNewInstance;
};

});
parcelRegister("01Isa", function(module, exports) {

$parcel$export(module.exports, "useFirstActivationDateMs", () => $f3b05b48d8980ff5$export$9df3a539e50a284b);

var $lvKO5 = parcelRequire("lvKO5");
const $f3b05b48d8980ff5$export$9df3a539e50a284b = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.firstActivationDateMs != null ? tenantContext.firstActivationDateMs : null;
};

});




parcelRegister("d425D", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $fbaaa6f9e3b78e29$export$4a39035bacc4ed76);

var $eJOHy = parcelRequire("eJOHy");

var $dSkLG = parcelRequire("dSkLG");

var $aUegr = parcelRequire("aUegr");
const $fbaaa6f9e3b78e29$export$4a39035bacc4ed76 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $dSkLG.useJiraSoftwareProjectNavigation)();
    const extractedData = (0, $eJOHy.useMemo)(()=>data && (0, $aUegr.extractData)(data), [
        data
    ]);
    return {
        data: extractedData,
        loading: loading,
        error: error
    };
};

});
parcelRegister("aUegr", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $9b62be99ad8c6603$export$9df5fa0a366163d2);

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");
const $9b62be99ad8c6603$export$9df5fa0a366163d2 = (data)=>{
    const { aiInfo: aiInfo, hasBacklog: hasBacklog, hasBoard: hasBoard, hasCalendar: hasCalendar, hasCode: hasCode, hasComponents: hasComponents, hasDeployments: hasDeployments, hasDevelopment: hasDevelopment, hasForms: hasForms, hasGoals: hasGoals, hasIncidents: hasIncidents, hasIssues: hasIssues, hasList: hasList, hasOpsgenieSchedule: hasOpsgenieSchedule, hasPages: hasPages, hasReleases: hasReleases, hasReports: hasReports, hasRequests: hasRequests, hasRoadmap: hasRoadmap, hasSecurity: hasSecurity, hasSummaryPage: hasSummaryPage, permissionInfo: permissionInfo, hasArchivedIssues: hasArchivedIssues = false } = data;
    const isProjectOrSiteAdmin = permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    const hasEditWorkflowPermissions = permissionInfo.projectPermissionsQueried.EDIT_WORKFLOW === true;
    const hasEditIssueLayoutPermissions = permissionInfo.projectPermissionsQueried.EDIT_ISSUE_LAYOUT === true;
    const hasManageVersionsPermissions = permissionInfo.projectPermissionsQueried.MANAGE_VERSIONS === true;
    const hasSettings = (0, $7jTnu.fg)('vmc-11-manage-versions-permission') ? isProjectOrSiteAdmin || hasEditWorkflowPermissions || hasEditIssueLayoutPermissions || hasManageVersionsPermissions : isProjectOrSiteAdmin || hasEditWorkflowPermissions || hasEditIssueLayoutPermissions;
    return {
        hasArchivedIssues: hasArchivedIssues,
        hasAIInNIN: hasIssues && aiInfo?.isEnabledInIssueNavigator === true,
        hasBacklog: hasBacklog,
        hasBoard: hasBoard,
        hasCalendar: hasCalendar,
        hasCode: hasCode,
        hasComponents: hasComponents,
        hasDeployments: hasDeployments,
        hasDevelopment: hasDevelopment,
        hasForms: (0, $epTsa.expValEquals)('forms_for_jsw_experiment', 'isEnabled', true) && hasForms,
        hasGoals: hasGoals,
        hasIncidents: hasIncidents,
        hasIssues: hasIssues,
        hasList: (0, $epTsa.expValEquals)('jsw_list_view', 'cohort', 'variation') ? hasList : false,
        hasOpsgenieSchedule: hasOpsgenieSchedule,
        hasPages: hasPages,
        hasReleases: hasReleases,
        hasReports: hasReports,
        hasRequests: hasRequests,
        hasRoadmap: hasRoadmap,
        hasSecurity: hasSecurity,
        hasSettings: hasSettings,
        hasShortcutsAdd: isProjectOrSiteAdmin,
        hasSummaryPage: hasSummaryPage
    };
};

});


parcelRegister("eu90N", function(module, exports) {

$parcel$export(module.exports, "default", () => $29c81ab90f081e0c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $29c81ab90f081e0c$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    deploymentsLink: {
        "id": "development-summary-deployments-view-link.deployments-link",
        "defaultMessage": "See all deployments"
    }
});

});


parcelRegister("cYVTJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f5038a33435379a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $l9pUQ = parcelRequire("l9pUQ");

var $e7Dbk = parcelRequire("e7Dbk");
const $3f5038a33435379a$var$FeatureFlags = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { hasFeatureFlagsProviders: hasFeatureFlagsProviders, hasFeatureFlags: hasFeatureFlags, onClick: onClick, detailsLink: detailsLink, disabledFeatureFlags: disabledFeatureFlags, disabledFeatureFlagsCnt: disabledFeatureFlagsCnt, enabledFeatureFlags: enabledFeatureFlags, enabledFeatureFlagsCnt: enabledFeatureFlagsCnt, issueContext: issueContext, rolloutSummary: rolloutSummary, connectFeatureFlagTarget: connectFeatureFlagTarget, createFeatureFlagTarget: createFeatureFlagTarget, totalFeatureFlags: totalFeatureFlags } = props;
    const onLinkClicked = (0, $eJOHy.useCallback)((attributes, onClickAction)=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        }), 'clickFeatureFlagsSummaryLink', attributes);
        if (onClickAction) onClickAction();
    }, [
        createAnalyticsEvent
    ]);
    const { issueStatusCategory: issueStatusCategory, projectType: projectType, projectId: projectId, isSimplifiedProject: isSimplifiedProject } = issueContext;
    const analyticsAttributes = {
        issueStatusCategory: issueStatusCategory,
        projectType: projectType,
        projectId: projectId,
        isSimplifiedProject: isSimplifiedProject,
        totalFeatureFlags: totalFeatureFlags
    };
    if (hasFeatureFlagsProviders) {
        if (hasFeatureFlags) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
            sourceType: (0, $466f60259c330878$export$9d2de6eebf7462b5),
            sourceName: "viewFeatureFlagSummary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e7Dbk.default), {
            onClick: ()=>onLinkClicked(analyticsAttributes, onClick),
            connectFeatureFlagTarget: connectFeatureFlagTarget,
            createFeatureFlagTarget: createFeatureFlagTarget,
            detailsLink: detailsLink,
            disabledFeatureFlags: disabledFeatureFlags,
            disabledFeatureFlagsCnt: disabledFeatureFlagsCnt,
            enabledFeatureFlags: enabledFeatureFlags,
            enabledFeatureFlagsCnt: enabledFeatureFlagsCnt,
            rolloutSummary: rolloutSummary,
            totalFeatureFlags: totalFeatureFlags
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l9pUQ.default), {
            connectFeatureFlagTarget: connectFeatureFlagTarget,
            createFeatureFlagTarget: createFeatureFlagTarget
        });
    }
    return null;
};
$3f5038a33435379a$var$FeatureFlags.defaultProps = {
    hasFeatureFlagsProviders: false,
    hasFeatureFlags: false
};
var $3f5038a33435379a$export$2e2bcd8739ae039 = $3f5038a33435379a$var$FeatureFlags;

});
parcelRegister("l9pUQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7493899af30b1669$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5lAAn = parcelRequire("5lAAn");

var $1OQKp = parcelRequire("1OQKp");

var $5H92h = parcelRequire("5H92h");

var $cDP77 = parcelRequire("cDP77");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $iqtgH = parcelRequire("iqtgH");
var $ftN6c = parcelRequire("ftN6c");

var $coXKe = parcelRequire("coXKe");


var $jVbgD = parcelRequire("jVbgD");

var $8l6I8 = parcelRequire("8l6I8");

var $4tjjn = parcelRequire("4tjjn");
const $7493899af30b1669$export$939aea659a72e70b = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5H92h))), {
        spacing: "spacious",
        label: "Flag Icon"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDP77.SummaryItem), {
        icon: icon,
        disabled: true,
        title: formatMessage((0, $4tjjn.default).emptyState),
        "data-testid": (0, $6990640e4d37943e$export$1b3d3e6f99fd9330)
    });
};
const $7493899af30b1669$var$AddFeatureFlagSummaryItem = ({ connectFeatureFlagTarget: connectFeatureFlagTarget, createFeatureFlagTarget: createFeatureFlagTarget })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { userPreferredLayout: userPreferredLayout } = (0, $coXKe.useUserPreferredWorkItemLayout)();
    const isWideViewLayout = userPreferredLayout === 'WIDE';
    const downChevron = (0, $eJOHy.useMemo)(()=>isWideViewLayout ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
            color: "var(--ds-link, #0C66E4)",
            label: formatMessage((0, $4tjjn.default).featureFlagActionDropdownIconLabel),
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
            testId: "development-summary-feature-flag.ui.empty.chevron-down-icon",
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $4tjjn.default).featureFlagActionDropdownIconLabel),
            size: "small"
        }), [
        formatMessage,
        isWideViewLayout
    ]);
    const commonSummaryItemProps = {
        title: formatMessage((0, $4tjjn.default).addFeatureFlagTitle),
        linkFormatting: true,
        icon: isWideViewLayout ? (0, $jVbgD.AddFeatureFlagIconWideLayout) : (0, $jVbgD.AddFeatureFlagIcon)
    };
    return connectFeatureFlagTarget != null && connectFeatureFlagTarget !== undefined || createFeatureFlagTarget != null && createFeatureFlagTarget !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireUiAnalytics), {
        key: "viewed button createDevAction",
        action: "viewed",
        actionSubject: "button",
        actionSubjectId: "createDevAction",
        attributes: {
            inline: false,
            summaryItemType: 'commit'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8l6I8.FeatureFlagActionDropdownSimple), {
        getDropdownTrigger: ({ ref: ref, onClick: onClick, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDP77.SummaryItem), {
                secondaryData: downChevron,
                reference: ref,
                ...commonSummaryItemProps,
                ...props,
                onClick: ()=>{
                    onClick();
                    (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createDevAction', {
                        inline: false,
                        summaryItemType: 'commit'
                    });
                },
                "data-testid": (0, $6990640e4d37943e$export$1b3d3e6f99fd9330)
            }),
        connectFeatureFlagTarget: connectFeatureFlagTarget,
        createFeatureFlagTarget: createFeatureFlagTarget
    })) : null;
};
var $7493899af30b1669$export$2e2bcd8739ae039 = $7493899af30b1669$var$AddFeatureFlagSummaryItem;

});
const $6990640e4d37943e$export$1b3d3e6f99fd9330 = 'development-summary-feature-flag.ui.summary-item';

parcelRegister("jVbgD", function(module, exports) {

$parcel$export(module.exports, "AddFeatureFlagIcon", () => $a9197a2a8ab68a3b$export$c3b91b420ace5d12);
$parcel$export(module.exports, "AddFeatureFlagIconWideLayout", () => $a9197a2a8ab68a3b$export$dba901d02bfe3eba);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kMmrb = parcelRequire("kMmrb");

var $5H92h = parcelRequire("5H92h");

var $dcLzM = parcelRequire("dcLzM");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a9197a2a8ab68a3b$var$IconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_s7n4nkob",
            __cmplp.className
        ])
    });
});
const $a9197a2a8ab68a3b$export$ade1044df21e8c42 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a9197a2a8ab68a3b$var$IconWrapper, {
    "aria-hidden": true
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5H92h))), {
    LEGACY_size: "medium",
    spacing: "spacious",
    label: ""
}));
const $a9197a2a8ab68a3b$export$c3b91b420ace5d12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a9197a2a8ab68a3b$var$IconWrapper, {
    "aria-hidden": true
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kMmrb))), {
    LEGACY_size: "medium",
    spacing: "spacious",
    label: ""
}));
const $a9197a2a8ab68a3b$export$dba901d02bfe3eba = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a9197a2a8ab68a3b$var$IconWrapper, {
    "aria-hidden": true
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
    color: "var(--ds-link, #0C66E4)",
    label: ""
}));

});

parcelRegister("8l6I8", function(module, exports) {

$parcel$export(module.exports, "FeatureFlagActionDropdownSimple", () => $56b11bb3bdfeb34d$export$13c650f5e4062632);
$parcel$export(module.exports, "default", () => $56b11bb3bdfeb34d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dPMMf = parcelRequire("dPMMf");

var $cNe2t = parcelRequire("cNe2t");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $bbdV2 = parcelRequire("bbdV2");

var $ciFJV = parcelRequire("ciFJV");

var $cBavF = parcelRequire("cBavF");

var $gO9je = parcelRequire("gO9je");
const $56b11bb3bdfeb34d$var$entryPointParams = {};
const $56b11bb3bdfeb34d$var$FeatureFlagActionDropdownInner = ({ connectFeatureFlagTarget: connectFeatureFlagTarget, createFeatureFlagTarget: createFeatureFlagTarget, onOpenDropdown: onOpenDropdown, getDropdownTrigger: getDropdownTrigger, hideConnectFeatureFlagLinks: hideConnectFeatureFlagLinks = false, hideCreateFeatureFlagLinks: hideCreateFeatureFlagLinks = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const previousOpen = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (previousOpen.current !== isOpen) {
            previousOpen.current = isOpen;
            isOpen && (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdown opened', 'featureFlagActionDropdown');
            !isOpen && (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdown closed', 'featureFlagActionDropdown');
            onOpenDropdown && onOpenDropdown({
                isOpen: isOpen
            });
        }
    }, [
        createAnalyticsEvent,
        isOpen,
        onOpenDropdown
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $gO9je.createFeatureFlagDropdownContentEntrypoint), $56b11bb3bdfeb34d$var$entryPointParams);
    const triggerRef = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    const runtimeProps = (0, $eJOHy.useMemo)(()=>({
            connectFeatureFlagTarget: connectFeatureFlagTarget,
            createFeatureFlagTarget: createFeatureFlagTarget,
            hideConnectFeatureFlagLinks: hideConnectFeatureFlagLinks,
            hideCreateFeatureFlagLinks: hideCreateFeatureFlagLinks,
            setIsOpen: setIsOpen
        }), [
        connectFeatureFlagTarget,
        createFeatureFlagTarget,
        hideConnectFeatureFlagLinks,
        hideCreateFeatureFlagLinks,
        setIsOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        id: "feature-flag-action-dropdown",
        testId: "development-summary-feature-flag.common.ui.feature-flag-action-dropdown-simple.popup",
        zIndex: (0, $dPMMf.layers).modal + 1,
        placement: "bottom-end",
        messageId: "development-summary-feature-flag.common.ui.feature-flag-action-dropdown-simple.popup",
        messageType: "transactional",
        shouldFlip: true,
        trigger: (triggerProps)=>getDropdownTrigger({
                ...triggerProps,
                isSelected: isOpen,
                onClick: ()=>setIsOpen(!isOpen),
                ref: (element)=>{
                    triggerRef(element);
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    triggerProps.ref(element);
                }
            }),
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "dev-panel-feature-flag-action-dropdown-content",
                packageName: "jira-development-summary-feature-flag",
                fallback: null,
                runtimeProps: runtimeProps
            })
    });
};
const $56b11bb3bdfeb34d$export$13c650f5e4062632 = ({ connectFeatureFlagTarget: connectFeatureFlagTarget, createFeatureFlagTarget: createFeatureFlagTarget, onOpenDropdown: onOpenDropdown, getDropdownTrigger: getDropdownTrigger, hideConnectFeatureFlagLinks: hideConnectFeatureFlagLinks = false, hideCreateFeatureFlagLinks: hideCreateFeatureFlagLinks = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        attributes: {
            singleFFProvider: connectFeatureFlagTarget != null && connectFeatureFlagTarget !== undefined || createFeatureFlagTarget != null && createFeatureFlagTarget !== undefined
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($56b11bb3bdfeb34d$var$FeatureFlagActionDropdownInner, {
        connectFeatureFlagTarget: connectFeatureFlagTarget,
        createFeatureFlagTarget: createFeatureFlagTarget,
        onOpenDropdown: onOpenDropdown,
        getDropdownTrigger: getDropdownTrigger,
        hideConnectFeatureFlagLinks: hideConnectFeatureFlagLinks,
        hideCreateFeatureFlagLinks: hideCreateFeatureFlagLinks
    }));
var $56b11bb3bdfeb34d$export$2e2bcd8739ae039 = $56b11bb3bdfeb34d$export$13c650f5e4062632;

});
parcelRegister("gO9je", function(module, exports) {

$parcel$export(module.exports, "createFeatureFlagDropdownContentEntrypoint", () => $79c2005a3c2c6744$export$f1b7e1367507e8bc);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $79c2005a3c2c6744$export$f1b7e1367507e8bc = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("2Idzs")), {
        moduleId: "017c8546",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("2Idzs", function(module, exports) {

let $1f9a37bbf523dbed$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1f9a37bbf523dbed$var$load("liQi4").then(()=>parcelRequire('18TQU'));

});



parcelRegister("4tjjn", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb03713853782247$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $bb03713853782247$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    emptyState: {
        "id": "development-summary-feature-flag.empty.empty-state",
        "defaultMessage": "Feature Flag"
    },
    addFeatureFlagTitle: {
        "id": "development-summary-feature-flag.empty.add-feature-flag-title",
        "defaultMessage": "Add feature flag"
    },
    featureFlagActionDropdownIconLabel: {
        "id": "development-summary-feature-flag.empty.feature-flag-action-dropdown-icon-label",
        "defaultMessage": "Open feature flag action dropdown"
    },
    tooltip: {
        "id": "development-summary-feature-flag.empty.tooltip",
        "defaultMessage": "Open feature flag"
    }
});

});


parcelRegister("e7Dbk", function(module, exports) {

$parcel$export(module.exports, "default", () => $9014dbf907d4322e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5H92h = parcelRequire("5H92h");

var $cDP77 = parcelRequire("cDP77");

var $lRq8t = parcelRequire("lRq8t");

var $8l6I8 = parcelRequire("8l6I8");

var $eL3j7 = parcelRequire("eL3j7");

var $2PVen = parcelRequire("2PVen");

var $iogD6 = parcelRequire("iogD6");

var $8Mkrx = parcelRequire("8Mkrx");
const $9014dbf907d4322e$var$FEATURE_FLAG_SUMMARY_ITEM_TEST_ID = 'development-summary-feature-flag.ui.summary-item';
const $9014dbf907d4322e$export$b141efd0b0fb9174 = (previousProps, nextProps)=>nextProps.enabledFeatureFlagsCnt === previousProps.enabledFeatureFlagsCnt && nextProps.disabledFeatureFlagsCnt === previousProps.disabledFeatureFlagsCnt && nextProps.detailsLink === previousProps.detailsLink;
const $9014dbf907d4322e$var$FeatureFlagSummaryItem = /*#__PURE__*/ (0, $eJOHy.memo)(({ connectFeatureFlagTarget: connectFeatureFlagTarget, createFeatureFlagTarget: createFeatureFlagTarget, detailsLink: detailsLink, disabledFeatureFlags: disabledFeatureFlags, disabledFeatureFlagsCnt: disabledFeatureFlagsCnt, enabledFeatureFlags: enabledFeatureFlags, enabledFeatureFlagsCnt: enabledFeatureFlagsCnt, onClick: onClick, rolloutSummary: rolloutSummary, totalFeatureFlags: totalFeatureFlags })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [shouldForceVisibleSecondary, setShouldForceVisibleSecondary] = (0, $eJOHy.useState)(false);
    const title = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2PVen.default), {
            enabledFeatureFlags: enabledFeatureFlags,
            disabledFeatureFlags: disabledFeatureFlags
        }), [
        enabledFeatureFlags,
        disabledFeatureFlags
    ]);
    const secondaryData = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Mkrx.default), {
            hasFeatureFlags: disabledFeatureFlagsCnt + enabledFeatureFlagsCnt > 0,
            disabledFeatureFlagsCnt: disabledFeatureFlagsCnt,
            enabledFeatureFlagsCnt: enabledFeatureFlagsCnt,
            rolloutSummary: rolloutSummary
        }), [
        disabledFeatureFlagsCnt,
        enabledFeatureFlagsCnt,
        rolloutSummary
    ]);
    return(// TODO - Apply the same solution as the one being designed for relative date in commits
    // to prevent the secondaryData overlapping the title onHover.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDP77.SummaryItem), {
        title: title,
        secondaryData: secondaryData,
        onClick: onClick,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5H92h))), {
            label: "Flag Icon",
            LEGACY_size: "medium",
            spacing: "spacious"
        }),
        showIconInPlainLink: true,
        itemType: "featureFlag",
        itemCount: totalFeatureFlags,
        oneClickUrl: detailsLink,
        oneClickToolTipContent: formatMessage((0, $iogD6.default).tooltip),
        secondaryHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8l6I8.default), {
            connectFeatureFlagTarget: connectFeatureFlagTarget,
            createFeatureFlagTarget: createFeatureFlagTarget,
            getDropdownTrigger: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eL3j7.default), props),
            onOpenDropdown: ({ isOpen: isOpen })=>{
                setShouldForceVisibleSecondary(isOpen);
            }
        }),
        forceVisibleSecondary: shouldForceVisibleSecondary,
        "data-testid": $9014dbf907d4322e$var$FEATURE_FLAG_SUMMARY_ITEM_TEST_ID
    }));
}, $9014dbf907d4322e$export$b141efd0b0fb9174);
var $9014dbf907d4322e$export$2e2bcd8739ae039 = $9014dbf907d4322e$var$FeatureFlagSummaryItem;

});
parcelRegister("eL3j7", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b8fafc0e4075d4c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $jQjGM = parcelRequire("jQjGM");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $iqtgH = parcelRequire("iqtgH");

var $exoTY = parcelRequire("exoTY");
const $4b8fafc0e4075d4c$var$FeatureFlagActionIconButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onClick: onClickProp, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const tooltipContent = formatMessage((0, $exoTY.default).tooltipContent);
    const onClick = (e, analyticsEvent)=>{
        onClickProp && onClickProp();
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'createDevAction', {
            inline: true,
            summaryItemType: 'feature-flag'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: tooltipContent,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireUiAnalytics), {
        action: "viewed",
        actionSubject: "button",
        actionSubjectId: "createDevAction",
        attributes: {
            inline: true,
            summaryItemType: 'feature-flag'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        ref: ref,
        ...props,
        appearance: "subtle",
        testId: "development-summary-feature-flag.ui.summary.feature-flag-action-icon-button.button",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jQjGM))), {
            LEGACY_size: "small",
            label: tooltipContent
        }),
        onClick: onClick
    }));
});
var $4b8fafc0e4075d4c$export$2e2bcd8739ae039 = $4b8fafc0e4075d4c$var$FeatureFlagActionIconButton;

});
parcelRegister("exoTY", function(module, exports) {

$parcel$export(module.exports, "default", () => $de90e88ef7317cd7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $de90e88ef7317cd7$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    tooltipContent: {
        "id": "development-summary-feature-flag.summary.feature-flag-action-icon-button.tooltip-content",
        "defaultMessage": "Create/Connect Feature Flag"
    }
});

});


parcelRegister("2PVen", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb4781514ff74c47$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $1TWc3 = parcelRequire("1TWc3");

var $dxojm = parcelRequire("dxojm");
const $cb4781514ff74c47$var$FlagsDescription = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { enabledFeatureFlags: enabledFeatureFlags, disabledFeatureFlags: disabledFeatureFlags } = props;
    const hasFlags = ()=>enabledFeatureFlags.length + disabledFeatureFlags.length > 0;
    const Description = (0, $eJOHy.useMemo)(()=>{
        let labelText;
        const flagsCnt = enabledFeatureFlags.length + disabledFeatureFlags.length;
        if (flagsCnt === 1) labelText = enabledFeatureFlags.length === 1 ? enabledFeatureFlags[0] : disabledFeatureFlags[0];
        else labelText = formatMessage((0, $1TWc3.default).many, {
            flagsCnt: flagsCnt
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null, labelText);
    }, [
        disabledFeatureFlags,
        enabledFeatureFlags,
        formatMessage
    ]);
    if (!hasFlags()) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dxojm.default), {
        enabledFeatureFlags: enabledFeatureFlags,
        disabledFeatureFlags: disabledFeatureFlags
    }, Description);
};
var $cb4781514ff74c47$export$2e2bcd8739ae039 = $cb4781514ff74c47$var$FlagsDescription;

});
parcelRegister("1TWc3", function(module, exports) {

$parcel$export(module.exports, "default", () => $17675d88cd25b3e9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $17675d88cd25b3e9$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    many: {
        "id": "development-summary-feature-flag.summary.flags-description.many",
        "defaultMessage": "{flagsCnt} feature flags"
    }
});

});

parcelRegister("dxojm", function(module, exports) {

$parcel$export(module.exports, "default", () => $e45c7f3c20e1909e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $ghpM4 = parcelRequire("ghpM4");
class $e45c7f3c20e1909e$var$ContentLineKeyGenerator {
    next() {
        this.cnt += 1;
        return `rp-cnt-tt-${this.cnt}`;
    }
    constructor(){
        this.cnt = 0;
    }
}
const $e45c7f3c20e1909e$var$ContentTooltip = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const TooltipContentHeader = (0, $eJOHy.useMemo)(()=>{
        const { enabledFeatureFlags: enabledFeatureFlags, disabledFeatureFlags: disabledFeatureFlags } = props;
        const keyGenerator = new $e45c7f3c20e1909e$var$ContentLineKeyGenerator();
        const contentLines = enabledFeatureFlags.concat(disabledFeatureFlags).sort().slice(0, 3).map((featureFlagName)=>featureFlagName);
        return contentLines.map((contentLine)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                key: keyGenerator.next()
            }, contentLine));
    }, [
        props
    ]);
    const TooltipFooter = (0, $eJOHy.useMemo)(()=>{
        const { enabledFeatureFlags: enabledFeatureFlags, disabledFeatureFlags: disabledFeatureFlags } = props;
        const remainingFeatureFlags = enabledFeatureFlags.length + disabledFeatureFlags.length - 3;
        if (remainingFeatureFlags > 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, formatMessage((0, $ghpM4.default).moreFeatureFlags, {
            featureFlagsCnt: remainingFeatureFlags
        }));
        if (remainingFeatureFlags === 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, formatMessage((0, $ghpM4.default).oneMoreFeatureFlag));
        return null;
    }, [
        formatMessage,
        props
    ]);
    const TooltipContent = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, TooltipContentHeader, TooltipFooter), [
        TooltipContentHeader,
        TooltipFooter
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: TooltipContent,
        tag: "span"
    }, props.children);
};
var $e45c7f3c20e1909e$export$2e2bcd8739ae039 = $e45c7f3c20e1909e$var$ContentTooltip;

});
parcelRegister("ghpM4", function(module, exports) {

$parcel$export(module.exports, "default", () => $15f1b75352c0dbd3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $15f1b75352c0dbd3$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    oneMoreFeatureFlag: {
        "id": "development-summary-feature-flag.summary.flags-description.tooltip.one-more-feature-flag",
        "defaultMessage": "(+1 more flag)"
    },
    moreFeatureFlags: {
        "id": "development-summary-feature-flag.summary.flags-description.tooltip.more-feature-flags",
        "defaultMessage": "(+{featureFlagsCnt} more flag)"
    }
});

});



parcelRegister("iogD6", function(module, exports) {

$parcel$export(module.exports, "default", () => $71b8f2158d1173ae$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $71b8f2158d1173ae$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    emptyState: {
        "id": "development-summary-feature-flag.summary.empty-state",
        "defaultMessage": "Feature Flag"
    },
    addFeatureFlagTitle: {
        "id": "development-summary-feature-flag.summary.add-feature-flag-title",
        "defaultMessage": "Add feature flag"
    },
    featureFlagActionDropdownIconLabel: {
        "id": "development-summary-feature-flag.summary.feature-flag-action-dropdown-icon-label",
        "defaultMessage": "Open feature flag action dropdown"
    },
    tooltip: {
        "id": "development-summary-feature-flag.summary.tooltip",
        "defaultMessage": "Open feature flag"
    }
});

});

parcelRegister("8Mkrx", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb0bb1a38857eb12$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $jdqdp = parcelRequire("jdqdp");

var $7q3ht = parcelRequire("7q3ht");
const $fb0bb1a38857eb12$var$lozengeAppearance = (isOn)=>isOn ? 'success' : 'default';
const $fb0bb1a38857eb12$var$lozengeValue = (isOn)=>isOn ? 'on' : 'off';
function $fb0bb1a38857eb12$export$2e2bcd8739ae039(props) {
    const { disabledFeatureFlagsCnt: disabledFeatureFlagsCnt, enabledFeatureFlagsCnt: enabledFeatureFlagsCnt, hasFeatureFlags: hasFeatureFlags, rolloutSummary: rolloutSummary } = props;
    const isOn = enabledFeatureFlagsCnt > 0;
    return hasFeatureFlags ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7q3ht.default), {
        disabledFeatureFlagsCnt: disabledFeatureFlagsCnt,
        enabledFeatureFlagsCnt: enabledFeatureFlagsCnt,
        rolloutSummary: rolloutSummary
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: $fb0bb1a38857eb12$var$lozengeAppearance(isOn)
    }, $fb0bb1a38857eb12$var$lozengeValue(isOn))) : null;
}

});
parcelRegister("7q3ht", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fd779fe8b9b8888$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $aS30j = parcelRequire("aS30j");
/**
 * @returns a tootlip message for indicating the current state of a single enabled flag
 */ const $9fd779fe8b9b8888$var$SingleFlagIsOnTooltip = (rolloutSummary)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (rolloutSummary) {
        if (rolloutSummary.text !== null || rolloutSummary.text !== undefined) return formatMessage((0, $aS30j.default).rolloutText, {
            text: rolloutSummary.text
        });
        if (rolloutSummary.percentage != null && rolloutSummary.percentage > 0) return formatMessage((0, $aS30j.default).rolloutPercentage, {
            percentage: rolloutSummary.percentage
        });
        if (rolloutSummary.rules != null && rolloutSummary.rules > 1) return formatMessage((0, $aS30j.default).rolloutMultipleRules, {
            rulesCnt: rolloutSummary.rules
        });
        return formatMessage((0, $aS30j.default).rolloutSingleRule);
    }
    return '';
};
/**
 * @returns a tooltip message when only a single flag is associated
 */ const $9fd779fe8b9b8888$var$SingleFlagTooptip = (enabledFeatureFlagsCnt, rolloutSummary)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (enabledFeatureFlagsCnt > 0) return $9fd779fe8b9b8888$var$SingleFlagIsOnTooltip(rolloutSummary);
    /**
   * @returns a tooltip message indicating the flag is off
   */ return formatMessage((0, $aS30j.default).singleFeatureFlagOff);
};
/**
 * @returns a tooltip message for multiple flags
 */ const $9fd779fe8b9b8888$var$MultipleFlagsTooltip = (enabledFeatureFlagsCnt, disabledFeatureFlagsCnt)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (enabledFeatureFlagsCnt === 0) return formatMessage((0, $aS30j.default).multipleFeatureFlagsAllOff);
    if (disabledFeatureFlagsCnt === 0) return formatMessage((0, $aS30j.default).multipleFeatureFlagsAllOn);
    return formatMessage((0, $aS30j.default).multipleFeatureFlagsSomeOn, {
        onCnt: enabledFeatureFlagsCnt,
        offCnt: enabledFeatureFlagsCnt + disabledFeatureFlagsCnt
    });
};
/**
 * @returns a tootlip message for indicating the current state based on the rollout summary
 */ const $9fd779fe8b9b8888$var$RolloutSummaryTooltip = (rolloutSummary)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (rolloutSummary.text !== null && rolloutSummary.text !== undefined) return formatMessage((0, $aS30j.default).rolloutText, {
        text: rolloutSummary.text
    });
    if (rolloutSummary.percentage != null && rolloutSummary.percentage > 0) return formatMessage((0, $aS30j.default).rolloutPercentage, {
        percentage: rolloutSummary.percentage
    });
    if (rolloutSummary.rules != null && rolloutSummary.rules > 1) return formatMessage((0, $aS30j.default).rolloutMultipleRules, {
        rulesCnt: rolloutSummary.rules
    });
    return formatMessage((0, $aS30j.default).rolloutSingleRule);
};
const $9fd779fe8b9b8888$var$StatusTooltip = (props)=>{
    const { enabledFeatureFlagsCnt: enabledFeatureFlagsCnt, disabledFeatureFlagsCnt: disabledFeatureFlagsCnt, rolloutSummary: rolloutSummary } = props;
    let tooltipContent;
    if (rolloutSummary) tooltipContent = $9fd779fe8b9b8888$var$RolloutSummaryTooltip(rolloutSummary);
    else if (enabledFeatureFlagsCnt + disabledFeatureFlagsCnt === 1) tooltipContent = $9fd779fe8b9b8888$var$SingleFlagTooptip(enabledFeatureFlagsCnt, rolloutSummary);
    else tooltipContent = $9fd779fe8b9b8888$var$MultipleFlagsTooltip(enabledFeatureFlagsCnt, disabledFeatureFlagsCnt);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: tooltipContent
    }, props.children);
};
var $9fd779fe8b9b8888$export$2e2bcd8739ae039 = $9fd779fe8b9b8888$var$StatusTooltip;

});
parcelRegister("aS30j", function(module, exports) {

$parcel$export(module.exports, "default", () => $b17c2f213636b983$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b17c2f213636b983$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    rolloutText: {
        "id": "development-summary-feature-flag.summary.status.tooltip.rollout-text",
        "defaultMessage": "{text}"
    },
    rolloutPercentage: {
        "id": "development-summary-feature-flag.summary.status.tooltip.rollout-percentage",
        "defaultMessage": "{percentage}%"
    },
    rolloutSingleRule: {
        "id": "development-summary-feature-flag.summary.status.tooltip.rollout-single-rule",
        "defaultMessage": "1 Rule"
    },
    rolloutMultipleRules: {
        "id": "development-summary-feature-flag.summary.status.tooltip.rollout-multiple-rules",
        "defaultMessage": "{rulesCnt} Rules"
    },
    singleFeatureFlagOff: {
        "id": "development-summary-feature-flag.summary.status.tooltip.single-feature-flag-off",
        "defaultMessage": "Feature flag off"
    },
    multipleFeatureFlagsAllOn: {
        "id": "development-summary-feature-flag.summary.status.tooltip.multiple-feature-flags-all-on",
        "defaultMessage": "All feature flags on"
    },
    multipleFeatureFlagsSomeOn: {
        "id": "development-summary-feature-flag.summary.status.tooltip.multiple-feature-flags-some-on",
        "defaultMessage": "{onCnt} of {offCnt} feature flags on"
    },
    multipleFeatureFlagsAllOff: {
        "id": "development-summary-feature-flag.summary.status.tooltip.multiple-feature-flags-all-off",
        "defaultMessage": "All feature flags off"
    }
});

});





parcelRegister("cchwz", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ca9f6d7f512ed94$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $av9Of = parcelRequire("av9Of");

var $cDP77 = parcelRequire("cDP77");

var $lRq8t = parcelRequire("lRq8t");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $i3dXO = parcelRequire("i3dXO");
const $0ca9f6d7f512ed94$var$Description = ({ description: description })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, description);
const $0ca9f6d7f512ed94$export$cd0ba36797648943 = ({ remoteLinksCount: remoteLinksCount, issueContext: issueContext, onClick: onClick })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onLinkClicked = (0, $eJOHy.useCallback)((attributes, onClickAction)=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        }), 'clickRemoteLinksSummaryLink', attributes);
        if (onClickAction) onClickAction();
    }, [
        createAnalyticsEvent
    ]);
    const summaryItemLabel = formatMessage((0, $i3dXO.default).summaryItemLabel, {
        remoteLinksCount: remoteLinksCount
    });
    const { issueStatusCategory: issueStatusCategory, projectType: projectType, projectId: projectId, isSimplifiedProject: isSimplifiedProject } = issueContext;
    const analyticsAttributes = {
        issueStatusCategory: issueStatusCategory,
        projectType: projectType,
        projectId: projectId,
        isSimplifiedProject: isSimplifiedProject,
        remoteLinksCount: remoteLinksCount
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceType: (0, $466f60259c330878$export$9d2de6eebf7462b5),
        sourceName: "viewRemoteLinksSummary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDP77.SummaryItem), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0ca9f6d7f512ed94$var$Description, {
            description: summaryItemLabel
        }),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
            label: formatMessage((0, $i3dXO.default).linkIconLabel),
            LEGACY_size: "medium",
            spacing: "spacious"
        }),
        onClick: ()=>{
            onLinkClicked(analyticsAttributes, onClick);
        },
        showIconInPlainLink: true,
        itemType: "remote-links",
        itemCount: remoteLinksCount,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "development-summary-remote-links.ui.summary-item"
    }));
};
var $0ca9f6d7f512ed94$export$2e2bcd8739ae039 = $0ca9f6d7f512ed94$export$cd0ba36797648943;

});
parcelRegister("i3dXO", function(module, exports) {

$parcel$export(module.exports, "default", () => $690e7f637d87966f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $690e7f637d87966f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    summaryItemLabel: {
        "id": "development-summary-remote-links.summary-item-label",
        "defaultMessage": "{remoteLinksCount} other {remoteLinksCount, plural, one {link} other {links}}"
    },
    linkIconLabel: {
        "id": "development-summary-remote-links.link-icon-label",
        "defaultMessage": "Link icon"
    }
});

});


parcelRegister("eQLsa", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cd493108c9d2a9e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $8cd493108c9d2a9e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    label: {
        "id": "development-summary-releases-field.summary.label",
        "defaultMessage": "Releases"
    }
});

});


parcelRegister("1gHM1", function(module, exports) {

$parcel$export(module.exports, "useOnMountedAnalytics", () => $4ca4e1e2db32ff32$export$92d629d31f712073);

var $eJOHy = parcelRequire("eJOHy");

var $aX8Tx = parcelRequire("aX8Tx");

var $eq3Hf = parcelRequire("eq3Hf");

var $4J0ad = parcelRequire("4J0ad");

var $lq5Hg = parcelRequire("lq5Hg");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $gnQAk = parcelRequire("gnQAk");

var $2m2Hx = parcelRequire("2m2Hx");

var $6N429 = parcelRequire("6N429");
var $4ca4e1e2db32ff32$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $4J0ad.default)(), (0, $gnQAk.connect)((state)=>({
        flagsPerProvider: (0, $2m2Hx.flagsPerProviderSelector)(state),
        providers: (0, $2m2Hx.providersSelector)(state),
        remoteLinksData: (0, $2m2Hx.remoteLinksDataSelector)(state)
    }), {}))((0, $6N429.default));
const $4ca4e1e2db32ff32$export$f504f1e1350b92c4 = (flagsPerProvider)=>{
    const flagsPerProviderCnt = {};
    Object.keys(flagsPerProvider).forEach((key)=>{
        flagsPerProviderCnt[key] = flagsPerProvider[key].length;
    });
    return flagsPerProviderCnt;
};
const $4ca4e1e2db32ff32$export$cdf9861d920ad813 = (providers)=>{
    const deploymentsPerProviderCnt = {};
    (providers ?? []).forEach((provider)=>{
        const deployments = (0, (/*@__PURE__*/$parcel$interopDefault($aX8Tx)))(Object.values(provider.environments));
        deploymentsPerProviderCnt[provider.id] = deployments.length;
    });
    return deploymentsPerProviderCnt;
};
const $4ca4e1e2db32ff32$export$b83c10dcc81ac546 = (providers)=>{
    const environmentsPerProviderCnt = {};
    (providers ?? []).forEach((provider)=>{
        const { environments: environments } = provider;
        Object.keys(environments).forEach((environmentType)=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"STAGING" | "PRODUCTION" | "DEVELOPMENT" | "TESTING" | "UNMAPPED", DeploymentData[]>>'.
            const deployments = environments[environmentType];
            environmentsPerProviderCnt[environmentType] = (environmentsPerProviderCnt[environmentType] || 0) + deployments.length;
        });
    });
    return environmentsPerProviderCnt;
};
const $4ca4e1e2db32ff32$export$6666f03614fb8b5f = (remoteLinksData)=>{
    const remoteLinksPerProviderCnt = {};
    (remoteLinksData?.remoteLinks ?? []).forEach((link)=>{
        remoteLinksPerProviderCnt[(0, $lq5Hg.fromRemoteLinkProviderId)(link.providerId)] = (remoteLinksPerProviderCnt[(0, $lq5Hg.fromRemoteLinkProviderId)(link.providerId)] || 0) + 1;
    });
    return remoteLinksPerProviderCnt;
};
const $4ca4e1e2db32ff32$export$10aafcd0e0ff7f4f = (remoteLinksData)=>{
    const remoteLinksPerTypeCnt = {};
    (remoteLinksData?.remoteLinks ?? []).forEach((link)=>{
        remoteLinksPerTypeCnt[(0, $lq5Hg.fromRemoteLinkType)(link.type)] = (remoteLinksPerTypeCnt[(0, $lq5Hg.fromRemoteLinkType)(link.type)] || 0) + 1;
    });
    return remoteLinksPerTypeCnt;
};
const $4ca4e1e2db32ff32$export$92d629d31f712073 = ({ actionSubject: actionSubject, actionSubjectId: actionSubjectId, flagsPerProvider: flagsPerProvider, providers: providers, remoteLinksData: remoteLinksData })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const hasFired = (0, $eJOHy.useRef)(false);
    return ()=>{
        if (hasFired.current === true) return;
        hasFired.current = true;
        const flagsPerProviderStat = $4ca4e1e2db32ff32$export$f504f1e1350b92c4(flagsPerProvider);
        const totalNumFlags = Object.keys(flagsPerProviderStat).reduce((acc, key)=>acc + flagsPerProviderStat[key], 0);
        const totalNumFeatureFlagProviders = Object.keys(flagsPerProviderStat).length;
        const deploymentsPerProviderStat = $4ca4e1e2db32ff32$export$cdf9861d920ad813(providers);
        const totalNumDeployments = Object.keys(deploymentsPerProviderStat).reduce((acc, key)=>acc + deploymentsPerProviderStat[key], 0);
        const deploymentsPerEnvironmentStat = $4ca4e1e2db32ff32$export$b83c10dcc81ac546(providers);
        const totalNumDeploymentProviders = Object.keys(deploymentsPerProviderStat).length;
        const totalNumRemoteLinks = remoteLinksData ? remoteLinksData.remoteLinks.length : 0;
        const totalNumRemoteLinkProviders = remoteLinksData ? remoteLinksData.providers.length : 0;
        const remoteLinksPerProviderStat = $4ca4e1e2db32ff32$export$6666f03614fb8b5f(remoteLinksData);
        const remoteLinksPerTypeStat = $4ca4e1e2db32ff32$export$10aafcd0e0ff7f4f(remoteLinksData);
        const flagsPerProviderJson = JSON.stringify(flagsPerProviderStat);
        const deploymentsPerProviderJson = JSON.stringify(deploymentsPerProviderStat);
        const environmentsPerProviderJson = JSON.stringify(deploymentsPerEnvironmentStat);
        const remoteLinksPerProviderJson = JSON.stringify(remoteLinksPerProviderStat);
        const remoteLinksPerTypeJson = JSON.stringify(remoteLinksPerTypeStat);
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'rendered',
            actionSubject: actionSubject
        }), actionSubjectId, {
            totalNumFlags: totalNumFlags,
            totalNumFeatureFlagProviders: totalNumFeatureFlagProviders,
            flagsPerProvider: flagsPerProviderJson,
            totalNumDeployments: totalNumDeployments,
            totalNumDeploymentProviders: totalNumDeploymentProviders,
            totalNumRemoteLinks: totalNumRemoteLinks,
            totalNumRemoteLinkProviders: totalNumRemoteLinkProviders,
            remoteLinksPerProviderStat: remoteLinksPerProviderJson,
            remoteLinksPerTypeStat: remoteLinksPerTypeJson,
            deploymentsPerProviderStat: deploymentsPerProviderJson,
            environmentsPerProviderStat: environmentsPerProviderJson
        });
    };
};

});
parcelRegister("6N429", function(module, exports) {

$parcel$export(module.exports, "default", () => $72da6312ecb5149f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aX8Tx = parcelRequire("aX8Tx");

var $lq5Hg = parcelRequire("lq5Hg");

var $gCeeo = parcelRequire("gCeeo");
class $72da6312ecb5149f$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    componentDidMount() {
        const flagsPerProviderStat = this.calculateFlagsPerProviderStat();
        const totalNumFlags = Object.keys(flagsPerProviderStat).reduce((acc, key)=>acc + flagsPerProviderStat[key], 0);
        const totalNumFeatureFlagProviders = Object.keys(flagsPerProviderStat).length;
        const deploymentsPerProviderStat = this.calculateDeploymentsPerProviderStat();
        const totalNumDeployments = Object.keys(deploymentsPerProviderStat).reduce((acc, key)=>acc + deploymentsPerProviderStat[key], 0);
        const deploymentsPerEnvironmentStat = this.calculateDeploymentsPerEnvironmentStat();
        const totalNumDeploymentProviders = Object.keys(deploymentsPerProviderStat).length;
        const { remoteLinksData: remoteLinksData } = this.props;
        const totalNumRemoteLinks = remoteLinksData.remoteLinks.length;
        const totalNumRemoteLinkProviders = remoteLinksData.providers.length;
        const remoteLinksPerProviderStat = this.calculateRemoteLinksPerProviderStat();
        const remoteLinksPerTypeStat = this.calculateRemoteLinksPerTypeStat();
        if (this.props.createAnalyticsEvent) {
            const flagsPerProviderJson = JSON.stringify(flagsPerProviderStat);
            const deploymentsPerProviderJson = JSON.stringify(deploymentsPerProviderStat);
            const environmentsPerProviderJson = JSON.stringify(deploymentsPerEnvironmentStat);
            const remoteLinksPerProviderJson = JSON.stringify(remoteLinksPerProviderStat);
            const remoteLinksPerTypeJson = JSON.stringify(remoteLinksPerTypeStat);
            (0, $gCeeo.fireUIAnalytics)(this.props.createAnalyticsEvent({
                action: 'rendered',
                actionSubject: this.props.actionSubject
            }), this.props.actionSubjectId, {
                totalNumFlags: totalNumFlags,
                totalNumFeatureFlagProviders: totalNumFeatureFlagProviders,
                flagsPerProvider: flagsPerProviderJson,
                totalNumDeployments: totalNumDeployments,
                totalNumDeploymentProviders: totalNumDeploymentProviders,
                totalNumRemoteLinks: totalNumRemoteLinks,
                totalNumRemoteLinkProviders: totalNumRemoteLinkProviders,
                remoteLinksPerProviderStat: remoteLinksPerProviderJson,
                remoteLinksPerTypeStat: remoteLinksPerTypeJson,
                deploymentsPerProviderStat: deploymentsPerProviderJson,
                environmentsPerProviderStat: environmentsPerProviderJson
            });
        }
    }
    calculateFlagsPerProviderStat() {
        const { flagsPerProvider: flagsPerProvider } = this.props;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const flagsPerProviderCnt = {};
        Object.keys(flagsPerProvider).forEach((key)=>{
            flagsPerProviderCnt[key] = flagsPerProvider[key].length;
        });
        return flagsPerProviderCnt;
    }
    calculateDeploymentsPerProviderStat() {
        const { providers: providers } = this.props;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const deploymentsPerProviderCnt = {};
        providers.forEach((provider)=>{
            const deployments = (0, (/*@__PURE__*/$parcel$interopDefault($aX8Tx)))(Object.values(provider.environments));
            deploymentsPerProviderCnt[provider.id] = deployments.length;
        });
        return deploymentsPerProviderCnt;
    }
    calculateDeploymentsPerEnvironmentStat() {
        const { providers: providers } = this.props;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const environmentsPerProviderCnt = {};
        providers.forEach((provider)=>{
            const { environments: environments } = provider;
            Object.keys(environments).forEach((environmentType)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"STAGING" | "PRODUCTION" | "DEVELOPMENT" | "TESTING" | "UNMAPPED", DeploymentData[]>>'.
                const deployments = environments[environmentType];
                environmentsPerProviderCnt[environmentType] = (environmentsPerProviderCnt[environmentType] || 0) + deployments.length;
            });
        });
        return environmentsPerProviderCnt;
    }
    calculateRemoteLinksPerProviderStat() {
        const { remoteLinksData: remoteLinksData } = this.props;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const remoteLinksPerProviderCnt = {};
        remoteLinksData.remoteLinks.forEach((link)=>{
            remoteLinksPerProviderCnt[(0, $lq5Hg.fromRemoteLinkProviderId)(link.providerId)] = (remoteLinksPerProviderCnt[(0, $lq5Hg.fromRemoteLinkProviderId)(link.providerId)] || 0) + 1;
        });
        return remoteLinksPerProviderCnt;
    }
    calculateRemoteLinksPerTypeStat() {
        const { remoteLinksData: remoteLinksData } = this.props;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const remoteLinksPerTypeCnt = {};
        remoteLinksData.remoteLinks.forEach((link)=>{
            remoteLinksPerTypeCnt[(0, $lq5Hg.fromRemoteLinkType)(link.type)] = (remoteLinksPerTypeCnt[(0, $lq5Hg.fromRemoteLinkType)(link.type)] || 0) + 1;
        });
        return remoteLinksPerTypeCnt;
    }
    render() {
        return null;
    }
}

});




parcelRegister("kxjPv", function(module, exports) {

$parcel$export(module.exports, "default", () => $0beda5ebd1e29761$export$2e2bcd8739ae039);

var $2uhjq = parcelRequire("2uhjq");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $bJscI = parcelRequire("bJscI");

var $hqYEY = parcelRequire("hqYEY");

var $kEkIL = parcelRequire("kEkIL");

var $coiM0 = parcelRequire("coiM0");

var $1pV1F = parcelRequire("1pV1F");

var $2P4bc = parcelRequire("2P4bc");

var $lyqfE = parcelRequire("lyqfE");

var $1KdDN = parcelRequire("1KdDN");

var $lRq8t = parcelRequire("lRq8t");

var $9NIQG = parcelRequire("9NIQG");

var $16sa1 = parcelRequire("16sa1");

var $iqtgH = parcelRequire("iqtgH");

var $2uhjq = parcelRequire("2uhjq");

var $kEUB1 = parcelRequire("kEUB1");

var $lUto7 = parcelRequire("lUto7");

var $eSXqs = parcelRequire("eSXqs");

var $GVwJq = parcelRequire("GVwJq");

var $f3AUL = parcelRequire("f3AUL");
const $0beda5ebd1e29761$var$getExperienceTrackerSamplingRate = ()=>50;
const $0beda5ebd1e29761$var$securityFieldTimeToLoad = (0, $hqYEY.metrics).interaction({
    key: 'security-field',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '300_1000_2500_4000_7000_10000'
    }
});
function $0beda5ebd1e29761$var$SecurityFieldContents({ queryRef: queryRef }) {
    (0, $eJOHy.useEffect)(()=>{
        $0beda5ebd1e29761$var$securityFieldTimeToLoad.stop();
    }, []);
    const data = (0, $j4oe4.usePreloadedQuery)((0, $2uhjq.default), queryRef);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const appEdges = data.jira?.devOps?.configStates?.edges ?? [];
    const isInContextConfigPromptDismissed = data.jira?.devOps?.isInContextConfigPromptDismissed || false;
    const unconfiguredDisplayableEdges = isInContextConfigPromptDismissed ? [] : appEdges // Known apps filter
    .filter((edge)=>(0, $coiM0.SECURITY_KNOWN_APPS).includes(edge.node?.id ?? '')) // UNCONFIGURED filter
    .filter((edge)=>(edge.node?.config?.edges ?? []).map((configEdge)=>configEdge.node) // finding apps that have only workspaces whose states are either NOT_SET, NOT_CONFIGURED or PROVIDER_ACTION_CONFIGURED
        .find((node)=>node?.status === 'CONFIGURED' || node?.status === 'PROVIDER_ACTION_CONFIGURED') === undefined).filter(Boolean);
    const vulnRelationshipList = data.devOps?.ariGraph?.relationships?.nodes ?? [];
    const vulnDataList = vulnRelationshipList.flatMap((vuln)=>vuln?.from.data ? [
            vuln.from.data
        ] : []) ?? [];
    const shouldDisplayInContextPrompt = data.devOps?.ariGraph?.hasRelationship === false && unconfiguredDisplayableEdges.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (vulnDataList.length > 0 || shouldDisplayInContextPrompt) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireUiAnalytics), {
        action: "viewed",
        actionSubject: "securityFieldInIssueView"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9NIQG.FieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0beda5ebd1e29761$var$SecurityFieldHeading, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9NIQG.FieldHeadingTitle), null, formatMessage((0, $GVwJq.default).securityFieldHeadingTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9NIQG.SideBySideField), null, shouldDisplayInContextPrompt && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1pV1F.AppConfigurationPromptSummary), {
        location: "SECURITY_PANEL"
    }), vulnDataList.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lyqfE.Vulnerability), {
        vulnerabilityData: vulnDataList
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2P4bc.ViewSecurityFieldInTheIssueViewSuccessTracker), {
        experienceName: (0, $2P4bc.VIEW_SECURITY_FIELD_IN_THE_ISSUE_VIEW),
        hasVulnerabilities: vulnRelationshipList.length !== 0
    }));
}
function $0beda5ebd1e29761$export$7f58deb68d49d652({ issueAri: issueAri }) {
    const cloudId = (0, $kEUB1.useCloudId)();
    const projectAri = (0, $f3AUL.useProjectAri)();
    const isSiteAdmin = (0, $lUto7.useIsSiteAdmin)();
    const [queryRef, loadQuery] = (0, $j4oe4.useQueryLoader)((0, $2uhjq.default));
    (0, $eJOHy.useEffect)(()=>{
        $0beda5ebd1e29761$var$securityFieldTimeToLoad.start();
        loadQuery({
            issueAri: issueAri,
            cloudId: cloudId,
            projectAri: projectAri,
            isNotSiteAdmin: !isSiteAdmin
        });
    }, [
        issueAri,
        cloudId,
        loadQuery,
        projectAri,
        isSiteAdmin
    ]); // As the security field is rendered on the issue view,
    // we will sample this at a 1 in (ff value) rate to minimise the number of experiences.
    const [isInSample] = (0, $eJOHy.useState)((0, $kEkIL.default)($0beda5ebd1e29761$var$getExperienceTrackerSamplingRate()));
    const securityFieldInTheIssueViewExperiencesFailed = (0, $2P4bc.useSecurityFieldInTheIssueViewExperiencesFailed)({
        experienceName: (0, $2P4bc.VIEW_SECURITY_FIELD_IN_THE_ISSUE_VIEW)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "development-summary-security-field"
    }, isInSample && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2P4bc.ViewSecurityFieldInTheIssueViewExperienceStart), {
        experienceName: (0, $2P4bc.VIEW_SECURITY_FIELD_IN_THE_ISSUE_VIEW),
        experienceId: `${(0, $2P4bc.VIEW_SECURITY_FIELD_IN_THE_ISSUE_VIEW)}-${Date.now()}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        teamName: "fusion-isotopes",
        packageName: "jiraDevelopmentSummaryVulnerability",
        id: "jiraDevelopmentSummaryVulnerability",
        sendToPrivacyUnsafeSplunk: true,
        onError: securityFieldInTheIssueViewExperiencesFailed,
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, queryRef && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eSXqs.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0beda5ebd1e29761$var$SecurityFieldContents, {
        queryRef: queryRef
    }))));
}
const $0beda5ebd1e29761$var$SecurityFieldHeadingForLayoutsExperiment = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $0beda5ebd1e29761$var$fieldWithLayoutStyles
    }, children); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $0beda5ebd1e29761$var$SecurityFieldHeadingWithoutLayoutsExperiment = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $9NIQG.FieldHeadingSideBySide), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _u5f3idpf",
            __cmplp.className
        ])
    });
});
const $0beda5ebd1e29761$var$fieldWithLayoutStyles = (0, $1DXK0.xcss)({
    position: 'relative',
    boxSizing: 'border-box',
    minWidth: '120px',
    paddingTop: 'space.100',
    flex: '1 0 0%',
    display: 'flex',
    paddingRight: 'space.200',
    maxWidth: '170px',
    padding: 'space.050',
    borderRadius: 'border.radius.100',
    ':hover': {
        backgroundColor: 'color.background.neutral.hovered'
    }
});
const $0beda5ebd1e29761$var$SecurityFieldHeading = (0, $bJscI.componentWithFG)('issue_view_layout_experiment_feature_gate', $0beda5ebd1e29761$var$SecurityFieldHeadingForLayoutsExperiment, $0beda5ebd1e29761$var$SecurityFieldHeadingWithoutLayoutsExperiment);
var $0beda5ebd1e29761$export$2e2bcd8739ae039 = $0beda5ebd1e29761$export$7f58deb68d49d652;

});
parcelRegister("2uhjq", function(module, exports) {

$parcel$export(module.exports, "default", () => $702d325a1ac0a38d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<33febed11f81ce3b9d923dd21d779b49>>
 * @relayHash fa1f62631078455244a1ba9638d040a1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 71f8210874aaa7d71dbef4a88ee1436165381ae367671f668ad140a7b5ae26f5
const $702d325a1ac0a38d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isNotSiteAdmin"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectAri"
    }, v4 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        },
        {
            "kind": "Variable",
            "name": "to",
            "variableName": "issueAri"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "vulnerability-associated-issue"
        }
    ], v5 = {
        "condition": "isNotSiteAdmin",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "from",
                        "variableName": "projectAri"
                    },
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "project-associated-vulnerability"
                    }
                ],
                "kind": "ScalarField",
                "name": "hasRelationship"
            }
        ]
    }, v6 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "status"
    }, v9 = {
        "args": [
            v6 /*: any*/ ,
            {
                "kind": "Literal",
                "name": "providerTypeFilter",
                "value": [
                    "SECURITY"
                ]
            }
        ],
        "concreteType": "JiraAppConfigStateConnection",
        "kind": "LinkedField",
        "name": "configStates",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraAppConfigStateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraAppConfigState",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v7 /*: any*/ ,
                            {
                                "concreteType": "JiraConfigStateConnection",
                                "kind": "LinkedField",
                                "name": "config",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraConfigStateEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraConfigState",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v8 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v10 = {
        "args": [
            v6 /*: any*/ ,
            {
                "kind": "Literal",
                "name": "location",
                "value": "SECURITY_PANEL"
            }
        ],
        "kind": "ScalarField",
        "name": "isInContextConfigPromptDismissed"
    }, v11 = [
        v7 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainDevelopmentSummarySecurityFieldQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AriGraph",
                            "kind": "LinkedField",
                            "name": "ariGraph",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "AriGraphRelationshipConnection",
                                    "kind": "LinkedField",
                                    "name": "relationships",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "AriGraphRelationship",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationshipNode",
                                                    "kind": "LinkedField",
                                                    "name": "from",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "kind": "LinkedField",
                                                                "name": "data",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            {
                                                                                "kind": "FragmentSpread",
                                                                                "name": "main_developmentSummaryVulnerability_Vulnerability"
                                                                            }
                                                                        ],
                                                                        "type": "DevOpsSecurityVulnerabilityDetails"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "THROW",
                                                            "path": "devOps.ariGraph.relationships.nodes.from.data"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "condition": "isNotSiteAdmin",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraDevOpsQuery",
                                    "kind": "LinkedField",
                                    "name": "devOps",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "RequiredField",
                                            "field": v10 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.devOps.isInContextConfigPromptDismissed"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainDevelopmentSummarySecurityFieldQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AriGraph",
                            "kind": "LinkedField",
                            "name": "ariGraph",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "AriGraphRelationshipConnection",
                                    "kind": "LinkedField",
                                    "name": "relationships",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "AriGraphRelationship",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationshipNode",
                                                    "kind": "LinkedField",
                                                    "name": "from",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "data",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "title"
                                                                        },
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ],
                                                                    "type": "DevOpsSecurityVulnerabilityDetails"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v11 /*: any*/ ,
                                                                    "type": "Node",
                                                                    "abstractKey": "__isNode"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v11 /*: any*/ ,
                                                                    "type": "DevOpsFeatureFlag"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v11 /*: any*/ ,
                                                                    "type": "DevOpsOperationsComponentDetails"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v11 /*: any*/ ,
                                                                    "type": "DevOpsOperationsIncidentDetails"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v11 /*: any*/ ,
                                                                    "type": "DevOpsOperationsPostIncidentReviewDetails"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v11 /*: any*/ ,
                                                                    "type": "DevOpsPullRequestDetails"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v11 /*: any*/ ,
                                                                    "type": "DevOpsRepository"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v11 /*: any*/ ,
                                                                    "type": "JiraAutodevJob"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v11 /*: any*/ ,
                                                                    "type": "JiraConfluenceRemoteIssueLink"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v11 /*: any*/ ,
                                                                    "type": "JiraCustomRemoteIssueLink"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v11 /*: any*/ ,
                                                                    "type": "JiraIssueRemoteIssueLink"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v11 /*: any*/ ,
                                                                    "type": "JiraWebRemoteIssueLink"
                                                                }
                                                            ]
                                                        },
                                                        v7 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "condition": "isNotSiteAdmin",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraDevOpsQuery",
                                    "kind": "LinkedField",
                                    "name": "devOps",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "71f8210874aaa7d71dbef4a88ee1436165381ae367671f668ad140a7b5ae26f5",
            "metadata": {},
            "name": "mainDevelopmentSummarySecurityFieldQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$702d325a1ac0a38d$var$node.hash = "d81da7370785ec9d986e8ac15dcb40e4";
var $702d325a1ac0a38d$export$2e2bcd8739ae039 = $702d325a1ac0a38d$var$node;

});

parcelRegister("kEkIL", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e49e758c7951264$export$2e2bcd8739ae039);

var $3PFy3 = parcelRequire("3PFy3");
function $9e49e758c7951264$export$2e2bcd8739ae039(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return (0, $3PFy3.default)() * rate <= 1;
}

});
parcelRegister("3PFy3", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9486a34b5c48d65$export$2e2bcd8739ae039);
// code-reaper-ignore-file -- Alternative implementation of random numbers for the browser.
const $d9486a34b5c48d65$var$MAX_UINT32 = 4294967296;
function $d9486a34b5c48d65$export$2e2bcd8739ae039() {
    try {
        const buf = new Uint32Array(1);
        // buf now has a random uint32 value
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.crypto.getRandomValues(buf);
        // Turn it back into a value in [0,1)
        return buf[0] / $d9486a34b5c48d65$var$MAX_UINT32;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return Math.random();
    }
}

});


parcelRegister("2P4bc", function(module, exports) {

$parcel$export(module.exports, "VIEW_SECURITY_FIELD_IN_THE_ISSUE_VIEW", () => $5d0b8c41d33fa7b1$export$3df8f2db2d57cb81);
$parcel$export(module.exports, "ViewSecurityFieldInTheIssueViewSuccessTracker", () => $5d0b8c41d33fa7b1$export$831902433fd2f47d);
$parcel$export(module.exports, "useSecurityFieldInTheIssueViewExperiencesFailed", () => $5d0b8c41d33fa7b1$export$1ce855eb0c6cadc8);
$parcel$export(module.exports, "ViewSecurityFieldInTheIssueViewExperienceStart", () => $5d0b8c41d33fa7b1$export$ec3a0b93f352171a);

var $eJOHy = parcelRequire("eJOHy");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $bRJAs = parcelRequire("bRJAs");

var $8vyDv = parcelRequire("8vyDv");
const $5d0b8c41d33fa7b1$export$3df8f2db2d57cb81 = 'viewSecurityFieldInTheIssueView';
const $5d0b8c41d33fa7b1$export$831902433fd2f47d = ({ experienceName: experienceName = $5d0b8c41d33fa7b1$export$3df8f2db2d57cb81, hasVulnerabilities: hasVulnerabilities })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ctwv.ExperienceSuccess), {
        experience: experienceName,
        attributes: {
            hasVulnerabilities: hasVulnerabilities
        }
    });
const $5d0b8c41d33fa7b1$export$1ce855eb0c6cadc8 = ({ experienceName: experienceName = $5d0b8c41d33fa7b1$export$3df8f2db2d57cb81 })=>(0, $aqnJa.useExperienceFail)({
        experience: experienceName
    });
const $5d0b8c41d33fa7b1$export$ec3a0b93f352171a = ({ experienceId: experienceId = Date.now().toString(), experienceName: experienceName = $5d0b8c41d33fa7b1$export$3df8f2db2d57cb81, collect: collect })=>{
    const appEditions = (0, $8vyDv.useAppEditions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Uqf3.ExperienceStart), {
        experienceId: experienceId,
        experience: experienceName,
        analyticsSource: "security",
        edition: appEditions.software,
        application: (0, $bRJAs.JIRA_SOFTWARE),
        collect: collect || undefined
    });
};

});

parcelRegister("lyqfE", function(module, exports) {

$parcel$export(module.exports, "Vulnerability", () => $e811dfcec5c4866a$export$64ddc546e448f388);

var $h5uzg = parcelRequire("h5uzg");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $5lAAn = parcelRequire("5lAAn");

var $goZPP = parcelRequire("goZPP");

var $cDP77 = parcelRequire("cDP77");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $3DYZ8 = parcelRequire("3DYZ8");

var $hkLh5 = parcelRequire("hkLh5");

var $ibHZw = parcelRequire("ibHZw");
const $e811dfcec5c4866a$var$SUMMARY_ITEM_TEST_ID = 'development-summary-vulnerability.ui.summary-item';
const $e811dfcec5c4866a$export$64ddc546e448f388 = ({ vulnerabilityData: vulnerabilityData })=>{
    const data = (0, $j4oe4.useFragment)((0, $h5uzg.default), vulnerabilityData);
    const count = data.length;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
        ...(0, $hkLh5.default).summaryItemTitle,
        values: {
            count: count,
            styledCount: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e811dfcec5c4866a$var$BoldFont, null, count)
        }
    });
    const statusLozenge = // @ts-expect-error - Type '(DevOpsSecurityVulnerabilityStatus | null | undefined)[]' is not assignable to type '(DevOpsSecurityVulnerabilityStatus | null)[]'.
    count > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3DYZ8.PriorityStatusLozenge), {
        statuses: data.map((detail)=>detail.status)
    }) : null;
    const oneClickUrl = count === 1 ? data[0]?.url : null;
    const hasManyVulnerabilities = count > 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, hasManyVulnerabilities ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ibHZw.default), {
        vulnerabilityDropdownData: data,
        renderDropdownTrigger: ({ onClick: onClick, isSelected: isSelected, ref: ref, ...dropdownTriggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDP77.SummaryItem), {
                title: title,
                itemType: "vulnerability",
                itemCount: count,
                oneClickUrl: oneClickUrl,
                oneClickToolTipContent: formatMessage((0, $hkLh5.default).summaryItemOneClickTooltip),
                secondaryData: statusLozenge,
                secondaryHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e811dfcec5c4866a$var$TriggerButton, {
                    ...dropdownTriggerProps,
                    isSelected: isSelected,
                    onClick: onClick,
                    appearance: "subtle",
                    iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
                        LEGACY_size: "medium",
                        spacing: "spacious",
                        label: formatMessage((0, $hkLh5.default).summaryItemDropdownTriggerIconLabel),
                        size: "small"
                    })
                }),
                reference: ref,
                onClick: onClick,
                forceVisibleSecondary: isSelected,
                "data-testid": $e811dfcec5c4866a$var$SUMMARY_ITEM_TEST_ID
            })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDP77.SummaryItem), {
        title: title,
        itemType: "vulnerability",
        itemCount: count,
        oneClickUrl: oneClickUrl,
        oneClickToolTipContent: formatMessage((0, $hkLh5.default).summaryItemOneClickTooltip),
        secondaryData: statusLozenge,
        "data-testid": $e811dfcec5c4866a$var$SUMMARY_ITEM_TEST_ID
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $e811dfcec5c4866a$var$TriggerButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_w1ap1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $e811dfcec5c4866a$var$BoldFont = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_k48p1wq8",
            __cmplp.className
        ])
    });
});

});
parcelRegister("h5uzg", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f3bd858ea229eea$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6f179124c72f7100780170cc1db16624>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0f3bd858ea229eea$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "main_developmentSummaryVulnerability_Vulnerability",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "vulnerabilityDropdownItem_developmentSummaryVulnerability_VulnerabilityDropdownItemEntryPoint_vulnerabilityDropdownData"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        }
    ],
    "type": "DevOpsSecurityVulnerabilityDetails"
};
$0f3bd858ea229eea$var$node.hash = "37e7e6214218bd68ae9e17be1376e620";
var $0f3bd858ea229eea$export$2e2bcd8739ae039 = $0f3bd858ea229eea$var$node;

});

parcelRegister("3DYZ8", function(module, exports) {

$parcel$export(module.exports, "StatusLozenge", () => $d04eefb53f8a324a$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "PriorityStatusLozenge", () => $d04eefb53f8a324a$export$6e5dec10ef4abc92);

var $eJOHy = parcelRequire("eJOHy");

var $80xRm = parcelRequire("80xRm");

var $hKpwU = parcelRequire("hKpwU");

var $jdqdp = parcelRequire("jdqdp");

var $lRq8t = parcelRequire("lRq8t");

var $hNY0E = parcelRequire("hNY0E");
const $d04eefb53f8a324a$var$getLozengeConfig = (status, count)=>{
    switch(status){
        case 'OPEN':
            return {
                message: count ? (0, $hNY0E.default).openCount : (0, $hNY0E.default).open,
                appearance: 'inprogress'
            };
        case 'IGNORED':
            return {
                message: count ? (0, $hNY0E.default).ignoredCount : (0, $hNY0E.default).ignored
            };
        case 'CLOSED':
            return {
                message: count ? (0, $hNY0E.default).closedCount : (0, $hNY0E.default).closed,
                appearance: 'success'
            };
        default:
            return {
                message: count ? (0, $hNY0E.default).unknownCount : (0, $hNY0E.default).unknown
            };
    }
};
const $d04eefb53f8a324a$export$9dbddef21059688 = 'software-security-common.common.ui.status-lozenge.lozenge';
const $d04eefb53f8a324a$export$f72db4ad1e9b3e6d = ({ status: status, count: count })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { message: message, ...lozengeProps } = $d04eefb53f8a324a$var$getLozengeConfig(status, count);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        ...lozengeProps,
        testId: `${$d04eefb53f8a324a$export$9dbddef21059688}-${status}`
    }, formatMessage(message, {
        count: count
    }));
};
const $d04eefb53f8a324a$var$getStatusScore = (status)=>{
    switch(status){
        case 'OPEN':
            return 1;
        case 'IGNORED':
            return 2;
        case 'UNKNOWN':
            return 3;
        case 'CLOSED':
            return 4;
        default:
            return 5;
    }
};
const $d04eefb53f8a324a$export$6e5dec10ef4abc92 = ({ statuses: statuses })=>{
    const sortedStatuses = (0, (/*@__PURE__*/$parcel$interopDefault($80xRm)))(statuses, $d04eefb53f8a324a$var$getStatusScore);
    const priorityStatuses = (0, (/*@__PURE__*/$parcel$interopDefault($hKpwU)))(sortedStatuses, (status)=>status === sortedStatuses[0]);
    const priorityStatus = priorityStatuses[0] ?? null;
    // Hide the count when every status is of the same priority as it becomes noise.
    const count = statuses.length === priorityStatuses.length ? undefined : priorityStatuses.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d04eefb53f8a324a$export$f72db4ad1e9b3e6d, {
        status: priorityStatus,
        count: count
    });
};

});
parcelRegister("hKpwU", function(module, exports) {

var $1lM9j = parcelRequire("1lM9j");

var $6HiCL = parcelRequire("6HiCL");
/**
 * Creates a slice of `array` with elements taken from the beginning. Elements
 * are taken until `predicate` returns falsey. The predicate is invoked with
 * three arguments: (value, index, array).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.takeWhile(users, function(o) { return !o.active; });
 * // => objects for ['barney', 'fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.takeWhile(users, { 'user': 'barney', 'active': false });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.takeWhile(users, ['active', false]);
 * // => objects for ['barney', 'fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.takeWhile(users, 'active');
 * // => []
 */ function $ceba8937457e3cda$var$takeWhile(array, predicate) {
    return array && array.length ? $6HiCL(array, $1lM9j(predicate, 3)) : [];
}
module.exports = $ceba8937457e3cda$var$takeWhile;

});
parcelRegister("6HiCL", function(module, exports) {

var $1FqKq = parcelRequire("1FqKq");
/**
 * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
 * without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {Function} predicate The function invoked per iteration.
 * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the slice of `array`.
 */ function $4e05349b6a08640d$var$baseWhile(array, predicate, isDrop, fromRight) {
    var length = array.length, index = fromRight ? length : -1;
    while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
    return isDrop ? $1FqKq(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : $1FqKq(array, fromRight ? index + 1 : 0, fromRight ? length : index);
}
module.exports = $4e05349b6a08640d$var$baseWhile;

});


parcelRegister("hNY0E", function(module, exports) {

$parcel$export(module.exports, "default", () => $0038065c93b0d450$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $0038065c93b0d450$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    open: {
        "id": "software-security-common.status-lozenge.open",
        "defaultMessage": "OPEN"
    },
    ignored: {
        "id": "software-security-common.status-lozenge.ignored",
        "defaultMessage": "IGNORED"
    },
    closed: {
        "id": "software-security-common.status-lozenge.closed",
        "defaultMessage": "CLOSED"
    },
    unknown: {
        "id": "software-security-common.status-lozenge.unknown",
        "defaultMessage": "UNKNOWN"
    },
    openCount: {
        "id": "software-security-common.status-lozenge.open-count",
        "defaultMessage": "{count, plural, one {# OPEN} other {# OPEN}}"
    },
    ignoredCount: {
        "id": "software-security-common.status-lozenge.ignored-count",
        "defaultMessage": "{count, plural, one {# IGNORED} other {# IGNORED}}"
    },
    closedCount: {
        "id": "software-security-common.status-lozenge.closed-count",
        "defaultMessage": "{count, plural, one {# CLOSED} other {# CLOSED}}"
    },
    unknownCount: {
        "id": "software-security-common.status-lozenge.unknown-count",
        "defaultMessage": "{count, plural, one {# UNKNOWN} other {# UNKNOWN}}"
    }
});

});


parcelRegister("hkLh5", function(module, exports) {

$parcel$export(module.exports, "default", () => $60022abaf04512b3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $60022abaf04512b3$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    summaryItemTitle: {
        "id": "development-summary-vulnerability.summary-item-title",
        "defaultMessage": "{count, plural,\n                    =0 {no vulnerabilities}\n                    one {{styledCount} vulnerability}\n                    other {{styledCount} vulnerabilities}\n                }"
    },
    summaryItemOneClickTooltip: {
        "id": "development-summary-vulnerability.summary-item-one-click-tooltip",
        "defaultMessage": "Open vulnerability"
    },
    summaryItemDropdownTriggerIconLabel: {
        "id": "development-summary-vulnerability.summary-item-dropdown-trigger-icon-label",
        "defaultMessage": "Show more"
    }
});

});

parcelRegister("ibHZw", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb0da542dac8a114$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dPMMf = parcelRequire("dPMMf");

var $cNe2t = parcelRequire("cNe2t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $bbdV2 = parcelRequire("bbdV2");

var $ciFJV = parcelRequire("ciFJV");

var $cBavF = parcelRequire("cBavF");

var $gkfyg = parcelRequire("gkfyg");
const $eb0da542dac8a114$var$entryPointParams = {};
const $eb0da542dac8a114$export$c8d8a896c5ef8ff3 = ({ renderDropdownTrigger: renderDropdownTrigger, vulnerabilityDropdownData: vulnerabilityDropdownData })=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const previousOpen = (0, $eJOHy.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        if (previousOpen.current !== isOpen) {
            previousOpen.current = isOpen;
            isOpen && (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'dropdown',
                action: 'opened'
            }), 'devPanelVulnerabilityDropdown');
            !isOpen && (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'dropdown',
                action: 'closed'
            }), 'devPanelVulnerabilityDropdown');
        }
    }, [
        createAnalyticsEvent,
        isOpen
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $gkfyg.vulnerabilityDropdownItemEntrypoint), $eb0da542dac8a114$var$entryPointParams);
    const triggerRef = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    const runtimeProps = (0, $eJOHy.useMemo)(()=>({
            vulnerabilityDropdownData: vulnerabilityDropdownData,
            setIsOpen: setIsOpen
        }), [
        vulnerabilityDropdownData,
        setIsOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        messageId: "development-summary-vulnerability.ui.vulnerability-dropdown.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "dev-panel-vulnerability-dropdown",
                packageName: "jira-development-summary-vulnerability",
                fallback: null,
                runtimeProps: runtimeProps
            }),
        placement: "bottom-end",
        shouldFlip: true,
        zIndex: (0, $dPMMf.layers).modal,
        trigger: (triggerProps)=>renderDropdownTrigger({
                ...triggerProps,
                isSelected: isOpen,
                onClick: ()=>setIsOpen(!isOpen),
                ref: (element)=>{
                    triggerRef(element);
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    triggerProps.ref(element);
                }
            })
    });
};
var $eb0da542dac8a114$export$2e2bcd8739ae039 = $eb0da542dac8a114$export$c8d8a896c5ef8ff3;

});
parcelRegister("gkfyg", function(module, exports) {

$parcel$export(module.exports, "vulnerabilityDropdownItemEntrypoint", () => $58a60112e71399d8$export$a86040b1e179f317);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $58a60112e71399d8$export$a86040b1e179f317 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("2cDvC")), {
        moduleId: "a49ce161",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("2cDvC", function(module, exports) {

let $19ab59658beb11a2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $19ab59658beb11a2$var$load("bQtb6").then(()=>parcelRequire('c4J3P'));

});




parcelRegister("GVwJq", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc08ec44cc5f7227$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $cc08ec44cc5f7227$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    securityFieldHeadingTitle: {
        "id": "development-summary-security-field.security-field-heading-title",
        "defaultMessage": "Security"
    }
});

});

parcelRegister("f3AUL", function(module, exports) {

$parcel$export(module.exports, "useProjectAri", () => $d77d5ed30f671ecd$export$8688254b761eadc4);

var $8oKDI = parcelRequire("8oKDI");

var $2aY2d = parcelRequire("2aY2d");

var $kEUB1 = parcelRequire("kEUB1");
const $d77d5ed30f671ecd$export$8688254b761eadc4 = ()=>{
    const { data: projectContext } = (0, $2aY2d.useProjectContext)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const projectAri = projectContext?.projectId.toString() ?? '';
    return (0, $8oKDI.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'project',
        // Since we are in project context, empty string should not happen. If it happens, we will be able to monitor errors via the nearest error boundary, since the hasRelationship query will emit an error.
        resourceId: projectAri
    });
};

});




parcelRegister("Op2iN", function(module, exports) {

module.exports = (parcelRequire("g81qY"))('jiv-20508-remove-height-animation-dev-panel', function() {
    return parcelRequire('iRc42');
}, function() {
    return parcelRequire('gMlkF');
});

});


$parcel$global.rlb("d7W8O")
//# sourceMappingURL=async-dev-panel.c99330d0.js.map
